<template>
  <div style="width:100vw;height:100vh;font-family:PingFang SC;user-select:none;">
    <div class="head">
      <div class="head-title" :class="{ 'head-title-listening': voiceKeepListening || voiceListening || voiceStarting }"
        :title="voiceKeepListening || voiceListening || voiceStarting ? '点击停止语音监听' : '点击开始语音控制'"
        @click="toggleVoiceRecognition">
        <span class="head-title-text">婺源县文旅大数据平台系统</span>
      </div>
    </div>
    <div class="main" id="bodys">
      <div class="right-nav-drawer" :class="{ 'right-nav-drawer-collapsed': navCollapsed }"
        @mouseenter="navCollapsed = false" @mouseleave="navCollapsed = true">
        <div class="drawer-side-panel">
          <button class="right-nav-toggle" type="button" @click.stop="navCollapsed = !navCollapsed">
            {{ navCollapsed ? '菜单' : '收起' }}
          </button>
          <button class="right-nav-toggle voice-toggle" type="button" @click="toggleVoiceRecognition">
            <span class="voice-toggle-icon">语音</span>
            <span class="voice-toggle-dot" :class="{ 'voice-toggle-dot-on': voiceKeepListening || voiceListening || voiceStarting }"></span>
          </button>
        </div>
        <div class="head-type">
          <div class="type-item" v-for="item in type_item" :key="item.value"
            :class="{ 'type-item2': item.value == typeIndex }" @click="typeChange(item.value)">
            {{ item.label }}
          </div>
        </div>
        <div class="date-switch">
          <button class="changeDateOne" type="button" @click="changeTheDate(-1)">前日</button>
          <button class="changeDateOne" :class="{ active: isToday }" type="button" @click="changeTheDate(0)">今日</button>
          <button class="changeDateOne" type="button" @click="changeTheDate(1)">次日</button>
        </div>
      </div>
      <ScenicWarning ref="embeddedWarning" v-if="typeIndex == 4" :embedded="true" />
      <SentimentSurveillance ref="SentimentSurveillance" v-if="typeIndex == 9" :embedded="true" />
      <videoSurveillance ref="videoSurveillance" v-if="typeIndex == 10" :embedded="true" />
      <User ref="user" v-if="typeIndex == 12" :embedded="true" />
      <Role ref="role" v-if="typeIndex == 13" :embedded="true" />
      <Log ref="log" v-if="typeIndex == 14" :embedded="true" />

      <System ref="system" v-if="typeIndex == 11" :embedded="true" />
      <div v-if="typeIndex == 6" class="warning-push-board" style="width: 550px">
        <div class="warning-push-text" v-for="item in decision_type" @click="decision_type_index = item.index"
          :class="{ 'warning-push-text-on': decision_type_index == item.index }">{{ item.name }}</div>
      </div>
      <div id="migrateMap" class="migrateMap" :style="{ 'height': bodyHeight + 'px' }"
        v-show="typeIndex == 0 || typeIndex == 1 || typeIndex == 2 || typeIndex == 5 || (typeIndex == 6 && decision_type_index != 1) || typeIndex == 7 || typeIndex == 8">
      </div>
      <div v-if="(typeIndex == 0 || typeIndex == 1 || typeIndex == 2) && currentWarningItem"
        class="scenic-warning-board">
        <div class="scenic-warning-icon">!</div>
        <div class="scenic-warning-content">
          <transition name="warning-slide" mode="out-in">
            <div :key="warningCurrentIndex + '-' + currentWarningItem.title" class="scenic-warning-item">
              <span class="scenic-warning-title">风险动态</span>
              <span class="scenic-warning-tag">{{ currentWarningItem.title }}</span>
              <span class="scenic-warning-text">{{ currentWarningItem.text }}</span>
            </div>
          </transition>
        </div>
      </div>
      <transition name="voice-metric-fade">
        <div v-if="voiceMetricBoardVisible" class="voice-metric-board"
          :class="'voice-metric-board-' + voiceMetricBoardTone">
          <button class="voice-metric-close" @click="hideVoiceMetricBoard">×</button>
          <div class="voice-metric-caption">语音查询结果</div>
          <div class="voice-metric-title">{{ voiceMetricBoardTitle }}</div>
          <div class="voice-metric-value-row">
            <span class="voice-metric-value">{{ voiceMetricBoardValue }}</span>
            <span class="voice-metric-unit">{{ voiceMetricBoardUnit }}</span>
          </div>
          <div class="voice-metric-subtitle">{{ voiceMetricBoardSubtitle }}</div>
        </div>
      </transition>
      <!-- <div class="centenrBox centenr-echart" v-show="typeIndex == 2">
        
        <div class="all_or_shop">
          <div class="all_or_shop_btn" :class="{ 'all_or_shop_on': allShopIndex === 1 }" style="margin-right: 48px;"
            @click="changeAllShop(1)">总营收</div>
          <div class="all_or_shop_btn" :class="{ 'all_or_shop_on': allShopIndex === 2 }" @click="changeAllShop(2)">商户明细
          </div>
        </div>
        
        <div v-show="allShopIndex === 2" class="shop-charts-btn">
          <div id="shopRank" v-show="merchant_order_total_list.length <= 40" class="shop-charts-01"></div>
          <div id="shopRank_1" v-show="merchant_order_total_list.length > 40" class="shop-charts-02"></div>
          <div v-show="merchant_order_total_list.length > 40" id="shopRank_2" class="shop-charts-02"
            style="margin-left: 48px;"></div>
        </div>
      </div> -->
      <div v-show="typeIndex == 0" class="main_type culture-market-page">
        <div class="center-top-num traffic-kpi-card">
          <div class="traffic-kpi-head">
            <div>
              <div class="traffic-kpi-title">今日全县客流量</div>
              <div class="traffic-kpi-subtitle">实时累计客流</div>
            </div>
            <span class="traffic-kpi-status">实时</span>
          </div>
          <div class="traffic-kpi-value">
            <div class="traffic-kpi-number">
              <span v-for="(item, index) in dateSum" :key="index" class="traffic-kpi-digit">
                <CountFlop :val="item" />
              </span>
            </div>
            <span class="traffic-kpi-unit">人次</span>
          </div>
          <div class="traffic-kpi-meta">
            <div class="traffic-kpi-meta-item">
              <span>年同比</span>
              <strong>4.6%</strong>
            </div>
            <div class="traffic-kpi-meta-item">
              <span>月同比</span>
              <strong>4.9%</strong>
            </div>
          </div>
        </div>
        <div class="main-left market-left">
          <div class="heat-address market-source-filter">
            客源地
            <img style="margin-left:4px;width:1px;height:12px;" src="../../static/img/Rectangle 234.png">
            <img style="width:23px;height:23px;" src="../../static/img/chevron_down.png">
          </div>
          <div class="market-overview-card data-box">
            <div class="market-card-head">
              <div>
                <div class="market-eyebrow">年度运营总览</div>
                <div class="market-card-title">全域接待与车流</div>
              </div>
              <button class="market-ghost-btn" type="button" @click="isDataShow(isYearSumShow)">
                {{ isYearSumShow ? '隐藏' : '显示' }}
              </button>
            </div>
            <div class="market-total-strip">
              <div class="market-total-main">
                <span>{{ isToday ? nowDay.slice(0, 4) : req_date.slice(0, 4) }}年游客累计</span>
                <strong>
                  <template v-for="(item, index) in yearSum">
                    <span :key="'year-total-' + index">{{ isYearSumShow ? item : '*' }}</span>
                  </template>
                </strong>
              </div>
              <div class="market-total-main">
                <span>全年车次累计</span>
                <strong>
                  <template v-for="(item, index) in carSum">
                    <span :key="'car-total-' + index">{{ isYearSumShow ? item : '*' }}</span>
                  </template>
                </strong>
              </div>
            </div>
            <div class="market-metric-grid">
              <div class="market-metric-cell">
                <span>全县游客年同比</span>
                <strong>+4.6%</strong>
              </div>
              <div class="market-metric-cell">
                <span>景区游客年同比</span>
                <strong>+6.6%</strong>
              </div>
              <div class="market-metric-cell">
                <span>游客月同比</span>
                <strong>+4.9%</strong>
              </div>
              <div class="market-metric-cell">
                <span>车次月同比</span>
                <strong>+3.7%</strong>
              </div>
            </div>
          </div>
          <div class="market-spend-card data-box">
            <div class="market-card-head compact">
              <div>
                <div class="market-eyebrow">消费能力</div>
                <div class="market-card-title">文旅消费估算</div>
              </div>
            </div>
            <div class="market-spend-value">
              <span>文旅消费总量</span>
              <strong>{{ realTourists_data.year ? (realTourists_data.year.county_total * 85.3).toFixed(2) : 0
                }}</strong>
            </div>
            <div class="market-spend-row">
              <div>
                <span>人均消费</span>
                <strong>85.30</strong>
              </div>
              <div>
                <span>总量同比</span>
                <strong>+20.23%</strong>
              </div>
              <div>
                <span>客单同比</span>
                <strong>+20.53%</strong>
              </div>
            </div>
          </div>
          <div class="market-consume-card data-box">
            <div class="market-card-head compact">
              <div>
                <div class="market-eyebrow">结构拆解</div>
                <div class="market-card-title">文旅消费构成</div>
              </div>
            </div>
            <div class="market-consume-layout">
              <div id="ota_pie" class="ota_pie market-ota-pie"></div>
              <div class="ota_pie_list market-consume-list">
                <div><span class="pie-dot" style="background-color: #63a8ea;"></span>餐饮：20.18%</div>
                <div><span class="pie-dot" style="background-color: #ea8186;"></span>住宿：17.52%</div>
                <div><span class="pie-dot" style="background-color: #e9c16d;"></span>游玩：26.51%</div>
                <div><span class="pie-dot" style="background-color: #8c63ea;"></span>交通：31.16%</div>
                <div><span class="pie-dot" style="background-color: #049f09;"></span>购物：3.59%</div>
                <div><span class="pie-dot" style="background-color: #500509;"></span>其他：1.03%</div>
              </div>
            </div>
          </div>

        </div>
        <div class="main-center market-center">
          <div class="charts market-chart-stack">
            <!-- <div class="inOrOut data-box market-trend-card">
              <div class="chart-card-head">
                <div>
                  <div class="market-eyebrow">30日观察</div>
                  <div class="chart-card-title">近30日客流热度</div>
                </div>
                <div class="chart-card-tools">
                  <span>周视图</span>
                </div>
              </div>
              <div id="touristLine" class="touristLine market-trend-chart"></div>
            </div>
            <div class="inOrOut data-box market-flow-card">
              <div class="chart-card-head">
                <div>
                  <div class="market-eyebrow">小时节奏</div>
                  <div class="chart-card-title">入园 / 出园时段分布</div>
                </div>
                <div class="chart-card-tools muted">按小时</div>
              </div>
              <div id="inOrOut" class="inOrOut-chart market-flow-chart"></div>
            </div> -->
          </div>
        </div>
        <div class="main-right market-right" style="position: absolute;right:30px;top: 15px">
            <div class="inOrOut data-box market-trend-card">
              <div class="chart-card-head">
                <div>
                  <div class="market-eyebrow">30日观察</div>
                  <div class="chart-card-title">近30日客流热度</div>
                </div>
                <div class="chart-card-tools">
                  <span>周视图</span>
                </div>
              </div>
              <div id="touristLine" class="touristLine market-trend-chart"></div>
            </div>
          
          <div class="right-top data-box" style="height: 270px;">
            <div class="left-bottom-title" style="position: absolute">
              热门景区接待榜
            </div>
            <div id="scenic_ranking_list" class="travel-person" style="width:320px;height:240px;vertical-align: top;"
              @click="go_hl"></div>
          </div>
          <div class="right-top data-box" style="height: 240px;margin-top: 15px;">
            <div class="left-bottom-title">游览停留分布</div>
            <div id="time_1" class="gender-column" style="width: 320px;height:200px;"></div>
          </div>
          <div class="left-center data-box" style="height: 400px;">
            <div class="right-title" style="font-weight: 600;padding:10px 10px 5px;">客群画像概览</div>
            <div class="right-title" style="padding:10px">
              <div class="right-title-1">来源地分布</div>
              <div class="right-datetiem" style="top:5px">
                日
                <img style="margin-left:4px;width:1px;height:9px;" src="../../static/img/Rectangle 234.png">
                <img style="width:18px;height:18px;" src="../../static/img/chevron_down.png">
              </div>
              <div class="addressList">
                <div v-for="(item, index) in origin_list_dict.o_address_list" :key="index" class="addressListOne">
                  {{ item.slice(0, 2) }}</div>
                <div class="addressBar" id="addressBar_1"></div>
              </div>
            </div>
            <div id="address_1" class="address"></div>
            <div class="right-title-1" style="padding:20px 10px 10px">游客性别及时间安排</div>
            <div class="gender">
              <div class="a-gender">
                <img src="../../static/img/man.png">
                <div class="gender-content" style="margin-top:8px">男</div>
                <div class="gender-content" style="margin-top:5px">{{ this.gender.male ? this.gender.male.ratio : 0 }}
                </div>
              </div>
              <div class="a-gender">
                <img src="../../static/img/woman.png">
                <div class="gender-content" style="margin-top:8px">女</div>
                <div class="gender-content" style="margin-top:5px">{{ this.gender.female ? this.gender.female.ratio : 0
                  }}
                </div>
              </div>
              <div id="gender_1" class="gender-column"></div>
            </div>
          </div>

          <!-- <div class="right-bottom data-box">
            <div class="right-title">
              三天待入园人数
            </div>
            <div>
              <div id="waitInPart" class="travel-person" style="height: 230px;width: 180px;display:inline-block"></div>
              <div class="three-day">
                <div style="margin-bottom:10px;font-size:15px">
                  待入园渠道分析
                </div>
                <div v-for="(item, index) in three_show" :key="index" style="margin-bottom:6px">
                  {{ item.text }}
                </div>

                <div style="width: 128px;height: 128px;margin-left:-10px" id="three_pie"></div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div v-show="typeIndex == 1" class="main_type">
        <div class="main-left">
          <div class="right-top data-box" style="height: 320px;margin-top:18px;">
            <div class="right-title" style="padding-bottom: 0;font-size: 18px;">今日全县及各景区客流总量</div>
            <div class="right-title" style="padding-top: 0;">
              <div class="title-price" style="font-size: 15px;">
                全县游客总量
                <span class="num-price">{{ county_total_value }}</span>
                <div class="title-price-tong">同比+4.54%</div>
              </div>
              <div id="touristType_1" class="touristType" style="height: 250px;width: 300px;"></div>
            </div>
          </div>
          <div class="right-center data-box">
            <div class="right-title">
              客流峰值分析
            </div>
            <div id="peakLine" class="touristLine"></div>
          </div>
          <div class="left-bottom data-box" style="height: 320px;">
            <div class="right-title" style="padding-bottom: 0;font-size: 18px;">游客接待排行</div>
            <div class="right-title" style="padding-top: 0;">
              <div class="title-price" style="font-size: 15px;">
                全县游客总量
                <span class="num-price">{{ county_total_value }}</span>
              </div>
              <div id="scenic_ranking_list_1" class="travel-person" style="width: 300px;height:240px;"></div>
            </div>
          </div>
          <!--
          <div class="cityCome data-box" style="margin-top:36px">
            <div class="right-title" style="text-align:center">
              <div class="city-btn" @click="drawOldCome(1)" :class="{'onOldCome': oldComeIndex == 1}">老年</div>
              <div class="city-btn" @click="drawOldCome(2)" :class="{'onOldCome': oldComeIndex == 2}">中年</div>
              <div class="city-btn" @click="drawOldCome(3)" :class="{'onOldCome': oldComeIndex == 3}">青少</div>
              <div class="city-btn" @click="drawOldCome(4)" :class="{'onOldCome': oldComeIndex == 4}">亲子</div>
              <div class="city-btn" @click="drawOldCome(5)" :class="{'onOldCome': oldComeIndex == 5}">均衡</div>
            </div>
            <div style="padding:0 22px;font-size:16px">{{oldComeName}}客源市场(占比)TOP10</div>
            <div id="oldCome" class="cityCome-chart" style="height: 234px;"></div>
          </div> -->
        </div>
        <div class="main-right" style="width:360px">
          <div class="cityCome data-box" style="height: 200px;">
            <div class="right-title" style="padding:11px">客流过去30天走势</div>
            <div id="touristLine_1" class="inTime-chart"></div>
          </div>
          <div class="cityCome data-box" style="height: 200px;margin-top:18px">
            <div class="right-title" style="padding:11px">游客构成分析</div>
            <div id="inTime" class="inTime-chart"></div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px;height: 240px;">
            <div class="right-title">
              客源地统计
              <div class="right-datetiem">
                日
                <img style="margin-left:4px;width:1px;height:9px;" src="../../static/img/Rectangle 234.png">
                <img style="width:18px;height:18px;" src="../../static/img/chevron_down.png">
              </div>
              <div class="addressList_2">
                <div v-for="(item, index) in origin_list_dict.o_address_list" :key="index" class="addressListOne_2">
                  {{ item.slice(0, 2) }}</div>
                <div class="addressBar_2" id="addressBar_2"></div>
              </div>
            </div>
            <div id="address_2" class="address_2"></div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px;height: 240px;">
            <div class="right-title" style="padding-bottom:0">
              城市客源年龄结构分析
              <input type="text" class="cityInput" v-model="city_name">
              <div class="city-btn" @click="getCityCome()">查询</div>
            </div>
            <div style="padding:0 22px;font-size:16px;">{{ now_city_name }}</div>
            <div id="cityCome" class="cityCome-chart"></div>
          </div>
        </div>

      </div>
      <div v-show="typeIndex == 2" class="main_type map-pass-through">
        <div class="click-box" @click="openDefaultMonitorVideo">
          <div class="scroll-text-box">
            <div class="scroll-text-content">
              <span><span style="color: red;">当前监控：</span>篁岭景区[游客中心]出现拥堵情况，请尽快疏导</span>
              <span><span style="color: red;">当前监控：</span>篁岭景区[晒秋平台]出现拥堵情况，请尽快疏导</span>
            </div>
          </div>
        </div>
        <div class="resource-panel">
          <div class="resource-panel-title">文旅资源概况</div>
          <div class="resource-item" :class="{ active: isResourceItemActive(item) }" v-for="item in this_list"
            :key="item.key || item.name" @click="handleResourceItemClick(item)">
            <span class="resource-label">{{ item.name }}</span>
            <span class="resource-count">({{ item.value }})</span>
          </div>
        </div>
        <div class="main-left" style="width: 360px;">
          <div class="data-box" style="height: 233px;">
            <div class="right-title">重点景区实时客流量（入园人数）</div>
            <div id="in_ranking_list" class="travel-person" style="width: 320px;height:180px;vertical-align: top;">
            </div>
          </div>
          <div class="inOrOut data-box" style="width: 360px;margin-top: 18px;height: 278px;">
            <div class="right-title">景区实时客流排名榜单（在园人数）</div>
            <div id="on_ranking_list" class="travel-person" style="width: 320px;height:180px;vertical-align: top;">
            </div>
          </div>
          <div class="inOrOut data-box" style="width: 360px;margin-top: 18px;height: 280px;">
            <div class="right-title">
              景区实时客流走势
            </div>
            <div id="peakLine_2" class="touristLine" style="width:320px"></div>
          </div>
        </div>
        <div class="main-right" style="width: 360px;">
          <div class="data-box" style="height: 233px;">
            <div class="right-title">重点景区未来一小时客流预测</div>
            <div id="hourScenic" class="touristLine" style="height: 180px;width: 320px;"></div>
          </div>
          <div class="data-box" style="width: 360px;margin-top: 18px;height: 278px;">
            <div class="right-title">一小时后道路拥堵情况预测</div>
            <!-- 表格 -->
            <div class="table-container">
              <div class="table-header">
                <div class="th">市场路段</div>
                <div class="th">进口车流量</div>
                <div class="th">拥堵率</div>
                <div class="th">出口车流量</div>
                <div class="th">拥堵率</div>
              </div>

              <div class="table-body">
                <div v-for="(item, index) in tableData" :key="index" class="table-row"
                  :class="{ 'even': index % 2 === 0 }">
                  <div class="td road-name">{{ item.road }}</div>
                  <div class="td">{{ item.inFlow }}</div>
                  <div class="td">
                    <span class="rate-text" :class="getRateClass(item.inRate)">
                      {{ item.inRate }}%
                    </span>
                  </div>
                  <div class="td">{{ item.outFlow }}</div>
                  <div class="td">
                    <span class="rate-text" :class="getRateClass(item.outRate)">
                      {{ item.outRate }}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right-top data-box" style="height: 280px;margin-top: 18px;">
            <div class="right-title">明日易拥堵场所预测分析</div>
            <!-- 表格 -->
            <div class="table-container">
              <div class="table-header">
                <div class="th">易拥堵场所</div>
                <div class="th">客流量</div>
                <div class="th">饱和度</div>
              </div>
              <div class="table-body">
                <div v-for="(item, index) in tableData_1" :key="index" class="table-row"
                  :class="{ 'even': index % 2 === 0 }">
                  <div class="td road-name">{{ item.road }}</div>
                  <div class="td">{{ item.inFlow }}</div>
                  <div class="td">
                    <span class="rate-text" :class="getRateClass(item.inRate)">
                      {{ item.inRate }}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="inOrOut data-box" style="width: 360px;margin-top: 18px;height: 248px;">

          </div> -->

        </div>
      </div>
      <div v-show="typeIndex == 5" class="business-resource-page map-pass-through">
        <div class="business-right-panel business-saturation-panel">
          <div v-if="activeBusinessSaturationItem" class="business-saturation-card data-box"
            :class="{ 'is-danger': activeBusinessSaturationItem.isDanger, 'is-warning': activeBusinessSaturationItem.isWarning }">
            <div class="business-card-head business-saturation-head">
              <div class="business-card-title">饱和度研判</div>
              <button class="business-period-filter">
                {{ activeBusinessSaturationItem.period }}
                <span></span>
              </button>
            </div>
            <div class="business-saturation-tabs">
              <button v-for="(item, index) in businessSaturationList" :key="item.title" type="button"
                :class="{ active: businessSaturationActiveIndex === index }" @click="setBusinessSaturationTab(index)">
                {{ item.tabLabel || item.title.replace('饱和度', '') }}
              </button>
            </div>
            <div class="business-saturation-dashboard">
              <div class="business-saturation-current-title">{{ activeBusinessSaturationItem.title }}</div>
              <div class="business-percent-chart">
                <div class="business-percent-gauge">
                  <svg class="business-percent-gauge-svg" viewBox="0 0 160 94" aria-hidden="true">
                    <path class="business-gauge-bg" d="M20 80 A60 60 0 0 1 140 80" pathLength="100"></path>
                    <path class="business-gauge-value"
                      :class="{ 'is-danger': activeBusinessSaturationItem.isDanger, 'is-warning': activeBusinessSaturationItem.isWarning }"
                      d="M20 80 A60 60 0 0 1 140 80" pathLength="100"
                      :style="getBusinessGaugeValueStyle(activeBusinessSaturationItem)"></path>
                    <line class="business-gauge-needle" :class="{ 'is-danger': activeBusinessSaturationItem.isDanger }"
                      x1="80" y1="68" x2="80" y2="30"
                      :transform="getBusinessGaugeNeedleTransform(activeBusinessSaturationItem)"></line>
                    <circle class="business-gauge-center" cx="80" cy="80" r="5" fill="none"></circle>
                  </svg>
                  <div class="business-gauge-value-text"
                    :class="{ 'is-danger': activeBusinessSaturationItem.isDanger, 'is-warning': activeBusinessSaturationItem.isWarning }">
                    <strong>{{ activeBusinessSaturationItem.value }}</strong><span>%</span>
                  </div>
                </div>
                <div class="business-percent-gauge-meta">
                  <span>当前占比</span>
                  <span>阈值 {{ activeBusinessSaturationItem.threshold }}%</span>
                </div>
              </div>
              <div class="business-saturation-meta">
                <span>阈值 {{ activeBusinessSaturationItem.threshold }}%</span>
                <strong
                  :class="{ 'is-danger': activeBusinessSaturationItem.isDanger, 'is-warning': activeBusinessSaturationItem.isWarning }">{{ activeBusinessSaturationItem.statusText
                  }}</strong>
              </div>
              <div v-if="activeBusinessSaturationItem.isDanger" class="business-threshold-alert">{{
                activeBusinessSaturationItem.alertText }}</div>
            </div>
            <div class="business-advice-box">
              <div class="business-advice-title">资源配置优化建议</div>
              <p v-for="text in activeBusinessSaturationItem.advice" :key="activeBusinessSaturationItem.title + '-' + text">{{ text }}</p>
            </div>
          </div>
        </div>
        <div v-if="businessResourceDisplayList.length" class="business-resource-menu">
          <div class="business-resource-menu-head">
            <div class="business-resource-menu-title">业态资源概况</div>
            <button class="business-resource-label-toggle" type="button" @click="toggleBusinessResourceLabels">
              {{ businessResourceLabelVisible ? '关闭文字' : '显示文字' }}
            </button>
          </div>
          <div class="business-resource-item"
            :id="'business-resource-item-' + (item.id !== undefined ? item.id : item.key)"
            :data-category-id="item.categoryId !== undefined ? item.categoryId : item.id"
            :class="{ active: isBusinessResourceSelected(item) }" v-for="item in businessResourceDisplayList"
            :key="item.key || item.name" @click="handleResourceItemClick(item)">
            <span class="business-resource-name">{{ item.name }}</span>
            <span class="business-resource-count">({{ item.value }})</span>
          </div>
        </div>
        <div v-if="businessPointDetailVisible" class="business-point-detail-card data-box">
          <button class="business-point-detail-close" @click="closeBusinessPointDetail">×</button>
          <div class="business-card-title">点位详情</div>
          <div v-if="businessPointDetailLoading" class="business-point-detail-loading">详情加载中...</div>
          <div v-else-if="businessPointDetailError" class="business-point-detail-error">{{ businessPointDetailError }}
          </div>
          <div v-else class="business-point-detail-body">
            <div class="business-point-detail-name">{{ businessPointDetail.name || '--' }}</div>
            <div class="business-point-detail-row">
              <span>点位ID</span>
              <strong>{{ formatBusinessPointDetailValue(businessPointDetail.id !== undefined ? businessPointDetail.id :
                businessSelectedPointId) }}</strong>
            </div>
            <div class="business-point-detail-row">
              <span>{{ isBusinessHospitalityPointDetail(businessPointDetail) ? '客单价' : '人均消费' }}</span>
              <strong>{{ formatBusinessPointDetailValue(businessPointDetail.avg_consume) }}</strong>
            </div>
            <div class="business-point-detail-row">
              <span>{{ isBusinessHospitalityPointDetail(businessPointDetail) ? '接待量' : '游玩时间' }}</span>
              <strong>{{ formatBusinessPointDetailValue(businessPointDetail.visited_time) }}</strong>
            </div>
            <div class="business-point-detail-row" v-if="isBusinessHospitalityPointDetail(businessPointDetail)">
              <span>经营状态</span>
              <strong>正常</strong>
            </div>
            <div class="business-point-detail-row">
              <span>溢出预警</span>
              <strong class="business-point-detail-overflow" :style="getBusinessPointOverflowStyle(businessPointDetail)">
                {{ getBusinessPointOverflowText(businessPointDetail) }}
              </strong>
            </div>
          </div>
        </div>
        <div class="business-left-panel">
          <div class="business-tool-card data-box">
            <div class="business-card-title">电子围栏管理</div>
            <div class="business-tool-body">
              <div class="business-fence-form">
                <label>
                  <span>围栏名称</span>
                  <input type="text" v-model="businessFenceNameInput" placeholder="请输入电子围栏名称">
                </label>
                <label class="business-fence-coordinate-label">
                  <span>坐标范围</span>
                  <textarea :value="businessFenceCoordinateRangeText" readonly placeholder="选择快捷围栏或绘制区域后显示坐标范围"></textarea>
                </label>
              </div>
              <div class="business-tool-actions">
                <select class="business-fence-shape-select" :value="businessFenceDrawMode"
                  @change="setBusinessFenceDrawMode($event.target.value)">
                  <option v-for="item in businessFenceShapeActions" :key="item.mode" :value="item.mode">
                    {{ item.label }}
                  </option>
                </select>
                <button v-for="item in drawingToolActions" :key="item.action"
                  :class="{ active: businessDrawingToolActive(item.action) }"
                  :disabled="businessDrawingToolDisabled(item.action)" @click="handleDrawingToolAction(item.action)">
                  {{ item.label }}
                </button>
              </div>
              <div class="business-fence-history">
                <div class="business-fence-history-title">快捷电子围栏</div>
                <div class="business-fence-list">
                  <button v-for="item in businessFenceQuickList" :key="item.name" type="button"
                    :class="{ active: item.active }" :title="getBusinessFenceSummary(item)"
                    @click="selectBusinessFence(item)">
                    <span>{{ item.name }}</span>
                    <em v-if="item.deletable" @click.stop="deleteBusinessFence(item)">×</em>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="business-stat-card data-box">
            <div class="business-card-title">实时统计</div>
            <div class="business-stat-list">
              <div class="business-stat-row" v-for="item in businessAreaStats" :key="item.type">
                <div class="business-stat-info">
                  <span>{{ item.type }}</span>
                  <strong>{{ item.count }}</strong>
                </div>
                <div class="business-progress-wrap">
                  <div class="business-stat-progress">
                    <i :class="'business-rank-fill-' + item.loadType" :style="getBusinessRankProgressStyle(item)"></i>
                  </div>
                  <span class="business-progress-tip">{{ item.load }}</span>
                </div>
              </div>
            </div>
            <div class="business-passenger-box">
              <div class="business-passenger-title">客流量</div>
              <div class="business-passenger-meta">
                <span>在园人数：{{ businessPassengerSummary.online }}</span>
              </div>
              <div class="business-rank-row" v-for="(item, index) in businessFlowRanking"
                :key="item.name + '-' + index">
                <span>{{ index + 1 }}</span>
                <strong>{{ item.name }}</strong>
                <em>{{ item.count }}</em>
                <div class="business-progress-wrap">
                  <div class="business-rank-progress">
                    <i :class="'business-rank-fill-' + item.loadType" :style="getBusinessRankProgressStyle(item)"></i>
                  </div>
                  <span class="business-progress-tip">{{ item.percent }}%</span>
                </div>
              </div>
            </div>
            <div class="business-suggestion">
              <div class="business-advice-title">优化建议</div>
              <p v-for="text in businessDiversionAdvice" :key="text">{{ text }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-show="typeIndex == 3" class="sentiment-box">
        <div class="sentiment-left" style="width: 400px;">
          <div class="inOrOut data-box sentiment-stream-card" style="width: 400px;height: 300px;padding: 15px;">
            <div class="right-title">监控流 0000000003</div>
            <div class="sentiment-stream-body">
              <video ref="sentimentVideoOne" class="sentiment-stream-video" controls autoplay muted playsinline></video>
            </div>
          </div>
          <div class="inOrOut data-box sentiment-stream-card"
            style="width: 400px;margin-top: 80px;height: 300px;padding: 15px;">
            <div class="right-title">监控流 0000000005</div>
            <div class="sentiment-stream-body">
              <video ref="sentimentVideoTwo" class="sentiment-stream-video" controls autoplay muted playsinline></video>
            </div>
          </div>
        </div>
        <div class="sentiment-body">
          <div class="body-left  data-box">
            <div class="body-title">
              舆情动态
            </div>
            <div class="list-box">
              <div v-for="(item, index) in tendenciesList" :key="index">
                <div class="list-item" @click="handleDetail(item)">
                  <div class="item-header">
                    <div class="avatar">
                      <img v-if="item.userHead" :src="item.userHead"></img>
                      <div v-else style="background-color: #fff;"></div>
                    </div>
                    <div class="header-content">
                      <div class="header-content-left">
                        <div class="title">{{ item.nickName || item.userName || item.websiteName }}</div>
                        <div class="content">
                          <span>{{ item.createAt }}</span>
                          <span style="margin-left: 5px;">{{ `- 来源:${item.websiteName || '未知'}` }}</span>
                          <span style="margin-left: 5px;">{{ `- IP:${item.ipLocation || '未知'}` }}</span>
                        </div>
                      </div>
                      <div class="header-content-right" @click.stop="toUrl(item.url)">原帖<i
                          class="el-icon-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                  <div class="item-tap" style="padding: 0 13px;">
                    <div style="width: 34px;">标签: </div>
                    <div class="tap-list">
                      <div class="tap" v-for="(tap, index) in taps(item.region)" :key="tap">#{{ tap }}</div>
                    </div>
                  </div>
                  <div class="item-body">
                    <div class="body-text" v-html="highlightText(strictClean(item.content), item.matchKeywords)">
                    </div>
                    <div class="body-images">
                      <div class="images-list" ref="imagesList">
                        <div class="prev" @click.stop="prevImage(index)"
                          v-if="actIndex > 0 && imageList(item.imageUrl).length > 3"><i class="el-icon-arrow-left"></i>
                        </div>
                        <div class="next" @click.stop="nextImage(index)"
                          v-if="actIndex < (imageList(item.imageUrl).length - 3) && imageList(item.imageUrl).length > 3">
                          <i class="el-icon-arrow-right"></i>
                        </div>
                        <div v-if="imageList(item.imageUrl).length > 3" class="img-total">{{ `(${actIndex +
                          1}-${actIndex +
                          3})
                          / ${imageList(item.imageUrl).length}` }}</div>
                        <img referrerPolicy="no-referrer" v-for="(url, index) in imageList(item.imageUrl)" :src="url"
                          :key="index">
                      </div>
                    </div>
                  </div>
                  <div class="item-footer">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-left: 10px;" class="body-right data-box" v-if="isDetail">
            <div class="body-title">
              舆情详情
              <span style="float: right;margin-right: 10px;cursor: pointer;" @click="isDetail = !isDetail">X</span>
            </div>
            <div class="box-right list-item" v-if="tendenciesItem.antduId">
              <div class="right-header">
                <div class="item-header">
                  <div class="avatar">
                    <img v-if="tendenciesItem.userHead" :src="tendenciesItem.userHead"></img>
                    <img v-else style="background-color: #fff;"></img>
                  </div>
                  <div class="header-content">
                    <div class="header-content-left">
                      <div class="title">{{ tendenciesItem.nickName || tendenciesItem.userName ||
                        tendenciesItem.websiteName }}</div>
                      <div class="content">
                        <span>{{ tendenciesItem.createAt }}</span>
                        <span style="margin-left: 5px;">{{ tendenciesItem.websiteName ? `-
                          ${tendenciesItem.websiteName}` :
                          ''
                          }}</span>
                        <span style="margin-left: 5px;">{{ `- IP:${tendenciesItem.ipLocation || '未知'}` }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-body item-body">
                <div class="item-tap">
                  <div style="width: 30px;">标签: </div>
                  <div class="tap-list">
                    <div class="tap" v-for="(tap, index) in taps(tendenciesItem.region)" :key="tap">#{{ tap }}</div>
                  </div>
                </div>
                <div class="right-body-text"
                  v-html="highlightText(imgText(tendenciesItem.content), tendenciesItem.matchKeywords)"></div>
                <div class="right-body-images" v-if="isImg(tendenciesItem.content)">
                  <img referrerPolicy="no-referrer" v-for="(url, index) in imageList(tendenciesItem.imageUrl)"
                    :src="url" :key="index">
                </div>
              </div>
              <div class="item-footer">
              </div>
            </div>
          </div>
          <div style="margin-left: 10px;" class="body-right data-box" v-if="!isDetail">
            <div class="body-title">
              舆情列表
            </div>
            <div class="timeline">
              <div v-for="(value, key, i) in timelineList" :key="key">
                <div class="timeline-date">
                  <div class="date-span">
                    <div class="date-item1"></div>
                  </div>
                  <div class="date">{{ key }}</div>
                </div>
                <div v-for="(item, index) in value" :key="index" class="timeline-item">
                  <div class="timeline-content" style="width:100%">
                    <div class="timeline-span">
                      <div class="span-item1"></div>
                    </div>
                    <div class="timeline-time">{{ item.time }}</div>
                    <div class="timeline-text" @click="toUrl(item.url)">
                      <span style="color: #d6a450;" v-if="item.emotionStr === '负面'">(疑似负面)</span>
                      <span style="color: red;" v-if="item.emotionStr === '差评'">(负面)</span>
                      <span v-html="highlightText(item.title, item.matchKeywords)" style="margin-right: 10px;"></span>
                      <span style="font-size: 14px;color: #b2b2b2;"
                        v-html="highlightText(strictClean(item.content), item.matchKeywords)"></span>
                    </div>
                    <div class="timeline-website">
                      {{ item.websiteName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sentiment-right" style="width: 400px;">
          <div ref="emotion" class="right-top data-box" style="width: 400px;padding: 15px;height: 300px;">

          </div>
          <div ref="hotWeb" class="right-top data-box"
            style="width: 400px;padding: 15px;height: 300px;margin-top: 80px;">

          </div>
        </div>
      </div>
      <div v-show="typeIndex == 6">
        <div class="main_type" v-show="decision_type_index == 0">
          <div class="main-left">
            <div class="cityCome data-box" style="height: 300px;">
              <div class="right-title" style="padding:11px">用户画像</div>
              <div class="pie-flex-box">
                <div id="year_pie_6" class="ota_pie"></div>
                <div id="province_pie_6" class="ota_pie"></div>
                <div id="sex_pie_6" class="ota_pie"></div>
              </div>
              <!-- <div id="inTime_5" class="inTime-chart" style="height: 240px;padding-top: 18px;"></div> -->
            </div>
            <div class="cityCome data-box" style="height: 240px;margin-top:18px;padding-bottom: 10px;">
              <div class="right-title" style="padding:11px">客流过去30天走势</div>
              <div id="touristLine_6" class="inTime-chart" style="margin-top: 30px;"></div>
            </div>
            <div class="cityCome data-box" style="height:320px;margin-top: 18px">
              <div class="left-bottom-title">业态适配情况</div>
              <div class="pie-flex-box">
                <div id="ota_pie_5" class="ota_pie"></div>
                <div id="play_pie_6" class="ota_pie"></div>
              </div>
            </div>
          </div>
          <div class="main-right">
            <div class="right-center data-box" style="height:680px;">
              <div class="left-bottom-title">主力客群分析</div>
              <div class="pie-flex-box">
                <div id="province_pie_6_2" class="ota_pie"></div>
                <div id="year_pie_6_2" class="ota_pie"></div>
              </div>
              <div style="width:280px;height:720px;vertical-align: top;">
                <div class="day_plan_item" style="margin-top:0" @click="orderPlanChange(1)">
                  2026年业态适配建议
                  <img src="../../static/img/chevron_down.png" class="day_plan_item_img"
                    :class="{ 'day_plan_item_img_on': order_plan_index == 1 }" />
                </div>
                <div class="day_plan_text" v-if="order_plan_index == 1">
                  整体县域内业态适配比较均衡，其中：交通成本稍微过大，可适当增加旅游专线；购物占比较小，游客来婺仍以游玩为主，伴手礼、特色非遗类产品打造仍有较大空间。
                </div>
                <div class="day_plan_item" style="margin-top:0" @click="orderPlanChange(2)">
                  2026年动线优化方案
                  <img src="../../static/img/chevron_down.png" class="day_plan_item_img"
                    :class="{ 'day_plan_item_img_on': order_plan_index == 2 }" />
                </div>
                <div class="day_plan_text" v-if="order_plan_index == 2">
                  全面摸排县域所有文旅业态点位、承载容量、配套设施、运营现状，结合门票数据、车流数据、消费数据、游客调研信息，精准划分热门饱和业态、中等平稳业态、冷门闲置业态三类台账。精准定位客流扎堆时段、拥堵点位、闲置薄弱环节，分析游客选择偏差的核心原因（动线单一、宣传不均、交通不便、体验不足等），为动线优化提供精准数据支撑。
                </div>
                <div class="day_plan_item" style="margin-top:0" @click="orderPlanChange(3)">
                  2026年精准营销策略
                  <img src="../../static/img/chevron_down.png" class="day_plan_item_img"
                    :class="{ 'day_plan_item_img_on': order_plan_index == 3 }" />
                </div>
                <div class="day_plan_text" v-if="order_plan_index == 3">
                  坚持以热带冷、串热补冷、动线带货、全域分流的营销总策略，不再单一打造单点网红流量，而是依托全域游览动线，实施“流量再分配、客群再细分、产品再组合、内容再传播”。通过爆款业态引流、小众业态留客、主题线路锁客、场景消费增收，逐步纠正游客选择偏差，实现全域业态流量均衡、体验升级、消费扩容。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="decision_type_index == 1">
          <!-- <ScenicWarning_2 ref="embeddedWarning_2" :embedded="true" /> -->
          <ScenicWarning_3 ref="embeddedWarning"  :embedded="true" />
        </div>
        <div v-show="decision_type_index == 2" class="main_type" style="height: calc(100vh - 80px);overflow: hidden;">
          <div class="main-left" style="height: 100%;">
            <div class="data-box" style="width: 320px;padding:10px;">
              <div class="business-card-title" style="padding:10px">餐饮类型占比</div>
              <div class="ota_pie_box">
                <div id="catering_pie" class="ota_pie"></div>
                <div class="ota_pie_list" style="right:0px;">
                  <div><span class="pie-dot" style="background-color: #5B8FF9;"></span>徽菜：20.18%</div>
                  <div><span class="pie-dot" style="background-color: #5AD8A6;"></span>农家菜：17.52%</div>
                  <div><span class="pie-dot" style="background-color: #5D7092;"></span>米粉面馆：26.51%</div>
                  <div><span class="pie-dot" style="background-color: #F6BD16;"></span>江西菜：31.16%</div>
                  <div><span class="pie-dot" style="background-color: #E86452;"></span>川湘菜：3.59%</div>
                  <div><span class="pie-dot" style="background-color: #6DC8EC;"></span>烤串：1.03%</div>
                </div>
              </div>
            </div>
            <div class="data-box" 
              :class="{ 'is-danger': businessSaturationList[1].isDanger, 'is-warning': businessSaturationList[1].isWarning }">
              <div class="business-card-head" style="padding:10px 10px 0">
                <div class="business-card-title">{{ businessSaturationList[1].title }}</div>
              </div>
              <div class="business-saturation-dashboard">
                <div class="business-gauge-wrap">
                  <svg class="business-gauge-svg" viewBox="0 0 160 94" aria-hidden="true">
                    <path class="business-gauge-bg" d="M20 80 A60 60 0 0 1 140 80" pathLength="100"></path>
                    <path class="business-gauge-value"
                      :class="{ 'is-danger': businessSaturationList[1].isDanger, 'is-warning': businessSaturationList[1].isWarning }"
                      d="M20 80 A60 60 0 0 1 140 80" pathLength="100"
                      :style="getBusinessGaugeValueStyle(businessSaturationList[1])"></path>
                    <line class="business-gauge-needle" :class="{ 'is-danger': businessSaturationList[1].isDanger }"
                      x1="80" y1="68" x2="80" y2="30"
                      :transform="getBusinessGaugeNeedleTransform(businessSaturationList[1])"></line>
                    <circle class="business-gauge-center" cx="80" cy="80" r="5" fill="none"></circle>
                  </svg>
                  <div class="business-gauge-value-text"
                    :class="{ 'is-danger': businessSaturationList[1].isDanger, 'is-warning': businessSaturationList[1].isWarning }">
                    <strong>{{ businessSaturationList[1].value }}</strong><span>%</span>
                  </div>
                </div>
                <div class="business-saturation-meta">
                  <span>阈值 {{ businessSaturationList[1].threshold }}%</span>
                  <strong
                    :class="{ 'is-danger': businessSaturationList[1].isDanger, 'is-warning': businessSaturationList[1].isWarning }">{{
                      businessSaturationList[1].statusText }}</strong>
                </div>
                <div v-if="businessSaturationList[1].isDanger" class="business-threshold-alert">{{
                  businessSaturationList[1].alertText }}</div>
              </div>
              <div class="business-advice-box">
                <div class="business-advice-title">研判建议</div>
                <p v-for="text in businessSaturationList[1].advice" :key="businessSaturationList[1].title + '-' + text">
                  {{
                  text }}</p>
              </div>
            </div>
          </div>
          <div class="main-right">
            <div class="data-box" style="width: 320px;padding:10px;">
              <div style="padding:0 10px 10px;font-size: 15px;">餐饮门店排名(Top20)</div>
              <div class="ranking-list-box">
                <div class="ranking-list-item" v-for="(item, index) in cateringRankingData" :key="'rank-' + index">
                  <span class="ranking-number" :class="'rank-top-' + (index + 1)">{{ index + 1 }}</span>
                  <span class="ranking-name">{{ item.name }}</span>
                  <span class="ranking-score">{{ item.score }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="decision_type_index == 3" class="main_type" style="height:calc(100vh - 40px);">
          <div class="main-left" style="display: flex;flex-direction: column;">
            <div class="data-box" style="width: 360px;padding:10px;flex:1;">
              <div class="business-card-title" style="padding:10px">
                客流未来7天预测
              </div>
              <div id="seven_day" style="width:320px;height:200px;"></div>
            </div>
            <div class="data-box" style="width: 360px;margin-top:15px;padding:0;flex:1;">
              <div class="business-card-title" style="padding:20px">
                风险预警单
              </div>
              <div class="warning-list-box">
                <div class="warning-list-item" v-for="(item, index) in warning_list.slice(0, 2)" :key="'warning-' + index">
                  <span class="warning-list-name">{{ item.name }}</span>
                  <span class="warning-list-level" :class="'level-' + item.level">{{ item.level }}</span>
                  <span class="warning-list-time">{{ item.time }}</span>
                  <span class="warning-list-advice">{{ item.text }}</span>
                </div>
              </div>
            </div>
            <div class="data-box" style="width: 360px;margin-top:15px;padding:10px;flex:1;">
              <div class="business-card-title" style="padding:10px">
                节假日专项预案
              </div>
              <div class="day-plan-container">
                <div class="day-plan-group">
                  <div class="day_plan_item" :class="{ 'day_plan_active': day_plan_index == 1 }" @click="dayPlanChange(1)">
                    <span>春节游客专预案</span>
                    <span class="day_plan_arrow" :class="{ 'day_plan_arrow_on': day_plan_index == 1 }">&#9660;</span>
                  </div>
                  <div class="day_plan_text" v-if="day_plan_index == 1">
                    依托婺源徽州非遗、古村烟火、夜经济三大核心卖点，采用线上全域种草+线下渠道联动+分时票务引导模式，提前分流客流，避免假期集中扎埼，同时撒动跨省家庭游、摄影游、民俗研学游三大客群。
                  </div>
                </div>
                <div class="day-plan-group">
                  <div class="day_plan_item" :class="{ 'day_plan_active': day_plan_index == 2 }" @click="dayPlanChange(2)">
                    <span>劳动节游客专预案</span>
                    <span class="day_plan_arrow" :class="{ 'day_plan_arrow_on': day_plan_index == 2 }">&#9660;</span>
                  </div>
                  <div class="day_plan_text" v-if="day_plan_index == 2">
                    紧扣五一短途踏青、亲子遛娃、山野放松、摄影打卡四大出行需求，区别于春节年味营销，主打「人间四月尽，婺源暮春刚好」春日文旅标签，线上线下双向发力，通过分时票务、差异化产品、小众景点推荐，提前拆分核心景区客流。
                  </div>
                </div>
                <div class="day-plan-group">
                  <div class="day_plan_item" :class="{ 'day_plan_active': day_plan_index == 3 }" @click="dayPlanChange(3)">
                    <span>国庆节游客专预案</span>
                    <span class="day_plan_arrow" :class="{ 'day_plan_arrow_on': day_plan_index == 3 }">&#9660;</span>
                  </div>
                  <div class="day_plan_text" v-if="day_plan_index == 3">
                    紧扣国庆7天长假、全国出游、金秋晒秋、古村秋景、摄影采风核心需求，主打「国庆赴婺源，赴一场秋日晒秋之约」全年王牌文旅主题，面向全国客源地投放宣传，通过分日分时票务、错峰出行指南、全域梯度景区路线，拆分前4天高峰客流，引导游客错峰出行、全域漫游。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 价格监管 -->
      <div v-show="typeIndex == 8" class="main_type map-pass-through price-supervision-page" style="padding-top:15px;">
        <div>
          <div class="main-left price-supervision-left">
            <div class="flex flex_co">
              <div class="data-box price-panel price-trend-panel">
                <div class="price-panel-header">
                  <div class="right-title" style="font-size: 18px;">趋势分析</div>
                </div>
                <div class="price-trend-filters flex flex_w">
                  <div class="price-filter-item"
                    :class="{ 'price-filter-item-active': priceTrendActiveFilter === 'fence' }">
                    <select v-model="priceFenceRegionId" class="price-filter-select" @change="onPriceTrendFenceChange">
                      <option v-for="region in priceFenceRegions" :key="region.id" :value="region.id">
                        {{ region.name }}
                      </option>
                    </select>
                  </div>
                  <div class="price-filter-item"
                    :class="{ 'price-filter-item-active': priceTrendActiveFilter === 'merchant' }">
                    <select v-model="priceTrendMerchantId" class="price-filter-select" @change="onPriceTrendMerchantChange">
                      <option value="">请选择商户</option>
                      <option v-for="hotel in priceTrendMerchantOptions" :key="hotel.hotelId" :value="hotel.hotelId">
                        {{ hotel.hotelName }}
                      </option>
                    </select>
                  </div>
                  <div class="price-filter-item" :class="{ 'price-filter-item-active': priceTrendActiveFilter === 'time' }">
                    <select v-model="priceTrendDayCount" class="price-filter-select" @change="onPriceTrendTimeChange">
                      <option :value="7">前7天</option>
                      <option :value="14">前14天</option>
                    </select>
                  </div>
                </div>
                <div class="price-trend-chart-tip">{{ priceTrendChartTip }}</div>
                <div id="priceFluctuationChart" class="price-fluctuation-chart"></div>
              </div>
              <div v-if="priceMapWarnings.length" class="price-map-alert-board">
                <div class="alert-scroll-container">
                  <!-- 滚动内容层：自动动画 -->
                  <div class="alert-scroll-wrapper">
                    <div v-for="(item, index) in priceMapWarnings" :key="'price-map-alert-' + index"
                      class="price-map-alert-item">
                      <span class="price-map-alert-icon">{{ item.scenic }}</span>
                      <span class="price-map-alert-text">{{ item.text }}</span>
                    </div>
                    <!-- 复制一份用于无缝循环滚动（关键） -->
                    <div v-for="(item, index) in priceMapWarnings" :key="'price-map-alert-copy-' + index"
                      class="price-map-alert-item">
                      <span class="price-map-alert-icon">{{ item.scenic }}</span>
                      <span class="price-map-alert-text">{{ item.text }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="data-box price-panel">
                <div class="price-panel-header">
                  <div class="right-title" style="font-size: 18px;">价格监测列表</div>
                  <div class="price-search-box">
                    <input v-model="priceRoomSearch" type="text" placeholder="输入酒店/民宿" class="price-search-input" />
                  </div>
                </div>
                <div class="price-table-container">
                  <div class="price-table-header accommodation-header">
                    <div class="price-th hotel-col flex flex_c">酒店名称</div>
                    <div class="price-th room-type-col flex flex_c">房型</div>
                    <div class="price-th real-time-price-col flex flex_c">实时价格</div>
                    <div class="price-th history-avg-price-col flex flex_c">历史均价</div>
                    <div class="price-th premium-rate-col flex flex_c">溢价率</div>
                    <div class="price-th price-trend-col flex flex_c">价格趋势</div>
                    <div class="price-th supervision-col flex flex_c">监管提醒</div>
                  </div>
                  <div class="price-table-body accommodation-list-body">
                    <div v-for="(item, index) in filteredAccommodationPriceList" :key="'room-price-' + item.hotelId"
                      class="price-table-row accommodation-hotel-row"
                      :class="getPremiumRateClass(item.premiumRate)"
                      @click="selectAccommodationHotel(item)">
                      <div class="price-td hotel-name" :title="item.hotelName">{{ item.hotelName }}</div>
                      <div class="price-td room-type">{{ item.roomType }}</div>
                      <div class="price-td real-time-price">¥{{ item.realTimePrice }}</div>
                      <div class="price-td history-avg-price">¥{{ item.historyAvgPrice }}</div>
                      <div class="price-td premium-rate" :style="{ color: getPremiumRateColor(item.premiumRate) }">{{ formatPremiumRate(item.premiumRate) }}</div>
                      <div class="price-td price-trend flex flex_c">
                        <img 
                          src="/static/img/zhexiantu1.png" 
                          fit="contain" 
                          style="width: 15px; height: 15px; cursor: pointer;" 
                          @click.stop="openRightTrendPanel(item)"
                        />
                      </div>
                      <div class="price-td supervision">
                        <span
                          class="deal-status-btn"
                          :class="item.dealStatus === 'done' ? 'done' : 'doing'"
                          @click.stop="handleWorkOrder(item, index)"
                        >
                          {{ item.dealStatus === 'done' ? '已处置' : '跟进' }}
                        </span>
                      </div>
                    </div>
                    <div v-if="!filteredAccommodationPriceList.length" class="price-table-empty">未找到匹配的酒店</div>
                  </div>
                </div>
              </div>
              <div class="data-box price-panel price-trend-panel">
                <div class="right-title flex flex_co" style="font-size: 18px;">
                  投诉联动
                  <span v-if="activeAccommodationHotel" class="price-selected-hotel-tag">{{
                    activeAccommodationHotel.hotelName }}</span>
                </div>
                <div class="complaint-linkage-box">
                <!-- 投诉表格 -->
                <table class="complaint-table" v-if="activeHotelComplaintList.length > 0">
                  <thead>
                    <tr>
                      <th width="60">数量</th>
                      <th width="80">投诉分类</th>
                      <th>投诉摘要内容</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in activeHotelComplaintList" :key="index">
                      <td v-if="index === 0" :rowspan="activeHotelComplaintList.length">
                        {{ activeHotelComplaintCount.toLocaleString() }}
                      </td>
                      <td>{{ item.type }}</td>
                      <td>{{ formatComplaintContent(item.content, index) }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="price-table-empty">该民宿暂无投诉记录</div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="typeIndex == 7" class="main_type map-pass-through"  style="padding: 15px 54px 0 15px;">
        <div class="main-left">
          <div class="cityCome data-box" style="height: 270px;">
            <div class="left-bottom-title">多维画像</div>
            <div class="gender flex">
              <div id="sex_7" class="gender-column" style="height: 200px;width: 120px;"></div>
              <div id="gender_7" class="gender-column" style="height: 200px;width: 200px;"></div>
            </div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px;">
            <div class="left-bottom-title">人车出行比例</div>
            <div class="gender" style="height:200px;">
              <div id="travel_pie" class="gender-column" style="height:200px;width:100%;"></div>
            </div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px;height: 310px;">
            <div class="left-bottom-title">
              客源分析(层级下钻)：{{ level_value == 1 ? '省级' : (level_value == 2 ? '市级' : '县级') }}
              <div class="last-level" v-if="level_value > 1" @click="lastLevel">
              《 返回上一级</div>
            </div>
            <div id="level_pie" class="ota_pie" style="height:240px;width: 300px;"></div>
          </div>
        </div>
        <div class="main-right">
          <div class="right-top data-box" style="height: auto;min-height: 350px;">
            <div class="left-bottom-title">景区对比</div>
            <div class="comparison-select-row">
              <div class="comparison-select-box">
                <select class="comparison-select" v-model="comparison_1" @change="comparisonChange_1">
                  <option value="" disabled selected>请选择景区</option>
                  <option value="婺女洲">婺女洲</option>
                  <option value="篁岭">篁岭</option>
                  <option value="江湾">江湾</option>
                  <option value="江岭">江岭</option>
                  <option value="李坑">李坑</option>
                  <option value="月亮湾">月亮湾</option>
                  <option value="卧龙谷">卧龙谷</option>
                  <option value="弦高古城">弦高古城</option>
                </select>
              </div>
              <span class="comparison-vs">VS</span>
              <div class="comparison-select-box">
                <select class="comparison-select" v-model="comparison_2" @change="comparisonChange_2">
                  <option value="" disabled selected>请选择景区</option>
                  <option value="婺女洲">婺女洲</option>
                  <option value="篁岭">篁岭</option>
                  <option value="江湾">江湾</option>
                  <option value="江岭">江岭</option>
                  <option value="李坑">李坑</option>
                  <option value="月亮湾">月亮湾</option>
                  <option value="卧龙谷">卧龙谷</option>
                  <option value="弦高古城">弦高古城</option>
                </select>
              </div>
            </div>
            <div class="comparison-type-tabs">
              <div class="comparison-tab-item" :class="{ 'comparison-tab-active': comparison_type_index == item.value }"
                v-for="(item, index) in comparison_type_list" :key="index" @click="changeComparisonType(item.value)">
                {{ item.text }}
              </div>
            </div>
            <div class="comparison-chart-area" v-show="comparison_1 && comparison_2">
              <div class="comparison-chart-box">
                <div class="comparison-chart-label">{{ comparison_1 || 'A' }}</div>
                <div id="comparison_pie_1" class="comparison-chart" style="height:240px;"></div>
              </div>
              <div class="comparison-chart-box">
                <div class="comparison-chart-label">{{ comparison_2 || 'B' }}</div>
                <div id="comparison_pie_2" class="comparison-chart" style="height:240px;"></div>
              </div>
            </div>
          </div>
            <div class="data-box">
              <div class="left-bottom-title">营销策略调整</div>
              <div class="tour-customer-wrap">
              <!-- 固定高度滚动容器 -->
              <div class="scroll-box">
                <div class="block-item">
                  <h3 class="title">核心客群：省内地缘客群</h3>
                  <p class="desc">
                    客群画像：江西本省游客构成婺源最大客源底盘，以南昌、上饶、九江等周边城市为主，出游频次高，以周末短途度假、亲子出行、银发康养为主要诉求，对价格敏感，倾向于1-2日游。
                  </p>
                  <div class="point-wrap">
                    <h4 class="sub-title">策略要点：</h4>
                    <ul class="point-list">
                      <li>
                        <span class="label">产品端：</span>推出“周末微度假”产品包，含乡村游+民宿+农家宴打包优惠；打造亲子农事体验产品，如油菜花田科普、采茶制茶、晒秋手工等，满足家庭出行主理人——即80后、90后女性的决策需求。针对银发群体，策划“慢游康养”产品，结合中医药膳、田园晨练、古村落徒步等。
                      </li>
                      <li>
                        <span class="label">渠道端：</span>深耕本省社交媒体矩阵，以抖音同城榜、小红书区域种草为主阵地，联合江西本土达人进行内容共创；持续联动“村超”“村BA”等体育赛事IP，开发“看村超·游婺源·品乡味”主题线路，吸引体育旅游人群。
                      </li>
                      <li>
                        <span class="label">传播端：</span>以“说走就走的徽州后花园”为核心传播主题，强化“高铁1小时可达”的交通便利性认知，配合季节性油菜花、晒秋等视觉冲击力强的画面进行情感触达。
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="block-item">
                  <h3 class="title">潜力客群：长三角客群</h3>
                  <p class="desc">
                    客群画像：上海、浙江、江苏构成婺源第二大外省客源市场，以中高收入白领、亲子家庭为主，注重品质与服务，客单价高于省内地缘客群。2025年婺源接待游客数同比增长近三成，长三角贡献显著增量。
                  </p>
                  <div class="point-wrap">
                    <h4 class="sub-title">策略要点：</h4>
                    <ul class="point-list">
                      <li>
                        <span class="label">产品端：</span>推出“慢行徽州·乡居度假”高端产品线，组合茶旅融合体验（绿茶品鉴+民宿茶艺师服务）、非遗手工体验（甲路纸伞制作、歙砚雕刻）、夜游产品（婺女洲灯光秀、梦里老家实景演出）。针对亲子家庭，开发“跟着课本游徽州”研学产品，以朱熹文化、婺源三雕为载体。
                      </li>
                      <li>
                        <span class="label">渠道端：</span>在上海、杭州、南京等长三角核心城市地铁站及高铁站加大文旅品牌广告投放，在携程、同程等OTA平台面向长三角定向推送婺源产品。联合OTA探索“上饶文旅星球号”旗舰店模式，形成线上线下营销闭环。在长三角大型社区组织下沉式推介活动，贴近社区白领及家庭客群。
                      </li>
                      <li>
                        <span class="label">传播端：</span>以“中国最美乡村·长三角慢生活后花园”为传播主题，突出高品质乡村度假定位，强化“高铁3小时通达”的交通便利性，联合携程等平台定向发放文旅消费券。
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="block-item">
                  <h3 class="title">机会客群：华北与华南远途客群（北京、广东）</h3>
                  <p class="desc">
                    客群画像：北京、广东游客以长线旅行为主，出行计划性强，停留时间约3-5天，多为年度/季度出游，倾向于深度体验、高品质住宿与定制服务。广东游客对美食关注度高于其他省份，北京游客对历史文化与古建资源兴趣更浓。
                  </p>
                  <div class="point-wrap">
                    <h4 class="sub-title">策略要点：</h4>
                    <ul class="point-list">
                      <li>
                        <span class="label">产品端：</span>针对北京客群，开发“徽文化深度探访”产品，聚焦婺源三雕、晒秋民俗、徽派古建等在地文化，推出专家导览+沉浸式体验。针对广东客群，推出“寻味徽州·美食之旅”产品，串联徽菜品鉴、酒糟鱼制作体验、婺源绿茶品茗等美食主题行程。两类客群均需搭配高品质住宿（五星级婺源鑫邦大酒店或高端民宿集群）。
                      </li>
                      <li>
                        <span class="label">渠道端：</span>联合中央媒体（如央视、人民网）及头部旅游KOL进行品牌露出，在广深线、京沪线高铁车厢/航司机舱杂志投放婺源文旅广告。与广之旅、中青旅等大型旅行社合作推出定制小团产品。
                      </li>
                      <li>
                        <span class="label">传播端：</span>以“四季皆可婺源”为核心理念，打破“婺源只有油菜花季”的季节性认知，重点推介秋季晒秋、夏季避暑、冬季徽州年俗等四季产品。结合“2025亚洲100目的地”等国际荣誉进行权威背书，提升高端客群信任度。
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="block-item">
                  <h3 class="title">机会客群：安徽客群（徽文化同源客群）</h3>
                  <p class="desc">
                    客群画像：安徽（尤其是黄山、宣城）与婺源同属古徽州文化圈，文化认同度高，以寻找乡愁记忆、文化寻根、家庭出游为主要诉求，对古村落、徽派建筑、徽商文化等有天然的亲近感。徽文化爱好者和高端文化体验者是这一客群中的高价值人群。
                  </p>
                  <div class="point-wrap">
                    <h4 class="sub-title">策略要点：</h4>
                    <ul class="point-list">
                      <li>
                        <span class="label">产品端：</span>联合安徽黄山共同打造“徽州文化深度之旅”跨省产品线，串联婺源篁岭、江湾与黄山宏村、西递等徽派古村落，推出“一程游两省”的长线产品。在婺源景区内深度植入“徽剧徽腔”“徽商角色扮演剧本游”等沉浸式体验，满足徽文化爱好者的深度体验需求。开发“古建鉴赏+非遗传承”主题产品，吸引对徽派三雕、歙砚文化有浓厚兴趣的高端客群。
                      </li>
                      <li>
                        <span class="label">渠道端：</span>在安徽黄山、合肥等核心城市的高铁站、机场投放婺源文旅广告，利用“95联盟大道”等区域旅游通道进行联合推广。联合安徽主流媒体及区域KOL进行徽文化主题内容共创。
                      </li>
                      <li>
                        <span class="label">传播端：</span>以“同源徽州·异彩婺源”为传播主题，突出婺源作为“徽文化在江西的活态传承地”的独特定位，强调在徽文化大背景下婺源的差异化特色（如晒秋民俗、油菜花田）。借势“江西晒秋&皖南赏秋”等跨省联动营销活动，打造“一程两省、文化同源”的品牌认知。
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="block-item full-bg">
                  <h3 class="title">全域贯穿策略：女性游客专项营销</h3>
                  <p class="desc">
                    鉴于女性用户比男性高15个百分点，上述所有客群策略需贯穿以下女性专项设计：
                  </p>
                  <ul class="point-list">
                    <li>
                      <span class="label">产品设计：</span>在住宿端，在高端民宿和酒店推行女性友好设施（安全门禁、女性专属楼层、经期用品提供、卸妆用品等），提升女性住客安全感与体验感。在体验端，推广“晒娘服”“古风旅拍”等IP，联合知名摄影师推出定制旅拍服务，满足女性“能玩能出片”的核心诉求，同时延长游客停留时间。
                    </li>
                    <li>
                      <span class="label">传播触达：</span>文旅营销内容的情感触达要多采用画面感强的视觉素材，瞄准女性游客作为家庭旅游决策主理人的角色定位，策划“带父母去婺源”“带孩子去古村过暑假”等情感化传播主题，让女性游客成为家庭出游的发起者和组织者。
                    </li>
                    <li>
                      <span class="label">AI赋能：</span>在小红书、抖音等女性高频使用的社交平台推出AI行程规划助手，围绕“小众独特”“沉浸式体验”等女性高频搜索关键词进行内容优化。联合去哪儿、同程旅行等平台，优化女性用户的行程咨询体验。
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 自定义弹窗 -->
      <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
          <div class="modal-header">
            <span>{{ videoTitle || '视频播放' }}</span>
            <button class="close-btn" @click="closeModal">×</button>
          </div>
          <div class="modal-body">
            <video :key="videoElementKey" ref="videoElement" controls width="100%"></video>
          </div>
        </div>
      </div>
      <!-- 价格预警弹窗 -->
      <div v-if="showPriceWarningModal" class="modal-overlay price-warning-modal-overlay"
        @click.self="closePriceWarningModal">
        <div class="modal-content price-warning-modal-content">
          <div class="modal-header price-warning-modal-header">
            <span>{{ priceWarningModalTitle }}</span>
            <button class="close-btn price-warning-close-btn" @click="closePriceWarningModal">×</button>
          </div>
          <div class="modal-body price-warning-modal-body">
            <div class="price-warning-modal-subtitle">{{ priceWarningModalSubtitle }}</div>
            <div class="price-warning-modal-tip">近5日价格波动（不含当日）</div>
            <div id="priceWarningModalChart" class="price-warning-modal-chart"></div>
          </div>
        </div>
      </div>
      <!-- 方案展示弹窗 -->
      <div v-if="showPlanModal" class="plan-modal-box">
        <div class="plan-modal-title" v-if="plan_modal_type == 1">
          动线优化方案
          <img src="/static/img/tips_close.png" class="plan-modal-close" @click="showPlanModal = false" />
        </div>
        <div class="plan-modal-title" v-if="plan_modal_type == 2">
          精准营销策略
          <img src="/static/img/tips_close.png" class="plan-modal-close" @click="showPlanModal = false" />
        </div>
        <div style="color: #111;margin: 6px">
          发布日期：2026-06-02
        </div>
        <div v-html="planContent_1" class="rich-text-content" v-if="plan_modal_type == 1"></div>
        <div v-html="planContent_2" class="rich-text-content" v-if="plan_modal_type == 2"></div>
      </div>
      <!-- 工单处置确认弹窗 -->
      <div v-show="showDealModal" class="deal-modal-overlay" @click.self="closeDealModal">
        <div class="deal-modal-content">
          <div class="deal-modal-header">
            <div class="deal-modal-title">处理结果</div>
            <button class="deal-modal-close" @click="closeDealModal">×</button>
          </div>
          <div class="deal-modal-body">
            <div class="deal-modal-tip">是否确认完结该预警工单？</div>
          </div>
          <div class="deal-modal-footer">
            <button class="deal-btn cancel" @click="closeDealModal">取消</button>
            <button class="deal-btn confirm" @click="confirmDealWorkOrder">确认完结</button>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import CountFlop from '../components/CountFlop/CountFlop.vue'
import ScenicWarning from './ScenicWarning.vue'
import ScenicWarning_2 from './ScenicWarning_2.vue'
import ScenicWarning_3 from './ScenicWarning_3.vue'
import SentimentSurveillance from './sentiment-surveillance.vue'
import videoSurveillance from './video-surveillance.vue'
import System from './system.vue'
import User from './user.vue'
import Role from './role.vue'
import Log from './log.vue'

import store from '@/store/index'
import planContent_1 from '@/utils/plan_html_1.json'
import planContent_2 from '@/utils/plan_html_2.json'
import {
  getSettingByIdApi, planeFigure, ticketNumberStatistics,
  realTimeTraffic, currentTrafficTrend, originList,
  realTouristsData, historyTouristsData, genderScheduleData,
  weatherData, weatherDataNew, getDataCustomerSourceMarketApi, getDataMainSourceMarketApi,
  getAnalysisMonthApi, getTradingNumApi, getTouristAgencyType,
  getSalesNumApi, xcxGetHotelDataApi, getMerchantOrder,
  getMerchantOrderList, getBigDataOfflineRetailInfo, salesComparisonApi,
  getDataRepurchaseAnalysisApi, getWaitingInApi, xcxGetDeliciousFoodDataApi,
  getCoefficientDataSettingApi, getMapResourceApi, getMapPointListApi, getMapPointDetailApi
} from '../api/ScenicAPI'
import {
  realTouristsWYData, visitorTrendData, scenicRankingData,
  todayVisitorsData, userPortraitData, visitorSourceData,
  channelAnalysisData, visitorRatioData, scenicHourlyData
} from '../api/wuyuanApi'
import {
  getIotScenicHistoryData, getIotScenicVillageRealData, getIotScenicVillageTrend, iotSettingData,
} from '../api/ScenicIotApi'
import {
  get_subscribe_info_list, get_dynamic_subscribe_info_list, get_dynamic_subscribe_info_detail,
  get_subscribe_time_trend
} from '../api/sentiment'

import echarts from 'echarts'
import { parseTime, debounce, createXfyunSpeechRecognizer, XfyunSpeechRecognizer } from '@/utils/index'
import { VOICE_PENDING_ACTION_KEY, VOICE_RECOGNITION_EOS_MS, VOICE_STATUS_HIDE_MS, findVoiceCommandMatch } from '@/utils/voiceCommandConfig'
import { accommodationPriceList, priceSupervisionWorkOrders, PRICE_FENCE_REGIONS, filterHotelsByFenceRegion, getPriceFenceRegionById, generatePriceTrendByRegion, generatePriceTrendByHotel } from '@/utils/priceSupervisionData.js'
var arcData = [];
var heatData = []
var SENTIMENT_STREAM_URLS = [
  'http://121.40.47.136:50080/video/0402b05801a098b1/0000000003.flv',
  'http://121.40.47.136:50080/video/0402b05801a098b1/0000000005.flv'
]
var DEFAULT_MONITOR_STREAM_URL = 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000005.flv'
const VOICE_VIDEO_STREAM_LIST = [
  {
    name: '区域A大门入口',
    aliases: ['区域A', 'A区', 'a区', '区域一', '一区', '大门入口', '入口区域'],
    url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000003.flv'
  },
  {
    name: '区域B中心广场',
    aliases: ['区域B', 'B区', 'b区', '区域二', '二区', '中心广场', '商业区'],
    url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000005.flv'
  },
  {
    name: '月亮湾月亮之门',
    aliases: ['月亮湾月亮之门', '月亮湾'],
    url: 'http://121.40.47.136:50080/video/0402b05801a09731/0000000006.flv'
  },
  {
    name: '篁岭晒秋平台',
    aliases: ['篁岭晒秋平台', '晒秋平台'],
    url: DEFAULT_MONITOR_STREAM_URL
  },
  {
    name: '篁岭游客中心',
    aliases: ['篁岭游客中心', '游客中心'],
    url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000003.flv'
  }
]
const VOICE_METRIC_QUERY_LIST = [
  {
    key: 'todayEntry',
    title: '今日累计入园人数',
    unit: '人',
    targetTypeIndex: 0,
    aliases: ['今日累计入园人数', '今日入园人数', '今日入园', '累计入园人数', '累计入园', '入园人数']
  },
  {
    key: 'currentInPark',
    title: '当前在园游客',
    unit: '人',
    targetTypeIndex: 0,
    aliases: ['当前在园游客', '当前在园人数', '在园游客', '在园人数']
  },
  {
    key: 'todayOut',
    title: '今日出园游客总量',
    unit: '人',
    targetTypeIndex: 0,
    aliases: ['今日出园游客总量', '今日出园人数', '出园游客', '出园人数']
  },
  {
    key: 'yearTourists',
    title: '全年游客总量',
    unit: '人',
    targetTypeIndex: 0,
    aliases: ['全年游客总量', '全年游客', '年度游客总量', '年游客总量']
  },
  {
    key: 'todayTraffic',
    title: '今日全县客流总量',
    unit: '人',
    targetTypeIndex: 0,
    aliases: ['今日全县客流总量', '全县客流总量', '今日客流总量', '客流总量']
  }
]
const VOICE_PAGE_TARGET_LIST = [
  { label: '大数据首页', typeIndex: 0, aliases: ['大数据首页', '首页', '文旅市场', '大屏首页'] },
  { label: '客流分析', typeIndex: 1, aliases: ['客流分析', '游客分析', '客流页面'] },
  { label: '大数据驾驶舱', typeIndex: 2, aliases: ['大数据驾驶舱', '驾驶舱', '数据驾驶舱'] },
  { label: '客流预警', typeIndex: 4, aliases: ['客流预警', '预警页', '预警页面', '交通预警', '住宿预警'] },
  { label: '业态资源统筹', typeIndex: 5, aliases: ['业态资源统筹', '业态资源', '业态资源页', '业态资源页面', '承载力监测', '承载力'] },
  { label: '数据决策中心', typeIndex: 6, aliases: ['数据决策中心', '决策中心', '决策分析', '数据决策', '研判中心'] },
  { label: '客群画像分析', typeIndex: 7, aliases: ['客群画像分析', '客群画像', '画像分析', '游客画像'] },
  { label: '价格动态监管', typeIndex: 8, aliases: ['价格动态监管', '价格监管', '价格监管页', '价格监管页面', '价格动态'] },
  { label: '全网舆情监测', typeIndex: 9, aliases: ['全网舆情监测', '舆情监测', '舆情分析', '全网舆情', '舆情页面'] },
  { label: '视频监测管理', typeIndex: 10, aliases: ['视频监测管理', '视频监控管理', '视频监测', '视频监控', '监控管理'] },
  { label: '系统管理', typeIndex: 11, aliases: ['系统管理', '系统设置'] },
  { label: '用户管理', typeIndex: 12, aliases: ['用户管理', '用户页面'] },
  { label: '角色配置', typeIndex: 13, aliases: ['角色配置', '角色管理', '权限角色'] },
  { label: '系统日志', typeIndex: 14, aliases: ['系统日志', '日志', '日志页面'] }
]
const WUYUAN_CENTER = {
  lat: 29.254015,
  lng: 117.861488
}
const WUYUAN_HEAT_POINTS = [
  { name: '婺女洲', lat: 29.248238, lng: 117.890132, count: 92 },
  { name: '月亮湾', lat: 29.326918, lng: 117.946742, count: 76 },
  { name: '李坑', lat: 29.336004, lng: 117.959221, count: 84 },
  { name: '汪口', lat: 29.316551, lng: 118.015337, count: 68 },
  { name: '江湾', lat: 29.408924, lng: 118.036428, count: 95 },
  { name: '晓起', lat: 29.422785, lng: 118.066138, count: 62 },
  { name: '篁岭', lat: 29.361509, lng: 117.996186, count: 98 },
  { name: '思溪延村', lat: 29.359347, lng: 117.801713, count: 58 },
  { name: '灵岩洞', lat: 29.270215, lng: 117.708824, count: 46 },
  { name: '卧龙谷', lat: 29.479124, lng: 117.773842, count: 52 },
  { name: '严田古樟', lat: 29.314671, lng: 117.737193, count: 40 },
  { name: '彩虹桥', lat: 29.338845, lng: 117.622175, count: 44 }
]
const WUYUAN_BOUNDARY_LOCAL_URL = process.env.NODE_ENV === 'production'
  ? '/static/big_data_web/geo/361130.json'
  : '/static/geo/361130.json'
const WUYUAN_BOUNDARY_REMOTE_URL = 'https://geo.datav.aliyun.com/areas_v3/bound/361130.json'
const WUYUAN_BOUNDARY_URLS = [WUYUAN_BOUNDARY_LOCAL_URL, WUYUAN_BOUNDARY_REMOTE_URL]
const WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO = 0.38
const WUYUAN_VIEW_VERTICAL_PADDING_RATIO = 0.18
const WUYUAN_MAP_MIN_ZOOM = 11.2
const WUYUAN_FALLBACK_BOUNDS = {
  minLat: 29.01,
  maxLat: 29.59,
  minLng: 117.36,
  maxLng: 118.22
}
const PRICE_SUPERVISION_TYPE_INDEX = 8
const BUSINESS_FENCE_STORAGE_KEY = 'wy_business_fence_history'
const QIANJING_SERVICE_ORIGIN = 'https://qianjing.dev.ioing.uk:8443'
const LOCATION_ICON_URL = process.env.NODE_ENV === 'production'
  ? '/static/big_data_web/img/location_icon.png'
  : '/static/img/location_icon.png'
const BUSINESS_FENCE_POINT_ICON_URL = 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2214%22%20viewBox%3D%220%200%2014%2014%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Ccircle%20cx%3D%227%22%20cy%3D%227%22%20r%3D%226%22%20fill%3D%22%238fffff%22/%3E%3C/svg%3E'
const SCENIC_4A_RESOURCE_KEY = 'scenic_4a'
const BUSINESS_ACCOMMODATION_OPTIMIZATION_ADVICE = [
  '空间上“错位布局”\n构建“臻品民宿为引领、精品民宿为主体、大众民宿为补充”的住宿格局。东线篁岭等热点景区周边着重发展高端度假与古宅民宿集群；北线清华、虹关等古村落依托田园风光，主推文化主题精品“宿集”；县城则重点升级商务型酒店与主题客栈，承接政务接待与高铁客流分流需求。',
  '产品上“增值体验”\n依托全国甲级、乙级旅游民宿标准，对投资额度达到相应要求的精品、臻品民宿给予12万元或8万元装修补贴，鼓励配备地暖、智能家电、品牌卫浴与专职管家等设施，实现“外看五百年、内享五星级”的居住体验。同时，实施“一宿一品”工程，扶持40余家精品民宿引入歙砚制作、甲路纸伞、徽墨文化等非遗项目，开发11条非遗主题线路与120余种文创产品，有效提升民宿文化附加值。',
  '管理上“降本赋能”\n依托“宿小二”平台，整合布草洗涤、采购、培训等20余项供应链服务，助民宿主体经营成本下降30%—40%、融资成本下降45%、资源配置效率提升80%。同步推广“党建+人才”机制，每年向民宿基地输送实习生120余名，储备厨师、维修、保洁等各类人才200余人，并定期开展咖啡调制、徽菜烹饪等技能培训，有效缓解淡旺季用工矛盾。'
]
const BUSINESS_CATERING_OPTIMIZATION_ADVICE = [
  '空间上“分级布局”\n构建“县城为枢纽、景区为重点、村落为特色”的三级餐饮体系。县城重点培育特色美食街区与创意餐厅，提升接待能力；东线篁岭、江湾等热门景区打造主题餐饮与体验式宴演（如“江湾宴遇”节气主题餐秀）；北线清华、浙源等古村落结合非遗豆腐、徽菜等传统资源，培育田园餐厅与康养膳食业态，实现差异化供给。支持和引导主题餐厅、创意餐厅及各类休闲餐饮店建设，不断提升“吃”的吸引力。',
  '产品上“提质增值”\n大力培育和推广“婺风山珍”“婺风食记”特色美食系列，依托“一叶两花、一蜜两鱼、中药材、米酒”产业体系，推动荷包红鲤、米酒、蜂蜜、汽糕、粉蒸肉等非遗美食标准化生产与品牌化运营，建立近百道特色美食数字化档案库。对中高端餐饮项目给予加盟费补助（最高100万元）及装修补贴（最高60万元），引导餐饮企业提升服务品质。同步开发节气文化宴演、美食+非遗、茶宴等沉浸式餐饮体验项目，以“一道菜·一节令·一仪式”重塑婺源美食文化品牌。',
  '管理上“规范赋能”\n加强全域餐饮服务及卫生管理，完善现有酒店、餐馆、农家乐等设施，推广“互联网+AI监管”智慧食安模式，强化明码标价与投诉快反机制，严打价格欺诈、“双菜单”等突出问题。整合本地餐饮商户资源，建立数字化餐饮数据库，与线上外卖平台深度合作，利用“桃溪兄弟”等本土网红达人进行短视频场景化推广，深化立体化宣传传播效应，实现从“景点婺源”到“场景婺源”的餐饮消费升级'
]
const BUSINESS_ENTERTAINMENT_OPTIMIZATION_ADVICE = [
  '空间上"错位布局"\n构建"县城夜游集聚、东线体验多元、北线古村活化"的互娱业态格局。县城重点壮大婺女洲、弦高城等夜间经济集聚区，拓展光影秀、夜游演艺等场景，形成"白天景区游、晚上城里住"的新模式。篁岭、江湾等热门景区周边应丰富沉浸式演艺（如烟火江湾·宴遇人生）和亲子互动体验项目，增强夜游消费黏性；北线古村落依托自然与非遗资源，深挖徽墨制作、茶文化研学、古建夜探等深度体验业态，引导客人从"走马观花"向"寓教于乐"转变，延长逗留时间，实现民宿"睡一晚就走"到"深度度假"的转变。',
  '产品上"增值体验"\n支持农业观光园与精品民宿、非遗工坊联动，推出"农事体验+匠心手作+夜游演艺"的联票产品和组合玩法。将茶叶采摘、田园小火车等简单项目升级为创意互动，串联出篁岭晒秋、油菜花海、甲路伞制作、花灯巡游等亮点，开发"亲子研学""闺蜜旅拍""银发康养"等细分产品矩阵，增强游客全时参与度。丰富夜间经济的互动品类，建设含文创市集、小酒馆、露营地、团建KTV包厢等新潮娱乐体验场景。引导具备条件的休闲农场和田园综合体叠加“食宿游购娱”闭环，推动一产到三产融合增值，不断提升“玩”的丰富性与客单价。',
  '管理上“规范赋能”\n加强各经营主体的资质审核与安全监管，推广行业服务标准和安全规范，尤其在采摘园、网红打卡地和夜游场景中强化卫生、价格、设施维护等常态化抽查。依托"宿小二"等平台，统筹娱乐类商户的布草洗涤、数字营销、人才培训、个性化托管运营等公共服务，降低小业主成本，提升淡旺季服务品质。积极探索"互联网＋互娱资源"智能化融合，加强实时客流预警与应急疏导，防范节假日瞬时客流拥堵。整合散落的采摘园、农家乐、非遗工坊等体验线索，通过大V种草和购票App、地方文旅官方渠道推出线上预约与"一程多站"导引，实现"资源联动、客流共享、品牌共塑"的互娱消费闭环'
]
const SCENIC_4A_SPOTS = [
  { id: 'scenic4a-1', name: '大鄣山卧龙谷景区', lng: 117.756709, lat: 29.485153 },
  { id: 'scenic4a-2', name: '灵岩洞景区', lng: 117.611753, lat: 29.47278 },
  { id: 'scenic4a-3', name: '文公山景区', lng: 117.747754, lat: 29.161558 },
  { id: 'scenic4a-4', name: '鸳鸯湖景区', lng: 117.51886, lat: 29.319423 },
  { id: 'scenic4a-5', name: '李坑景区', lng: 117.928314, lat: 29.325495 },
  { id: 'scenic4a-6', name: '思溪延村景区', lng: 117.788217, lat: 29.34055 },
  { id: 'scenic4a-7', name: '汪口景区', lng: 117.99147, lat: 29.350091 },
  { id: 'scenic4a-8', name: '严田景区', lng: 117.635814, lat: 29.366016 },
  { id: 'scenic4a-9', name: '五龙源景区', lng: 118.02027, lat: 29.492432 },
  { id: 'scenic4a-10', name: '熹园景区', lng: 117.852147, lat: 29.253135 },
  { id: 'scenic4a-11', name: '翼天文化旅游城', lng: 117.837654, lat: 29.206087 },
  { id: 'scenic4a-12', name: '源头古村景区', lng: 117.607083, lat: 29.396537 }
]

function fetchJson(url) {
  if (typeof window !== 'undefined' && window.fetch) {
    return window.fetch(url).then(response => {
      if (!response.ok) {
        throw new Error('边界数据请求失败(' + response.status + '): ' + url)
      }
      return response.json()
    })
  }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) {
        return
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          resolve(JSON.parse(xhr.responseText))
        } catch (error) {
          reject(error)
        }
      } else {
        reject(new Error('边界数据请求失败(' + xhr.status + '): ' + url))
      }
    }
    xhr.onerror = function () {
      reject(new Error('边界数据请求失败: ' + url))
    }
    xhr.send()
  })
}

function fetchJsonWithFallback(urls) {
  const sourceList = Array.isArray(urls) ? urls.filter(Boolean) : []
  let currentIndex = 0
  let lastError = null

  const tryNext = () => {
    if (currentIndex >= sourceList.length) {
      return Promise.reject(lastError || new Error('边界数据请求失败'))
    }
    const currentUrl = sourceList[currentIndex++]
    return fetchJson(currentUrl).catch(error => {
      lastError = error
      return tryNext()
    })
  }

  return tryNext()
}
export default {
  components: {
    CountFlop,
    ScenicWarning,
    ScenicWarning_2,
    ScenicWarning_3,
    SentimentSurveillance,
    videoSurveillance,
    System,
    User,
    Role,
    Log,
  },
  data() {
    return {
      planContent_1: planContent_1.planContent,
      planContent_2: planContent_2.planContent,
      geoCoordMap: {}, //  全国省份。  也不能叫全省吧。 就是所有数据要展示的经纬度。
      navCollapsed: true,
      type_item: [
        { label: '大数据首页', value: 0 },
        { label: '价格动态监管', value: PRICE_SUPERVISION_TYPE_INDEX },
        {label: '全网舆情监测', value: 9},
        { label: '业态资源统筹', value: 5 },
        {label: '视频监测管理', value: 10},
        {label: '承载力监测', value: 5},
        {label: '用户管理', value: 12},
        {label: '角色配置', value: 13},
        {label: '系统日志', value: 14},
      //   { label: '大数据驾驶舱', value: 2 },
      //   { label: '客流预警', value: 4 },
      // { label: '客流分析', value: 1 },
        
        // {label: '系统管理', value: 11},
        
      ],
      // ,"营收分析"
      typeIndex: 0,
      yearSum: [],
      carSum: [],
      dateSum: [],
      dateInSum: [],
      dateOutSum: [],
      crowding: '',//在园游客饱和度
      ticket_of_data: '',//当日售票占比
      mouth_tourists_num: '',//本月游客
      yesterday_tourists_num: '',//昨日游客
      last_mouth_tourists_num: '',//上月游客
      last_years_tourists_num: '',//去年游客
      gender: {},//性别数据
      menP: 0,//男占比
      womenP: 0,//女占比
      schedule: [],//时间
      // temperature:'',//温度
      // winddirection:'',//风向
      // windpower:'',//风力
      nowDay: '',//今天日期
      nowYear: '',//现在年份
      week: '',//星期几
      nowTime: '',//时分秒
      tourists_list: {},//游客入园时间统计
      real_time_traffic_list: {},//游客客流分析
      current_traffic_trend: {
        categories: [],
        series: [],
      },//游客进出园时间分析
      ticket_number_statistics: {},//入园游客类型统计
      weather: {},
      scenic_id: '',
      req_date: null,
      bodyHeight: '',
      originType: ['全部', '散客', '团队'],
      isShowType: false,
      originIndex: 0,
      origin_list_dict: {},
      flightMap: null,
      hotMap: '',
      map: null,
      map_2: {},
      boundaryLayer: null,
      boundaryMaskLayer: null,
      priceFenceLayer: null,
      boundaryGeometries: [],
      boundaryHitPolygons: [],
      boundaryBounds: null,
      viewportBounds: null,
      boundaryLoadingPromise: null,
      isWuyuanViewportResetting: false,
      wuyuanMapGuardHandlers: null,
      scenic4AMarkerLayer: null,
      scenic4ALabelLayer: null,
      activeResourceItemKeys: ['scenic_all'],
      businessFencePoints: [],
      businessFenceDrawMode: 'polygon',
      businessFenceCircleCenter: null,
      businessFenceCircleRadius: 0,
      businessFenceRectangleStart: null,
      businessFenceRectangleEnd: null,
      isBusinessFenceCircleDragging: false,
      businessFenceNameInput: '全域',
      selectedBusinessFenceName: '全域',
      businessFenceCoordinateInput: '',
      businessFenceMarkers: null,
      businessFencePolyline: null,
      businessFencePolygon: null,
      businessResourceMarkerLayer: null,
      businessResourceLabelLayer: null,
      businessResourceLabelVisible: true,
      businessSaturationActiveIndex: 0,
      selectedBusinessResourceKeys: [],
      businessFenceMetric: 0,
      businessResourceList: [],
      businessResourceTypeList: [],
      businessResourcePointList: [],
      businessResourcePointLoaded: false,
      businessPointDetailVisible: false,
      businessPointDetailLoading: false,
      businessPointDetailError: '',
      businessPointDetail: {},
      businessSelectedPointId: '',
      isBusinessFenceDrawing: false,
      businessFenceBoundaryTip: '',
      businessFenceBoundaryTipTimer: null,
      businessSavedFenceCount: 1,
      hotMapList: [],
      changeWeek: '',
      isToday: true,
      setting: {
        first_refresh_time: 2,
        second_refresh_time: 5,
        third_refresh_time: 10,
      },
      // matinee:'',
      // evening:'',
      matinee_evening: [],
      hour: '',
      isYearSumShow: false,
      isGetUser: false,
      isGetRevenue: false,
      isIndex: false,
      city_name: '南昌',
      now_city_name: '南昌',
      cityComeData: '',
      oldComeIndex: 1,
      oldComeName: '老年主体',
      monthList: [],
      tradingNum: {},
      productMoneyList: [],
      pieColor: ['#2f80ed', '#12b886', '#f59f00', '#e8590c', '#845ef7', '#15aabf',
        '#fa5252', '#51cf66', '#fcc419', '#748ffc', '#20c997', "#9A60B4",
        "#ea7ccc", "#1890FF", "#91CB74", "#FAC858", "#EE6666"],
      hotelData: {},
      businessNum: {},
      offlineRetailInfo: {},
      ote_type_sale_person_list: [],
      re_sex: {},
      total_tourists_num: 0,
      free_check_gate_record_num: 0,
      three_series: [],
      three_show: [],
      last_day: '',
      tableTurnoverRate: 0,
      deliciousFoodData: {},
      IotAppendDataCache: null,
      allShopIndex: 1,
      merchant_order_total_list: [],
      coefficient_data: 100,
      //舆情分析
      timeTrend: null,
      timeTrendData: {
        x: [], y: []
      },
      emotion: null,
      emotionData: [],
      mediaType: null,
      mediaTypeData: [],
      hotWeb: null,
      hotWebData: { x: [], y: [] },
      list: [],
      platform_type: {
        'XINWEN': '新闻',
        'APP': 'APP',
        'SHUZIBAO': '数字报',
        'WEIXIN': '微信公众号',
        'SHORT_VIDEO': '视频',
        'MICRO_BLOG': '微博客',
        'WENDA': '问答',
        'LUNTAN': '论坛'
      },
      emotionType: {
        '正面': '#67C23A',
        '中立': '#909399',
        '疑似负面': '#E6A23C',
        '负面': '#F56C6C'
      },
      timelineList: null,
      tendenciesList: [],
      tendenciesItem: {},
      isDetailLoading: false,
      actIndex: 0,
      isDetail: false,
      realTourists_data: {},
      county_total_value: 0,
      warningList: [],
      warningCurrentIndex: 0,
      warningTimer: null,
      warningPushBoardVisible: false,
      warningPushBoardTimer: null,
      voiceRecognition: null,
      voiceRecognitionSupported: false,
      voiceKeepListening: false,
      voiceListening: false,
      voiceStarting: false,
      voiceStatusVisible: false,
      voiceStatusText: '',
      voiceStatusTone: 'info',
      voiceStatusTimer: null,
      voiceRestartTimer: null,
      voiceEndReason: '',
      voiceSuppressEndStatus: false,
      voiceCommandHandled: false,
      voiceMetricBoardVisible: false,
      voiceMetricBoardTitle: '',
      voiceMetricBoardValue: '',
      voiceMetricBoardUnit: '',
      voiceMetricBoardSubtitle: '',
      voiceMetricBoardTone: 'success',
      voiceMetricBoardTimer: null,
      showModal: false,
      videoTitle: '',
      modalVideoUrl: DEFAULT_MONITOR_STREAM_URL,
      videoElementKey: 0,
      player: null,
      sentimentPlayers: [],
      tableData: [
        { road: '婺源高速口', inFlow: 385, inRate: 94, outFlow: 312, outRate: 94 },
        { road: '婺源北高速口', inFlow: 223, inRate: 36, outFlow: 232, outRate: 33 },
        { road: '江湾高速口', inFlow: 457, inRate: 89, outFlow: 402, outRate: 89 },
        { road: '清华高速口', inFlow: 343, inRate: 92, outFlow: 331, outRate: 82 }
      ],
      tableData_1: [
        { road: '德兴-婺源交界', inFlow: 9232, inRate: 96 },
        { road: '景德镇-婺源交界', inFlow: 2256, inRate: 21 },
        { road: '黄山-婺源交界', inFlow: 8443, inRate: 89 },
        { road: '高铁站出口地下', inFlow: 8377, inRate: 92 }
      ],
      businessSaturationList: [
        {
          title: '住宿饱和度',
          tabLabel: '住宿',
          period: '周',
          value: 92,
          threshold: 80,
          statusText: '高位预警',
          alertText: '住宿业态饱和度超过阈值',
          isDanger: true,
          isWarning: false,
          advice: BUSINESS_ACCOMMODATION_OPTIMIZATION_ADVICE
        },
        {
          title: '餐饮饱和度',
          tabLabel: '餐饮',
          period: '周',
          value: 89,
          threshold: 80,
          statusText: '高位预警',
          alertText: '餐饮业态饱和度超过阈值',
          isDanger: true,
          isWarning: false,
          advice: BUSINESS_CATERING_OPTIMIZATION_ADVICE
        },
        {
          title: '互娱饱和度',
          tabLabel: '互娱',
          period: '周',
          value: 82,
          threshold: 80,
          statusText: '高位预警',
          alertText: '互娱业态饱和度超过阈值',
          isDanger: true,
          isWarning: false,
          advice: BUSINESS_ENTERTAINMENT_OPTIMIZATION_ADVICE
        }
      ],
      businessAreaStats: [
        { type: '酒店', count: 345, load: '81.5%', percent: 81.5, loadType: 'danger' },
        { type: '餐饮', count: 3423, load: '72.6%', percent: 72.6, loadType: 'warning' },
        { type: '互娱', count: 131, load: '28.5%', percent: 28.5, loadType: 'normal' }
      ],
      businessPassengerSummary: {
        online: '64,151',
        saturation: '57.8'
      },
      businessDiversionAdvice: [
        '区域客流接近承载上限，建议立即开放外围资源点和临时疏散通道。',
        '高负荷点位增加现场引导与预约限流提示，优先分流至低饱和业态。'
      ],
      businessFlowRanking: [
        { name: '篁岭', count: 10291, percent: 93.5, loadType: 'danger' },
        { name: '弦高古城', count: 13218, percent: 72.5, loadType: 'warning' },
        { name: '婺女洲', count: 5383, percent: 54.3, loadType: 'normal' },
        { name: '李坑', count: 4628, percent: 46.8, loadType: 'normal' },
        { name: '卧龙谷', count: 1239, percent: 23.1, loadType: 'normal' }
      ],
      businessFenceList: [
        { name: '全域', type: 'polygon', active: true, deletable: false, quick: true, points: [] },
        { name: '篁岭片区', type: 'polygon', active: false, deletable: false, quick: true, points: [{ lat: 29.324993, lng: 118.136749 }, { lat: 29.302571, lng: 118.118294 }, { lat: 29.326694, lng: 118.102634 }, { lat: 29.347777, lng: 118.105517 }, { lat: 29.337697, lng: 118.128146 }] },
        { name: '婺女洲片区', type: 'polygon', active: false, deletable: false, quick: true, points: [{ lat: 29.305935, lng: 117.853371 }, { lat: 29.305935, lng: 117.853371 }, { lat: 29.288144, lng: 117.842929 }, { lat: 29.261177, lng: 117.845323 }, { lat: 29.255116, lng: 117.858086 }, { lat: 29.255116, lng: 117.858086 }, { lat: 29.269414, lng: 117.865695 }, { lat: 29.292338, lng: 117.867822 }, { lat: 29.297066, lng: 117.869781 }] },
        { name: '李坑片区', type: 'polygon', active: false, deletable: false, quick: true, points: [{ lat: 29.353096, lng: 117.906833 }, { lat: 29.344486, lng: 117.946989 }, { lat: 29.323188, lng: 117.959185 }, { lat: 29.298993, lng: 117.946946 }, { lat: 29.305381, lng: 117.918214 }, { lat: 29.312840, lng: 117.902929 }, { lat: 29.330469, lng: 117.899832 }, { lat: 29.341801, lng: 117.898473 }] },
        { name: '江湾片区', type: 'polygon', active: false, deletable: false, quick: true, points: [{ lat: 29.375279, lng: 118.050451 }, { lat: 29.373748, lng: 118.067085 }, { lat: 29.361048, lng: 118.076868 }, { lat: 29.346698, lng: 118.072037 }, { lat: 29.341627, lng: 118.044854 }, { lat: 29.350236, lng: 118.031306 }, { lat: 29.361487, lng: 118.031272 }, { lat: 29.370636, lng: 118.036336 }] },
        { name: '弦高片区', type: 'polygon', active: false, deletable: false, quick: true, points: [{ lat: 29.251085, lng: 117.853611 }, { lat: 29.253959, lng: 117.866880 }, { lat: 29.251361, lng: 117.872086 }, { lat: 29.243903, lng: 117.870289 }, { lat: 29.240718, lng: 117.863652 }, { lat: 29.240455, lng: 117.853019 }, { lat: 29.249241, lng: 117.851326 }] }
      ],
      businessFenceShapeActions: [
        { label: '多边形', mode: 'polygon' },
        { label: '圆形', mode: 'circle' },
        { label: '方形', mode: 'rectangle' }
      ],
      drawingToolActions: [
        { label: '绘制', action: 'redraw' },
        { label: '确定', action: 'confirm' },
        { label: '取消', action: 'cancel' },
        { label: '保存', action: 'save' }
      ],
      businessResourceSeedList: [
        { key: 'scenic_all', name: '景区', base: 36, markerColor: '#8fffff' },
        { key: 'venue', name: '园馆', base: 122, markerColor: '#71a7ff' },
        { key: 'village_spot', name: '乡村旅游点', base: 122, markerColor: '#a47dff' },
        { key: 'monitor', name: '检测', base: 126, markerColor: '#4de2a6' },
        { key: 'hotel', name: '酒店', base: 1233, markerColor: '#ffd744' },
        { key: 'restaurant', name: '餐厅', base: 9882, markerColor: '#ff8a3d' },
        { key: 'parking', name: '停车场', base: 232, markerColor: '#d9f2ff' },
        { key: 'other', name: '其它资源', base: 2212, markerColor: '#ff65a8' }
      ],
      priceRoomSearch: '',
      selectedPriceHotelId: '',
      priceFenceRegions: PRICE_FENCE_REGIONS,
      priceFenceRegionId: 'wuyuan_al',
      priceTrendMerchantId: '',
      priceTrendDayCount: 7,
      // 趋势筛选三选一：merchant | fence | time
      priceTrendActiveFilter: 'fence',
      accommodationPriceList: accommodationPriceList,
      priceMapWarnings: [
        { scenic: '婺源全城', text: '五一假期民宿整体溢价偏高，重点巡查高价民宿' },
        { scenic: '篁岭景区', text: '多家观景民宿溢价突破90%，开启重点监管工单' },
        { scenic: '婺女洲度假区', text: '湖景民宿均价远超片区均值，投诉量小幅上涨' },
      ],
      priceSupervisionWorkOrders: priceSupervisionWorkOrders,
      priceFluctuationChart: null,
      showPriceWarningModal: false,
      priceWarningModalTitle: '',
      priceWarningModalSubtitle: '',
      priceWarningModalTrend: null,
      priceWarningModalChart: null,
      this_list: [
        { key: 'scenic_5a', name: '景区（5A）', value: 0 },
        { key: SCENIC_4A_RESOURCE_KEY, name: '景区（4A）', value: 0 },
        { key: 'provincial_resort', name: '度假区（省级）', value: 0 },
        { key: 'village_spot', name: '乡村旅游点', value: 0 },
        { key: 'hotel', name: '酒店', value: 0 },
        { key: 'homestay', name: '民宿', value: 0 },
        { key: 'highway_checkpoint', name: '高速卡口', value: 0 },
        { key: 'parking', name: '公共停车场', value: 0 },
        { key: 'restaurant', name: '餐饮门店', value: 0 },
        { key: 'shopping', name: '购物门店', value: 0 }
      ],
      text_type_list: [
        { value: 1, text: '核心客群' },
        { value: 2, text: '潜力客群' },
        { value: 3, text: '机会客群' }
      ],
      text_type_value: 1,
      comparison_1: '',
      comparison_2: '',
      comparison_type_list: [
        { value: 1, text: '客源地' },
        { value: 2, text: '年龄' },
        { value: 3, text: '性别结构' },
      ],
      comparison_type_index: 1,
      level_value: 1,
      decision_type: [
        { name: '客群与运营研判', index: 0 },
        { name: '交通与住宿研判', index: 1 },
        { name: '餐饮与业态研判', index: 2 },
        { name: '全域风险与趋势研判', index: 3 }
      ],
      decision_type_index: 0,
      showPlanModal: false,
      plan_modal_type: 1,
      showDealModal: false,        // 控制弹窗显示
      currentDealItem: null,      // 当前点击的工单
      currentDealIndex: -1,       // 当前点击下标
      day_plan_index: 0,
      order_plan_index: 0,
      warning_list: [
        { name: '人群密集', level: '2级', time: '6-10 11:22:33', text: '尽快安排安保人员前往现场，对游客进行分流，并安抚现场游客情绪' },
        { name: '人群密集', level: '2级', time: '6-10 11:22:33', text: '尽快安排安保人员前往现场，对游客进行分流，并安抚现场游客情绪' },
        { name: '人群密集', level: '2级', time: '6-10 11:22:33', text: '尽快安排安保人员前往现场，对游客进行分流，并安抚现场游客情绪' },
        { name: '人群密集', level: '2级', time: '6-10 11:22:33', text: '尽快安排安保人员前往现场，对游客进行分流，并安抚现场游客情绪' },
        { name: '人群密集', level: '2级', time: '6-10 11:22:33', text: '尽快安排安保人员前往现场，对游客进行分流，并安抚现场游客情绪' },
        { name: '人群密集', level: '2级', time: '6-10 11:22:33', text: '尽快安排安保人员前往现场，对游客进行分流，并安抚现场游客情绪' },
        { name: '人群密集', level: '2级', time: '6-10 11:22:33', text: '尽快安排安保人员前往现场，对游客进行分流，并安抚现场游客情绪' },
      ],
      cateringRankingData: [
        { name: '婺源人家农家菜', score: 236 },
        { name: '竹香楼', score: 228 },
        { name: '樊氏牛骨粉（书乡路店）', score: 221 },
        { name: '朗妈私房菜', score: 198 },
        { name: '婺源鑫邦大酒店·品轩中餐厅', score: 185 },
        { name: '婺女洲故园里酒店·水上餐厅', score: 172 },
        { name: '大傻徽菜园（老街店）', score: 163 },
        { name: '婺源第一楼', score: 155 },
        { name: '悦亭徽菜馆·老字号', score: 148 },
        { name: '王家食府', score: 139 },
        { name: '天街食府（篁岭景区）', score: 127 },
        { name: '朝花汐食·正宗农家菜', score: 118 },
        { name: '小巷人家（篁岭店）', score: 109 },
        { name: '一味领先', score: 98 },
        { name: '婺江饭店', score: 87 },
        { name: '廖厨', score: 79 },
        { name: '秀嫂挞粿', score: 71 },
        { name: '江家私房菜', score: 64 },
        { name: '赋春猪脚馆', score: 58 },
        { name: '星江饭店', score: 51 }
      ],
      showRightTrendPanel: false,
      trendPanelTitle: '',
      trendPanelSub: '',
      rightTrendChart: null,
      currentDealHotel: null,
      tempActiveHotel: null
    };
  },
  computed: {
    activeHotelComplaintList() {
      if (!this.activeAccommodationHotel) return []
      const source = this.activeAccommodationHotel.complaints || []
      return Array.isArray(source) ? source : []
    },
    activeHotelComplaints() {
      if (!this.activeAccommodationHotel) return []
      const source = this.activeAccommodationHotel.complaints || this.activeAccommodationHotel.complaintSummary || []
      if (typeof source === 'string') {
        return source ? [source] : []
      }
      if (!Array.isArray(source)) return []
      return source.map(item => {
        if (typeof item === 'string') return item
        return item && (item.content || item.summary || item.type) ? (item.content || item.summary || item.type) : ''
      }).filter(Boolean)
    },
    activeHotelPriceWarnings() {
      if (!this.activeAccommodationHotel) return []
      const source = this.activeAccommodationHotel.priceWarnings || this.activeAccommodationHotel.warnings || []
      return Array.isArray(source) ? source : []
    },
    filteredAccommodationPriceList() {
      var keyword = (this.priceRoomSearch || '').trim().toLowerCase()
      var list = Array.isArray(this.accommodationPriceList) ? this.accommodationPriceList : []
      if (!keyword) {
        return list
      }
      return list.filter(function (item) {
        return (
          item.hotelName.indexOf(keyword) !== -1 ||
          item.roomType.indexOf(keyword) !== -1 ||
          (item.area && item.area.indexOf(keyword) !== -1)
        )
      })
    },
    activeAccommodationHotel: {
      get() {
        const list = Array.isArray(this.filteredAccommodationPriceList) ? this.filteredAccommodationPriceList : []
        if (!list.length) return null
        if (this.selectedPriceHotelId) {
          const selected = list.find(item => String(item.hotelId) === String(this.selectedPriceHotelId))
          if (selected) return selected
        }
        if (this.tempActiveHotel) return this.tempActiveHotel
        return list[0]
      },
      set(val) {
        this.tempActiveHotel = val
        if (val && val.hotelId) {
          this.selectedPriceHotelId = val.hotelId
        }
      }
    },
    activeHotelComplaintCount() {
      if (!this.activeAccommodationHotel) return 0
      console.log('activeAccommodationHotel', this.activeAccommodationHotel)
      const count = Number(this.activeAccommodationHotel.complaints.length)
      return isFinite(count) ? count : 0
    },
    priceTrendMerchantOptions() {
      return this.accommodationPriceList
    },
    priceTrendChartDayCount() {
      // 不管是什么筛选模式，都返回用户选择的天数
      return Number(this.priceTrendDayCount) || 7
    },
    priceTrendChartTip() {
      var dayCount = this.priceTrendChartDayCount
      var suffix = '近' + dayCount + '天价格 vs 上年同期'
      if (this.priceTrendActiveFilter === 'merchant') {
        var merchant = this.accommodationPriceList.find(function (item) {
          return item.hotelId === this.priceTrendMerchantId
        }.bind(this))
        return (merchant ? merchant.hotelName : '请选择商户') + ' · ' + suffix
      }
      if (this.priceTrendActiveFilter === 'time') {
        return '时间范围：前' + dayCount + '天 · ' + suffix
      }
      var region = getPriceFenceRegionById(this.priceFenceRegionId)
      return region.name + ' · 区域均价 · ' + suffix
    },
    currentWarningItem() {
      if (!this.warningList.length) {
        return null
      }
      return this.warningList[this.warningCurrentIndex] || this.warningList[0]
    },
    activeBusinessSaturationItem() {
      return this.businessSaturationList[this.businessSaturationActiveIndex] || this.businessSaturationList[0] || null
    },
    businessResourceDisplayList() {
      const sourceList = this.businessResourceList.length ? this.businessResourceList : this.businessResourceSeedList
      const shouldUsePointCount = this.businessResourcePointLoaded && this.businessResourceList.length
      const shouldUseApiValue = this.businessResourceList.length
      return sourceList.map(item => {
        const points = shouldUsePointCount ? this.getBusinessResourcePointsForResource(item) : (item.points || [])
        const value = shouldUsePointCount
          ? points.length
          : (shouldUseApiValue ? (item.value !== undefined ? item.value : 0) : 0)
        return Object.assign({}, item, {
          value,
          areaValue: value,
          points
        })
      })
    },
    businessFenceQuickList() {
      return this.businessFenceList.filter(item => item.quick)
    },
    businessFenceCoordinateRangeText() {
      const points = this.getBusinessFenceAreaPoints()
      if (!points.length) {
        return '全域范围'
      }
      const bounds = this.getBusinessFenceBounds(points)
      if (!bounds) {
        return ''
      }
      return '经度 ' + bounds.minLng.toFixed(6) + ' - ' + bounds.maxLng.toFixed(6) +
        '\n纬度 ' + bounds.minLat.toFixed(6) + ' - ' + bounds.maxLat.toFixed(6) +
        '\n点位 ' + points.length + ' 个'
    },
    taps() {
      return function (tapsStr) {
        if (tapsStr) {
          return tapsStr.split(' ').slice(0, 4)
        } else {
          return []
        }
      }
    },
    imageList() {
      return function (imagesStr) {
        if (imagesStr) {
          return imagesStr.split(',')
        } else {
          return []
        }
      }
    },
    isImg() {
      return function (text) {
        if (!text) return true
        return text.indexOf('<img') < 0
      }
    }
  },
  created() {
    this.loadBusinessFenceHistory()
    // if (sessionStorage.getItem('scenicId') === 'dsflksdjkfjlsdjlk1112312312111') {
    //   this.type_item.splice(3, 0, { label: '舆情分析', value: 3 })
    // }
    if (sessionStorage.getItem('scenicId') === 'dsflksdjkfjlsdjlk1112312312111') {
      this.type_item.splice(1, 0, { label: '数据决策中心', value: 6 })
    }
    if (sessionStorage.getItem('scenicId') === 'dsflksdjkfjlsdjlk1112312312111') {
      this.type_item.splice(4, 0, { label: '客群画像分析', value: 7 })
    }
    this.getVisitorTrendData()
  },
  mounted() {
    if (!this.$route.query.id) {
      let id = sessionStorage.getItem('scenicId');
      this.$router.push({ path: '/', query: { id: id, token: store.state.token } })
      this.$router.go(0)
    }
    this.getToday();
    this.scenic_id = this.$route.query.id
    if (this.scenic_id == 'e7bfd798d9ca461c9f37a4191d55edea') {
      this.type_item = this.type_item.filter(item => item.value !== 2)
    }

    if (this.$route.query.date) {
      this.req_date = this.$route.query.date
      if (this.req_date && this.req_date != '') {
        var reDate = new Date(this.req_date)
        this.changeWeek = this.getWeek(reDate.getDay())
      }

    }
    if (this.$route.query.token) {
      this.$store.commit('setToken', this.$route.query.token);
    }
    if (this.$route.query.typeIndex !== undefined && this.$route.query.typeIndex !== null) {
      this.typeIndex = Number(this.$route.query.typeIndex)
    }
    if (this.$route.query.decisionTypeIndex !== undefined && this.$route.query.decisionTypeIndex !== null) {
      this.decision_type_index = Number(this.$route.query.decisionTypeIndex)
    }
    this.getCoefficientDataSetting()
    // this.getSettingById();
    if (this.req_date && this.req_date != '' && this.req_date != this.nowDay2) {
      this.isToday = false;
    } else {
      let _this = this;
      //设置零点十分刷新
      let current = new Date();
      let next = new Date();
      next.setDate(current.getDate() + 1);
      next.setHours(0);
      next.setMinutes(10);
      next.setSeconds(0);
      setTimeout(doIT, next - current);
      function doIT() {
        // _this.getGenderSchedule();
        _this.getHistoryData();
        _this.getRealTimeTraffic();
        _this.getPlaneFigure(1)
        setTimeout(doIT, 24 * 60 * 60 * 1000);
      }
    }
    if (this.typeIndex === 2 && this.isToday) {
      var today = new Date()
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24
      today.setTime(targetday_milliseconds) //注意，这行是关键代码
      var tYear = today.getFullYear()
      var tMonth = today.getMonth()
      var tDate = today.getDate()
      this.nowYear = tYear;
      tMonth = this.doHandleMonth(tMonth + 1)
      tDate = this.doHandleMonth(tDate)
      this.last_day = tYear + "-" + tMonth + "-" + tDate
    }

    this.bodyHeight = document.getElementById("bodys").offsetHeight + 54;
    this.initVoiceRecognitionSupport()
    this.startWarningPushBoardTimer()
    this.$nextTick(() => {
      this.consumePendingVoiceAction(0)
      this.initSentimentPlayersIfNeeded()
    })
    if (this.filteredAccommodationPriceList && this.filteredAccommodationPriceList.length) {
      const firstItem = this.filteredAccommodationPriceList[0]
      this.selectedPriceHotelId = firstItem.hotelId
      // 同步赋值给计算属性，激活选中状态
      this.activeAccommodationHotel = firstItem
    }
    this.$nextTick(() => {
      // 2、渲染婺源全城电子围栏
      this.renderPriceFenceLayer()
      // 3、加载默认全城价格趋势图表
      this.initPriceFluctuationChart()
    })
  },
  beforeDestroy() {
    this.stopWarningScroll()
    this.clearWarningPushBoardTimer()
    this.destroyVoiceRecognition()
    this.clearVoiceMetricBoardTimer()
    this.destroyPlayer()
    this.destroySentimentPlayers()
    this.destroyMainMap()
    this.destroyPriceWarningModalChart()
  },
  watch: {
    showModal(val) {
      if (val) {
        this.$nextTick(() => this.initPlayer())
      } else {
        this.destroyPlayer()
      }
    },
    typeIndex(val) {
      if (val === 3) {
        this.$nextTick(() => this.initSentimentPlayersIfNeeded())
        return
      }
      if (val === 6) {
        setTimeout(() => {
          this.getYearPie()
          this.getProvincePie()
          this.getSexPie6()
          this.getYearPie2()
          this.getPlayPie()
          this.getTouristLine()
        }, 300)
      }
      if (val === 1) {
        setTimeout(() => {
          this.getTouristLine()
        }, 300)
      }
      this.destroySentimentPlayers()
      if (val === PRICE_SUPERVISION_TYPE_INDEX) {
        this.$nextTick(() => {
          this.renderPriceFenceLayer()
          this.refreshPriceFluctuationChart()
        })
      } else {
        this.removePriceFenceLayer()
      }
    },
    decision_type_index(val) {
      if (val === 3) {
        this.initSevenDayChart()
      } else if (val === 0 && this.typeIndex === 6) {
        setTimeout(() => {
          this.getYearPie()
          this.getProvincePie()
          this.getSexPie6()
          this.getYearPie2()
          this.getPlayPie()
          this.getTouristLine()
        }, 300)
      }
    }
  },
  methods: {
    // 格式化投诉内容，第三条将微博替换为小红书
    formatComplaintContent(content, index) {
      if (index === 2 && content) {
        return content.replace(/微博/g, '小红书')
      }
      return content
    },
    openRightTrendPanel(hotelItem) {
      if (!hotelItem) return
      this.activeAccommodationHotel = hotelItem
      this.trendPanelTitle = hotelItem.hotelName + ' · ' + hotelItem.roomType
      this.trendPanelSub = '民宿近5日价格波动详情'
      this.showRightTrendPanel = true
      this.$nextTick(() => {
        console.log('当前打开图表民宿', hotelItem.hotelName, hotelItem.priceTrend.week14)
        this.initRightTrendChart(hotelItem)
      })
    },
    closeRightTrendPanel() {
      this.showRightTrendPanel = false
      if (this.rightTrendChart) {
        this.rightTrendChart.dispose()
        this.rightTrendChart = null
      }
    },
    initRightTrendChart(hotel) {
      const chartDom = document.getElementById('rightTrendChart')
      if (!chartDom) return
      // 销毁旧实例
      if (this.rightTrendChart) {
        this.rightTrendChart.dispose()
      }
      const trendData = this.buildLast5DaysPriceTrend(hotel)
      this.rightTrendChart = this.echarts.init(chartDom)
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: function (params) {
            if (!params || !params.length) return ''
            let lines = [params[0].axisValue]
            params.forEach(p => {
              lines.push(p.marker + p.seriesName + '：¥' + p.value)
            })
            return lines.join('<br/>')
          }
        },
        legend: {
          data: ['当日挂牌价', '历史均价'],
          textStyle: { color: '#2f80ed', fontSize: 12 },
          top: 0
        },
        grid: {
          top: '18%',
          left: '8%',
          right: '5%',
          bottom: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: trendData.dates,
          axisLabel: { color: '#2f80ed', fontSize: 12 },
          axisLine: { lineStyle: { color: 'rgba(0, 170, 255, 0.45)' } }
        },
        yAxis: {
          type: 'value',
          name: '价格(元)',
          nameTextStyle: { color: '#2f80ed', fontSize: 11 },
          axisLabel: { color: '#2f80ed', formatter: '¥{value}' },
          splitLine: { lineStyle: { color: 'rgba(0, 170, 255, 0.12)', type: 'dashed' } }
        },
        series: [
          {
            name: '当日挂牌价',
            type: 'line', // 改为折线
            data: trendData.prices,
            symbol: 'circle',
            symbolSize: 7,
            lineStyle: {
              width: 3,
              color: '#023aff'
            },
            itemStyle: { color: '#01f1e3' },
            label: { show: true, position: 'top', color: '#606266', fontSize: 11, formatter: '¥{c}' }
          },
          {
            name: '历史均价',
            type: 'line',
            data: trendData.historyAvgLine,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: { color: '#ff9f43' },
            lineStyle: { width: 2, type: 'dashed', color: '#ff9f43' }
          }
        ]
      }
      this.rightTrendChart.setOption(option)
    },
    getBusinessFlowPercentWidth(percent) {
      const value = Number(percent)
      if (!isFinite(value)) return '0%'
      return Math.max(0, Math.min(100, value)) + '%'
    },
    getLightChartColors() {
      return ['#2f80ed', '#12b886', '#f59f00', '#e8590c', '#845ef7', '#15aabf', '#fa5252', '#51cf66']
    },
    getLightAxisTextStyle(fontSize) {
      return {
        color: '#526173',
        fontSize: fontSize || 10
      }
    },
    getLightSplitLineStyle() {
      return {
        color: 'rgba(34, 49, 63, 0.12)',
        type: 'dashed'
      }
    },
    getLightTooltipStyle() {
      return {
        backgroundColor: 'rgba(255, 255, 255, 0.96)',
        borderColor: 'rgba(47, 128, 237, 0.18)',
        borderWidth: 1,
        textStyle: {
          color: '#22313f'
        },
        extraCssText: 'box-shadow:0 8px 20px rgba(34,49,63,.12);'
      }
    },
    getLightBarGradient(startColor, endColor, horizontal) {
      return new this.echarts.graphic.LinearGradient(
        0,
        0,
        horizontal ? 1 : 0,
        horizontal ? 0 : 1,
        [
          { offset: 0, color: startColor || '#6bb7ff' },
          { offset: 1, color: endColor || '#2f80ed' }
        ]
      )
    },
    styleLightCategoryAxis(axis, fontSize) {
      const target = axis || {}
      target.axisLine = { lineStyle: { color: 'rgba(34, 49, 63, 0.18)' } }
      target.axisTick = { show: false }
      target.axisLabel = Object.assign({}, target.axisLabel || {}, {
        textStyle: this.getLightAxisTextStyle(fontSize || 10),
        color: '#526173'
      })
      target.splitLine = target.splitLine || { show: false }
      return target
    },
    styleLightValueAxis(axis, fontSize) {
      const target = axis || {}
      target.axisLine = { show: false }
      target.axisTick = { show: false }
      target.axisLabel = Object.assign({}, target.axisLabel || {}, {
        textStyle: this.getLightAxisTextStyle(fontSize || 10),
        color: '#526173'
      })
      target.splitLine = {
        show: true,
        lineStyle: this.getLightSplitLineStyle()
      }
      return target
    },
    // 打开处置弹窗
    handleWorkOrder(item) {
      if (item.dealStatus === 'done') return
      this.currentDealHotel = item
      this.showDealModal = true
    },
    // 确认完结
    confirmDealWorkOrder() {
      if (!this.currentDealHotel) return
      const target = this.accommodationPriceList.find(h => h.hotelId === this.currentDealHotel.hotelId)
      if (target) {
        target.dealStatus = 'done'
      }
      this.showDealModal = false
      this.currentDealHotel = null
    },
    // 关闭弹窗
    closeDealModal() {
      this.showDealModal = false
    },
    go_hl() {
      // 跳转篁岭
      this.$router.push({ path: '/scenic_date_data', query: { id: 'dsflksdjkfjlsdjlk1112312312111' } })
    },
    getRateClass(rate) {
      if (rate >= 80) return 'danger'    // 红色 - 严重拥堵
      if (rate >= 50) return 'warning'   // 黄色 - 拥堵
      return 'normal'                    // 绿色 - 畅通
    },
    getPremiumRateClass(rate) {
      const num = parseFloat(rate) || 0
      // 档位可自定义：≥100红，60~99.99橙，＜60绿
      if (num >= 100) {
        return 'premium-danger'
      } else if (num >= 60) {
        return 'premium-warning'
      }
      return 'premium-normal'
    },
    formatPremiumRate(rate) {
      const num = parseFloat(rate) || 0
      return num.toFixed(2) + '%'
    },
    getPremiumRateColor(rate) {
      const num = parseFloat(rate) || 0
      if (num >= 100) {
        return 'red'
      } else if (num >= 60) {
        return 'orange'
      }
      return 'red' // 默认红色
    },
    isAccommodationHotelActive(item) {
      if (!item || item.hotelId === undefined || item.hotelId === null) {
        return false
      }
      return String(item.hotelId) === String(this.selectedPriceHotelId)
    },
    selectAccommodationHotel(item) {
      if (!item) return
      this.selectedPriceHotelId = item.hotelId
      this.activeAccommodationHotel = item
    },
    buildLast5DaysPriceTrend(hotel) {
      const baseDate = new Date(2026, 4, 7);
      const dates = [];
      const historyAvgLine = [];
      let prices = [];
      const avgPrice = Number(hotel.historyAvgPrice) || 0;

      // 5.3 ~ 5.7
      for (let dayOffset = 5; dayOffset >= 1; dayOffset--) {
        const pointDate = new Date(baseDate);
        pointDate.setDate(baseDate.getDate() - dayOffset);
        dates.push(parseTime(pointDate, '{m}-{d}'));
        historyAvgLine.push(avgPrice);
      }

      // 按酒店类型生成真实价格
      if (hotel.fenceRegionId === 'huangling') {
        prices = [1250, 1120, 960, 810, 680];
      } else if (hotel.fenceRegionId === 'wunvzhou') {
        prices = [931, 922, 775, 640, 495];
      } else {
        const base = avgPrice;
        prices = [
          Math.round(base * 1.8),
          Math.round(base * 1.65),
          Math.round(base * 1.45),
          Math.round(base * 1.22),
          Math.round(base * 1.03),
        ];
      }

      return { dates, prices, historyAvgLine, roomType: hotel.roomType };
    },
    openPriceWarningDetail(item) {
      const hotel = this.activeAccommodationHotel
      if (!hotel) return
      this.destroyPriceWarningModalChart()
      this.priceWarningModalTitle = hotel.hotelName + '价格预警'
      this.priceWarningModalSubtitle = item && item.message ? item.message : '当前民宿价格波动异常，请关注近5日挂牌价变化'
      this.priceWarningModalTrend = this.buildLast5DaysPriceTrend(hotel)
      this.showPriceWarningModal = true
      this.$nextTick(() => {
        const chartDom = document.getElementById('priceWarningModalChart')
        if (!chartDom || !this.echarts || !this.priceWarningModalTrend) return
        this.priceWarningModalChart = this.echarts.init(chartDom)
        this.priceWarningModalChart.setOption({
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              if (!params || !params.length) return ''
              return params.map(function (p) {
                return p.marker + p.seriesName + '：¥' + p.value
              }).join('<br/>')
            }
          },
          legend: {
            data: ['当日挂牌价', '历史均价'],
            top: 0,
            textStyle: { color: '#2f80ed' }
          },
          grid: {
            top: 42,
            left: 46,
            right: 24,
            bottom: 32
          },
          xAxis: {
            type: 'category',
            data: this.priceWarningModalTrend.dates,
            axisLine: { lineStyle: { color: 'rgba(47, 128, 237, 0.35)' } },
            axisLabel: { color: '#526173' }
          },
          yAxis: {
            type: 'value',
            axisLine: { show: false },
            axisLabel: { color: '#526173', formatter: '¥{value}' },
            splitLine: { lineStyle: { color: 'rgba(34, 49, 63, 0.12)', type: 'dashed' } }
          },
          series: [
            {
              name: '当日挂牌价',
              type: 'line',
              data: this.priceWarningModalTrend.prices,
              smooth: true,
              symbolSize: 7,
              itemStyle: { color: '#e8590c' },
              lineStyle: { width: 3, color: '#e8590c' }
            },
            {
              name: '历史均价',
              type: 'line',
              data: this.priceWarningModalTrend.historyAvgLine,
              smooth: true,
              symbolSize: 6,
              itemStyle: { color: '#2f80ed' },
              lineStyle: { width: 2, type: 'dashed', color: '#2f80ed' }
            }
          ]
        })
      })
    },
    closePriceWarningModal() {
      this.showPriceWarningModal = false
      this.destroyPriceWarningModalChart()
    },
    destroyPriceWarningModalChart() {
      if (this.priceWarningModalChart) {
        this.priceWarningModalChart.dispose()
        this.priceWarningModalChart = null
      }
    },
    initPriceSupervisionSelection() {
      this.priceFenceRegionId = 'wuyuan_all'
      this.priceTrendActiveFilter = 'fence'
      this.priceTrendMerchantId = ''
      this.priceTrendDayCount = 7
    },
    // 切换商户
    onPriceTrendMerchantChange() {
      // 设置筛选模式为商户
      this.priceTrendActiveFilter = 'merchant'
      // 清空区域选择（可选，保持体验）
      // this.priceFenceRegionId = ''
      const currentDayCount = Number(this.priceTrendDayCount) || 7
      const selectedHotel = this.accommodationPriceList.find(item =>
        item.hotelId === this.priceTrendMerchantId
      )

      if (selectedHotel) {
        console.log('切换商户:', selectedHotel.hotelName, '实时价格:', selectedHotel.realTimePrice, '天数:', currentDayCount)
      }

      // 刷新图表
      this.refreshPriceFluctuationChart()
    },
    onPriceTrendFenceChange() {
      this.priceTrendActiveFilter = 'fence'
      this.priceTrendMerchantId = ''
      const currentDayCount = Number(this.priceTrendDayCount) || 7
      // 切换区域时自动调整地图视野到对应区域
      const selectedRegion = getPriceFenceRegionById(this.priceFenceRegionId)
      if (selectedRegion && selectedRegion.mapCenter && this.map) {
        this.map.setCenter(new TMap.LatLng(selectedRegion.mapCenter.lat, selectedRegion.mapCenter.lng))
        if (selectedRegion.mapZoom) {
          this.map.setZoom(selectedRegion.mapZoom)
        }
      }
      this.renderPriceFenceLayer()
      this.refreshPriceFluctuationChart()
    },
    onPriceTrendTimeChange() {
      this.refreshPriceFluctuationChart()
    },
    removePriceFenceLayer() {
      if (this.priceFenceLayer && this.priceFenceLayer.setMap) {
        this.priceFenceLayer.setMap(null)
        this.priceFenceLayer = null
      }
    },
    renderPriceFenceLayer() {
      if (this.typeIndex !== PRICE_SUPERVISION_TYPE_INDEX || !this.map) {
        return
      }
      var region = getPriceFenceRegionById(this.priceFenceRegionId)
      if (!region || !region.paths || !region.paths.length) {
        return
      }
      this.removePriceFenceLayer()
      var fenceStyle = new TMap.PolygonStyle({
        color: 'rgba(255, 77, 79, 0.18)',
        showBorder: true,
        borderColor: 'rgba(255, 193, 7, 0.95)',
        borderWidth: 3
      })
      this.priceFenceLayer = new TMap.MultiPolygon({
        map: this.map,
        zIndex: 12,
        styles: {
          priceFence: fenceStyle
        },
        geometries: [{
          id: 'price-fence-' + region.id,
          styleId: 'priceFence',
          paths: region.paths
        }]
      })
      if (region.mapCenter && this.map.setCenter) {
        this.map.setCenter(this.normalizeWuyuanCenter(new TMap.LatLng(region.mapCenter.lat, region.mapCenter.lng)))
      }
      if (region.mapZoom && this.map.setZoom) {
        this.map.setZoom(Math.max(Number(region.mapZoom), WUYUAN_MAP_MIN_ZOOM))
      }
    },
    // 构建价格趋势系列数据
    buildPriceTrendSeries(hotels, dayCount) {
      const validDayCount = (dayCount === 7 || dayCount === 14) ? dayCount : 7

      // 优先判断：如果是商户模式且有选中商户
      if (this.priceTrendActiveFilter === 'merchant' && this.priceTrendMerchantId) {
        const selectedHotel = this.accommodationPriceList.find(item =>
          item.hotelId === this.priceTrendMerchantId
        )

        if (selectedHotel) {
          console.log('商户模式 - 使用商户数据:', selectedHotel.hotelName, '天数:', validDayCount)

          // 使用商户特定的价格趋势数据
          const trend = generatePriceTrendByHotel(selectedHotel, validDayCount)

          if (trend && trend.dates && trend.recentSeries && trend.lastMonthSeries) {
            return trend
          }
        }
      }

      // 围栏模式：使用区域数据
      if (this.priceTrendActiveFilter === 'fence') {
        let regionId = this.priceFenceRegionId
        console.log('围栏模式 - 使用区域数据:', regionId, '天数:', validDayCount)

        const trend = generatePriceTrendByRegion(regionId, validDayCount)

        if (trend && trend.dates && trend.recentSeries && trend.lastMonthSeries) {
          return trend
        }
      }

      // 时间模式：使用区域均价
      console.log('时间模式 - 使用区域均价, 天数:', validDayCount)
      const trend = generatePriceTrendByRegion(this.priceFenceRegionId, validDayCount)

      if (!trend || !trend.dates || !trend.recentSeries || !trend.lastMonthSeries) {
        console.warn('趋势数据生成失败，使用默认数据')
        return this.getDefaultTrendData(validDayCount)
      }

      return trend
    },
    // 获取默认趋势数据（降级方案）
    getDefaultTrendData(dayCount) {
      const baseDate = new Date(2026, 4, 7)
      const dates = []
      for (let i = dayCount - 1; i >= 0; i--) {
        const d = new Date(baseDate)
        d.setDate(baseDate.getDate() - i)
        dates.push(`${d.getMonth() + 1}-${d.getDate()}`)
      }
      const recentSeries = Array(dayCount).fill(300).map((v, i) => v + i * 10)
      const lastMonthSeries = recentSeries.map(v => Math.round(v * 0.65))
      return { dates, recentSeries, lastMonthSeries }
    },
    // 获取价格趋势目标酒店
    getPriceTrendTargetHotels() {
      // 商户模式：返回选中的商户
      if (this.priceTrendActiveFilter === 'merchant' && this.priceTrendMerchantId) {
        var merchant = this.accommodationPriceList.find(function (item) {
          return item.hotelId === this.priceTrendMerchantId
        }.bind(this))
        return merchant ? [merchant] : []
      }

      // 时间模式：返回所有酒店（用于区域均价）
      if (this.priceTrendActiveFilter === 'time') {
        return this.accommodationPriceList.slice()
      }

      // 围栏模式：返回围栏内的酒店
      return filterHotelsByFenceRegion(
        this.accommodationPriceList,
        this.priceFenceRegionId
      )
    },
    refreshPriceFluctuationChart() {
      this.$nextTick(() => {
        this.initPriceFluctuationChart()
      })
    },
    destroyMainMap() {
      this.stopBusinessFenceDrawing()
      this.clearBusinessResourceMarkers()
      this.clearBusinessFenceLayers()
      this.removeScenic4AMarkerLayer()
      this.removePriceFenceLayer()
      this.unbindWuyuanMapGuard()
      if (this.boundaryMaskLayer && this.boundaryMaskLayer.setMap) {
        this.boundaryMaskLayer.setMap(null)
        this.boundaryMaskLayer = null
      }
      if (this.boundaryLayer && this.boundaryLayer.setMap) {
        this.boundaryLayer.setMap(null)
        this.boundaryLayer = null
      }
      if (this.flightMap) {
        this.flightMap.remove()
        this.flightMap = null
      }
      if (this.map && this.map.destroy) {
        this.map.destroy()
      }
      this.map = null
    },
    clearFlightLayer() {
      if (this.flightMap) {
        this.flightMap.remove()
        this.flightMap = null
      }
    },
    businessDrawingToolActive(action) {
      return action === 'redraw' && this.isBusinessFenceDrawing
    },
    businessDrawingToolDisabled(action) {
      if (action === 'confirm') {
        return this.businessFencePoints.length < 3
      }
      if (action === 'save') {
        return this.businessFencePoints.length < 3
      }
      if (action === 'cancel') {
        return !this.isBusinessFenceDrawing && !this.businessFencePoints.length
      }
      return false
    },
    setBusinessFenceDrawMode(mode) {
      if (mode !== 'polygon' && mode !== 'circle' && mode !== 'rectangle') {
        return
      }
      this.businessFenceDrawMode = mode
      this.businessFenceCircleCenter = null
      this.businessFenceCircleRadius = 0
      this.businessFenceRectangleStart = null
      this.businessFenceRectangleEnd = null
      this.isBusinessFenceCircleDragging = false
      this.businessFencePoints = []
      this.businessFenceCoordinateInput = ''
      this.clearBusinessFenceLayers()
      this.renderBusinessResourceMarkers()
      if (this.isBusinessFenceDrawing) {
        this.bindBusinessFenceMapClick()
      }
    },
    getBusinessFenceModeLabel(mode) {
      if (mode === 'circle') {
        return '圆形'
      }
      if (mode === 'rectangle') {
        return '方形'
      }
      return '多边形'
    },
    handleDrawingToolAction(action) {
      if (action === 'redraw') {
        this.startBusinessFenceDrawing()
      } else if (action === 'confirm') {
        this.confirmBusinessFenceArea()
      } else if (action === 'cancel') {
        this.cancelBusinessFenceDrawing()
      } else if (action === 'save') {
        this.saveBusinessFenceArea()
      }
    },
    startBusinessFenceDrawing() {
      if (!this.map) {
        return
      }
      this.clearBusinessFenceLayers()
      this.businessFencePoints = []
      this.businessFenceCircleCenter = null
      this.businessFenceCircleRadius = 0
      this.businessFenceRectangleStart = null
      this.businessFenceRectangleEnd = null
      this.isBusinessFenceCircleDragging = false
      this.businessFenceCoordinateInput = ''
      if (this.selectedBusinessFenceName === '全域') {
        this.selectedBusinessFenceName = ''
        this.businessFenceNameInput = '县城区域'
      }
      this.businessFenceList = this.businessFenceList.map(item => Object.assign({}, item, { active: false }))
      this.businessFenceBoundaryTip = ''
      this.isBusinessFenceDrawing = true
      this.bindBusinessFenceMapClick()
      this.renderBusinessResourceMarkers()
    },
    confirmBusinessFenceArea() {
      if (this.businessFencePoints.length < 3) {
        return
      }
      this.isBusinessFenceDrawing = false
      this.businessFenceBoundaryTip = ''
      this.unbindBusinessFenceMapClick()
      this.renderBusinessFenceLayers()
      this.refreshBusinessFenceDynamicData()
      this.renderBusinessResourceMarkers()
    },
    saveBusinessFenceArea() {
      if (this.businessFencePoints.length < 3) {
        return
      }
      if (this.isBusinessFenceDrawing) {
        this.confirmBusinessFenceArea()
      }
      const fenceName = this.businessFenceNameInput && this.businessFenceNameInput.trim() && this.businessFenceNameInput.trim() !== '全域'
        ? this.businessFenceNameInput.trim()
        : '自定义围栏' + this.businessSavedFenceCount
      const defaultFence = this.businessFenceList.find(item => item.name === fenceName && !item.deletable)
      if (defaultFence) {
        this.businessFenceBoundaryTip = '默认快捷围栏不可覆盖，请修改围栏名称'
        return
      }
      const serializedPoints = this.serializeBusinessFencePoints(this.businessFencePoints)
      const savedFence = {
        name: fenceName,
        type: this.businessFenceDrawMode,
        active: true,
        deletable: true,
        quick: true,
        points: serializedPoints,
        coordinateRange: this.getBusinessFenceRangeTextByPoints(serializedPoints)
      }
      if (this.businessFenceDrawMode === 'circle') {
        savedFence.circleCenter = this.serializeBusinessFencePoint(this.businessFenceCircleCenter)
        savedFence.circleRadius = this.businessFenceCircleRadius
      }
      this.businessSavedFenceCount += 1
      this.businessFenceList = this.businessFenceList
        .filter(item => item.name !== fenceName)
        .map(item => Object.assign({}, item, { active: false }))
        .concat(savedFence)
      this.businessFenceNameInput = fenceName
      this.selectedBusinessFenceName = fenceName
      this.businessFenceList = this.businessFenceList.map(item => Object.assign({}, item, { active: item.name === fenceName }))
      this.persistBusinessFenceHistory()
      this.refreshBusinessFenceDynamicData()
      this.renderBusinessResourceMarkers()
    },
    loadBusinessFenceHistory() {
      if (typeof window === 'undefined' || !window.localStorage) {
        return
      }
      const rawValue = window.localStorage.getItem(BUSINESS_FENCE_STORAGE_KEY)
      if (!rawValue) {
        return
      }
      let historyList = []
      try {
        historyList = JSON.parse(rawValue)
      } catch (error) {
        window.localStorage.removeItem(BUSINESS_FENCE_STORAGE_KEY)
        return
      }
      if (!Array.isArray(historyList) || !historyList.length) {
        return
      }
      const normalizedHistory = historyList.map(item => {
        const points = Array.isArray(item && item.points)
          ? item.points.map(point => {
            const lat = Number(point && point.lat)
            const lng = Number(point && point.lng)
            return isFinite(lat) && isFinite(lng) ? { lat, lng } : null
          }).filter(Boolean)
          : []
        if (!item || !item.name || points.length < 3) {
          return null
        }
        const circleCenter = item.circleCenter && isFinite(Number(item.circleCenter.lat)) && isFinite(Number(item.circleCenter.lng))
          ? { lat: Number(item.circleCenter.lat), lng: Number(item.circleCenter.lng) }
          : null
        return {
          name: String(item.name),
          type: item.type === 'circle' || item.type === 'rectangle' ? item.type : 'polygon',
          active: false,
          deletable: true,
          quick: true,
          points,
          circleCenter,
          circleRadius: Number(item.circleRadius || 0),
          coordinateRange: item.coordinateRange || this.getBusinessFenceRangeTextByPoints(points)
        }
      }).filter(Boolean)
      if (!normalizedHistory.length) {
        return
      }
      const defaultNameMap = {}
      this.businessFenceList.forEach(item => {
        if (!item.deletable) {
          defaultNameMap[item.name] = true
        }
      })
      const customFenceList = this.businessFenceList.filter(item => !item.deletable)
      normalizedHistory.forEach(item => {
        if (!defaultNameMap[item.name]) {
          const existIndex = customFenceList.findIndex(fence => fence.name === item.name)
          if (existIndex === -1) {
            customFenceList.push(item)
          } else {
            customFenceList.splice(existIndex, 1, item)
          }
        }
      })
      this.businessFenceList = customFenceList
    },
    persistBusinessFenceHistory() {
      if (typeof window === 'undefined' || !window.localStorage) {
        return
      }
      const historyList = this.businessFenceList
        .filter(item => item.deletable)
        .map(item => ({
          name: item.name,
          type: item.type,
          points: item.points || [],
          circleCenter: item.circleCenter || null,
          circleRadius: item.circleRadius || 0,
          coordinateRange: item.coordinateRange || this.getBusinessFenceSummary(item)
        }))
      window.localStorage.setItem(BUSINESS_FENCE_STORAGE_KEY, JSON.stringify(historyList))
    },
    getBusinessFenceRangeTextByPoints(points) {
      const bounds = this.getBusinessFenceBounds(points)
      if (!bounds) {
        return '全域范围'
      }
      return '经度 ' + bounds.minLng.toFixed(6) + ' - ' + bounds.maxLng.toFixed(6) +
        '；纬度 ' + bounds.minLat.toFixed(6) + ' - ' + bounds.maxLat.toFixed(6)
    },
    getBusinessFenceSummary(item) {
      if (!item || !item.points || !item.points.length) {
        return '全域范围'
      }
      return item.coordinateRange || this.getBusinessFenceRangeTextByPoints(item.points)
    },
    cancelBusinessFenceDrawing() {
      this.stopBusinessFenceDrawing()
      this.businessFencePoints = []
      this.businessFenceCircleCenter = null
      this.businessFenceCircleRadius = 0
      this.businessFenceRectangleStart = null
      this.businessFenceRectangleEnd = null
      this.isBusinessFenceCircleDragging = false
      this.businessFenceCoordinateInput = ''
      this.businessFenceBoundaryTip = ''
      this.clearBusinessFenceLayers()
      this.renderBusinessResourceMarkers()
    },
    bindBusinessFenceMapClick() {
      if (!this.map || !this.map.on) {
        return
      }
      this.unbindBusinessFenceMapClick()
      if (this.businessFenceDrawMode === 'circle' || this.businessFenceDrawMode === 'rectangle') {
        this.setBusinessMapDragEnabled(false)
        this.map.on('mousedown', this.handleBusinessFenceCircleMouseDown)
        this.map.on('mousemove', this.handleBusinessFenceCircleMouseMove)
        this.map.on('mouseup', this.handleBusinessFenceCircleMouseUp)
        if (typeof document !== 'undefined' && document.addEventListener) {
          document.addEventListener('mouseup', this.handleBusinessFenceCircleDocumentMouseUp)
        }
        return
      }
      this.map.on('click', this.handleBusinessFenceMapClick)
    },
    unbindBusinessFenceMapClick() {
      if (this.map && this.map.off) {
        this.map.off('click', this.handleBusinessFenceMapClick)
        this.map.off('mousedown', this.handleBusinessFenceCircleMouseDown)
        this.map.off('mousemove', this.handleBusinessFenceCircleMouseMove)
        this.map.off('mouseup', this.handleBusinessFenceCircleMouseUp)
      }
      this.setBusinessMapDragEnabled(true)
      if (typeof document !== 'undefined' && document.removeEventListener) {
        document.removeEventListener('mouseup', this.handleBusinessFenceCircleDocumentMouseUp)
      }
    },
    setBusinessMapDragEnabled(enabled) {
      if (!this.map) {
        return
      }
      const draggable = !!enabled
      try {
        if (this.map.setOptions) {
          this.map.setOptions({ draggable })
        }
        if (draggable && this.map.enableDragging) {
          this.map.enableDragging()
        } else if (!draggable && this.map.disableDragging) {
          this.map.disableDragging()
        }
        if (this.map.setDraggable) {
          this.map.setDraggable(draggable)
        }
      } catch (error) {
        console.warn('[ScenicData] 切换地图拖拽状态失败。', error)
      }
    },
    stopBusinessFenceDrawing() {
      this.isBusinessFenceDrawing = false
      this.isBusinessFenceCircleDragging = false
      this.businessFenceBoundaryTip = ''
      clearTimeout(this.businessFenceBoundaryTipTimer)
      this.businessFenceBoundaryTipTimer = null
      this.unbindBusinessFenceMapClick()
    },
    handleBusinessFenceMapClick(event) {
      if (!this.isBusinessFenceDrawing || !event || !event.latLng) {
        return
      }
      if (!this.canAddBusinessFencePointInWuyuan(event.latLng)) {
        this.showBusinessFenceBoundaryTip()
        return
      }
      this.businessFenceBoundaryTip = ''
      if (this.businessFenceDrawMode === 'circle' || this.businessFenceDrawMode === 'rectangle') {
        return
      }
      this.businessFencePoints.push(event.latLng)
      this.syncBusinessFenceCoordinateInput()
      this.renderBusinessFenceLayers()
    },
    handleBusinessFenceCircleMouseDown(event) {
      if (!this.isBusinessFenceDrawing || (this.businessFenceDrawMode !== 'circle' && this.businessFenceDrawMode !== 'rectangle') || !event || !event.latLng) {
        return
      }
      this.stopBusinessFenceMapNativeEvent(event)
      this.setBusinessMapDragEnabled(false)
      if (!this.canAddBusinessFencePointInWuyuan(event.latLng)) {
        this.showBusinessFenceBoundaryTip()
        return
      }
      this.businessFenceBoundaryTip = ''
      this.isBusinessFenceCircleDragging = true
      this.businessFenceCircleCenter = event.latLng
      this.businessFenceCircleRadius = 0
      this.businessFenceRectangleStart = event.latLng
      this.businessFenceRectangleEnd = event.latLng
      this.businessFencePoints = [event.latLng]
      this.syncBusinessFenceCoordinateInput()
      this.renderBusinessFenceLayers()
    },
    handleBusinessFenceCircleMouseMove(event) {
      if (!this.isBusinessFenceCircleDragging || !this.businessFenceCircleCenter || !event || !event.latLng) {
        return
      }
      this.stopBusinessFenceMapNativeEvent(event)
      this.updateBusinessFenceDragShapeByPoint(event.latLng)
    },
    handleBusinessFenceCircleMouseUp(event) {
      if (!this.isBusinessFenceCircleDragging) {
        return
      }
      this.stopBusinessFenceMapNativeEvent(event)
      this.isBusinessFenceCircleDragging = false
      if (event && event.latLng) {
        this.updateBusinessFenceDragShapeByPoint(event.latLng)
      }
      this.setBusinessMapDragEnabled(true)
    },
    handleBusinessFenceCircleDocumentMouseUp() {
      if (!this.isBusinessFenceCircleDragging) {
        return
      }
      this.isBusinessFenceCircleDragging = false
      this.setBusinessMapDragEnabled(true)
    },
    stopBusinessFenceMapNativeEvent(event) {
      const nativeEvent = event && (event.originalEvent || event.domEvent || event.event)
      if (nativeEvent) {
        if (nativeEvent.preventDefault) {
          nativeEvent.preventDefault()
        }
        if (nativeEvent.stopPropagation) {
          nativeEvent.stopPropagation()
        }
        if (nativeEvent.stopImmediatePropagation) {
          nativeEvent.stopImmediatePropagation()
        }
      }
      if (event && event.stopPropagation) {
        event.stopPropagation()
      }
    },
    updateBusinessFenceCircleByEdgePoint(point) {
      if (!this.businessFenceCircleCenter || !point) {
        return
      }
      const radius = Math.max(80, Math.round(this.getBusinessFenceDistanceMeters(this.businessFenceCircleCenter, point)))
      this.businessFenceCircleRadius = radius
      this.businessFencePoints = this.buildBusinessFenceCirclePoints(this.businessFenceCircleCenter, radius)
      this.syncBusinessFenceCoordinateInput()
      this.renderBusinessFenceLayers()
    },
    updateBusinessFenceDragShapeByPoint(point) {
      if (this.businessFenceDrawMode === 'circle') {
        this.updateBusinessFenceCircleByEdgePoint(point)
        return
      }
      if (this.businessFenceDrawMode === 'rectangle') {
        this.updateBusinessFenceRectangleByCornerPoint(point)
      }
    },
    updateBusinessFenceRectangleByCornerPoint(point) {
      if (!this.businessFenceRectangleStart || !point) {
        return
      }
      if (!this.canAddBusinessFencePointInWuyuan(point)) {
        this.showBusinessFenceBoundaryTip()
        return
      }
      this.businessFenceRectangleEnd = point
      this.businessFencePoints = this.buildBusinessFenceRectanglePoints(this.businessFenceRectangleStart, point)
      this.syncBusinessFenceCoordinateInput()
      this.renderBusinessFenceLayers()
    },
    showBusinessFenceBoundaryTip() {
      this.businessFenceBoundaryTip = '只能在婺源县范围内绘制和选择区域'
      clearTimeout(this.businessFenceBoundaryTipTimer)
      this.businessFenceBoundaryTipTimer = setTimeout(() => {
        this.businessFenceBoundaryTip = ''
        this.businessFenceBoundaryTipTimer = null
      }, 1800)
    },
    canAddBusinessFencePointInWuyuan(point) {
      if (!this.isPointInWuyuanBoundary(point)) {
        return false
      }
      if (this.businessFenceDrawMode === 'circle' || this.businessFenceDrawMode === 'rectangle') {
        return true
      }
      const lastPoint = this.businessFencePoints[this.businessFencePoints.length - 1]
      if (lastPoint && !this.isSegmentInWuyuanBoundary(lastPoint, point)) {
        return false
      }
      const firstPoint = this.businessFencePoints[0]
      if (firstPoint && this.businessFencePoints.length >= 2 && !this.isSegmentInWuyuanBoundary(point, firstPoint)) {
        return false
      }
      return true
    },
    clearBusinessFenceLayers() {
      if (this.businessFenceMarkers && this.businessFenceMarkers.setMap) {
        this.businessFenceMarkers.setMap(null)
      }
      this.businessFenceMarkers = null
      if (this.businessFencePolyline && this.businessFencePolyline.setMap) {
        this.businessFencePolyline.setMap(null)
      }
      this.businessFencePolyline = null
      if (this.businessFencePolygon && this.businessFencePolygon.setMap) {
        this.businessFencePolygon.setMap(null)
      }
      this.businessFencePolygon = null
    },
    clearBusinessResourceMarkers() {
      if (this.businessResourceMarkerLayer && this.businessResourceMarkerLayer.setMap) {
        if (this.businessResourceMarkerLayer.off) {
          this.businessResourceMarkerLayer.off('click', this.handleBusinessResourceMarkerClick)
        }
        this.businessResourceMarkerLayer.setMap(null)
      }
      this.businessResourceMarkerLayer = null
      if (this.businessResourceLabelLayer && this.businessResourceLabelLayer.setMap) {
        this.businessResourceLabelLayer.setMap(null)
      }
      this.businessResourceLabelLayer = null
    },
    renderBusinessFenceLayers() {
      if (!this.map) {
        return
      }
      this.clearBusinessFenceLayers()
      if (!this.businessFencePoints.length) {
        return
      }

      const isDragShapeMode = this.businessFenceDrawMode === 'circle' || this.businessFenceDrawMode === 'rectangle'
      const shouldShowFencePointMarkers = !isDragShapeMode
      const shouldRenderFenceArea = isDragShapeMode
        ? this.businessFencePoints.length >= 3
        : (!this.isBusinessFenceDrawing && this.businessFencePoints.length >= 3)
      const markerPoints = shouldShowFencePointMarkers ? this.normalizeBusinessFencePoints(this.businessFencePoints) : []
      const fenceAreaPoints = this.getBusinessFenceAreaPoints()
      const markerGeometries = markerPoints.map((point, index) => ({
        id: 'business-fence-point-' + index,
        styleId: 'businessFencePoint',
        position: point,
        properties: {
          title: '点位' + (index + 1)
        }
      }))

      if (markerGeometries.length) {
        this.businessFenceMarkers = new TMap.MultiMarker({
          id: 'business-fence-marker-layer',
          map: this.map,
          zIndex: 30,
          styles: {
            businessFencePoint: new TMap.MarkerStyle({
              width: 14,
              height: 14,
              src: BUSINESS_FENCE_POINT_ICON_URL,
              anchor: { x: 7, y: 7 },
            })
          },
          geometries: markerGeometries
        })
      }

      if (shouldRenderFenceArea && fenceAreaPoints.length > 1) {
        const linePath = fenceAreaPoints.slice()
        linePath.push(fenceAreaPoints[0])
        this.businessFencePolyline = new TMap.MultiPolyline({
          id: 'business-fence-polyline-layer',
          map: this.map,
          zIndex: 29,
          styles: {
            businessFenceLine: new TMap.PolylineStyle({
              color: 'rgba(127, 255, 255, 0.95)',
              width: 3,
              borderColor: 'rgba(127, 255, 255, 0)',
              borderWidth: 0
            })
          },
          geometries: [{
            id: 'business-fence-line',
            styleId: 'businessFenceLine',
            paths: linePath
          }]
        })
      }

      if (shouldRenderFenceArea && fenceAreaPoints.length >= 3) {
        this.businessFencePolygon = new TMap.MultiPolygon({
          id: 'business-fence-polygon-layer',
          map: this.map,
          zIndex: 28,
          styles: {
            businessFencePolygon: new TMap.PolygonStyle({
              color: 'rgba(65, 234, 232, 0.22)',
              showBorder: true,
              borderColor: 'rgba(127, 255, 255, 0.95)',
              borderWidth: 3
            })
          },
          geometries: [{
            id: 'business-fence-polygon',
            styleId: 'businessFencePolygon',
            paths: fenceAreaPoints
          }]
        })
      }
    },
    refreshBusinessFenceDynamicData() {
      const fenceAreaPoints = this.getBusinessFenceAreaPoints()
      if (fenceAreaPoints.length < 3) {
        return
      }
      const metric = this.calculateBusinessFenceMetric(fenceAreaPoints)
      this.businessFenceMetric = metric
      const resourceSourceList = this.businessResourceTypeList.length ? this.businessResourceTypeList : this.businessResourceSeedList
      const isApiResourceSource = !!this.businessResourceTypeList.length
      this.businessResourceList = resourceSourceList.map((item, index) => {
        const jitter = this.seededBusinessRandom(metric, index) * 0.38 + 0.82
        const areaRatio = Math.max(0.08, Math.min(0.95, metric / 9000))
        const base = Number(item.base || item.value || 0)
        const areaValue = Math.max(1, Math.round(base * areaRatio * jitter))
        return Object.assign({}, item, {
          base: base,
          value: isApiResourceSource ? item.value : areaValue,
          areaValue: areaValue,
          points: this.buildBusinessResourcePoints(item, areaValue, index, fenceAreaPoints)
        })
      })
      this.refreshBusinessSaturationData(metric)
      this.refreshBusinessAreaStats(metric)
      this.refreshBusinessFlowRanking(metric)
      this.refreshBusinessPassengerSummary(metric)
      this.renderBusinessResourceMarkers()
    },
    isBusinessCountyFenceActive() {
      return this.selectedBusinessFenceName !== '全域' || this.businessFencePoints.length >= 3
    },
    getMapResourceList() {
      getMapResourceApi().then(res => {
        const responseData = res && res.data ? res.data : {}
        if (Number(responseData.code) !== 1 || !Array.isArray(responseData.data)) {
          console.warn('[ScenicData] 业态资源类型汇总列表获取失败。', responseData)
          return
        }
        const resourceList = responseData.data
          .slice()
          .sort((a, b) => Number(a.idx || 0) - Number(b.idx || 0))
          .map((item, index) => this.normalizeBusinessResourceType(item, index))
          .map(item => {
            const oldItem = this.businessResourceList.find(resource => resource.key === item.key)
            return oldItem && oldItem.points ? Object.assign({}, item, { points: oldItem.points }) : item
          })
        this.businessResourceTypeList = resourceList
        this.businessResourceList = resourceList
        this.selectedBusinessResourceKeys = this.selectedBusinessResourceKeys.filter(key => {
          return resourceList.some(item => item.key === key)
        })
        this.refreshBusinessAreaStats(this.getCurrentBusinessMetric())
        this.refreshBusinessFlowRanking(0)
        if (this.businessFencePoints.length >= 3) {
          this.refreshBusinessFenceDynamicData()
        }
        this.consumePendingVoiceAction(0)
      }).catch(error => {
        console.warn('[ScenicData] 业态资源类型汇总列表请求异常。', error)
      })
    },
    normalizeBusinessResourceType(item, index) {
      const seedResource = this.businessResourceSeedList[index % this.businessResourceSeedList.length] || {}
      const id = item && item.id !== undefined ? item.id : index
      const key = 'business_resource_' + id
      const count = Number(item && item.point_count)
      return {
        id: id,
        typeId: id,
        categoryId: id,
        idx: item && item.idx !== undefined ? item.idx : index,
        key: key,
        name: item && item.name ? item.name : '未命名资源',
        icon: this.normalizeBusinessResourceIcon(item && item.icon),
        value: isFinite(count) ? count : 0,
        base: isFinite(count) ? count : 0,
        markerColor: seedResource.markerColor || '#8fffff',
        points: []
      }
    },
    normalizeBusinessResourceIcon(icon) {
      const iconUrl = String(icon || '').trim()
      if (!iconUrl) {
        return ''
      }
      if (/^(https?:)?\/\//.test(iconUrl) || iconUrl.indexOf('data:') === 0) {
        return iconUrl
      }
      return iconUrl.charAt(0) === '/'
        ? QIANJING_SERVICE_ORIGIN + iconUrl
        : QIANJING_SERVICE_ORIGIN + '/' + iconUrl
    },
    selectBusinessFence(item) {
      if (!item) {
        return
      }
      this.businessFenceList = this.businessFenceList.map(fence => Object.assign({}, fence, { active: fence.name === item.name }))
      this.businessFenceNameInput = item.name
      this.selectedBusinessFenceName = item.name
      this.businessFenceDrawMode = item.type === 'circle' || item.type === 'rectangle' ? item.type : 'polygon'
      this.businessFenceCircleCenter = item.circleCenter ? new TMap.LatLng(item.circleCenter.lat, item.circleCenter.lng) : null
      this.businessFenceCircleRadius = Number(item.circleRadius || 0)
      this.businessFenceRectangleStart = null
      this.businessFenceRectangleEnd = null
      this.isBusinessFenceCircleDragging = false
      this.businessFencePoints = (item.points || []).map(point => new TMap.LatLng(point.lat, point.lng))
      if (item.name === '全域') {
        this.businessFenceCoordinateInput = ''
      } else {
        this.syncBusinessFenceCoordinateInput()
      }
      this.renderBusinessFenceLayers()
      if (item.name === '全域') {
        this.clearBusinessFenceLayers()
        this.clearBusinessResourceMarkers()
      }
      this.refreshBusinessAreaStats(this.getCurrentBusinessMetric())
      this.refreshBusinessFlowRanking(0)
      this.refreshBusinessPassengerSummary(0)
      this.renderBusinessResourceMarkers()
    },
    deleteBusinessFence(item) {
      if (!item || !item.deletable) {
        return
      }
      const wasActive = item.active
      this.businessFenceList = this.businessFenceList.filter(fence => fence.name !== item.name)
      this.persistBusinessFenceHistory()
      if (wasActive) {
        const defaultFence = this.businessFenceList.find(fence => fence.name === '全域') || this.businessFenceList[0]
        if (defaultFence) {
          this.selectBusinessFence(defaultFence)
        }
      }
    },
    handleBusinessFenceCoordinateInputChange() {
      const points = this.parseBusinessFenceCoordinateInput(this.businessFenceCoordinateInput)
      if (points.length < 3) {
        this.showBusinessFenceBoundaryTip()
        return
      }
      const invalidPoint = points.find(point => !this.isPointInWuyuanBoundary(point))
      if (invalidPoint) {
        this.showBusinessFenceBoundaryTip()
        return
      }
      this.businessFenceDrawMode = 'polygon'
      this.businessFenceCircleCenter = null
      this.businessFenceCircleRadius = 0
      this.businessFenceRectangleStart = null
      this.businessFenceRectangleEnd = null
      this.isBusinessFenceCircleDragging = false
      this.businessFencePoints = points
      this.syncBusinessFenceCoordinateInput()
      this.renderBusinessFenceLayers()
      this.refreshBusinessFenceDynamicData()
      this.renderBusinessResourceMarkers()
    },
    parseBusinessFenceCoordinateInput(value) {
      return String(value || '').split(';').map(text => {
        const pair = text.split(',').map(item => Number(item.trim()))
        if (pair.length < 2 || !isFinite(pair[0]) || !isFinite(pair[1])) {
          return null
        }
        return new TMap.LatLng(pair[0], pair[1])
      }).filter(Boolean)
    },
    syncBusinessFenceCoordinateInput() {
      this.businessFenceCoordinateInput = this.serializeBusinessFencePoints(this.businessFencePoints)
        .map(point => point.lat.toFixed(6) + ',' + point.lng.toFixed(6))
        .join('; ')
    },
    serializeBusinessFencePoints(points) {
      return (points || []).map(point => this.serializeBusinessFencePoint(point)).filter(Boolean)
    },
    serializeBusinessFencePoint(point) {
      const lat = this.getBusinessFencePointLat(point)
      const lng = this.getBusinessFencePointLng(point)
      if (!isFinite(lat) || !isFinite(lng)) {
        return null
      }
      return { lat, lng }
    },
    getBusinessFenceDistanceMeters(firstPoint, secondPoint) {
      const lat1 = this.getBusinessFencePointLat(firstPoint) * Math.PI / 180
      const lat2 = this.getBusinessFencePointLat(secondPoint) * Math.PI / 180
      const latDiff = lat2 - lat1
      const lngDiff = (this.getBusinessFencePointLng(secondPoint) - this.getBusinessFencePointLng(firstPoint)) * Math.PI / 180
      const a = Math.sin(latDiff / 2) * Math.sin(latDiff / 2) +
        Math.cos(lat1) * Math.cos(lat2) * Math.sin(lngDiff / 2) * Math.sin(lngDiff / 2)
      return 6371000 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    },
    buildBusinessFenceCirclePoints(center, radius) {
      const centerLat = this.getBusinessFencePointLat(center)
      const centerLng = this.getBusinessFencePointLng(center)
      const latDelta = radius / 111320
      const lngDelta = radius / (111320 * Math.cos(centerLat * Math.PI / 180) || 1)
      const points = []
      for (let index = 0; index < 36; index++) {
        const angle = Math.PI * 2 * index / 36
        const lat = centerLat + Math.sin(angle) * latDelta
        const lng = centerLng + Math.cos(angle) * lngDelta
        points.push(new TMap.LatLng(lat, lng))
      }
      return points
    },
    buildBusinessFenceRectanglePoints(startPoint, endPoint) {
      const startLat = this.getBusinessFencePointLat(startPoint)
      const startLng = this.getBusinessFencePointLng(startPoint)
      const endLat = this.getBusinessFencePointLat(endPoint)
      const endLng = this.getBusinessFencePointLng(endPoint)
      if (!isFinite(startLat) || !isFinite(startLng) || !isFinite(endLat) || !isFinite(endLng)) {
        return []
      }
      return [
        new TMap.LatLng(startLat, startLng),
        new TMap.LatLng(startLat, endLng),
        new TMap.LatLng(endLat, endLng),
        new TMap.LatLng(endLat, startLng)
      ]
    },
    getBusinessFenceAreaPoints() {
      const fencePoints = this.normalizeBusinessFencePoints(this.businessFencePoints)
      if (fencePoints.length < 4 || !this.hasBusinessFenceSelfIntersection(fencePoints)) {
        return fencePoints
      }
      const outerHullPoints = this.getBusinessFenceOuterHullPoints(fencePoints)
      return outerHullPoints.length >= 3 ? outerHullPoints : fencePoints
    },
    normalizeBusinessFencePoints(points) {
      const normalizedPoints = []
        ; (points || []).forEach(point => {
          const lat = this.getBusinessFencePointLat(point)
          const lng = this.getBusinessFencePointLng(point)
          if (!isFinite(lat) || !isFinite(lng)) {
            return
          }
          const duplicated = normalizedPoints.some(item => this.isSameBusinessFencePoint(item, point))
          if (!duplicated) {
            normalizedPoints.push(point)
          }
        })
      return normalizedPoints
    },
    getBusinessFencePointLat(point) {
      if (!point) {
        return NaN
      }
      return Number(typeof point.getLat === 'function' ? point.getLat() : point.lat)
    },
    getBusinessFencePointLng(point) {
      if (!point) {
        return NaN
      }
      return Number(typeof point.getLng === 'function' ? point.getLng() : point.lng)
    },
    isSameBusinessFencePoint(firstPoint, secondPoint) {
      const latGap = Math.abs(this.getBusinessFencePointLat(firstPoint) - this.getBusinessFencePointLat(secondPoint))
      const lngGap = Math.abs(this.getBusinessFencePointLng(firstPoint) - this.getBusinessFencePointLng(secondPoint))
      return latGap < 0.0000001 && lngGap < 0.0000001
    },
    getBusinessFenceOuterHullPoints(points) {
      const sortedPoints = points.slice().sort((firstPoint, secondPoint) => {
        const lngDiff = this.getBusinessFencePointLng(firstPoint) - this.getBusinessFencePointLng(secondPoint)
        if (lngDiff !== 0) {
          return lngDiff
        }
        return this.getBusinessFencePointLat(firstPoint) - this.getBusinessFencePointLat(secondPoint)
      })
      const lowerPoints = []
      sortedPoints.forEach(point => {
        while (
          lowerPoints.length >= 2 &&
          this.getBusinessFenceTurnDirection(lowerPoints[lowerPoints.length - 2], lowerPoints[lowerPoints.length - 1], point) <= 0
        ) {
          lowerPoints.pop()
        }
        lowerPoints.push(point)
      })
      const upperPoints = []
      for (let index = sortedPoints.length - 1; index >= 0; index--) {
        const point = sortedPoints[index]
        while (
          upperPoints.length >= 2 &&
          this.getBusinessFenceTurnDirection(upperPoints[upperPoints.length - 2], upperPoints[upperPoints.length - 1], point) <= 0
        ) {
          upperPoints.pop()
        }
        upperPoints.push(point)
      }
      return lowerPoints.slice(0, -1).concat(upperPoints.slice(0, -1))
    },
    getBusinessFenceTurnDirection(firstPoint, secondPoint, targetPoint) {
      return (
        (this.getBusinessFencePointLng(secondPoint) - this.getBusinessFencePointLng(firstPoint)) *
        (this.getBusinessFencePointLat(targetPoint) - this.getBusinessFencePointLat(firstPoint))
      ) - (
          (this.getBusinessFencePointLat(secondPoint) - this.getBusinessFencePointLat(firstPoint)) *
          (this.getBusinessFencePointLng(targetPoint) - this.getBusinessFencePointLng(firstPoint))
        )
    },
    hasBusinessFenceSelfIntersection(points) {
      if (!points || points.length < 4) {
        return false
      }
      for (let firstIndex = 0; firstIndex < points.length; firstIndex++) {
        const firstStart = points[firstIndex]
        const firstEnd = points[(firstIndex + 1) % points.length]
        for (let secondIndex = firstIndex + 1; secondIndex < points.length; secondIndex++) {
          const isAdjacent = Math.abs(firstIndex - secondIndex) <= 1 || (firstIndex === 0 && secondIndex === points.length - 1)
          if (isAdjacent) {
            continue
          }
          const secondStart = points[secondIndex]
          const secondEnd = points[(secondIndex + 1) % points.length]
          if (this.doBusinessFenceSegmentsIntersect(firstStart, firstEnd, secondStart, secondEnd)) {
            return true
          }
        }
      }
      return false
    },
    doBusinessFenceSegmentsIntersect(firstStart, firstEnd, secondStart, secondEnd) {
      const firstStartPoint = this.toBusinessFencePlanePoint(firstStart)
      const firstEndPoint = this.toBusinessFencePlanePoint(firstEnd)
      const secondStartPoint = this.toBusinessFencePlanePoint(secondStart)
      const secondEndPoint = this.toBusinessFencePlanePoint(secondEnd)
      const firstOrientation = this.getBusinessFenceOrientation(firstStartPoint, firstEndPoint, secondStartPoint)
      const secondOrientation = this.getBusinessFenceOrientation(firstStartPoint, firstEndPoint, secondEndPoint)
      const thirdOrientation = this.getBusinessFenceOrientation(secondStartPoint, secondEndPoint, firstStartPoint)
      const fourthOrientation = this.getBusinessFenceOrientation(secondStartPoint, secondEndPoint, firstEndPoint)

      if (firstOrientation * secondOrientation < 0 && thirdOrientation * fourthOrientation < 0) {
        return true
      }
      return (
        this.isBusinessFencePointOnSegment(firstStartPoint, secondStartPoint, firstEndPoint, firstOrientation) ||
        this.isBusinessFencePointOnSegment(firstStartPoint, secondEndPoint, firstEndPoint, secondOrientation) ||
        this.isBusinessFencePointOnSegment(secondStartPoint, firstStartPoint, secondEndPoint, thirdOrientation) ||
        this.isBusinessFencePointOnSegment(secondStartPoint, firstEndPoint, secondEndPoint, fourthOrientation)
      )
    },
    toBusinessFencePlanePoint(point) {
      return {
        x: this.getBusinessFencePointLng(point),
        y: this.getBusinessFencePointLat(point)
      }
    },
    getBusinessFenceOrientation(firstPoint, secondPoint, targetPoint) {
      const orientation = (secondPoint.x - firstPoint.x) * (targetPoint.y - firstPoint.y) - (secondPoint.y - firstPoint.y) * (targetPoint.x - firstPoint.x)
      return Math.abs(orientation) < 0.000000000001 ? 0 : orientation
    },
    isBusinessFencePointOnSegment(startPoint, targetPoint, endPoint, orientation) {
      if (orientation !== 0) {
        return false
      }
      return targetPoint.x >= Math.min(startPoint.x, endPoint.x) - 0.000000000001 &&
        targetPoint.x <= Math.max(startPoint.x, endPoint.x) + 0.000000000001 &&
        targetPoint.y >= Math.min(startPoint.y, endPoint.y) - 0.000000000001 &&
        targetPoint.y <= Math.max(startPoint.y, endPoint.y) + 0.000000000001
    },
    calculateBusinessFenceMetric(fencePoints) {
      const points = fencePoints || this.getBusinessFenceAreaPoints()
      if (points.length < 3) {
        return 0
      }
      let area = 0
      for (let index = 0; index < points.length; index++) {
        const currentPoint = points[index]
        const nextPoint = points[(index + 1) % points.length]
        const currentLat = this.getBusinessFencePointLat(currentPoint)
        const currentLng = this.getBusinessFencePointLng(currentPoint)
        const nextLat = this.getBusinessFencePointLat(nextPoint)
        const nextLng = this.getBusinessFencePointLng(nextPoint)
        area += currentLng * nextLat - nextLng * currentLat
      }
      return Math.max(1, Math.round(Math.abs(area) * 50000000))
    },
    getBusinessFenceBounds(fencePoints) {
      const points = fencePoints || this.getBusinessFenceAreaPoints()
      if (!points.length) {
        return null
      }
      let minLat = Infinity
      let maxLat = -Infinity
      let minLng = Infinity
      let maxLng = -Infinity
      points.forEach(point => {
        const lat = this.getBusinessFencePointLat(point)
        const lng = this.getBusinessFencePointLng(point)
        minLat = Math.min(minLat, lat)
        maxLat = Math.max(maxLat, lat)
        minLng = Math.min(minLng, lng)
        maxLng = Math.max(maxLng, lng)
      })
      if (!isFinite(minLat) || !isFinite(maxLat) || !isFinite(minLng) || !isFinite(maxLng)) {
        return null
      }
      return { minLat, maxLat, minLng, maxLng }
    },
    seededBusinessRandom(seed, offset) {
      const value = Math.sin(Number(seed || 1) * 12.9898 + offset * 78.233) * 43758.5453
      return value - Math.floor(value)
    },
    buildBusinessResourcePoints(resource, count, offset, fencePoints) {
      const bounds = this.getBusinessFenceBounds(fencePoints)
      if (!bounds) {
        return []
      }
      const pointCount = Math.min(Math.max(Math.round(count / 28), 3), 28)
      const points = []
      let attempt = 0
      while (points.length < pointCount && attempt < pointCount * 8) {
        const index = attempt
        const latRatio = this.seededBusinessRandom(count + offset * 31, index + 1)
        const lngRatio = this.seededBusinessRandom(count + offset * 47, index + 11)
        const lat = bounds.minLat + (bounds.maxLat - bounds.minLat) * (0.12 + latRatio * 0.76)
        const lng = bounds.minLng + (bounds.maxLng - bounds.minLng) * (0.12 + lngRatio * 0.76)
        attempt += 1
        if (!this.isBusinessPointInFence(lat, lng, fencePoints)) {
          continue
        }
        points.push({
          id: resource.key + '-' + points.length,
          name: resource.name + (points.length + 1),
          position: new TMap.LatLng(lat, lng)
        })
      }
      return points
    },
    isBusinessPointInFence(lat, lng, fencePoints) {
      const points = fencePoints || this.getBusinessFenceAreaPoints()
      if (points.length < 3) {
        return false
      }
      let isInside = false
      for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
        const pointI = points[i]
        const pointJ = points[j]
        const latI = this.getBusinessFencePointLat(pointI)
        const lngI = this.getBusinessFencePointLng(pointI)
        const latJ = this.getBusinessFencePointLat(pointJ)
        const lngJ = this.getBusinessFencePointLng(pointJ)
        const intersects = ((latI > lat) !== (latJ > lat)) &&
          (lng < (lngJ - lngI) * (lat - latI) / (latJ - latI || 0.000001) + lngI)
        if (intersects) {
          isInside = !isInside
        }
      }
      return isInside
    },
    refreshBusinessSaturationData(metric) {
      const source = [
        {
          title: '住宿饱和度',
          tabLabel: '住宿',
          advice: BUSINESS_ACCOMMODATION_OPTIMIZATION_ADVICE
        },
        {
          title: '餐饮饱和度',
          tabLabel: '餐饮',
          advice: BUSINESS_CATERING_OPTIMIZATION_ADVICE
        },
        {
          title: '互娱饱和度',
          tabLabel: '互娱',
          advice: BUSINESS_ENTERTAINMENT_OPTIMIZATION_ADVICE
        }
      ]
      this.businessSaturationList = source.map((group, groupIndex) => {
        const threshold = 80
        const value = Math.round(58 + this.seededBusinessRandom(metric + groupIndex * 23, groupIndex + 4) * 38)
        const isDanger = value > threshold
        const isWarning = !isDanger
        return {
          title: group.title,
          tabLabel: group.tabLabel,
          period: '周',
          value,
          threshold,
          statusText: isDanger ? '高位预警' : '运行平稳',
          alertText: group.title.replace('饱和度', '业态饱和度') + '超过阈值',
          isDanger,
          isWarning,
          advice: group.advice
        }
      })
    },
    getBusinessGaugeValueStyle(item) {
      const value = Math.max(0, Math.min(100, Number(item && item.value) || 0))
      return {
        strokeDasharray: value + ' 100'
      }
    },
    getBusinessGaugeNeedleTransform(item) {
      const value = Math.max(0, Math.min(100, Number(item && item.value) || 0))
      const angle = -90 + value * 1.8
      return 'rotate(' + angle + ' 80 80)'
    },
    getBusinessAreaStatSourceList() {
      const sourceList = this.businessResourceDisplayList
      if (!this.selectedBusinessResourceKeys.length) {
        return sourceList
      }
      return sourceList.filter(item => item && item.key && this.selectedBusinessResourceKeys.indexOf(item.key) !== -1)
    },
    getCurrentBusinessMetric() {
      return this.businessFenceMetric || 0
    },
    refreshBusinessAreaStats(metric) {
      this.businessAreaStats = this.getBusinessAreaStatSourceList().map((item, index) => {
        const loadValue = this.getBusinessResourceLoadPercent(item, metric, index)
        const loadInfo = this.getBusinessResourceLoadInfo(loadValue)
        return {
          type: item.name,
          count: item.value,
          load: loadValue.toFixed(1) + '%',
          percent: Number(loadValue.toFixed(1)),
          loadType: loadInfo.loadType
        }
      })
    },
    findBusinessResourceByKeywords(keywords) {
      return this.businessResourceList.find(item => {
        const key = item && item.key ? item.key : ''
        const name = item && item.name ? item.name : ''
        return keywords.some(keyword => key === keyword || name.indexOf(keyword) !== -1)
      })
    },
    getBusinessResourceAreaValue(resource) {
      if (!resource) {
        return 0
      }
      const areaValue = Number(resource.areaValue)
      if (isFinite(areaValue)) {
        return areaValue
      }
      const value = Number(resource.value)
      return isFinite(value) ? value : 0
    },
    getBusinessResourceLoadPercent(resource, metric, offset) {
      const idx = Number(resource && resource.idx)
      const randomValue = this.seededBusinessRandom(metric || 0, Number(resource && (resource.id !== undefined ? resource.id : offset)) || offset || 0)
      if (idx <= 1) {
        return 20 + randomValue * 39.5
      }
      if (idx === 2) {
        return 60 + randomValue * 19.5
      }
      return 80 + randomValue * 18.8
    },
    getBusinessResourceLoadInfo(loadValue) {
      let loadType = 'normal'
      if (loadValue >= 80) {
        loadType = 'danger'
      } else if (loadValue >= 60) {
        loadType = 'warning'
      }
      return {
        loadType
      }
    },
    refreshBusinessFlowRanking(metric) {
      this.businessFlowRanking = this.businessResourceDisplayList.map((item, index) => {
        const percent = this.getBusinessResourceLoadPercent(item, metric, index)
        const loadInfo = this.getBusinessResourceLoadInfo(percent)
        return {
          name: item.name,
          count: item.value,
          percent: Number(percent.toFixed(1)),
          loadType: loadInfo.loadType
        }
      })
    },
    getBusinessRankProgressStyle(item) {
      return {
        width: this.getBusinessFlowPercentWidth(item.percent)
      }
    },
    refreshBusinessPassengerSummary(metric) {
      const isCountyFence = this.isBusinessCountyFenceActive()
      const saturation = isCountyFence ? '61.1' : '57.8'
      this.businessPassengerSummary = isCountyFence
        ? { online: '18,913', saturation }
        : { online: '64,151', saturation }
      if (Number(saturation) >= 85) {
        this.businessDiversionAdvice = [
          '区域客流接近承载上限，建议立即开放外围资源点和临时疏散通道。',
          '高负荷点位增加现场引导与预约限流提示，优先分流至低饱和业态。'
        ]
      } else if (Number(saturation) >= 70) {
        this.businessDiversionAdvice = [
          '区域客流处于高位，建议推送错峰游览线路和周边可承接资源。',
          '餐饮、住宿、互娱资源按负荷分级推荐，减少核心片区持续聚集。'
        ]
      } else {
        this.businessDiversionAdvice = [
          '区域承载相对平稳，可承接周边游客导入并保持常规巡检频次。',
          '持续观察重点点位客流变化，保留低负荷资源作为后续分流承接。'
        ]
      }
    },
    renderBusinessResourceMarkers() {
      this.clearBusinessResourceMarkers()
      if (!this.map || !this.selectedBusinessResourceKeys.length) {
        this.closeBusinessPointDetail()
        return
      }
      const selectedResources = this.businessResourceDisplayList.filter(item => this.selectedBusinessResourceKeys.indexOf(item.key) !== -1)
      const markerGeometries = []
      const labelGeometries = []
      const styles = {}
      const visiblePointIdMap = {}
      selectedResources.forEach(resource => {
        this.getBusinessResourcePointsForResource(resource).forEach(point => {
            const geometryId = resource.key + '-point-' + (point.pointId !== undefined ? point.pointId : point.id)
            const pointIdx = this.getBusinessPointIdx(point, resource.idx)
            const markerColor = this.getBusinessPointMarkerColor(point, resource.idx)
            const styleId = resource.key + '-idx-' + (pointIdx !== null ? pointIdx : 'default')
            if (!styles[styleId]) {
              const shape = this.getBusinessResourceShape(resource)
              const anchorMap = {
                triangle: { x: 7, y: 12 },
                circle: { x: 7, y: 7 },
                diamond: { x: 7, y: 7 },
                square: { x: 7, y: 7 },
                hexagon: { x: 7, y: 7 },
                pentagon: { x: 7, y: 7 },
                star: { x: 7, y: 7 },
                pin: { x: 7, y: 13 }
              }
              styles[styleId] = new TMap.MarkerStyle({
                width: 14,
                height: 14,
                src: this.buildBusinessResourceIcon(markerColor, resource),
                anchor: anchorMap[shape] || { x: 7, y: 7 }
              })
            }
            if (point.pointId !== undefined && point.pointId !== null && point.pointId !== '') {
              visiblePointIdMap[String(point.pointId)] = true
            }
            markerGeometries.push({
              id: geometryId,
              styleId: styleId,
              position: point.position,
              properties: {
                title: point.name,
                pointId: point.pointId,
                name: point.name,
                idx: pointIdx,
                categoryId: point.categoryId,
                categoryKey: point.categoryKey,
                resourceName: resource.name,
                resourceIdx: resource.idx,
                markerColor: markerColor
              }
            })
            if (this.businessResourceLabelVisible) {
              labelGeometries.push({
                id: geometryId + '-label',
                styleId: 'businessResourceLabel',
                position: point.position,
                content: point.name,
                rank: 20,
                properties: {
                  title: point.name
                }
              })
            }
        })
      })
      if (this.businessPointDetailVisible && this.businessSelectedPointId !== '' && !visiblePointIdMap[String(this.businessSelectedPointId)]) {
        this.closeBusinessPointDetail()
      }
      if (!markerGeometries.length) {
        return
      }
      this.businessResourceMarkerLayer = new TMap.MultiMarker({
        id: 'business-resource-marker-layer',
        map: this.map,
        zIndex: 31,
        styles,
        isStopPropagation: true,
        geometries: markerGeometries
      })
      if (this.businessResourceMarkerLayer && this.businessResourceMarkerLayer.on) {
        this.businessResourceMarkerLayer.on('click', this.handleBusinessResourceMarkerClick)
      }
      if (labelGeometries.length) {
        this.businessResourceLabelLayer = new TMap.MultiLabel({
          id: 'business-resource-label-layer',
          map: this.map,
          zIndex: 32,
          styles: {
            businessResourceLabel: new TMap.LabelStyle({
              color: '#1f2937',
              size: 12,
              offset: { x: 0, y: -24 },
              angle: 0,
              alignment: 'center',
              verticalAlignment: 'middle',
              padding: '4px 8px',
              backgroundColor: '#ffffff',
              borderWidth: 1,
              borderRadius: 6,
              borderColor: '#dcdfe6'
            })
          },
          disableInteractive: true,
          isStopPropagation: false,
          geometries: labelGeometries
        })
      }
    },
    getBusinessResourceMarkerColor(resource) {
      return this.getBusinessMarkerColorByIdx(resource && resource.idx)
    },
    getBusinessPointIdx(point, fallbackIdx) {
      if (point && point.idx !== undefined && point.idx !== null && point.idx !== '') {
        const idx = Number(point.idx)
        return isFinite(idx) ? idx : null
      }
      if (fallbackIdx !== undefined && fallbackIdx !== null && fallbackIdx !== '') {
        const idx = Number(fallbackIdx)
        return isFinite(idx) ? idx : null
      }
      return null
    },
    getBusinessPointMarkerColor(point, fallbackIdx) {
      return this.getBusinessMarkerColorByIdx(this.getBusinessPointIdx(point, fallbackIdx))
    },
    getBusinessMarkerColorByIdx(idxValue) {
      if (idxValue === null || idxValue === undefined || idxValue === '') {
        return '#f56c6c'
      }
      const idx = Number(idxValue)
      if (!isFinite(idx)) {
        return '#f56c6c'
      }
      if (idx <= 1) {
        return '#12b886'
      }
      if (idx === 2) {
        return '#f2c94c'
      }
      return '#f56c6c'
    },
    toggleBusinessResourceLabels() {
      this.businessResourceLabelVisible = !this.businessResourceLabelVisible
      this.renderBusinessResourceMarkers()
    },
    setBusinessSaturationTab(index) {
      if (index < 0 || index >= this.businessSaturationList.length) {
        return
      }
      this.businessSaturationActiveIndex = index
    },
    getBusinessResourcePointList() {
      return getMapPointListApi().then(res => {
        const responseData = res && res.data ? res.data : {}
        if (Number(responseData.code) !== 1 || !Array.isArray(responseData.data)) {
          console.warn('[ScenicData] 业态资源点位列表获取失败。', responseData)
          return
        }
        this.businessResourcePointList = responseData.data
          .slice()
          .sort((a, b) => Number(a.idx || 0) - Number(b.idx || 0))
          .map((item, index) => this.normalizeBusinessResourcePoint(null, item, index))
          .filter(Boolean)
        this.businessResourcePointLoaded = true
        this.refreshBusinessAreaStats(this.getCurrentBusinessMetric())
        this.refreshBusinessFlowRanking(0)
        this.renderBusinessResourceMarkers()
      }).catch(error => {
        this.businessResourcePointLoaded = false
        console.warn('[ScenicData] 业态资源点位列表请求异常。', error)
      })
    },
    handleBusinessResourceMarkerClick(event) {
      this.stopBusinessFenceMapNativeEvent(event)
      const geometry = event && (event.geometry || (event.geometries && event.geometries[0]))
      const properties = geometry && geometry.properties ? geometry.properties : {}
      const pointId = properties.pointId !== undefined ? properties.pointId : ''
      if (pointId === '' || pointId === undefined || pointId === null) {
        return
      }
      this.openBusinessPointDetailByPoint({
        pointId,
        name: properties.name || properties.title || '',
        idx: properties.idx,
        categoryId: properties.categoryId,
        categoryKey: properties.categoryKey,
        resourceName: properties.resourceName,
        resourceIdx: properties.resourceIdx,
        markerColor: properties.markerColor
      })
    },
    closeBusinessPointDetail() {
      this.businessPointDetailVisible = false
      this.businessPointDetailLoading = false
      this.businessPointDetailError = ''
      this.businessPointDetail = {}
      this.businessSelectedPointId = ''
    },
    getBusinessPointOverflowInfo(detail) {
      const idx = this.getBusinessPointIdx(detail, detail && detail.resourceIdx)
      if (idx !== null && idx <= 1) {
        return { text: '无溢出', color: '#12b886' }
      }
      if (idx === 2) {
        return { text: '轻度', color: '#f2c94c' }
      }
      return { text: '重度', color: '#f56c6c' }
    },
    getBusinessPointOverflowText(detail) {
      return this.getBusinessPointOverflowInfo(detail).text
    },
    getBusinessPointOverflowStyle(detail) {
      const info = this.getBusinessPointOverflowInfo(detail)
      return {
        color: detail && detail.markerColor ? detail.markerColor : info.color
      }
    },
    isBusinessHospitalityPointDetail(detail) {
      if (!detail) {
        return false
      }
      const text = [
        detail.resourceName,
        detail.categoryName,
        detail.typeName,
        detail.type,
        detail.name
      ].map(item => String(item || '')).join('')
      if (/(酒店|住宿|民宿|餐饮|餐厅|美食|门店)/.test(text)) {
        return true
      }
      const key = String(detail.categoryKey || '').toLowerCase()
      return /(hotel|homestay|restaurant|catering|dining|food)/.test(key)
    },
    formatBusinessPointDetailValue(value) {
      if (value === undefined || value === null || value === '') {
        return '--'
      }
      return value
    },
    getBusinessResourcePointsForResource(resource) {
      if (this.businessResourcePointLoaded) {
        const resourceCategoryKey = this.getBusinessResourceCategoryKey(resource)
        return this.businessResourcePointList.filter(point => {
          return point.categoryKey === resourceCategoryKey && this.isBusinessResourcePointInCurrentFence(point)
        })
      }
      return (resource && resource.points ? resource.points : []).filter(point => this.isBusinessResourcePointInCurrentFence(point))
    },
    getBusinessResourceCategoryKey(resource) {
      if (!resource) {
        return ''
      }
      const value = resource.categoryId !== undefined ? resource.categoryId : (resource.id !== undefined ? resource.id : resource.typeId)
      return this.normalizeBusinessResourceCategoryKey(value)
    },
    isBusinessResourcePointInCurrentFence(point) {
      if (!point || !point.position) {
        return false
      }
      const fencePoints = this.getBusinessFenceAreaPoints()
      if (fencePoints.length < 3) {
        return true
      }
      const lat = this.getBusinessFencePointLat(point.position)
      const lng = this.getBusinessFencePointLng(point.position)
      return this.isBusinessPointInFence(lat, lng, fencePoints)
    },
    normalizeBusinessResourcePoint(resource, item, index) {
      const lngLat = this.parseBusinessResourceLngLat(item && item.lng_lat)
      if (!lngLat) {
        return null
      }
      const categoryId = this.getBusinessResourcePointCategoryId(item)
      const categoryKey = this.normalizeBusinessResourceCategoryKey(categoryId)
      const resourceKey = resource && resource.key ? resource.key : ('business_resource_' + (categoryKey || 'all'))
      return {
        id: resourceKey + '-point-' + (item && item.id !== undefined ? item.id : index),
        categoryId: categoryId,
        categoryKey: categoryKey,
        pointId: item && item.id,
        idx: item && item.idx,
        name: item && item.name ? item.name : ((resource && resource.name ? resource.name : '点位') + (index + 1)),
        position: new TMap.LatLng(lngLat.lat, lngLat.lng)
      }
    },
    getBusinessResourcePointCategoryId(item) {
      if (!item || typeof item !== 'object') {
        return ''
      }
      const fields = ['category_id', 'categoryId', 'categoryID', 'category', 'type_id', 'typeId', 'resource_type_id', 'resourceTypeId']
      for (let i = 0; i < fields.length; i += 1) {
        const value = item[fields[i]]
        if (value !== undefined && value !== null && value !== '') {
          return value && typeof value === 'object' ? value.id : value
        }
      }
      return ''
    },
    normalizeBusinessResourceCategoryKey(value) {
      if (value === undefined || value === null || value === '') {
        return ''
      }
      return String(value)
    },
    parseBusinessResourceLngLat(value) {
      if (Array.isArray(value) && value.length >= 2) {
        return this.normalizeBusinessResourceLngLatPair(value[0], value[1])
      }
      if (value && typeof value === 'object') {
        const lng = value.lng !== undefined ? value.lng : value.longitude
        const lat = value.lat !== undefined ? value.lat : value.latitude
        return this.normalizeBusinessResourceLngLatPair(lng, lat)
      }
      const parts = String(value || '').trim().split(/[,，\s]+/).map(item => Number(item.trim()))
      if (parts.length < 2) {
        return null
      }
      return this.normalizeBusinessResourceLngLatPair(parts[0], parts[1])
    },
    normalizeBusinessResourceLngLatPair(firstValue, secondValue) {
      const first = Number(firstValue)
      const second = Number(secondValue)
      if (!isFinite(first) || !isFinite(second)) {
        return null
      }
      const firstLooksLat = Math.abs(first) <= 90 && Math.abs(second) > 90
      return firstLooksLat
        ? { lat: first, lng: second }
        : { lat: second, lng: first }
    },
    updateBusinessResourcePoints(resourceKey, points) {
      const updater = item => item.key === resourceKey ? Object.assign({}, item, { points }) : item
      if (this.businessResourceList.length) {
        this.businessResourceList = this.businessResourceList.map(updater)
      } else {
        this.businessResourceSeedList = this.businessResourceSeedList.map(updater)
      }
    },
    getBusinessResourceFallbackPoints(resource) {
      const areaPoints = this.getBusinessFenceAreaPoints()
      const fallbackFencePoints = areaPoints.length >= 3 ? areaPoints : this.getBusinessDefaultResourceFencePoints()
      return this.buildBusinessResourcePoints(resource, resource.value || resource.base || 18, 0, fallbackFencePoints)
    },
    getBusinessDefaultResourceFencePoints() {
      const center = WUYUAN_CENTER
      return [
        new TMap.LatLng(center.lat + 0.035, center.lng - 0.045),
        new TMap.LatLng(center.lat + 0.035, center.lng + 0.045),
        new TMap.LatLng(center.lat - 0.035, center.lng + 0.045),
        new TMap.LatLng(center.lat - 0.035, center.lng - 0.045)
      ]
    },
    getBusinessResourceShape(resource) {
      const key = resource.key || ''
      const name = resource.name || ''
      const keyMap = {
        hotel: 'triangle',
        scenic_all: 'circle',
        restaurant: 'diamond',
        parking: 'square',
        monitor: 'circle',
        village_spot: 'circle',
        venue: 'pin'
      }
      if (keyMap[key]) return keyMap[key]
      if (name.indexOf('酒店') !== -1 || name.indexOf('宾馆') !== -1 || name.indexOf('民宿') !== -1) return 'triangle'
      if (name.indexOf('景点') !== -1 || name.indexOf('景区') !== -1) return 'circle'
      if (name.indexOf('餐饮') !== -1 || name.indexOf('餐厅') !== -1 || name.indexOf('饭店') !== -1) return 'diamond'
      if (name.indexOf('厕所') !== -1 || name.indexOf('洗手间') !== -1 || name.indexOf('卫生间') !== -1) return 'hexagon'
      if (name.indexOf('购物') !== -1) return 'square'
      if (name.indexOf('警务') !== -1) return 'pentagon'
      if (name.indexOf('公交') !== -1 || name.indexOf('巴士') !== -1) return 'square'
      if (name.indexOf('观景台') !== -1) return 'star'
      if (name.indexOf('游客中心') !== -1 || name.indexOf('游客') !== -1) return 'circle'
      if (name.indexOf('售票') !== -1) return 'diamond'
      if (name.indexOf('停车') !== -1) return 'square'
      if (name.indexOf('乡村') !== -1) return 'circle'
      if (name.indexOf('检测') !== -1 || name.indexOf('监控') !== -1) return 'circle'
      if (name.indexOf('园馆') !== -1 || name.indexOf('场馆') !== -1) return 'pin'
      return 'circle'
    },
    buildBusinessResourceIcon(color, resource) {
      const safeColor = encodeURIComponent(color || '#8fffff')
      const shape = resource ? this.getBusinessResourceShape(resource) : 'circle'
      const pre = 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cdefs%3E%3Cfilter%20id%3D%22s%22%3E%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221.2%22%20flood-opacity%3D%220.3%22/%3E%3C/filter%3E%3C/defs%3E'
      switch (shape) {
        case 'triangle':
          return pre + '%3Cpath%20d%3D%22M10%200.5L19%2018L1%2018Z%22%20fill%3D%22' + safeColor + '%22%20filter%3D%22url(%23s)%22/%3E%3C/svg%3E'
        case 'diamond':
          return pre + '%3Cpath%20d%3D%22M10%200.5L19%2010L10%2019.5L1%2010Z%22%20fill%3D%22' + safeColor + '%22%20filter%3D%22url(%23s)%22/%3E%3C/svg%3E'
        case 'square':
          return pre + '%3Crect%20x%3D%222%22%20y%3D%222%22%20width%3D%2216%22%20height%3D%2216%22%20rx%3D%223%22%20fill%3D%22' + safeColor + '%22%20filter%3D%22url(%23s)%22/%3E%3C/svg%3E'
        case 'hexagon':
          return pre + '%3Cpath%20d%3D%22M10%200.5L19%205.5L19%2014.5L10%2019.5L1%2014.5L1%205.5Z%22%20fill%3D%22' + safeColor + '%22%20filter%3D%22url(%23s)%22/%3E%3C/svg%3E'
        case 'pentagon':
          return pre + '%3Cpath%20d%3D%22M10%200.5L19%207L16%2019.5L4%2019.5L1%207Z%22%20fill%3D%22' + safeColor + '%22%20filter%3D%22url(%23s)%22/%3E%3C/svg%3E'
        case 'star':
          return pre + '%3Cpath%20d%3D%22M10%200.5L12.5%207.5L20%208L14%2013L15.5%2020L10%2016L4.5%2020L6%2013L0%208L7.5%207.5Z%22%20fill%3D%22' + safeColor + '%22%20filter%3D%22url(%23s)%22/%3E%3C/svg%3E'
        case 'pin':
          return 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2220%22%20height%3D%2228%22%20viewBox%3D%220%200%2020%2028%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cdefs%3E%3Cfilter%20id%3D%22s%22%3E%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221.2%22%20flood-opacity%3D%220.3%22/%3E%3C/filter%3E%3C/defs%3E%3Cpath%20d%3D%22M10%2028C13%2022%2020%2017%2020%2010C20%204.48%2015.52%200%2010%200C4.48%200%200%204.48%200%2010C0%2017%207%2022%2010%2028Z%22%20fill%3D%22' + safeColor + '%22%20filter%3D%22url(%23s)%22/%3E%3Ccircle%20cx%3D%2210%22%20cy%3D%229%22%20r%3D%224.5%22%20fill%3D%22%23fff%22%20opacity%3D%220.92%22/%3E%3C/svg%3E'
        default:
          return pre + '%3Ccircle%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%228%22%20fill%3D%22' + safeColor + '%22%20filter%3D%22url(%23s)%22/%3E%3Ccircle%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%223.5%22%20fill%3D%22%23fff%22%20opacity%3D%220.92%22/%3E%3C/svg%3E'
      }
    },
    isResourceItemActive(item) {
      if (!item || !item.key) {
        return false
      }
      return this.activeResourceItemKeys.indexOf(item.key) !== -1
    },
    isBusinessResourceSelected(item) {
      return !!(item && item.key && this.selectedBusinessResourceKeys.indexOf(item.key) !== -1)
    },
    handleResourceItemClick(item) {
      if (!item || !item.key) {
        return
      }
      if (this.typeIndex === 5) {
        const currentIndex = this.selectedBusinessResourceKeys.indexOf(item.key)
        if (currentIndex === -1) {
          this.selectedBusinessResourceKeys.push(item.key)
        } else {
          this.selectedBusinessResourceKeys.splice(currentIndex, 1)
        }
        this.refreshBusinessAreaStats(this.getCurrentBusinessMetric())
        this.renderBusinessResourceMarkers()
        return
      }
      if (item.key === SCENIC_4A_RESOURCE_KEY) {
        this.toggleScenic4AResource()
      }
    },
    toggleResourceItemKey(key, forceActive) {
      if (!key) {
        return false
      }
      const currentIndex = this.activeResourceItemKeys.indexOf(key)
      const shouldActivate = typeof forceActive === 'boolean' ? forceActive : currentIndex === -1
      if (shouldActivate && currentIndex === -1) {
        this.activeResourceItemKeys.push(key)
      }
      if (!shouldActivate && currentIndex !== -1) {
        this.activeResourceItemKeys.splice(currentIndex, 1)
      }
      return shouldActivate
    },
    toggleScenic4AResource(forceActive) {
      const shouldActivate = this.toggleResourceItemKey(SCENIC_4A_RESOURCE_KEY, forceActive)
      if (shouldActivate) {
        this.renderScenic4AMarkerLayer()
      } else {
        this.removeScenic4AMarkerLayer()
      }
    },
    removeScenic4AMarkerLayer() {
      if (this.scenic4AMarkerLayer && this.scenic4AMarkerLayer.setMap) {
        this.scenic4AMarkerLayer.setMap(null)
      }
      this.scenic4AMarkerLayer = null
      if (this.scenic4ALabelLayer && this.scenic4ALabelLayer.setMap) {
        this.scenic4ALabelLayer.setMap(null)
      }
      this.scenic4ALabelLayer = null
    },
    renderScenic4AMarkerLayer() {
      if (!this.map || this.typeIndex !== 2) {
        return
      }

      this.removeScenic4AMarkerLayer()

      const markerGeometries = SCENIC_4A_SPOTS.map(item => ({
        id: item.id,
        styleId: 'scenic4a',
        position: new TMap.LatLng(item.lat, item.lng),
        properties: {
          title: item.name
        }
      }))
      const labelGeometries = SCENIC_4A_SPOTS.map(item => ({
        id: item.id + '-label',
        styleId: 'scenic4aLabel',
        position: new TMap.LatLng(item.lat, item.lng),
        content: item.name,
        rank: 12,
        properties: {
          title: item.name
        }
      }))

      this.scenic4AMarkerLayer = new TMap.MultiMarker({
        id: 'scenic4a-marker-layer',
        map: this.map,
        zIndex: 12,
        styles: {
          scenic4a: new TMap.MarkerStyle({
            width: 18,
            height: 24,
            src: LOCATION_ICON_URL,
            anchor: { x: 9, y: 24 }
          })
        },
        disableInteractive: true,
        isStopPropagation: false,
        geometries: markerGeometries
      })

      this.scenic4ALabelLayer = new TMap.MultiLabel({
        id: 'scenic4a-label-layer',
        map: this.map,
        zIndex: 13,
        styles: {
          scenic4aLabel: new TMap.LabelStyle({
            color: '#1f2937',
            size: 15,
            offset: { x: 0, y: -42 },
            angle: 0,
            alignment: 'center',
            verticalAlignment: 'middle',
            padding: '7px 12px',
            backgroundColor: '#ffffff',
            borderWidth: 1,
            borderRadius: 6,
            borderColor: '#dcdfe6'
          })
        },
        disableInteractive: true,
        isStopPropagation: false,
        geometries: labelGeometries
      })
    },
    syncDashboardResourceOverlays() {
      if (this.isResourceItemActive({ key: SCENIC_4A_RESOURCE_KEY })) {
        this.renderScenic4AMarkerLayer()
      } else {
        this.removeScenic4AMarkerLayer()
      }
    },
    ensureWuyuanBoundaryReady() {
      if (this.boundaryGeometries.length) {
        this.calculateBoundaryBounds()
        return Promise.resolve(this.boundaryGeometries)
      }
      if (this.boundaryLoadingPromise) {
        return this.boundaryLoadingPromise
      }

      this.boundaryLoadingPromise = fetchJsonWithFallback(WUYUAN_BOUNDARY_URLS)
        .then(data => {
          const parsedBoundary = this.parseBoundaryGeometries(data)
          this.boundaryGeometries = parsedBoundary.geometries
          this.boundaryHitPolygons = parsedBoundary.hitPolygons
          this.calculateBoundaryBounds()
          return this.boundaryGeometries
        })
        .catch(error => {
          this.boundaryGeometries = []
          this.boundaryHitPolygons = []
          this.boundaryBounds = null
          this.viewportBounds = null
          console.warn('[ScenicData] 婺源县边界数据加载失败，已降级为婺源县外接范围。', error)
          return []
        })
        .then(result => {
          this.boundaryLoadingPromise = null
          return result
        }, error => {
          this.boundaryLoadingPromise = null
          throw error
        })

      return this.boundaryLoadingPromise
    },
    parseBoundaryGeometries(geojson) {
      const geometries = []
      const hitPolygons = []
      let geometryIndex = 0
      const features = geojson && geojson.features ? geojson.features : []

      const appendPolygon = polygonCoordinates => {
        if (!polygonCoordinates || !polygonCoordinates.length) {
          return
        }
        const paths = polygonCoordinates.map(ring => {
          return ring.map(point => ({
            lat: Number(point[1]),
            lng: Number(point[0])
          }))
        }).filter(ring => ring.length > 2)

        if (!paths.length) {
          return
        }

        geometries.push({
          id: 'wuyuan-boundary-' + geometryIndex++,
          styleId: 'boundary',
          paths: paths.length === 1 ? paths[0] : paths
        })
        hitPolygons.push(paths)
      }

      for (let index = 0; index < features.length; index++) {
        const geometry = features[index].geometry || {}
        if (geometry.type === 'Polygon') {
          appendPolygon(geometry.coordinates)
        } else if (geometry.type === 'MultiPolygon') {
          for (let polygonIndex = 0; polygonIndex < geometry.coordinates.length; polygonIndex++) {
            appendPolygon(geometry.coordinates[polygonIndex])
          }
        }
      }

      return {
        geometries,
        hitPolygons
      }
    },
    calculateBoundaryBounds() {
      if (!this.boundaryGeometries.length) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      let minLat = Infinity
      let maxLat = -Infinity
      let minLng = Infinity
      let maxLng = -Infinity

      const walkPoints = points => {
        for (let index = 0; index < points.length; index++) {
          const point = points[index]
          if (Array.isArray(point)) {
            walkPoints(point)
          } else if (point && typeof point.lat === 'number' && typeof point.lng === 'number') {
            minLat = Math.min(minLat, point.lat)
            maxLat = Math.max(maxLat, point.lat)
            minLng = Math.min(minLng, point.lng)
            maxLng = Math.max(maxLng, point.lng)
          }
        }
      }

      for (let index = 0; index < this.boundaryGeometries.length; index++) {
        walkPoints(this.boundaryGeometries[index].paths)
      }

      if (!isFinite(minLat) || !isFinite(maxLat) || !isFinite(minLng) || !isFinite(maxLng)) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      this.boundaryBounds = {
        sw: new TMap.LatLng(minLat, minLng),
        ne: new TMap.LatLng(maxLat, maxLng)
      }
      const latSpan = maxLat - minLat
      const lngSpan = maxLng - minLng
      const latPadding = latSpan * WUYUAN_VIEW_VERTICAL_PADDING_RATIO
      const lngPadding = lngSpan * WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO
      this.viewportBounds = {
        sw: new TMap.LatLng(minLat - latPadding, minLng - lngPadding),
        ne: new TMap.LatLng(maxLat + latPadding, maxLng + lngPadding)
      }
      return this.boundaryBounds
    },
    getMapPointLat(point) {
      if (!point) {
        return NaN
      }
      return Number(typeof point.getLat === 'function' ? point.getLat() : point.lat)
    },
    getMapPointLng(point) {
      if (!point) {
        return NaN
      }
      return Number(typeof point.getLng === 'function' ? point.getLng() : point.lng)
    },
    getWuyuanFallbackBounds() {
      return {
        sw: new TMap.LatLng(WUYUAN_FALLBACK_BOUNDS.minLat, WUYUAN_FALLBACK_BOUNDS.minLng),
        ne: new TMap.LatLng(WUYUAN_FALLBACK_BOUNDS.maxLat, WUYUAN_FALLBACK_BOUNDS.maxLng)
      }
    },
    normalizeWuyuanCenter(center) {
      const lat = this.getMapPointLat(center)
      const lng = this.getMapPointLng(center)
      if (isFinite(lat) && isFinite(lng) && this.isPointInWuyuanBoundary(center)) {
        return center
      }
      return new TMap.LatLng(WUYUAN_CENTER.lat, WUYUAN_CENTER.lng)
    },
    isPointInWuyuanBoundary(point) {
      const lat = this.getMapPointLat(point)
      const lng = this.getMapPointLng(point)
      if (!isFinite(lat) || !isFinite(lng)) {
        return false
      }
      if (this.boundaryHitPolygons.length) {
        return this.boundaryHitPolygons.some(polygon => this.isPointInBoundaryPolygon(lat, lng, polygon))
      }
      const bounds = this.boundaryBounds || this.getWuyuanFallbackBounds()
      return lat >= this.getMapPointLat(bounds.sw) &&
        lat <= this.getMapPointLat(bounds.ne) &&
        lng >= this.getMapPointLng(bounds.sw) &&
        lng <= this.getMapPointLng(bounds.ne)
    },
    isSegmentInWuyuanBoundary(startPoint, endPoint) {
      const startLat = this.getMapPointLat(startPoint)
      const startLng = this.getMapPointLng(startPoint)
      const endLat = this.getMapPointLat(endPoint)
      const endLng = this.getMapPointLng(endPoint)
      if (!isFinite(startLat) || !isFinite(startLng) || !isFinite(endLat) || !isFinite(endLng)) {
        return false
      }
      if (this.boundaryHitPolygons.length) {
        return this.boundaryHitPolygons.some(polygon => {
          if (!this.isPointInBoundaryPolygon(startLat, startLng, polygon) || !this.isPointInBoundaryPolygon(endLat, endLng, polygon)) {
            return false
          }
          return !polygon.some(ring => this.doesSegmentCrossBoundaryRing(startPoint, endPoint, ring))
        })
      }
      const sampleCount = 14
      for (let index = 0; index <= sampleCount; index++) {
        const ratio = index / sampleCount
        const samplePoint = {
          lat: startLat + (endLat - startLat) * ratio,
          lng: startLng + (endLng - startLng) * ratio
        }
        if (!this.isPointInWuyuanBoundary(samplePoint)) {
          return false
        }
      }
      return true
    },
    doesSegmentCrossBoundaryRing(startPoint, endPoint, ring) {
      if (!ring || ring.length < 2) {
        return false
      }
      for (let index = 0; index < ring.length; index++) {
        const ringStart = ring[index]
        const ringEnd = ring[(index + 1) % ring.length]
        if (this.doBusinessFenceSegmentsIntersect(startPoint, endPoint, ringStart, ringEnd)) {
          return true
        }
      }
      return false
    },
    isPointInBoundaryPolygon(lat, lng, polygonRings) {
      if (!polygonRings || !polygonRings.length || !this.isPointInBoundaryRing(lat, lng, polygonRings[0])) {
        return false
      }
      for (let index = 1; index < polygonRings.length; index++) {
        if (this.isPointInBoundaryRing(lat, lng, polygonRings[index])) {
          return false
        }
      }
      return true
    },
    isPointInBoundaryRing(lat, lng, ring) {
      if (!ring || ring.length < 3) {
        return false
      }
      let isInside = false
      for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        const pointI = ring[i]
        const pointJ = ring[j]
        const latI = this.getMapPointLat(pointI)
        const lngI = this.getMapPointLng(pointI)
        const latJ = this.getMapPointLat(pointJ)
        const lngJ = this.getMapPointLng(pointJ)
        const intersects = ((latI > lat) !== (latJ > lat)) &&
          (lng < (lngJ - lngI) * (lat - latI) / (latJ - latI || 0.000001) + lngI)
        if (intersects) {
          isInside = !isInside
        }
      }
      return isInside
    },
    applyWuyuanMapBoundary(mapOptions) {
      const options = Object.assign({}, mapOptions)
      const mapBounds = this.viewportBounds || this.boundaryBounds || this.getWuyuanFallbackBounds()
      const minZoom = Math.max(Number(options.minZoom || 0), WUYUAN_MAP_MIN_ZOOM)
      options.minZoom = minZoom
      if (options.zoom) {
        options.zoom = Math.max(Number(options.zoom), minZoom)
      } else {
        options.zoom = minZoom
      }
      if (mapBounds) {
        options.boundary = new TMap.LatLngBounds(mapBounds.sw, mapBounds.ne)
      }
      options.center = this.normalizeWuyuanCenter(options.center)
      return options
    },
    createRestrictedWuyuanMap(containerId, mapOptions) {
      this.map = new TMap.Map(containerId, this.applyWuyuanMapBoundary(mapOptions))
      this.bindWuyuanMapGuard()
      this.renderWuyuanBoundaryLayer()
      return this.map
    },
    bindWuyuanMapGuard() {
      if (!this.map || !this.map.on) {
        return
      }
      this.unbindWuyuanMapGuard()
      const handleBoundsChange = () => {
        this.limitWuyuanMapViewport()
      }
      this.wuyuanMapGuardHandlers = {
        dragend: handleBoundsChange,
        zoom_changed: handleBoundsChange
      }
      this.map.on('dragend', handleBoundsChange)
      this.map.on('zoom_changed', handleBoundsChange)
    },
    unbindWuyuanMapGuard() {
      if (!this.map || !this.map.off || !this.wuyuanMapGuardHandlers) {
        this.wuyuanMapGuardHandlers = null
        return
      }
      this.map.off('dragend', this.wuyuanMapGuardHandlers.dragend)
      this.map.off('zoom_changed', this.wuyuanMapGuardHandlers.zoom_changed)
      this.wuyuanMapGuardHandlers = null
    },
    limitWuyuanMapViewport() {
      if (!this.map || this.isWuyuanViewportResetting) {
        return
      }
      const center = this.map.getCenter && this.map.getCenter()
      const minZoom = WUYUAN_MAP_MIN_ZOOM
      const zoom = this.map.getZoom && this.map.getZoom()
      const shouldResetCenter = center && !this.isPointInWuyuanBoundary(center)
      const shouldResetZoom = isFinite(Number(zoom)) && Number(zoom) < minZoom
      if (!shouldResetCenter && !shouldResetZoom) {
        return
      }
      this.isWuyuanViewportResetting = true
      if (shouldResetCenter && this.map.setCenter) {
        this.map.setCenter(new TMap.LatLng(WUYUAN_CENTER.lat, WUYUAN_CENTER.lng))
      }
      if (shouldResetZoom && this.map.setZoom) {
        this.map.setZoom(minZoom)
      }
      this.$nextTick(() => {
        this.isWuyuanViewportResetting = false
      })
    },
    renderWuyuanBoundaryLayer() {
      if (!this.map || !this.boundaryGeometries.length) {
        return
      }

      this.renderWuyuanBoundaryMaskLayer()

      if (this.boundaryLayer && this.boundaryLayer.setMap) {
        this.boundaryLayer.setMap(null)
      }

      const boundaryStyle = new TMap.PolygonStyle({
        color: 'rgba(47, 128, 237, 0.08)',
        showBorder: true,
        borderColor: 'rgba(47, 128, 237, 0.72)',
        borderWidth: 3
      })

      this.boundaryLayer = new TMap.MultiPolygon({
        map: this.map,
        zIndex: 2,
        styles: {
          boundary: boundaryStyle
        },
        geometries: this.boundaryGeometries
      })
    },
    renderWuyuanBoundaryMaskLayer() {
      if (!this.map || !this.boundaryHitPolygons.length) {
        return
      }

      if (this.boundaryMaskLayer && this.boundaryMaskLayer.setMap) {
        this.boundaryMaskLayer.setMap(null)
      }

      const maskStyle = new TMap.PolygonStyle({
        color: 'rgba(242, 246, 250, 0.72)',
        showBorder: false
      })
      const worldRing = [
        { lat: 85, lng: -180 },
        { lat: 85, lng: 180 },
        { lat: -85, lng: 180 },
        { lat: -85, lng: -180 }
      ]
      const maskPaths = [worldRing]
      this.boundaryHitPolygons.forEach(polygon => {
        polygon.forEach(ring => {
          maskPaths.push(ring.slice().reverse())
        })
      })

      this.boundaryMaskLayer = new TMap.MultiPolygon({
        map: this.map,
        zIndex: 1,
        styles: {
          wuyuanMask: maskStyle
        },
        geometries: [{
          id: 'wuyuan-map-mask',
          styleId: 'wuyuanMask',
          paths: maskPaths
        }]
      })
    },
    createDashboardMap() {
      const dashboardMapZoom = Math.max(Number(this.setting.map_show || 0), WUYUAN_MAP_MIN_ZOOM)
      const maxZoom = Math.max(dashboardMapZoom + 2.3, 14)
      const center = new TMap.LatLng(
        WUYUAN_CENTER.lat + Number(this.setting.lat_offset || 0),
        WUYUAN_CENTER.lng + Number(this.setting.lng_offset || 0)
      )
      const mapOptions = {
        zoom: dashboardMapZoom,
        minZoom: dashboardMapZoom,
        maxZoom: maxZoom,
        pitch: 0,
        center: center,
        showControl: false,
        baseMap: {
          type: 'vector',
          features: ['base', 'building3d', 'point']
        }
      }

      this.createRestrictedWuyuanMap('migrateMap', mapOptions)
      this.syncDashboardResourceOverlays()
    },
    startWarningPushBoardTimer() {
      this.clearWarningPushBoardTimer()
      this.warningPushBoardVisible = false
      this.warningPushBoardTimer = setTimeout(() => {
        this.warningPushBoardVisible = true
        this.warningPushBoardTimer = null
      }, 5000)
    },
    clearWarningPushBoardTimer() {
      if (this.warningPushBoardTimer) {
        clearTimeout(this.warningPushBoardTimer)
        this.warningPushBoardTimer = null
      }
    },
    closeWarningPushBoard() {
      this.warningPushBoardVisible = false
      this.clearWarningPushBoardTimer()
    },
    createFlvPlayer(videoElement, url, options) {
      if (!videoElement || typeof flvjs === 'undefined' || !flvjs.isSupported()) {
        return null
      }
      var playerOptions = options || {}
      if (playerOptions.muted) {
        videoElement.muted = true
      }
      var player = flvjs.createPlayer({
        type: 'flv',
        url: url,
        isLive: true,
        hasAudio: false,
        hasVideo: true,
        enableStashBuffer: false,
        stashInitialSize: 128,
        lazyLoad: false,
        lazyLoadMaxDuration: 0,
        seekType: 'range',
        cors: true
      })
      player.attachMediaElement(videoElement)
      player.load()
      var playPromise = player.play()
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => { })
      }
      return player
    },
    initSentimentPlayersIfNeeded() {
      if (this.typeIndex !== 3 || this.sentimentPlayers.length) {
        return
      }
      var videoConfigs = [
        { refName: 'sentimentVideoOne', url: SENTIMENT_STREAM_URLS[0] },
        { refName: 'sentimentVideoTwo', url: SENTIMENT_STREAM_URLS[1] }
      ]
      this.sentimentPlayers = videoConfigs.map(item => {
        var videoElement = this.$refs[item.refName]
        var player = this.createFlvPlayer(videoElement, item.url, { muted: true })
        if (!player) {
          return null
        }
        return {
          player: player,
          refName: item.refName
        }
      }).filter(Boolean)
    },
    destroySentimentPlayers() {
      if (!this.sentimentPlayers.length) {
        return
      }
      this.sentimentPlayers.forEach(item => {
        var videoElement = this.$refs[item.refName]
        try {
          if (item.player) {
            item.player.pause()
            item.player.unload()
            item.player.detachMediaElement()
            item.player.destroy()
          }
        } catch (error) {
        }
        if (videoElement) {
          try {
            videoElement.pause()
            videoElement.removeAttribute('src')
            videoElement.load()
          } catch (error) {
          }
        }
      })
      this.sentimentPlayers = []
    },
    initPlayer(url) {
      var videoUrl = url || this.modalVideoUrl || DEFAULT_MONITOR_STREAM_URL
      this.modalVideoUrl = videoUrl
      this.destroyPlayer()
      this.player = this.createFlvPlayer(
        this.$refs.videoElement,
        videoUrl
      )
    },
    openDefaultMonitorVideo() {
      this.openMonitorVideo('篁岭晒秋平台', DEFAULT_MONITOR_STREAM_URL)
    },
    openMonitorVideo(title, url) {
      this.videoTitle = title || '视频监控'
      this.modalVideoUrl = url || DEFAULT_MONITOR_STREAM_URL
      this.videoElementKey += 1
      if (!this.showModal) {
        this.showModal = true
        return
      }
      this.$nextTick(() => {
        this.initPlayer(this.modalVideoUrl)
      })
    },
    closeModal() {
      this.showModal = false
    },
    destroyPlayer() {
      if (this.player) {
        try {
          this.player.pause()
          this.player.unload()
          this.player.detachMediaElement()
          this.player.destroy()
        } catch (error) {
        }
        this.player = null
      }
      if (this.$refs.videoElement) {
        try {
          this.$refs.videoElement.pause()
          this.$refs.videoElement.removeAttribute('src')
          this.$refs.videoElement.load()
        } catch (error) {
        }
      }
    },
    formatWarningCount(value) {
      var num = Number(value)
      if (isNaN(num)) {
        return '0'
      }
      return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    formatWarningPercent(value) {
      var num = Number(value)
      if (isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    buildWarningList() {
      var crowdingValue = Number(this.crowding) * Number(this.coefficient_data || 100) / 100
      var ticketValue = Number(this.ticket_of_data) * Number(this.coefficient_data || 100) / 100
      var inParkNum = Number(this.dateInSum.join(''))
      var totalNum = Number(this.dateSum.join(''))
      var crowdingText = '园区承载平稳，请保持现场巡检。'
      var ticketText = '售票压力可控，请持续关注入口排队情况。'

      if (crowdingValue >= 90) {
        crowdingText = '客流已接近承载上限，请立即安排人员进行疏导。'
      } else if (crowdingValue >= 80) {
        crowdingText = '客流处于高位，请提前部署园区分流力量。'
      } else if (crowdingValue >= 60) {
        crowdingText = '客流持续攀升，建议加强重点区域巡查。'
      }

      if (ticketValue >= 90) {
        ticketText = '售票占比过高，请视情况开放备用检票通道。'
      } else if (ticketValue >= 75) {
        ticketText = '售票压力持续走高，建议提前做好游客分流。'
      }

      var warningLength = this.warningList.length
      this.warningList = [
        {
          title: crowdingValue >= 80 ? '客流预警' : '园区承载',
          text: '在园游客饱和度 ' + this.formatWarningPercent(crowdingValue) + '%，' + crowdingText
        },
        {
          title: ticketValue >= 75 ? '售票预警' : '售票监测',
          text: '当日售票占比 ' + this.formatWarningPercent(ticketValue) + '%，' + ticketText
        },
        {
          title: '实时客流',
          text: '当前在园游客 ' + this.formatWarningCount(inParkNum) + ' 人，今日累计入园 ' + this.formatWarningCount(totalNum) + ' 人。'
        }
      ]

      if (this.warningCurrentIndex >= this.warningList.length) {
        this.warningCurrentIndex = 0
      }
      if (warningLength !== this.warningList.length) {
        this.startWarningScroll()
      } else if (!this.warningTimer && this.warningList.length > 1) {
        this.startWarningScroll()
      } else if (this.warningList.length <= 1) {
        this.stopWarningScroll()
      }
    },
    startWarningScroll() {
      this.stopWarningScroll()
      if (this.warningList.length <= 1) {
        return
      }
      let _this = this
      this.warningTimer = setInterval(function () {
        _this.warningCurrentIndex = (_this.warningCurrentIndex + 1) % _this.warningList.length
      }, 3000)
    },
    stopWarningScroll() {
      if (this.warningTimer) {
        clearInterval(this.warningTimer)
        this.warningTimer = null
      }
    },
    initVoiceRecognitionSupport() {
      this.voiceRecognitionSupported = !!(
        XfyunSpeechRecognizer &&
        typeof XfyunSpeechRecognizer.isSupported === 'function' &&
        XfyunSpeechRecognizer.isSupported()
      )
    },
    ensureVoiceRecognition() {
      if (this.voiceRecognition) {
        return this.voiceRecognition
      }
      if (!this.voiceRecognitionSupported) {
        return null
      }
      var recognition = createXfyunSpeechRecognizer({
        eos: VOICE_RECOGNITION_EOS_MS
      })
      recognition.on('start', () => {
        if (this.voiceRecognition !== recognition) {
          return
        }
        this.voiceStarting = false
        this.voiceListening = true
        this.voiceKeepListening = true
        this.voiceCommandHandled = false
        this.voiceEndReason = ''
        this.voiceSuppressEndStatus = false
        this.setVoiceStatus('语音持续监听中，请讲话', 'listening', true)
      })
      recognition.on('partialResult', payload => {
        if (this.voiceRecognition !== recognition || !this.voiceListening) {
          return
        }
        if (payload && payload.text) {
          if (this.handleVoiceRecognitionText(payload.text, { isPartial: true })) {
            return
          }
          this.setVoiceStatus('正在识别中', 'listening', true)
        }
      })
      recognition.on('finalResult', payload => {
        if (this.voiceRecognition !== recognition || this.voiceCommandHandled) {
          return
        }
        this.handleVoiceRecognitionText(payload && payload.text ? payload.text : '', {
          isPartial: false
        })
      })
      recognition.on('error', payload => {
        if (this.voiceRecognition !== recognition) {
          return
        }
        this.handleVoiceRecognitionError(payload)
      })
      recognition.on('close', () => {
        if (this.voiceRecognition !== recognition) {
          return
        }
        if (!this.voiceListening && !this.voiceStarting) {
          return
        }
        if (this.voiceKeepListening && this.voiceEndReason !== 'manual') {
          this.destroyVoiceRecognitionInstance({ preserveStatus: true, keepListening: true })
          this.setVoiceStatus('语音持续监听中', 'listening', true)
          this.scheduleVoiceRecognitionRestart()
          return
        }
        this.setVoiceStatus('语音连接已关闭，请重试', 'warning')
        this.destroyVoiceRecognitionInstance({ preserveStatus: true })
      })
      this.voiceRecognition = recognition
      return recognition
    },
    toggleVoiceRecognition() {
      if (this.voiceKeepListening || this.voiceListening || this.voiceStarting) {
        this.stopVoiceRecognition('manual')
        return
      }
      this.startVoiceRecognition()
    },
    async startVoiceRecognition() {
      if (this.voiceListening || this.voiceStarting) {
        return
      }
      this.voiceKeepListening = true
      this.clearVoiceRestartTimer()
      this.clearVoiceStatusTimer()
      var recognition = this.ensureVoiceRecognition()
      if (!recognition) {
        this.voiceRecognitionSupported = false
        this.voiceKeepListening = false
        this.setVoiceStatus('当前环境不支持讯飞语音识别', 'error')
        return
      }
      this.voiceCommandHandled = false
      this.voiceEndReason = ''
      this.voiceSuppressEndStatus = false
      this.voiceListening = false
      this.voiceStarting = true
      this.setVoiceStatus('正在启动语音监听', 'info', true)
      try {
        await recognition.startListening()
        if (this.voiceRecognition !== recognition) {
          return
        }
      } catch (error) {
        if (this.voiceRecognition !== recognition || this.voiceEndReason === 'manual') {
          return
        }
        this.voiceStarting = false
        this.voiceListening = false
        if (this.voiceKeepListening && !this.shouldStopVoiceRecognitionOnError(error)) {
          this.destroyVoiceRecognitionInstance({ preserveStatus: true, keepListening: true })
          this.setVoiceStatus(this.getVoiceErrorMessage(error) + '，正在重新连接', 'warning', true)
          this.scheduleVoiceRecognitionRestart(1200)
          return
        }
        this.voiceKeepListening = false
        this.destroyVoiceRecognitionInstance({ preserveStatus: true })
        this.setVoiceStatus(this.getVoiceErrorMessage(error), 'error')
      }
    },
    stopVoiceRecognition(reason) {
      var wasActive = this.voiceRecognition || this.voiceListening || this.voiceStarting || this.voiceRestartTimer || this.voiceKeepListening
      this.voiceEndReason = reason || ''
      this.voiceKeepListening = false
      this.clearVoiceRestartTimer()
      if (!wasActive) {
        return
      }
      if (reason === 'manual') {
        this.setVoiceStatus('已停止监听', 'info')
      } else if (reason === 'no-match') {
        this.setVoiceStatus('未识别到有效指令', 'warning')
      }
      this.destroyVoiceRecognitionInstance({ preserveStatus: true })
    },
    handleVoiceRecognitionText(text, options) {
      console.log('语音识别结果：', text)
      var matchOptions = options || {}
      var matched = this.findScenicVoiceCommandMatch(text, matchOptions) || findVoiceCommandMatch(text, {
        preventPrefixOnlyMatch: !!matchOptions.isPartial
      })
      if (!matched || !matched.command) {
        if (!matchOptions.isPartial) {
          this.restartVoiceRecognitionSession('未识别到有效指令，继续监听', 'warning')
        }
        return false
      }
      this.voiceCommandHandled = true
      this.destroyVoiceRecognitionInstance({ preserveStatus: true, keepListening: this.voiceKeepListening })
      this.executeVoiceCommand(matched.command)
      this.scheduleVoiceRecognitionRestart(600)
      return true
    },
    findScenicVoiceCommandMatch(text, options) {
      const normalizedText = this.normalizeScenicVoiceText(text)
      if (!normalizedText) {
        return null
      }
      if (options && options.isPartial && normalizedText.length < 3) {
        return null
      }
      const command = this.buildScenicVoiceCommand(normalizedText)
      return command ? { command, transcript: text } : null
    },
    normalizeScenicVoiceText(text) {
      return String(text || '')
        .replace(/[，。！？、,.!?\s]/g, '')
        .replace(/请/g, '')
        .replace(/帮我/g, '')
        .replace(/把/g, '')
        .replace(/一下/g, '')
        .replace(/页面/g, '')
        .replace(/界面/g, '')
        .trim()
    },
    buildScenicVoiceCommand(text) {
      const busRouteCommand = this.buildVoiceBusRouteCommand(text)
      if (busRouteCommand) return busRouteCommand
      const typeCommand = this.buildScenicVoiceTypeCommand(text)
      if (typeCommand) return typeCommand
      const metricCommand = this.buildVoiceMetricCommand(text)
      if (metricCommand) return metricCommand
      const videoCommand = this.buildVoiceVideoStreamCommand(text)
      if (videoCommand) return videoCommand
      const businessPointCommand = this.buildBusinessPointVoiceCommand(text)
      if (businessPointCommand) return businessPointCommand
      const businessResourceCommand = this.buildBusinessResourceVoiceCommand(text)
      if (businessResourceCommand) return businessResourceCommand
      const businessFenceCommand = this.buildBusinessFenceVoiceCommand(text)
      if (businessFenceCommand) return businessFenceCommand
      const dateCommand = this.buildVoiceDateCommand(text)
      if (dateCommand) return dateCommand
      return null
    },
    buildVoiceBusRouteCommand(text) {
      if (!/(公交路线图|公交路线|旅游公交路线图|旅游公交实时路线图|公交实时路线)/.test(text)) {
        return null
      }
      if (!/(打开|查看|进入|调出|调取|展示|显示)/.test(text)) {
        return null
      }
      return {
        id: 'open-bus-route-viewer',
        label: '打开公交路线图',
        action: 'openBusRouteViewer'
      }
    },
    buildVoiceDateCommand(text) {
      if (!/(切换|打开|进入|回到|跳到|上一天|下一天|前一天|后一天|昨天|明天|今日|今天|昨日|明日|前日|次日)/.test(text)) {
        return null
      }
      if (/(回到今天|回到今日|切换今天|切换今日|打开今天|打开今日|进入今天|进入今日|跳到今天|跳到今日|当天)/.test(text)) {
        return {
          id: 'go-today',
          label: '今日',
          action: 'changeDate',
          payload: { day: 0 }
        }
      }
      if (/(前一天|上一天|前日|昨日|昨天)/.test(text)) {
        return {
          id: 'go-prev-day',
          label: '前一天',
          action: 'changeDate',
          payload: { day: -1 }
        }
      }
      if (/(后一天|下一天|次日|明天|明日)/.test(text)) {
        return {
          id: 'go-next-day',
          label: '后一天',
          action: 'changeDate',
          payload: { day: 1 }
        }
      }
      return null
    },
    buildVoiceMetricCommand(text) {
      if (!/(查询|查看|播报|告诉|多少|人数|客流|游客|指标|数据|入园|出园|在园)/.test(text)) {
        return null
      }
      const metric = VOICE_METRIC_QUERY_LIST.find(item => {
        return item.aliases.some(alias => text.indexOf(this.normalizeScenicVoiceText(alias)) !== -1)
      })
      if (!metric) {
        return null
      }
      return {
        id: 'metric-query-' + metric.key,
        label: '查询' + metric.title,
        action: 'queryMetric',
        payload: {
          metricKey: metric.key,
          targetTypeIndex: metric.targetTypeIndex
        }
      }
    },
    buildVoiceVideoStreamCommand(text) {
      if (!/(视频|监控|摄像头|画面|窗口|视频流)/.test(text)) {
        return null
      }
      if (/(关闭|关掉|隐藏)/.test(text) && /(视频|监控|窗口|画面)/.test(text)) {
        return {
          id: 'close-video-stream',
          label: '关闭视频流窗口',
          action: 'closeVideoStream'
        }
      }
      const stream = this.findVoiceVideoStreamByText(text)
      if (!stream) {
        if (text.indexOf('视频监控') !== -1 && !/(弹出|调取|调出|播放|窗口|画面|摄像头|视频流)/.test(text)) {
          return null
        }
        if (!/(弹出|调取|调出|播放|查看|打开)(监控视频|视频流|视频窗口|监控画面|摄像头|实时视频|实时画面)/.test(text)) {
          return null
        }
      }
      const targetStream = stream || VOICE_VIDEO_STREAM_LIST[0]
      return {
        id: 'play-video-stream-' + targetStream.name,
        label: '调取' + targetStream.name + '视频流',
        action: 'playVideoStream',
        payload: {
          streamName: targetStream.name,
          streamUrl: targetStream.url
        }
      }
    },
    findVoiceVideoStreamByText(text) {
      return VOICE_VIDEO_STREAM_LIST.find(item => {
        const names = [item.name].concat(item.aliases || [])
        return names.some(name => {
          const normalizedName = this.normalizeScenicVoiceText(name)
          return normalizedName && (text.indexOf(normalizedName) !== -1 || normalizedName.indexOf(text) !== -1)
        })
      })
    },
    buildScenicVoiceTypeCommand(text) {
      const target = VOICE_PAGE_TARGET_LIST.find(item => item.aliases.some(alias => text.indexOf(this.normalizeScenicVoiceText(alias)) !== -1))
      if (!target) {
        return null
      }
      return {
        id: 'switch-' + target.typeIndex,
        label: '切换到' + target.label,
        action: 'switchType',
        payload: {
          typeIndex: target.typeIndex
        }
      }
    },
    buildBusinessResourceVoiceCommand(text) {
      if (!/(资源|点位|气泡|文字|标签|名称|酒店|住宿|民宿|餐饮|餐厅|美食|互娱|娱乐|园馆|场馆|停车|景区|乡村|检测|监测)/.test(text)) {
        return null
      }
      if (/(气泡|文字|标签|名称)/.test(text)) {
        const shouldShow = /(?:显示|打开|展示|开启)/.test(text)
        const shouldHide = /(?:隐藏|关闭|取消|关掉)/.test(text)
        if (shouldShow || shouldHide) {
          return {
            id: 'business-resource-label-' + (shouldShow ? 'show' : 'hide'),
            label: (shouldShow ? '显示' : '关闭') + '点位文字',
            action: 'businessResourceLabel',
            payload: { visible: shouldShow }
          }
        }
      }
      if (/(隐藏全部|关闭全部|取消全部|清空|关闭所有|隐藏所有)/.test(text)) {
        return {
          id: 'business-resource-clear',
          label: '清空业态资源点位',
          action: 'businessResourceControl',
          payload: { control: 'clear' }
        }
      }
      if (/(显示全部|打开全部|展示全部|打开所有|显示所有)/.test(text)) {
        return {
          id: 'business-resource-show-all',
          label: '显示全部业态资源点位',
          action: 'businessResourceControl',
          payload: { control: 'showAll' }
        }
      }
      const isClose = /(?:隐藏|关闭|取消)/.test(text)
      const isOpen = /(?:显示|打开|查看|展示|选择|勾选)/.test(text)
      if (!isClose && !isOpen) {
        return null
      }
      const resourceName = this.findBusinessResourceVoiceName(text)
      if (!resourceName) {
        return null
      }
      return {
        id: 'business-resource-' + (isClose ? 'hide-' : 'show-') + resourceName,
        label: (isClose ? '隐藏' : '显示') + resourceName + '资源点位',
        action: 'businessResourceSelect',
        payload: {
          resourceName,
          forceActive: !isClose
        }
      }
    },
    findBusinessResourceVoiceName(text) {
      const aliasList = [
        ['酒店', '住宿', '民宿'],
        ['餐饮', '餐厅', '美食'],
        ['互娱', '娱乐', '园馆', '场馆'],
        ['停车场', '停车'],
        ['景区'],
        ['乡村旅游点', '乡村旅游', '乡村'],
        ['检测', '监测'],
        ['其它资源', '其他资源', '其它', '其他']
      ]
      for (let index = 0; index < aliasList.length; index += 1) {
        const matched = aliasList[index].find(alias => text.indexOf(alias) !== -1)
        if (matched) {
          return matched
        }
      }
      const resource = this.businessResourceDisplayList.find(item => {
        const name = this.normalizeScenicVoiceText(item.name)
        return name && (text.indexOf(name) !== -1 || name.indexOf(text) !== -1)
      })
      return resource ? resource.name : ''
    },
    buildBusinessFenceVoiceCommand(text) {
      if (text.indexOf('围栏') === -1 && text.indexOf('片区') === -1 && text.indexOf('全域') === -1 && text.indexOf('区域') === -1 && text.indexOf('圆形') === -1 && text.indexOf('多边形') === -1 && text.indexOf('方形') === -1) {
        return null
      }
      if (/(重新绘制|开始绘制|绘制|重画|重新画)/.test(text)) {
        let mode = ''
        if (text.indexOf('圆形') !== -1) {
          mode = 'circle'
        } else if (text.indexOf('方形') !== -1 || text.indexOf('矩形') !== -1) {
          mode = 'rectangle'
        } else if (text.indexOf('多边形') !== -1) {
          mode = 'polygon'
        }
        return {
          id: 'business-fence-redraw' + (mode ? '-' + mode : ''),
          label: '开始绘制' + (mode ? this.getBusinessFenceModeLabel(mode) : '') + '电子围栏',
          action: 'businessFenceAction',
          payload: { action: 'redraw', mode }
        }
      }
      if (text.indexOf('圆形') !== -1) {
        return { id: 'business-fence-circle', label: '切换圆形围栏', action: 'businessFenceMode', payload: { mode: 'circle' } }
      }
      if (text.indexOf('方形') !== -1 || text.indexOf('矩形') !== -1) {
        return { id: 'business-fence-rectangle', label: '切换方形围栏', action: 'businessFenceMode', payload: { mode: 'rectangle' } }
      }
      if (text.indexOf('多边形') !== -1) {
        return { id: 'business-fence-polygon', label: '切换多边形围栏', action: 'businessFenceMode', payload: { mode: 'polygon' } }
      }
      if (/(确定|确认|完成)/.test(text)) {
        return { id: 'business-fence-confirm', label: '确定电子围栏', action: 'businessFenceAction', payload: { action: 'confirm' } }
      }
      if (text.indexOf('取消') !== -1) {
        return { id: 'business-fence-cancel', label: '取消电子围栏绘制', action: 'businessFenceAction', payload: { action: 'cancel' } }
      }
      if (text.indexOf('保存') !== -1) {
        return { id: 'business-fence-save', label: '保存电子围栏', action: 'businessFenceAction', payload: { action: 'save' } }
      }
      const fence = this.findBusinessFenceByVoiceText(text)
      if (!fence) {
        return null
      }
      return {
        id: 'business-fence-select-' + fence.name,
        label: '选择' + fence.name + '电子围栏',
        action: 'businessFenceSelect',
        payload: { fenceName: fence.name }
      }
    },
    findBusinessFenceByVoiceText(text) {
      const fenceAliasList = [
        { name: '全域', aliases: ['全域', '全县', '全部区域', '全范围'] },
        { name: '篁岭片区', aliases: ['篁岭', '篁岭片区', '篁岭区域'] },
        { name: '婺女洲片区', aliases: ['婺女洲', '婺女洲片区', '婺女洲区域'] },
        { name: '李坑片区', aliases: ['李坑', '李坑片区', '李坑区域'] },
        { name: '江湾片区', aliases: ['江湾', '江湾片区', '江湾区域'] },
        { name: '弦高片区', aliases: ['弦高', '弦高片区', '弦高区域', '弦高古城'] }
      ]
      const aliasTarget = fenceAliasList.find(item => item.aliases.some(alias => text.indexOf(alias) !== -1))
      if (aliasTarget) {
        return this.businessFenceList.find(item => item.name === aliasTarget.name) || aliasTarget
      }
      return this.businessFenceList.find(item => {
        const fenceName = this.normalizeScenicVoiceText(item.name)
        return fenceName && (text.indexOf(fenceName) !== -1 || fenceName.indexOf(text) !== -1)
      })
    },
    buildBusinessPointVoiceCommand(text) {
      if (text.indexOf('点位详情') === -1 && text.indexOf('详情卡片') === -1 && text.indexOf('详情') === -1) {
        return null
      }
      if (text.indexOf('关闭') !== -1 || text.indexOf('隐藏') !== -1) {
        return { id: 'business-point-detail-close', label: '关闭点位详情', action: 'businessPointDetail', payload: { action: 'close' } }
      }
      if (text.indexOf('查看') !== -1 || text.indexOf('打开') !== -1) {
        return { id: 'business-point-detail-open', label: '查看点位详情', action: 'businessPointDetail', payload: { action: 'openFirst' } }
      }
      return null
    },
    handleVoiceRecognitionError(payload) {
      var error = payload && payload.error ? payload.error : payload
      if (this.voiceKeepListening && !this.shouldStopVoiceRecognitionOnError(error)) {
        this.destroyVoiceRecognitionInstance({ preserveStatus: true, keepListening: true })
        this.setVoiceStatus(this.getVoiceErrorMessage(error) + '，正在重新连接', 'warning', true)
        this.scheduleVoiceRecognitionRestart(1200)
        return
      }
      this.setVoiceStatus(this.getVoiceErrorMessage(error), 'error')
      this.destroyVoiceRecognitionInstance({ preserveStatus: true })
    },
    shouldStopVoiceRecognitionOnError(error) {
      if (!error) {
        return false
      }
      if (
        error.name === 'NotAllowedError' ||
        error.name === 'PermissionDeniedError' ||
        error.name === 'NotFoundError' ||
        error.name === 'DevicesNotFoundError'
      ) {
        return true
      }
      var message = error.message || String(error)
      return (
        message.indexOf('不支持') !== -1 ||
        message.indexOf('权限') !== -1 ||
        message.indexOf('未检测到') !== -1 ||
        message.indexOf('缺少') !== -1 ||
        message.indexOf('鉴权') !== -1 ||
        message.indexOf('签名') !== -1 ||
        message.indexOf('APIKey') !== -1 ||
        message.indexOf('APISecret') !== -1 ||
        message.indexOf('AppID') !== -1
      )
    },
    getVoiceErrorMessage(error) {
      if (!error) {
        return '语音识别失败，请重试'
      }
      if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
        return '麦克风权限未开启'
      }
      if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
        return '未检测到可用麦克风'
      }
      var message = error.message || String(error)
      if (message.indexOf('当前环境不支持前端签名') !== -1) {
        return '当前环境不支持讯飞语音鉴权'
      }
      if (message.indexOf('当前浏览器不支持') !== -1 || message.indexOf('不支持讯飞语音识别所需能力') !== -1) {
        return '当前环境不支持讯飞语音识别'
      }
      if (message.indexOf('连接失败') !== -1 || message.indexOf('连接已关闭') !== -1) {
        return '语音识别服务连接失败'
      }
      if (message.indexOf('麦克风采集') !== -1) {
        return '当前浏览器不支持麦克风采集'
      }
      return message || '语音识别失败，请重试'
    },
    executeVoiceCommand(command) {
      if (!command) {
        return
      }
      if (command.action === 'switchType') {
        this.executeVoiceTypeSwitch(command)
        return
      }
      if (command.action === 'changeDate') {
        this.setVoiceStatus('正在执行指令：' + command.label, 'success')
        this.changeTheDate(command.payload.day)
        return
      }
      if (command.action === 'openBusRouteViewer') {
        this.executeVoiceBusRouteCommand()
        return
      }
      if (command.action === 'playCamera') {
        this.executeVoiceCameraCommand(command)
        return
      }
      if (command.action === 'playVideoStream') {
        this.executeVoiceVideoStreamCommand(command)
        return
      }
      if (command.action === 'closeVideoStream') {
        this.closeModal()
        this.setVoiceStatus('已关闭视频流窗口', 'success')
        return
      }
      if (command.action === 'queryMetric') {
        this.executeVoiceMetricCommand(command)
        return
      }
      if (
        command.action === 'businessResourceSelect' ||
        command.action === 'businessResourceControl' ||
        command.action === 'businessResourceLabel' ||
        command.action === 'businessFenceSelect' ||
        command.action === 'businessFenceAction' ||
        command.action === 'businessFenceMode' ||
        command.action === 'businessPointDetail'
      ) {
        this.executeVoiceBusinessCommand(command)
        return
      }
    },
    executeVoiceTypeSwitch(command) {
      var targetTypeIndex = command && command.payload ? command.payload.typeIndex : this.typeIndex
      if (this.typeIndex === targetTypeIndex) {
        this.setVoiceStatus('当前已在' + this.getVoiceTypeLabel(targetTypeIndex), 'success')
        return
      }
      this.setVoiceStatus('正在执行指令：' + command.label, 'success')
      this.typeChange(targetTypeIndex)
    },
    executeVoiceBusRouteCommand() {
      const targetTypeIndex = this.typeIndex === 6 ? 6 : 4
      const targetDecisionTypeIndex = targetTypeIndex === 6 ? 1 : null
      this.setPendingVoiceAction('open-bus-route-viewer', {
        targetTypeIndex,
        targetDecisionTypeIndex
      })
      if (this.typeIndex !== targetTypeIndex || (targetTypeIndex === 6 && this.decision_type_index !== targetDecisionTypeIndex)) {
        this.setVoiceStatus('正在执行指令：打开公交路线图', 'success')
        if (targetDecisionTypeIndex !== null) {
          this.decision_type_index = targetDecisionTypeIndex
        }
        this.typeChange(targetTypeIndex)
        return
      }
      this.$nextTick(() => {
        this.consumePendingVoiceAction(0)
      })
    },
    executeVoiceCameraCommand(command) {
      var cameraName = command && command.payload ? command.payload.cameraName : ''
      var cameraUrl = command && command.payload ? command.payload.cameraUrl : ''
      if (!cameraUrl) {
        this.setVoiceStatus('未找到该摄像头的视频源', 'warning')
        return
      }
      this.setVoiceStatus('正在执行指令：' + command.label, 'success')
      this.playCameraVideo(cameraName, cameraUrl)
    },
    playCameraVideo(cameraName, cameraUrl) {
      this.openMonitorVideo(cameraName || '视频监控', cameraUrl)
      this.$nextTick(() => {
        if (!this.player) {
          this.setVoiceStatus('视频播放器初始化失败，请检查浏览器兼容性', 'warning')
        }
      })
    },
    executeVoiceVideoStreamCommand(command) {
      const streamName = command && command.payload ? command.payload.streamName : ''
      const streamUrl = command && command.payload ? command.payload.streamUrl : ''
      if (!streamUrl) {
        this.setVoiceStatus('未找到对应区域的视频源', 'warning')
        return
      }
      this.setVoiceStatus('正在执行指令：' + command.label, 'success')
      this.openMonitorVideo((streamName || '指定区域') + '视频流', streamUrl)
    },
    executeVoiceMetricCommand(command) {
      const targetTypeIndex = command && command.payload ? Number(command.payload.targetTypeIndex) : 0
      if (this.typeIndex !== targetTypeIndex) {
        this.setPendingVoiceAction('metric-query', command)
        this.setVoiceStatus('正在执行指令：切换到' + this.getVoiceTypeLabel(targetTypeIndex), 'success')
        this.typeChange(targetTypeIndex)
        return
      }
      if (!this.runVoiceMetricCommand(command)) {
        this.setVoiceStatus('指标数据加载中，请稍后重试', 'warning')
      }
    },
    runVoiceMetricCommand(command) {
      const metricKey = command && command.payload ? command.payload.metricKey : ''
      const result = this.resolveVoiceMetricResult(metricKey)
      if (!result) {
        return false
      }
      this.showVoiceMetricBoard(result)
      this.speakVoiceMetricResult(result)
      this.setVoiceStatus('已返回' + result.title, 'success')
      return true
    },
    resolveVoiceMetricResult(metricKey) {
      const metric = VOICE_METRIC_QUERY_LIST.find(item => item.key === metricKey)
      if (!metric) {
        return null
      }
      let value = null
      if (metricKey === 'todayEntry' || metricKey === 'todayTraffic') {
        value = this.getVoiceNumberFromDigitArray(this.dateSum)
        if (value === null && this.county_total_value !== undefined && this.county_total_value !== '') {
          value = Number(this.county_total_value)
        }
      } else if (metricKey === 'currentInPark') {
        value = this.getVoiceNumberFromDigitArray(this.dateInSum)
      } else if (metricKey === 'todayOut') {
        value = this.getVoiceNumberFromDigitArray(this.dateOutSum)
      } else if (metricKey === 'yearTourists') {
        value = this.getVoiceNumberFromDigitArray(this.yearSum)
      }
      if (value === null || !isFinite(Number(value))) {
        return null
      }
      const dateText = this.isToday ? this.nowDay : (this.req_date || this.nowDay)
      const formattedValue = this.formatWarningCount(value)
      return {
        title: metric.title,
        value: formattedValue,
        rawValue: Number(value).toFixed(0),
        unit: metric.unit,
        subtitle: dateText + ' · ' + this.getVoiceTypeLabel(metric.targetTypeIndex),
        speechText: metric.title + '为' + Number(value).toFixed(0) + metric.unit
      }
    },
    getVoiceNumberFromDigitArray(value) {
      if (!Array.isArray(value) || !value.length) {
        return null
      }
      const text = value.join('').replace(/[^\d.-]/g, '')
      if (!text) {
        return null
      }
      const numberValue = Number(text)
      return isFinite(numberValue) ? numberValue : null
    },
    showVoiceMetricBoard(result) {
      this.voiceMetricBoardTitle = result.title
      this.voiceMetricBoardValue = result.value
      this.voiceMetricBoardUnit = result.unit
      this.voiceMetricBoardSubtitle = result.subtitle
      this.voiceMetricBoardTone = 'success'
      this.voiceMetricBoardVisible = true
      this.clearVoiceMetricBoardTimer()
      this.voiceMetricBoardTimer = setTimeout(() => {
        this.voiceMetricBoardVisible = false
        this.voiceMetricBoardTimer = null
      }, 10000)
    },
    hideVoiceMetricBoard() {
      this.voiceMetricBoardVisible = false
      this.clearVoiceMetricBoardTimer()
    },
    clearVoiceMetricBoardTimer() {
      if (this.voiceMetricBoardTimer) {
        clearTimeout(this.voiceMetricBoardTimer)
        this.voiceMetricBoardTimer = null
      }
    },
    getMandarinSpeechVoice() {
      if (typeof window === 'undefined' || !window.speechSynthesis || typeof window.speechSynthesis.getVoices !== 'function') {
        return null
      }
      const voices = window.speechSynthesis.getVoices() || []
      if (!voices.length) {
        return null
      }
      const mandarinNamePattern = /(普通话|国语|Mandarin|Xiaoxiao|Huihui|Tingting|Yunxi|Yunyang|Xiaoyi)/i
      const excludedDialectPattern = /(粤|Cantonese|Hong Kong|香港|Taiwan|台湾|臺灣|Hokkien|Minnan)/i
      const exactLangVoice = voices.find(voice => {
        const lang = String(voice.lang || '').toLowerCase()
        const name = String(voice.name || '')
        return (lang === 'zh-cn' || lang === 'cmn-hans-cn') && !excludedDialectPattern.test(name)
      })
      if (exactLangVoice) {
        return exactLangVoice
      }
      const namedMandarinVoice = voices.find(voice => {
        const lang = String(voice.lang || '').toLowerCase()
        const name = String(voice.name || '')
        return (lang.indexOf('zh') === 0 || lang.indexOf('cmn') === 0 || mandarinNamePattern.test(name)) &&
          mandarinNamePattern.test(name) &&
          !excludedDialectPattern.test(name)
      })
      if (namedMandarinVoice) {
        return namedMandarinVoice
      }
      return voices.find(voice => {
        const lang = String(voice.lang || '').toLowerCase()
        const name = String(voice.name || '')
        return (lang.indexOf('zh') === 0 || lang.indexOf('cmn') === 0) && !excludedDialectPattern.test(name)
      }) || null
    },
    speakVoiceMetricResult(result) {
      if (typeof window === 'undefined' || !window.speechSynthesis || !window.SpeechSynthesisUtterance || !result || !result.speechText) {
        return
      }
      try {
        const mandarinVoice = this.getMandarinSpeechVoice()
        if (!mandarinVoice && typeof window.speechSynthesis.getVoices === 'function') {
          setTimeout(() => {
            const retryVoice = this.getMandarinSpeechVoice()
            try {
              window.speechSynthesis.cancel()
              const retryUtterance = new window.SpeechSynthesisUtterance(result.speechText)
              retryUtterance.lang = 'zh-CN'
              if (retryVoice) {
                retryUtterance.voice = retryVoice
              }
              retryUtterance.rate = 1
              retryUtterance.volume = 1
              window.speechSynthesis.speak(retryUtterance)
            } catch (error) {
            }
          }, 300)
          return
        }
        window.speechSynthesis.cancel()
        const utterance = new window.SpeechSynthesisUtterance(result.speechText)
        utterance.lang = 'zh-CN'
        utterance.voice = mandarinVoice
        utterance.rate = 1
        utterance.volume = 1
        window.speechSynthesis.speak(utterance)
      } catch (error) {
      }
    },
    executeVoiceBusinessCommand(command) {
      if (this.typeIndex !== 5) {
        this.setPendingVoiceAction('business-command', command)
        this.setVoiceStatus('正在执行指令：切换到业态资源', 'success')
        this.typeChange(5)
        return
      }
      this.runVoiceBusinessCommand(command)
    },
    runVoiceBusinessCommand(command) {
      if (!command) {
        return false
      }
      if (command.action === 'businessResourceSelect') {
        return this.executeVoiceBusinessResourceSelect(command)
      }
      if (command.action === 'businessResourceControl') {
        return this.executeVoiceBusinessResourceControl(command)
      }
      if (command.action === 'businessResourceLabel') {
        return this.executeVoiceBusinessResourceLabel(command)
      }
      if (command.action === 'businessFenceSelect') {
        return this.executeVoiceBusinessFenceSelect(command)
      }
      if (command.action === 'businessFenceAction') {
        return this.executeVoiceBusinessFenceAction(command)
      }
      if (command.action === 'businessFenceMode') {
        return this.executeVoiceBusinessFenceMode(command)
      }
      if (command.action === 'businessPointDetail') {
        return this.executeVoiceBusinessPointDetail(command)
      }
      return false
    },
    executeVoiceBusinessResourceSelect(command) {
      if (!this.businessResourceDisplayList.length) {
        return false
      }
      const resource = this.findBusinessResourceByVoiceName(command && command.payload ? command.payload.resourceName : '')
      if (!resource) {
        this.setVoiceStatus('未找到对应业态资源类型', 'warning')
        return false
      }
      const forceActive = command && command.payload ? command.payload.forceActive : true
      const currentIndex = this.selectedBusinessResourceKeys.indexOf(resource.key)
      if (forceActive && currentIndex === -1) {
        this.selectedBusinessResourceKeys.push(resource.key)
      } else if (!forceActive && currentIndex !== -1) {
        this.selectedBusinessResourceKeys.splice(currentIndex, 1)
      }
      this.refreshBusinessAreaStats(this.getCurrentBusinessMetric())
      this.renderBusinessResourceMarkers()
      this.setVoiceStatus('已' + (forceActive ? '显示' : '隐藏') + resource.name + '资源点位', 'success')
      return true
    },
    executeVoiceBusinessResourceControl(command) {
      const control = command && command.payload ? command.payload.control : ''
      if (control === 'clear') {
        this.selectedBusinessResourceKeys = []
        this.refreshBusinessAreaStats(this.getCurrentBusinessMetric())
        this.renderBusinessResourceMarkers()
        this.setVoiceStatus('已清空业态资源点位', 'success')
        return true
      }
      if (control === 'showAll') {
        if (!this.businessResourceDisplayList.length) {
          return false
        }
        this.selectedBusinessResourceKeys = this.businessResourceDisplayList.map(item => item.key).filter(Boolean)
        this.refreshBusinessAreaStats(this.getCurrentBusinessMetric())
        this.renderBusinessResourceMarkers()
        this.setVoiceStatus('已显示全部业态资源点位', 'success')
        return true
      }
      return false
    },
    executeVoiceBusinessResourceLabel(command) {
      const visible = !!(command && command.payload && command.payload.visible)
      this.businessResourceLabelVisible = visible
      this.renderBusinessResourceMarkers()
      this.setVoiceStatus('已' + (visible ? '显示' : '关闭') + '点位文字', 'success')
      return true
    },
    executeVoiceBusinessFenceSelect(command) {
      const fenceName = command && command.payload ? command.payload.fenceName : ''
      const fence = this.businessFenceList.find(item => item.name === fenceName)
      if (!fence) {
        this.setVoiceStatus('未找到对应电子围栏', 'warning')
        return false
      }
      this.selectBusinessFence(fence)
      this.setVoiceStatus('已选择' + fence.name + '电子围栏', 'success')
      return true
    },
    executeVoiceBusinessFenceAction(command) {
      const action = command && command.payload ? command.payload.action : ''
      if (!action) {
        return false
      }
      const mode = command && command.payload ? command.payload.mode : ''
      if (mode && (mode === 'circle' || mode === 'polygon' || mode === 'rectangle')) {
        this.setBusinessFenceDrawMode(mode)
      }
      if (this.businessDrawingToolDisabled(action)) {
        this.setVoiceStatus('当前不能执行：' + command.label, 'warning')
        return false
      }
      this.handleDrawingToolAction(action)
      this.setVoiceStatus('已执行：' + command.label, 'success')
      return true
    },
    executeVoiceBusinessFenceMode(command) {
      const mode = command && command.payload ? command.payload.mode : ''
      if (mode !== 'circle' && mode !== 'polygon' && mode !== 'rectangle') {
        return false
      }
      this.setBusinessFenceDrawMode(mode)
      this.setVoiceStatus('已切换为' + this.getBusinessFenceModeLabel(mode) + '围栏绘制模式', 'success')
      return true
    },
    executeVoiceBusinessPointDetail(command) {
      const action = command && command.payload ? command.payload.action : ''
      if (action === 'close') {
        this.closeBusinessPointDetail()
        this.setVoiceStatus('已关闭点位详情', 'success')
        return true
      }
      const firstPoint = this.getFirstVisibleBusinessResourcePoint()
      if (!firstPoint || firstPoint.pointId === undefined || firstPoint.pointId === null || firstPoint.pointId === '') {
        this.setVoiceStatus('请先显示一个业态资源点位', 'warning')
        return false
      }
      this.openBusinessPointDetailByPoint(firstPoint)
      this.setVoiceStatus('正在打开点位详情', 'success')
      return true
    },
    findBusinessResourceByVoiceName(resourceName) {
      const normalizedName = this.normalizeScenicVoiceText(resourceName)
      if (!normalizedName) {
        return null
      }
      const aliasMap = [
        { aliases: ['酒店', '住宿', '民宿'], keywords: ['酒店', '住宿', '民宿'] },
        { aliases: ['餐饮', '餐厅', '美食'], keywords: ['餐饮', '餐厅', '美食'] },
        { aliases: ['互娱', '娱乐', '园馆', '场馆'], keywords: ['互娱', '娱乐', '园馆', '场馆'] },
        { aliases: ['停车场', '停车'], keywords: ['停车'] },
        { aliases: ['景区'], keywords: ['景区'] },
        { aliases: ['乡村旅游点', '乡村旅游', '乡村'], keywords: ['乡村'] },
        { aliases: ['检测', '监测'], keywords: ['检测', '监测'] },
        { aliases: ['其它资源', '其他资源', '其它', '其他'], keywords: ['其它', '其他'] }
      ]
      const aliasGroup = aliasMap.find(item => item.aliases.some(alias => normalizedName.indexOf(this.normalizeScenicVoiceText(alias)) !== -1))
      const keywordList = aliasGroup ? aliasGroup.keywords : [normalizedName]
      return this.businessResourceDisplayList.find(item => {
        const itemName = this.normalizeScenicVoiceText(item.name)
        return keywordList.some(keyword => {
          const normalizedKeyword = this.normalizeScenicVoiceText(keyword)
          return itemName.indexOf(normalizedKeyword) !== -1 || normalizedKeyword.indexOf(itemName) !== -1
        })
      })
    },
    getFirstVisibleBusinessResourcePoint() {
      for (let index = 0; index < this.businessResourceDisplayList.length; index += 1) {
        const resource = this.businessResourceDisplayList[index]
        if (this.selectedBusinessResourceKeys.indexOf(resource.key) === -1) {
          continue
        }
        const points = this.getBusinessResourcePointsForResource(resource)
        if (points.length) {
          const point = points[0]
          return Object.assign({}, points[0], {
            idx: point.idx,
            categoryId: point.categoryId,
            categoryKey: point.categoryKey,
            resourceName: resource.name,
            resourceIdx: resource.idx,
            markerColor: this.getBusinessPointMarkerColor(point, resource.idx)
          })
        }
      }
      return null
    },
    openBusinessPointDetailByPoint(point) {
      this.businessSelectedPointId = point.pointId
      this.businessPointDetailVisible = true
      this.businessPointDetailLoading = true
      this.businessPointDetailError = ''
      this.businessPointDetail = {
        id: point.pointId,
        name: point.name || '',
        idx: point.idx,
        categoryId: point.categoryId,
        categoryKey: point.categoryKey,
        resourceName: point.resourceName,
        resourceIdx: point.resourceIdx !== undefined ? point.resourceIdx : point.idx,
        markerColor: point.markerColor || ''
      }
      getMapPointDetailApi({ point_id: point.pointId }).then(res => {
        const responseData = res && res.data ? res.data : {}
        if (String(this.businessSelectedPointId) !== String(point.pointId)) {
          return
        }
        this.businessPointDetailLoading = false
        if (Number(responseData.code) !== 1 || !responseData.data) {
          this.businessPointDetailError = '详情获取失败'
          return
        }
        const detailIdx = responseData.data.idx !== undefined && responseData.data.idx !== null && responseData.data.idx !== ''
          ? responseData.data.idx
          : point.idx
        const resourceIdx = point.resourceIdx !== undefined && point.resourceIdx !== null && point.resourceIdx !== ''
          ? point.resourceIdx
          : detailIdx
        this.businessPointDetail = Object.assign({}, responseData.data, {
          idx: detailIdx,
          categoryId: point.categoryId !== undefined && point.categoryId !== null && point.categoryId !== ''
            ? point.categoryId
            : responseData.data.category_id,
          categoryKey: point.categoryKey || this.normalizeBusinessResourceCategoryKey(responseData.data.category_id),
          resourceName: point.resourceName || responseData.data.category_name || responseData.data.type_name,
          resourceIdx: resourceIdx,
          markerColor: this.getBusinessMarkerColorByIdx(this.getBusinessPointIdx({ idx: detailIdx }, resourceIdx))
        })
      }).catch(() => {
        if (String(this.businessSelectedPointId) !== String(point.pointId)) {
          return
        }
        this.businessPointDetailLoading = false
        this.businessPointDetailError = '详情请求异常'
      })
    },
    getVoiceTypeLabel(typeIndex) {
      var typeLabelMap = {
        0: '大数据首页',
        1: '客流分析页面',
        2: '大数据驾驶舱页面',
        3: '舆情分析页面',
        4: '客流预警页面',
        5: '业态资源统筹页面',
        6: '数据决策中心页面',
        7: '客群画像分析页面',
        8: '价格动态监管页面',
        9: '全网舆情监测页面',
        10: '视频监测管理页面',
        11: '系统管理页面',
        12: '用户管理页面',
        13: '角色配置页面',
        14: '系统日志页面'
      }
      return typeLabelMap[typeIndex] || '当前页面'
    },
    restartVoiceRecognitionSession(text, tone) {
      if (!this.voiceKeepListening) {
        return
      }
      this.destroyVoiceRecognitionInstance({ preserveStatus: true, keepListening: true })
      this.setVoiceStatus(text || '语音持续监听中', tone || 'listening')
      this.scheduleVoiceRecognitionRestart(600)
    },
    scheduleVoiceRecognitionRestart(delay) {
      if (!this.voiceKeepListening) {
        return
      }
      this.clearVoiceRestartTimer()
      this.voiceRestartTimer = setTimeout(() => {
        this.voiceRestartTimer = null
        if (!this.voiceKeepListening || this.voiceListening || this.voiceStarting) {
          return
        }
        this.startVoiceRecognition()
      }, typeof delay === 'number' ? delay : 300)
    },
    clearVoiceRestartTimer() {
      if (this.voiceRestartTimer) {
        clearTimeout(this.voiceRestartTimer)
        this.voiceRestartTimer = null
      }
    },
    clearVoiceStatusTimer() {
      if (this.voiceStatusTimer) {
        clearTimeout(this.voiceStatusTimer)
        this.voiceStatusTimer = null
      }
    },
    setVoiceStatus(text, tone, persistent) {
      this.voiceStatusText = text
      this.voiceStatusTone = tone || 'info'
      this.voiceStatusVisible = true
      this.clearVoiceStatusTimer()
      if (persistent) {
        return
      }
      this.voiceStatusTimer = setTimeout(() => {
        this.voiceStatusVisible = false
      }, VOICE_STATUS_HIDE_MS)
    },
    setPendingVoiceAction(actionId, payload) {
      sessionStorage.setItem(VOICE_PENDING_ACTION_KEY, JSON.stringify({
        actionId: actionId,
        payload: payload || null,
        createdAt: Date.now()
      }))
    },
    getPendingVoiceAction() {
      var pendingAction = sessionStorage.getItem(VOICE_PENDING_ACTION_KEY)
      if (!pendingAction) {
        return null
      }
      try {
        return JSON.parse(pendingAction)
      } catch (error) {
        sessionStorage.removeItem(VOICE_PENDING_ACTION_KEY)
        return null
      }
    },
    clearPendingVoiceAction() {
      sessionStorage.removeItem(VOICE_PENDING_ACTION_KEY)
    },
    consumePendingVoiceAction(retryCount) {
      var pendingAction = this.getPendingVoiceAction()
      if (!pendingAction) {
        return
      }
      if (!pendingAction.createdAt || Date.now() - pendingAction.createdAt > 5 * 60 * 1000) {
        this.clearPendingVoiceAction()
        return
      }
      if (pendingAction.actionId === 'business-command') {
        if (this.typeIndex !== 5) {
          return
        }
        if (this.runVoiceBusinessCommand(pendingAction.payload)) {
          this.clearPendingVoiceAction()
          return
        }
        if (retryCount < 10) {
          setTimeout(() => {
            this.consumePendingVoiceAction(retryCount + 1)
          }, 250)
          return
        }
        this.clearPendingVoiceAction()
        this.setVoiceStatus('业态资源语音指令执行失败', 'warning')
        return
      }
      if (pendingAction.actionId === 'metric-query') {
        const targetTypeIndex = pendingAction.payload && pendingAction.payload.payload ? Number(pendingAction.payload.payload.targetTypeIndex) : 0
        if (this.typeIndex !== targetTypeIndex) {
          return
        }
        if (this.runVoiceMetricCommand(pendingAction.payload)) {
          this.clearPendingVoiceAction()
          return
        }
        if (retryCount < 20) {
          setTimeout(() => {
            this.consumePendingVoiceAction(retryCount + 1)
          }, 400)
          return
        }
        this.clearPendingVoiceAction()
        this.setVoiceStatus('指标数据加载超时，请稍后重试', 'warning')
        return
      }
      if (pendingAction.actionId !== 'open-bus-route-viewer') {
        return
      }
      this.consumePendingBusRouteVoiceAction(pendingAction, retryCount)
    },
    consumePendingBusRouteVoiceAction(pendingAction, retryCount) {
      const payload = pendingAction && pendingAction.payload ? pendingAction.payload : {}
      const targetTypeIndex = payload.targetTypeIndex !== undefined && payload.targetTypeIndex !== null
        ? Number(payload.targetTypeIndex)
        : 4
      const targetDecisionTypeIndex = payload.targetDecisionTypeIndex !== undefined && payload.targetDecisionTypeIndex !== null
        ? Number(payload.targetDecisionTypeIndex)
        : null
      if (this.typeIndex !== targetTypeIndex) {
        return
      }
      if (targetDecisionTypeIndex !== null && this.decision_type_index !== targetDecisionTypeIndex) {
        this.decision_type_index = targetDecisionTypeIndex
        this.$nextTick(() => {
          this.consumePendingBusRouteVoiceAction(pendingAction, retryCount)
        })
        return
      }
      const refName = targetTypeIndex === 6 ? 'embeddedWarning_2' : 'embeddedWarning'
      var warningPage = this.$refs[refName]
      if (!warningPage || typeof warningPage.openBusRouteViewer !== 'function') {
        if (retryCount < 8) {
          setTimeout(() => {
            this.consumePendingVoiceAction(retryCount + 1)
          }, 250)
        } else {
          this.clearPendingVoiceAction()
          this.setVoiceStatus('公交路线图页面加载超时，请稍后重试', 'warning')
        }
        return
      }
      this.clearPendingVoiceAction()
      warningPage.openBusRouteViewer()
      this.setVoiceStatus('已打开公交路线图', 'success')
    },
    destroyVoiceRecognitionInstance(options) {
      var destroyOptions = options || {}
      var recognition = this.voiceRecognition
      if (!destroyOptions.keepListening) {
        this.voiceKeepListening = false
      }
      if (!destroyOptions.keepListening) {
        this.clearVoiceRestartTimer()
      }
      this.voiceListening = false
      this.voiceStarting = false
      this.voiceCommandHandled = false
      this.voiceEndReason = ''
      this.voiceSuppressEndStatus = false
      this.voiceRecognition = null
      if (recognition) {
        try {
          recognition.removeAllListeners()
        } catch (error) {
        }
        try {
          recognition.destroy()
        } catch (error) {
        }
      }
      if (!destroyOptions.preserveStatus) {
        this.clearVoiceStatusTimer()
        this.voiceStatusVisible = false
      }
    },
    destroyVoiceRecognition() {
      this.destroyVoiceRecognitionInstance()
    },
    // 系数
    getCoefficientDataSetting() {
      getCoefficientDataSettingApi({ scenic_id: this.scenic_id }).then(res => {
        // if (res.data.data.coefficient_data) {
        //   this.coefficient_data = res.data.data.coefficient_data
        // }
        if (this.typeIndex === 0) {
          this.getSettingById();
          this.type_index()
        } else if (this.typeIndex === 1) {
          this.getSettingById();
          this.type_user()
        } else if (this.typeIndex === 2) {
          this.getSettingById();
          this.type_revenue()
        } else if (this.typeIndex === 3) {
          this.getSettingById();
          this.getTimeTrend()
          this.handleGetList()
          this.tendenciesScroll()
        } else if (this.typeIndex === 5) {
          this.getSettingById();
          this.type_business_resource()
        } else if (this.typeIndex === 6) {
          this.getSettingById()
          this.type_decision()
        } else if (this.typeIndex === PRICE_SUPERVISION_TYPE_INDEX) {
          this.getSettingById();
          this.type_price_supervision()
        } else if (this.typeIndex === 7) {
          this.getSettingById();
          this.typeTouristProfile()
        }
      })
    },
    prevImage(index) {
      this.actIndex--
      this.$refs.imagesList[index].style.marginLeft = `-${this.actIndex * 114}px`
    },
    nextImage(index) {
      this.actIndex++
      this.$refs.imagesList[index].style.marginLeft = `-${this.actIndex * 114}px`
    },
    isDataShow(state) {
      this.isYearSumShow = !state
    },
    type_index() {
      //调用接口
      this.getUserPortraitData()
      this.getTouristsDataNew()
      this.getTouristsData();
      this.getGenderSchedule();
      this.getWeatherData();
      this.getOriginList();
      // this.getEnrollmentTime();
      // this.getTicketNumberStatistics();
      // this.getCurrentTrafficTrend();
      // this.getRealTimeTraffic();
      this.getHistoryData();

      // this.getTouristAgencyType()
      this.getVisitorTrendData()
      this.getScenicRankingData()
      let _this = this;
      setInterval(function () {
        _this.getTouristsData('change');
        _this.getTouristsDataNew()
      }, 5000)
    },
    type_user() {
      this.getTouristsDataNew()
      this.getScenicRankingData()
      this.getUserPortraitData()
      // this.getCurrentTrafficTrend();
      this.getAnalysisMonth()
      // this.getGenderSchedule()
      // this.getTicketNumberStatistics();
      this.getOriginList()
      this.getWeatherData();
      this.getVisitorTrendData()
      // this.flight_coordinates(1)
      this.getScenicHourlyData()
    },
    type_revenue() {
      // this.changeTheDate('last')
      // this.getTradingNum()
      // this.getTouristAgencyType()
      this.getSalesNum()
      this.getBusinessNum()
      this.getBusinessList()
      this.getBigDataOfflineRetail()
      // this.salesComparison()
      this.xcxGetHotelData()
      this.getDeliciousFoodData()
      this.getTradingNum_bar()
      this.getScenicRankingData()
      this.getVisitorTrendData()
      this.getWeatherData();
      this.getData()
    },
    type_business_resource() {
      this.getWeatherData()
      this.getMapResourceList()
      if (!this.businessResourcePointLoaded) {
        this.getBusinessResourcePointList()
      }
    },
    type_decision() {
      this.getTouristsDataNew()
      this.getWeatherData();
      this.getCateringType()
      this.getCateringRatType()
      this.getWaitingIn()
      this.initSevenDayChart()
      this.getYearPie()
      this.getProvincePie()
      this.getSexPie6()
      this.getYearPie2()
      this.getVisitorTrendData()
      this.getPlayPie()
    },
    typeTouristProfile() {
      this.getWeatherData();
      this.getUserPortraitData()
      this.getAnalysisMonth()
      this.getTravelMode()
      this.getLevel(1)
    },
    getScenicHourlyData() {
      scenicHourlyData({
        date: this.req_date
      }).then(res => {
        console.log(res.data.data, '测试接口，看看')
        var categories = []
        var series = []
        const today = new Date();
        if (!this.req_date) {
          const hour = today.getHours()
          res.data.data.categories.forEach(item => {
            if (item <= hour) {
              categories.push(item)
            }
          })
          for (var i = 0; i < res.data.data.series.length; i++) {
            series.push({
              name: res.data.data.series[i].name,
              data: res.data.data.series[i].data.slice(0, categories.length)
            })
          }
        }

        this.getInTime({ categories: categories, series: series })
      })
    },
    //根据ID获取景区大数据参数设置详情
    getSettingById() {
      getSettingByIdApi({
        scenic_id: this.scenic_id,
      }).then(res => {
        this.setting = res.data.data;
        if (this.req_date && this.req_date != '' && this.req_date != this.nowDay2) {
          this.isToday = false;
        } else {
          let _this = this;
          setInterval(function () {
            _this.getTouristsData();
            _this.getTouristsDataNew()
            _this.getWeatherData(1);
            _this.getToday();
            // _this.getWaitingIn()
          }, this.setting.first_refresh_time * 60 * 1000)
          setInterval(function () {
            // _this.getTicketNumberStatistics();
          }, this.setting.second_refresh_time * 60 * 1000)
          setInterval(function () {
            _this.originIndex = 0;
            _this.getUserPortraitData()
            _this.getOriginList();
            // _this.getGenderSchedule(1);

            // _this.getCurrentTrafficTrend();

          }, this.setting.third_refresh_time * 60 * 1000)

        }
      })
    },
    //获取星期几
    getWeek(day) {
      switch (day) {
        case 0:
          return '周日'

        case 1:
          return '周一'

        case 2:
          return '周二'

        case 3:
          return '周三'

        case 4:
          return '周四'

        case 5:
          return '周五'

        case 6:
          return '周六'

      }
    },
    // 30天客流趋势
    getVisitorTrendData() {
      visitorTrendData({
        date: this.req_date,
        days: 30
      }).then(res => {
        console.log(res, '30天')
        var trend = res.data.data.trend
        this.trend_list = []
        this.real_time_traffic_list = {
          time_list: [],
          data_list: []
        }

        for (var i = 0; i < trend.length; i++) {
          if (i < 1) {
            this.real_time_traffic_list.time_list.push(trend[i].date)
            this.real_time_traffic_list.data_list.push(trend[i].count)
          } else {
            var length = this.real_time_traffic_list.data_list.length - 1
            if (this.real_time_traffic_list.time_list[length] == trend[i].date) {
              this.real_time_traffic_list.data_list[length] += trend[i].count
            } else {
              this.real_time_traffic_list.time_list.push(trend[i].date)
              this.real_time_traffic_list.data_list.push(trend[i].count)
            }
          }
        }
        this.real_time_traffic_list.time_list.reverse()
        this.real_time_traffic_list.data_list.reverse()
        var today_hourly = res.data.data.today_hourly
        const today = new Date();
        this.current_traffic_trend = {
          categories: [],
          series: [],
        }
        if (!this.req_date) {
          const hour = today.getHours()
          console.log(hour, 'hoiur')
          today_hourly.categories.forEach(item => {
            if (item <= hour) {
              this.current_traffic_trend.categories.push(item)
            }
          })
          for (var i = 0; i < today_hourly.series.length; i++) {
            this.current_traffic_trend.series.push({
              name: today_hourly.series[i].name,
              data: today_hourly.series[i].data.slice(0, this.current_traffic_trend.categories.length)
            })
          }
        } else {
          const target = new Date(this.req_date);
          if (target.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0)) {
            this.current_traffic_trend = {
              categories: JSON.parse(JSON.stringify(today_hourly.categories)),
              series: JSON.parse(JSON.stringify(today_hourly.series)),
            }
          } else {
            const hour = today.getHours()
            console.log(hour, 'hoiur')
            today_hourly.categories.forEach(item => {
              if (item <= hour) {
                this.current_traffic_trend.categories.push(item)
              }
            })
            for (var i = 0; i < today_hourly.series.length; i++) {
              this.current_traffic_trend.series.push({
                name: today_hourly.series[i].name,
                data: today_hourly.series[i].data.slice(0, this.current_traffic_trend.categories.length)
              })
            }
          }
        }
        this.getTouristLine()
        this.getInOrOut();
        this.showPeakLine(this.current_traffic_trend)
      })
    },
    // 景区排行
    getScenicRankingData() {
      scenicRankingData({
        date: this.req_date
      }).then(res => {
        console.log(res.data.data, '景区排行')
        if (this.typeIndex == 2) {
          this.setInParkRanking(res.data.data)
          this.setOnParkRanking(res.data.data)
        } else {
          this.setScenicRankingData(res.data.data)
        }
      })
    },
    setScenicRankingData(data) {
      var color = ['#FF00FF', '#FF69B4', '#FFD700', '#32CD32', '#00CED1', '#1E90FF', '#4169E1', '#8A2BE2']
      var chartData = []
      var categories = []
      var series_data = []
      var total = 0
      for (var i = 0; i < data.length; i++) {
        var entry_today = data[i].entry_today
        if (data[i].scenic_name == '篁岭') {
          entry_today = (data[i].entry_today * 0.85).toFixed(0)
        }
        chartData.push({
          value: entry_today, // 今日入园人数
          name: data[i].scenic_name,
          itemStyle: { color: color[i] }
        })
        categories.push(data[i].scenic_name)
        series_data.push(entry_today)
        total += entry_today
      }
      var categories_1 = JSON.parse(JSON.stringify(categories))
      var series_data_1 = JSON.parse(JSON.stringify(series_data))
      categories_1.reverse()
      series_data_1.reverse()
      // var scenic_ranking = this.echarts.init(document.getElementById('scenic_ranking'));
      const option = {
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            // radius: '50%',
            data: chartData,
            radius: [12, 60],
            roseType: 'area',
            itemStyle: {
              borderRadius: 8
            },
            center: ['50%', '30%'],
            label: {
              show: false
            }
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return params.data.name + ":<br/>" + ((params.data.value / total) * 100).toFixed(1) + '%'
          },
        },
        legend: {
          bottom: '20',
          left: 'center',
          icon: 'roundRect',
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: '#606266',
            fontSize: 12
          },
          data: chartData.map(item => item.name)
        },
      }
      // scenic_ranking.setOption(option)
      var scenic_ranking_list = this.echarts.init(document.getElementById('scenic_ranking_list'));
      var scenic_ranking_list_1 = this.echarts.init(document.getElementById('scenic_ranking_list_1'));
      var option_list = {
        tooltip: Object.assign({
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        }, this.getLightTooltipStyle()),
        legend: {
          orient: 'vertical',
          right: '10%',  
          top: '0%',     // 设置到右侧
        },
        grid: {
          top: '17%',
          left: '4%',
          right: '10%',
          bottom: '4%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            formatter: value => value >= 10000 ? (value / 10000).toFixed(1) + '万' : value,
            textStyle: {
              color: '#909399',
              fontSize: 10
            }
          },
          axisTick: { show: false },
          axisLine: { show: false },
          splitLine: {
            show: true,
            lineStyle: this.getLightSplitLineStyle()
          }
        },
        yAxis: {
          type: 'category',
          data: categories.map(item => item.slice(0, 6)).reverse(),
          axisLabel: {
            textStyle: {
              color: '#526173',
              fontSize: 11
            }
          },
          axisTick: { show: false },
          axisLine: { show: false }
        },
        series: [
          {
            name: '接待量',
            type: 'bar',
            data: series_data.slice().reverse(),
            barWidth: 10,
            itemStyle: {
              borderRadius: [0, 8, 8, 0],
              color: this.getLightBarGradient('#8ed1ff', '#2f80ed')
            },
            label: {
              show: true,
              position: 'right',
              color: '#606266',
              fontSize: 10
            }
          }
        ]
      }
      scenic_ranking_list.setOption(option_list)
      scenic_ranking_list_1.setOption(option_list)
      var touristType_1 = this.echarts.init(document.getElementById('touristType_1'));

      var touristType_option = {
        grid: {
          top: "10%",
          left: "15%",
          right: "4%",
          bottom: "25%"
        },
        tooltip: Object.assign({
          formatter: function (params) {
            return params.data
          }
        }, this.getLightTooltipStyle()),
        xAxis: {
          data: categories,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#526173',
              fontSize: 8      //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          axisLabel: {
            show: true,
            formatter: '{value}',
            textStyle: {
              color: '#526173',
              fontSize: 10      //更改坐标轴文字大小
            }
          },
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: this.getLightSplitLineStyle()
          }
        },
        series: [
          {
            type: 'bar',
            color: this.getLightBarGradient('#94d5ff', '#12b886'),
            data: series_data,
            barWidth: 14
          },
        ]
      }
      touristType_1.setOption(touristType_option)
    },
    setOnParkRanking(data) {
      var categories = []
      var series_data = []
      for (var i = 0; i < data.length; i++) {
        categories.push(data[i].scenic_name)
        series_data.push(data[i].in_park)
      }
      var option_list = {
        tooltip: Object.assign({
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        }, this.getLightTooltipStyle()),
        legend: {},
        grid: {
          top: '8%',
          left: '6%',
          right: '4%',
          bottom: '18%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            textStyle: {
              color: '#526173',
              fontSize: 10
            },
            rotate: 25,
            formatter: function (value) {
              return value.slice(0, 5);
            }
          },
          axisTick: { show: false },
          axisLine: { lineStyle: { color: 'rgba(34, 49, 63, 0.18)' } }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#526173',
              fontSize: 10
            }
          },
          splitLine: {
            show: true,
            lineStyle: this.getLightSplitLineStyle()
          }
        },
        series: [
          {
            name: '',
            type: 'bar',
            data: series_data,
            barWidth: 14,
            itemStyle: {
              color: this.getLightBarGradient('#a1e8c9', '#12b886')
            },
            label: {
              show: true,
              position: 'top',
              color: '#22313f'
            }
          }
        ]
      }
      var on_ranking_list = this.echarts.init(document.getElementById('on_ranking_list'));
      on_ranking_list.setOption(option_list)
    },
    setInParkRanking(data) {
      var categories = []
      var series_data = []
      for (var i = 0; i < data.length; i++) {
        var entry_today = data[i].entry_today
        if (data[i].scenic_name == '篁岭') {
          entry_today = (data[i].entry_today * 0.85).toFixed(0)
        }
        categories.push(data[i].scenic_name)
        series_data.push(entry_today)
      }
      var option_list = {
        tooltip: Object.assign({
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        }, this.getLightTooltipStyle()),
        legend: {},
        grid: {
          top: '8%',
          left: '6%',
          right: '4%',
          bottom: '18%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            textStyle: {
              color: '#526173',
              fontSize: 10
            },
            rotate: 25,
            formatter: function (value) {
              return value.slice(0, 5);
            }
          },
          axisTick: { show: false },
          axisLine: { lineStyle: { color: 'rgba(34, 49, 63, 0.18)' } }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#526173',
              fontSize: 10
            }
          },
          splitLine: {
            show: true,
            lineStyle: this.getLightSplitLineStyle()
          }
        },
        series: [
          {
            name: '',
            type: 'bar',
            data: series_data,
            barWidth: 14,
            itemStyle: {
              color: this.getLightBarGradient('#94d5ff', '#2f80ed')
            },
            label: {
              show: true,
              position: 'top',
              color: '#22313f'
            }
          }
        ]
      }
      var in_ranking_list = this.echarts.init(document.getElementById('in_ranking_list'));
      in_ranking_list.setOption(option_list)
    },
    //切换类型
    focusPrice() {
      this.isShowType = true;
    },
    blurPrice() {
      this.isShowType = false;
    },
    changeOrigin(index) {
      this.originIndex = index;
      this.isShowType = false;
      this.getOriginList()
      this.getUserPortraitData()
    },
    //点击头部切换类型
    typeChange(index) {
      this.typeIndex = index;
      var query = { id: this.scenic_id, date: this.req_date, typeIndex: this.typeIndex, token: store.state.token }
      if (this.typeIndex === 6) {
        query.decisionTypeIndex = this.decision_type_index
      }
      this.$router.push({ path: '/', query: query })
      this.$router.go(0)
    },
    // 获取是否需额外的IOT数据
    getIotAppendData(params) {
      if (this.IotAppendDataCache == null) {
        return iotSettingData(params).then(res => {
          this.IotAppendDataCache = res.data.data.mini_program_data || []
          return this.IotAppendDataCache || []
        })
      } else {
        return Promise.resolve(this.IotAppendDataCache)
      }
    },
    //获取实时游客数据
    getTouristsDataNew() {
      todayVisitorsData({
        date: this.req_date
      }).then(res => {
        this.county_total_value = (res.data.data.county_total.value * 4.9).toFixed(0)
        this.getTradingNum()
        this.dateSum = (res.data.data.county_total.value * 4.9).toFixed(0).toString().split('');
        if (6 - this.dateSum.length > 0) {
          var dateArr = []
          for (let i = 0; i < 6 - this.dateSum.length; i++) {
            dateArr.unshift('0')
          }
          this.dateSum.unshift(...dateArr)
        }
        this.consumePendingVoiceAction(0)
      })
    },
    getTouristsData(data) {
      realTouristsWYData({
        dates: this.req_date
      }).then(res => {
        this.yearSum = (res.data.data.year.county_total * this.coefficient_data / 100).toFixed(0).toString().split('');
        this.carSum = (res.data.data.year.county_total * this.coefficient_data / 100 / 13.9).toFixed(0).toString().split('');
        this.realTourists_data = res.data.data
        //不够位数前面补零
        if (8 - this.yearSum.length > 0) {
          var yearArr = []
          for (let i = 0; i < 8 - this.yearSum.length; i++) {
            yearArr.unshift('0')
          }
          this.yearSum.unshift(...yearArr)
        }
        if (8 - this.carSum.length > 0) {
          var yearArr = []
          for (let i = 0; i < 8 - this.carSum.length; i++) {
            yearArr.unshift('0')
          }
          this.carSum.unshift(...yearArr)
        }
        if (5 - this.dateInSum.length > 0) {
          var dateInArr = []
          for (let i = 0; i < 5 - this.dateInSum.length; i++) {
            dateInArr.unshift('0')
          }
          this.dateInSum.unshift(...dateInArr)
        }
        if (5 - this.dateOutSum.length > 0) {
          var dateInArr = []
          for (let i = 0; i < 5 - this.dateOutSum.length; i++) {
            dateInArr.unshift('0')
          }
          this.dateOutSum.unshift(...dateInArr)
        }
      })
      realTouristsData({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        return this.getIotAppendData({ scenic_biz: this.scenic_id, }).then(appendDataList => {
          if (appendDataList.find(item => item === 'villager_in_out')) {
            return getIotScenicVillageRealData({ scenic_id: this.scenic_id, dates: this.req_date }).then(realRes => {
              res.data.data.total_tourists_num += realRes.data.data.total_tourists_num
              res.data.data.out_park_num += realRes.data.data.villager_out_num
              res.data.data.mouth_tourists_num += realRes.data.data.month_villager_num
              res.data.data.years_tourists_num += realRes.data.data.year_villager_num

              var in_tourists_num = res.data.data.total_tourists_num - res.data.data.out_park_num
              res.data.data.in_tourists_num = in_tourists_num > 0 ? in_tourists_num : 0
              return res
            })
          } else {
            return res
          }
        })
      }).then(res => {
        // if (data == 'change') {
        //   this.dateSum =  res.data.data.total_tourists_num.toString().split('');
        //   if(6-this.dateSum.length>0){
        //     var dateArr = []
        //     for(let i=0;i<6-this.dateSum.length;i++){
        //       dateArr.unshift('0')
        //     }
        //     this.dateSum.unshift(...dateArr)
        //   }
        //   return
        // }
        // if (this.scenic_id == 'e7bfd798d9ca461c9f37a4191d55edea') {
        //   this.yearSum = (res.data.data.years_tourists_num * this.coefficient_data / 100 + 330000).toFixed(0).toString().split('');
        // } else {
        //   this.yearSum = (res.data.data.years_tourists_num * this.coefficient_data / 100).toFixed(0).toString().split('');
        // }
        // this.dateSum =  (res.data.data.total_tourists_num * this.coefficient_data / 100).toFixed(0).toString().split('');
        this.dateInSum = (res.data.data.in_tourists_num * this.coefficient_data / 100).toFixed(0).toString().split('');
        this.dateOutSum = (res.data.data.out_park_num * this.coefficient_data / 100).toFixed(0).toString().split('');
        this.crowding = res.data.data.crowding.replace('%', '');
        this.ticket_of_data = res.data.data.ticket_of_data.replace('%', '');
        this.mouth_tourists_num = (res.data.data.mouth_tourists_num * this.coefficient_data / 100).toFixed(0);
        this.total_tourists_num = (res.data.data.total_tourists_num * this.coefficient_data / 100).toFixed(0);
        this.free_check_gate_record_num = (res.data.data.free_check_gate_record_num * this.coefficient_data / 100).toFixed(0);
        this.consumePendingVoiceAction(0)

        // if (6 - this.dateSum.length > 0) {
        //   var dateArr = []
        //   for (let i = 0; i < 6 - this.dateSum.length; i++) {
        //     dateArr.unshift('0')
        //   }
        //   this.dateSum.unshift(...dateArr)
        // }

        if (data != 'change') {
          // this.getWaitingIn()
        }
      });
    },
    // 首页大屏 - 用户画像
    getUserPortraitData() {
      userPortraitData({
        scenic_id: this.scenic_id,
        date: this.req_date
      }).then(res => {
        // userPortraitData({
        //   scenic_id: this.scenic_id,
        //   date: this.req_date
        // }).then(res => {
        //   console.log(res.data.data, '首页大屏 - 用户画像getUserPortraitData')
        //   this.gender = res.data.data.age_range
        //   this.gender.male = res.data.data.gender.male
        //   this.gender.female = res.data.data.gender.female
        //   this.getGender(res.data.data.gender);
        // })
        this.gender = {
          male: Number((1176 * 14.9).toFixed(0)),
          female: Number((1599 * 14.9).toFixed(0)),
          men: [
            { name: '0-18', data: Number((38 * 14.9 * 0.4238).toFixed(0)) },
            { name: '18-30', data: Number((592 * 14.9 * 0.4238).toFixed(0)) },
            { name: '30-40', data: Number((534 * 14.9 * 0.4238).toFixed(0)) },
            { name: '40-50', data: Number((418 * 14.9 * 0.4238).toFixed(0)) },
            { name: '50-60', data: Number((556 * 14.9 * 0.4238).toFixed(0)) },
            { name: '60+', data: Number((637 * 14.9 * 0.4238).toFixed(0)) }
          ],
          women: [
            { name: '0-18', data: Number((38 * 14.9 * 0.5762).toFixed(0)) },
            { name: '18-30', data: Number((592 * 14.9 * 0.5762).toFixed(0)) },
            { name: '30-40', data: Number((534 * 14.9 * 0.5762).toFixed(0)) },
            { name: '40-50', data: Number((418 * 14.9 * 0.5762).toFixed(0)) },
            { name: '50-60', data: Number((556 * 14.9 * 0.5762).toFixed(0)) },
            { name: '60+', data: Number((637 * 14.9 * 0.5762).toFixed(0)) }
          ]
        }
        this.$nextTick(() => {
          this.getGender(this.gender);
          this.getSexPie();
        })
      })
    },
    //获取历史游客数据
    getHistoryData() {
      var yesterday_tourists_num = 0
      var last_month_villager_num = 0
      var last_years_tourists_num = 0
      historyTouristsData({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        yesterday_tourists_num = (res.data.data.yesterday_tourists_num * this.coefficient_data / 100).toFixed(0);
        this.last_mouth_tourists_num = (res.data.data.last_mouth_tourists_num * this.coefficient_data / 100).toFixed(0);
        if (this.scenic_id == 'e7bfd798d9ca461c9f37a4191d55edea') {
          last_years_tourists_num = (res.data.data.last_years_tourists_num * this.coefficient_data / 100 + 220000).toFixed(0);
        } else {
          last_years_tourists_num = (res.data.data.last_years_tourists_num * this.coefficient_data / 100).toFixed(0);
        }
      }).then(res => {
        this.getIotAppendData({ scenic_biz: this.scenic_id, }).then(appendDataList => {

          if (appendDataList.find(item => item === 'villager_in_out')) {
            getIotScenicHistoryData({ scenic_id: this.scenic_id, dates: this.req_date }).then(res => {
              this.yesterday_tourists_num = Number(yesterday_tourists_num) + Number((res.data.data.yesterday_villager_in_num * this.coefficient_data / 100).toFixed(0));
              this.last_month_villager_num = Number(last_month_villager_num) + Number((res.data.data.last_month_villager_num * this.coefficient_data / 100).toFixed(0));
              this.last_years_tourists_num = Number(last_years_tourists_num) + Number((res.data.data.last_year_villager_num * this.coefficient_data / 100).toFixed(0));
            })
          } else {
            this.yesterday_tourists_num = yesterday_tourists_num
            this.last_month_villager_num = last_month_villager_num
            this.last_years_tourists_num = last_years_tourists_num
          }
        })
      })
    },
    //获取游客性别及时间安排
    getGenderSchedule(i) {
      genderScheduleData({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        this.gender = res.data.data.gender;
        this.schedule = res.data.data.schedule;
        // var total = res.data.data.matinee_evening.matinee + res.data.data.matinee_evening.evening
        // if(total>0){
        // 	this.matinee = (res.data.data.matinee_evening.matinee/total*100).toFixed(2)
        // 	this.evening = (res.data.data.matinee_evening.evening/total*100).toFixed(2)
        // }else{
        // 	this.matinee = 0;
        // 	this.evening = 0;
        // }
        this.matinee_evening = res.data.data.matinee_evening;
        if (res.data.data.men_total > 0) {
          this.menP = res.data.data.men_total / (res.data.data.men_total + res.data.data.women_total) * 100
        } else { this.menP = 0 }
        if (res.data.data.women_total > 0) {
          this.womenP = res.data.data.women_total / (res.data.data.men_total + res.data.data.women_total) * 100
        } else { this.womenP = 0 }
        // this.getGender();
        if (i == 1) {
          return false
        } else {
          this.getTime();
          this.getMatineeEvening();
        }

      })
    },
    //早晚场次
    getMatineeEvening() {
      var series = [];
      series.push({ value: this.matinee_evening[0].replace('%', ''), name: '日游场' })
      series.push({ value: this.matinee_evening[1].replace('%', ''), name: '夜游场' })
      series.push({ value: this.matinee_evening[2].replace('%', ''), name: '日转夜' })
      series.push({ value: this.matinee_evening[3].replace('%', ''), name: '过夜' })
      series.push({ value: this.matinee_evening[4].replace('%', ''), name: '其他' })

      var MatineeEvening_1 = this.echarts.init(document.getElementById('matinee_evening_1'));
      var option = {
        color: ['#01f1e3', '#023aff', '#bb63ff', '#ffa63f', '#f13b01'],
        series: [
          {
            type: 'pie',
            // radius: '50%',
            data: series,
            label: {
              show: false
            },
          }
        ],
        tooltip: {
          formatter: function (params) {
            return params.data.name + ":<br/>" + params.data.value + '%'
          },
        }
      }

      MatineeEvening_1.setOption(option)
    },
    //获取时间
    getToday() {
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth() > 8 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
      var date = today.getDate() > 9 ? today.getDate() : '0' + today.getDate();
      this.hour = today.getHours() > 9 ? today.getHours() : '0' + today.getHours();
      var min = today.getMinutes() > 9 ? today.getMinutes() : '0' + today.getMinutes();
      var second = today.getSeconds() > 9 ? today.getSeconds() : '0' + today.getSeconds();
      this.nowDay = year + '/' + month + '/' + date;
      this.nowYear = year;
      this.nowDay2 = year + '-' + month + '-' + date;
      this.nowTime = this.hour + ":" + min + ":" + second;
      this.week = this.getWeek(today.getDay())
    },
    //获取天气
    getWeatherData(i) {
      weatherDataNew({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        // this.temperature = res.data.data.weather.temperature;
        // this.winddirection = res.data.data.weather.winddirection;
        // this.windpower = res.data.data.weather.windpower;
        this.weather = res.data.data.weather;
        if (i && i != undefined) {
          this.getToday();
          return
        } else {
          if (this.typeIndex === 0) {
            this.getPlaneFigure();
          } else if (this.typeIndex === 1) {
            this.getPlaneFigure();
          } else if (this.typeIndex === 2 || this.typeIndex === 5 || this.typeIndex === PRICE_SUPERVISION_TYPE_INDEX) {
            this.getPlaneFigure();
          } else if (this.typeIndex === 6) {
            this.getPlaneFigure();
          } else if (this.typeIndex === 7) {
            this.getPlaneFigure();
          }
        }
      })
    },
    //获取飞机图数据
    getPlaneFigure(i) {
      planeFigure({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        var to = { lat: parseFloat(this.weather.lat), lng: parseFloat(this.weather.lng) }
        var arr = [];
        fly = [];
        this.hotMapList = []

        arcData = [];
        heatData = [];
        for (var j = 0; j < res.data.data.lists.length; j++) {
          var fly = res.data.data.lists[j]
          for (var city in fly) {
            this.hotMapList.push({ name: city, value: fly[city].total })
            arcData.push({ to: to, from: { lat: parseFloat(fly[city].latitude), lng: parseFloat(fly[city].longitude) }, count: fly[city].total })
            heatData.push({ lat: parseFloat(fly[city].latitude), lng: parseFloat(fly[city].longitude), count: fly[city].total })
          }

        }
        // arcData = res.data.data.dicts
        this.flight_coordinates(i)
      })

    },
    //获取游客入园时间统计
    // getEnrollmentTime(){
    //   enrollmentTimeData({
    //     scenic_id:2,
    //     dates:'2021-07-17'
    //   }).then(res => {
    //     this.touristsData = res.data.data;
    //     this.getInTime()
    //   })
    // },
    //获取客源地(省份/城市)数据
    getOriginList() {
      originList({
        scenic_id: this.scenic_id,
        dates: this.req_date,
        sort_type: this.originIndex + 1,
        data_type: 2
      }).then(res => {
        this.origin_list_dict = res.data.data.origin_list_dict
        this.getAddress();
      })
      // visitorSourceData({
      //   date: this.req_date,
      // }).then(res => {
      //   console.log(res, '客源地visitorSourceData')
      // })
    },
    //游客进出园时间分析
    getCurrentTrafficTrend() {
      currentTrafficTrend({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        var obj = res.data.data.current_traffic_trend
        // this.current_traffic_trend.categories = [];
        // this.current_traffic_trend.series = [];
        this.$set(this.current_traffic_trend, 'categories', []);
        this.$set(this.current_traffic_trend, 'series', []);
        return obj
      }).then(current_traffic_trend => {
        return this.getIotAppendData({ scenic_biz: this.scenic_id, }).then(appendDataList => {
          if (appendDataList.find(item => item === 'villager_in_out')) {
            return getIotScenicVillageTrend({ scenic_id: this.scenic_id, dates: this.req_date }).then(res => {
              res.data.data.villager_trend.series.forEach(item => { current_traffic_trend.series.push(item) })
              return current_traffic_trend
            })
          } else {
            return current_traffic_trend
          }
        })
      }).then(current_traffic_trend => {
        if (!this.req_date || this.req_date == '' || this.req_date == this.nowDay2) {
          for (var i = 0; i < current_traffic_trend.categories.length; i++) {
            if (current_traffic_trend.categories[i] <= (parseInt(this.hour) + 1)) {
              this.current_traffic_trend.categories.push(current_traffic_trend.categories[i])
            } else {
              break
            }
          }
          for (var j = 0; j < current_traffic_trend.series.length; j++) {
            this.current_traffic_trend.series.push({ name: current_traffic_trend.series[j].name, data: current_traffic_trend.series[j].data.slice(0, this.current_traffic_trend.categories.length) })
          }
        } else {
          this.current_traffic_trend = current_traffic_trend
        }
        for (var i = 0; i < this.current_traffic_trend.categories.length; i++) {
          var series = this.current_traffic_trend.series
          series[0].data[i] = (series[0].data[i] * this.coefficient_data / 100).toFixed(0)
          series[1].data[i] = (series[1].data[i] * this.coefficient_data / 100).toFixed(0)
          series[2].data[i] = (series[2].data[i] * this.coefficient_data / 100).toFixed(0)
          series[3].data[i] = (series[3].data[i] * this.coefficient_data / 100).toFixed(0)
          series[4].data[i] = (series[4].data[i] * this.coefficient_data / 100).toFixed(0)
          series[5].data[i] = (series[5].data[i] * this.coefficient_data / 100).toFixed(0)
          series[6].data[i] = (series[6].data[i] * this.coefficient_data / 100).toFixed(0)
          if (series[7]) {
            series[7].data[i] = (series[7].data[i] * this.coefficient_data / 100).toFixed(0)
          }
          if (series[8]) {
            series[8].data[i] = (series[8].data[i] * this.coefficient_data / 100).toFixed(0)
          }
        }
        // this.getInOrOut();
        this.getInTime()
        // this.showPeakLine(this.current_traffic_trend)
      })
    },
    // 入园出园趋势
    showPeakLine(chartData) {
      console.log(chartData, '入园出园趋势')
      var categories = [];
      var series = [];
      var order_series = [];
      if (this.isToday) {
        for (var i = 0; i < chartData.categories.length; i++) {
          if (chartData.categories[i] <= (parseInt(this.hour) + 1)) {
            categories.push(chartData.categories[i])
          } else {
            break
          }
        }
      } else {
        categories = chartData.categories;
      }
      let series_0, series_1, series_6
      series_0 = JSON.parse(JSON.stringify(chartData.series[0]));
      series_1 = JSON.parse(JSON.stringify(chartData.series[1]));
      // series_6 = JSON.parse(JSON.stringify(chartData.series[6]));
      series_0.data = this.pushTrafficLine(chartData.series[0].data)
      series_1.data = this.pushTrafficLine(chartData.series[1].data)
      for (var i = 0; i < categories.length; i++) {
        series_0.data[i] = (series_0.data[i] * 4.9).toFixed(0)
        series_1.data[i] = (series_1.data[i] * 4.9).toFixed(0)
      }

      // series_6.data = this.pushTrafficLine(chartData.series[6].data)

      console.log(series, '峰值')
      var option = {
        grid: {
          top: "20%",
          left: "15%",
          right: "5%",
          bottom: "16%"
        },
        legend: {
          show: true,
          y: 'top',
          x: 'right',
          icon: 'rect',
          width: 200,
          itemWidth: 9,
          itemHeight: 9,
          align: "auto",
          textStyle: {
            color: '#526173',
            fontSize: 10
          }
        },
        tooltip: this.getLightTooltipStyle(),
        xAxis: {
          boundaryGap: true,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#526173',
              fontSize: 10
            },
            formatter: (value, index) => {
              return value + '点'
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: 'rgba(34, 49, 63, 0.12)',
              type: 'dashed'
            }
          },
          axisTick: { show: false },
          axisLine: { lineStyle: { color: 'rgba(34, 49, 63, 0.18)' } },
          data: this.current_traffic_trend.categories
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#526173',
              fontSize: 11
            },
          },
          splitLine: {
            show: true,
            lineStyle: this.getLightSplitLineStyle()
          },
          splitNumber: 4,
        },
        color: this.getLightChartColors(),
        series: [{
          data: series_0.data.slice(0, categories.length),
          type: 'bar',
          name: series_0.name,
          barWidth: 10,
          itemStyle: {
            normal: {
              color: this.getLightBarGradient('#94d5ff', '#2f80ed')
            },
          }
        },
        {
          data: series_1.data.slice(0, categories.length),
          type: 'bar',
          name: series_1.name,
          barWidth: 10,
          itemStyle: {
            normal: {
              color: this.getLightBarGradient('#a1e8c9', '#12b886')
            }
          }
        },
          // {
          //   data: series_6.data.slice(0, categories.length),
          //   type: 'line',
          //   smooth: true,
          //   name: series_6.name,
          //   symbol: 'circle',
          //   symbolSize: 6,
          //   itemStyle: {
          //     normal: {
          //       lineStyle: {
          //         width: 0.5
          //       },
          //       borderColor: '#fff',
          //       borderWidth: 2,
          //     }
          //   },
          //   areaStyle: {}
          // }
        ]
      }
      var peakLine = this.echarts.init(document.getElementById('peakLine'));
      var peakLine_2 = this.echarts.init(document.getElementById('peakLine_2'));
      peakLine.setOption(option)
      peakLine_2.setOption(option)
      this.setHourScenic()
    },
    setHourScenic(chartData) {
      const today = new Date();
      const hour = today.getHours()
      var categories = [hour + ':00', hour + ':10', hour + ':20', hour + ':30', hour + ':40', hour + ':50'];
      var series = [];
      series = [
        { name: '篁岭', data: [20, 32, 53, 22, 43, 19, 24, 41, 22, 43, 19, 24], type: 'bar', barWidth: 8, stack: 'forecast' },
        { name: '弦高', data: [12, 13, 15, 12, 14, 11, 12, 14, 12, 14, 11], type: 'bar', barWidth: 8, stack: 'forecast' },
        { name: '婺女洲', data: [2, 3, 5, 2, 4, 1, 2, 4, 5, 2, 4, 1], type: 'bar', barWidth: 8, stack: 'forecast' },
      ]
      var option = {
        grid: {
          top: "12%",
          left: "12%",
          right: "5%",
          bottom: "18%"
        },
        legend: {
          show: true,
          y: 'top',
          x: 'right',
          icon: 'rect',
          width: 200,
          itemWidth: 9,
          itemHeight: 9,
          align: "auto",
          textStyle: {
            color: '#526173',
            fontSize: 10
          }
        },
        tooltip: this.getLightTooltipStyle(),
        xAxis: {
          boundaryGap: true,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#526173',
              fontSize: 10
            },
            formatter: (value, index) => {
              return value + '点'
            }
          },
          splitLine: {
            show: false
          },
          axisTick: { show: false },
          axisLine: { lineStyle: { color: 'rgba(34, 49, 63, 0.18)' } },
          data: categories
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#526173',
              fontSize: 11
            },
          },
          splitLine: {
            show: true,
            lineStyle: this.getLightSplitLineStyle()
          },
          splitNumber: 4,
        },
        color: this.getLightChartColors(),
        series: series
      }
      var hourScenic = this.echarts.init(document.getElementById('hourScenic'));
      hourScenic.setOption(option)
    },
    //入园游客类型统计
    getTicketNumberStatistics() {
      ticketNumberStatistics({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        this.ticket_number_statistics = res.data.data.ticket_number_statistics
        this.getTouristType()
      })
    },
    //游客入园时间图表
    getInTime(data) {
      data = data || this.current_traffic_trend
      if (!data || !data.categories || !data.series || data.series.length < 7) {
        return
      }
      var inTime = this.echarts.init(document.getElementById('inTime'));
      // var xAxisArr = [];
      // for(let i=this.touristsData.dates_list.length-1;i>=0;i--){
      //   xAxisArr.push(this.touristsData.dates_list[i].slice(5))
      // }
      // var yAxisArr = []
      // for(var name in this.touristsData.tourists_list){
      //   yAxisArr.push({type:'line',name:name,data:[]});
      // }
      // for(let i=0;i<yAxisArr.length;i++){
      //   for(let j=0;j<this.touristsData.tourists_list[yAxisArr[i].name].length;j++){
      //     yAxisArr[i].data.unshift(this.touristsData.tourists_list[yAxisArr[i].name][j])
      //   }
      // }

      var iotAppendData = []
      // iotAppendData.push({ ...JSON.parse(dataItem), data: this.current_traffic_trend.series[9].data, name: this.current_traffic_trend.series[9].name })
      var option = {
        grid: {
          top: "20%",
          left: "15%",
          right: "5%",
          bottom: "20%"
        },
        legend: {
          show: true,
          y: 'top',
          x: 'right',
          icon: 'rect',
          width: 200,
          itemWidth: 9,
          itemHeight: 9,
          align: "auto",
          textStyle: {
            color: '#526173',
            fontSize: 10
          }
        },
        tooltip: this.getLightTooltipStyle(),
        xAxis: {
          boundaryGap: true,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#526173',
              fontSize: 10
            },
            formatter: (value, index) => {
              return value + '点'
            }
          },
          splitLine: {
            show: false
          },
          axisTick: { show: false },
          axisLine: { lineStyle: { color: 'rgba(34, 49, 63, 0.18)' } },
          data: data.categories
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#526173',
              fontSize: 11
            },
          },
          splitLine: {
            show: true,
            lineStyle: this.getLightSplitLineStyle()
          },
          splitNumber: 4,
        },
        color: this.getLightChartColors(),
        series: [{
          data: data.series[3].data,
          type: 'bar',
          name: '散客',
          barWidth: 8,
          itemStyle: {
            normal: {
              color: this.getLightBarGradient('#94d5ff', '#2f80ed')
              // color:{
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 0,
              //   y2: 1,
              //   colorStops: [{
              //       offset: 0, color: '#01F1E3' // 0% 处的颜色
              //   }, {
              //       offset: 1, color: '#4DA1FF' // 100% 处的颜色
              //   }],
              // }
            },
          }
        },
        {
          data: data.series[4].data,
          type: 'bar',
          name: '团队',
          barWidth: 8,
          itemStyle: {
            normal: {
              color: this.getLightBarGradient('#a1e8c9', '#12b886')
              // color:{
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 0,
              //   y2: 1,
              //   colorStops: [{
              //       offset: 0, color: '#02A4FF' // 0% 处的颜色
              //   }, {
              //       offset: 1, color: '#7D40FF' // 100% 处的颜色
              //   }],
              // }
            }
          }
        },
        {
          data: data.series[5].data,
          type: 'bar',
          name: '企业',
          barWidth: 8,
          itemStyle: {
            normal: {
              color: this.getLightBarGradient('#ffd480', '#f59f00')
              // color:{
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 0,
              //   y2: 1,
              //   colorStops: [{
              //       offset: 0, color: '#02A4FF' // 0% 处的颜色
              //   }, {
              //       offset: 1, color: '#7D40FF' // 100% 处的颜色
              //   }],
              // }
            }
          }
        },
        {
          data: data.series[6].data,
          type: 'bar',
          name: '贵宾',
          barWidth: 8,
          itemStyle: {
            normal: {
              color: this.getLightBarGradient('#d0bfff', '#845ef7')
              // color:{
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 0,
              //   y2: 1,
              //   colorStops: [{
              //       offset: 0, color: '#02A4FF' // 0% 处的颜色
              //   }, {
              //       offset: 1, color: '#7D40FF' // 100% 处的颜色
              //   }],
              // }
            }
          }
        }].concat(iotAppendData)
      }
      inTime.setOption(option);

    },
    //性别占比图表
    getGender() {
      var xAxisArr = [];
      var yAxisMen = [];
      var yAxisWomen = [];
      for (let i = 0; i < this.gender.men.length; i++) {
        xAxisArr.push(this.gender.men[i].name);
        yAxisMen.push(this.gender.men[i].data);
        yAxisWomen.push(this.gender.women[i].data);
      }
      this.gender.men.type = 'bar';
      this.gender.men.name = '男';
      this.gender.women.type = 'bar';
      this.gender.women.name = '女'
      var option = {
        grid: {
          top: '12%',
          left: '12%',
          right: '4%',
          bottom: '22%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        legend: {
          bottom: 0,
          left: 'center',
          itemWidth: 10,
          itemHeight: 10,
          textStyle: { color: '#333', fontSize: 10 }
        },
        xAxis: {
          axisLabel: {
            show: true,
            color: '#666',
            fontSize: 9
          },
          axisLine: {
            lineStyle: { color: '#ddd' }
          },
          axisTick: { show: false },
          splitLine: { show: false },
          data: xAxisArr
        },
        yAxis: {
          axisLabel: {
            show: true,
            color: '#666',
            fontSize: 9
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eee',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            type: 'bar',
            name: '男',
            data: yAxisMen,
            barWidth: 8,
            itemStyle: {
              borderRadius: [4, 4, 0, 0],
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: '#60a5fa' },
                  { offset: 1, color: '#3b82f6' }
                ]
              }
            }
          },
          {
            type: 'bar',
            name: '女',
            data: yAxisWomen,
            barWidth: 8,
            itemStyle: {
              borderRadius: [4, 4, 0, 0],
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: '#f472b6' },
                  { offset: 1, color: '#ec4899' }
                ]
              }
            }
          }
        ]
      }
      // 只初始化当前可见的图表
      var gender_1_el = document.getElementById('gender_1')
      if (gender_1_el && gender_1_el.offsetWidth > 0) {
        var gender_1 = this.echarts.init(gender_1_el);
        gender_1.setOption(option)
      }
      var gender_7_el = document.getElementById('gender_7')
      if (gender_7_el && gender_7_el.offsetWidth > 0) {
        var gender_7 = this.echarts.init(gender_7_el);
        gender_7.setOption(option)
      }
    },
    //时间占比图表
    getTime() {
      var label = ['1天内', '1天', '2天', '3天', '3天以上']
      var yAxisArr = [23.73, 39.81, 21.82, 11.72, 2.92];
      // for (let i = 0; i < this.schedule.value.length; i++) {
      //   yAxisArr.push(this.schedule.value[i].replace('%', ''))
      // }
      console.log(yAxisArr, this.schedule.label, '????????????????????')
      // var time = this.echarts.init(document.getElementById('time'));
      var time_1 = this.echarts.init(document.getElementById('time_1'));
      var option = {
        grid: {
          top: "10%",
          left: "10%",
          right: "4%",
          bottom: "25%"
        },
        tooltip: {
          formatter: function (params) {
            return params.data + '%'
          }
        },
        xAxis: {
          data: label,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#526173',
              fontSize: 12     //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          axisLabel: {
            show: true,
            formatter: '{value}%',
            textStyle: {
              color: '#526173',
              fontSize: 10      //更改坐标轴文字大小
            }
          },
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: this.getLightSplitLineStyle()
          }
        },
        series: [
          {
            type: 'bar',
            color: this.getLightBarGradient('#ffd480', '#f59f00'),
            data: yAxisArr,
            barWidth: 12
          },
        ]
      }
      // time.setOption(option)
      var option_1 = JSON.parse(JSON.stringify(option))
      option_1.grid.right = '6%'
      option_1.grid.left = '12%'
      option_1.xAxis.axisLabel.textStyle.fontSize = 10
      option_1.tooltip.formatter = function (params) {
        return params.data + '%'
      }
      time_1.setOption(option_1)
    },
    //入园游客类型图表
    getTouristType() {
      // 每项顺序['散客票数','团队票数',"贵宾接待",'单位VIP','本地游客']
      var qianjing = [
        this.ticket_number_statistics.wx_mini_pro_member_num,
        this.ticket_number_statistics.wx_mini_pro_agency_num,
        this.ticket_number_statistics.wx_mini_pro_vip_num,
        this.ticket_number_statistics.wx_mini_pro_enterprise_vip_num
      ]

      var ota = [this.ticket_number_statistics.ota_num, 0, 0, 0, 0]
      var unLine = [
        this.ticket_number_statistics.member,
        this.ticket_number_statistics.agency,
        this.ticket_number_statistics.vip,
        this.ticket_number_statistics.enterprise_vip,
        this.ticket_number_statistics.free_check_gate_record_num
      ]
      // var touristType = this.echarts.init(document.getElementById('touristType'));
      var touristType_1 = this.echarts.init(document.getElementById('touristType_1'));
      var option = {
        grid: {
          top: "5%",
          left: "15%",
          right: "4%",
          bottom: "25%"
        },
        legend: {
          show: true,
          y: 'bottom',
          icon: "circle",
          itemWidth: 5,
          itemHeight: 5,
          itemGap: 30,
          textStyle: {  // 图例文字的样式
            color: '#526173',
          },
        },
        tooltip: this.getLightTooltipStyle(),
        xAxis: {
          data: ['散客票数', '团队票数', "贵宾接待", '单位VIP', '本地游客'],
          axisLabel: {
            show: true,
            textStyle: {
              color: '#526173',
              fontSize: 9      //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: true,
            lineStyle: this.getLightSplitLineStyle()
          }
        },
        yAxis: {
          splitNumber: 4,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#526173',
              fontSize: 12     //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: true,
            lineStyle: this.getLightSplitLineStyle()
          }
        },
        series: [
          {
            type: 'bar',
            name: '线下窗口',
            color: '#2f80ed',
            data: unLine,
            barWidth: 10,
            stack: 'x'
          },
          {
            type: 'bar',
            name: '牵景平台',
            color: '#12b886',
            data: qianjing,
            barWidth: 10,
            stack: 'x'
          },
          {
            type: 'bar',
            name: 'OTA',
            color: '#f59f00',
            data: ota,
            barWidth: 10,
            stack: 'x'
          }
        ]
      }
      // touristType.setOption(option)
      touristType_1.setOption(option)
    },
    //客源地统计图表
    getAddress() {
      var xAxisArr = [];
      var max = Math.max.apply(null, this.origin_list_dict.area_total_list);
      var divisor = max / 4;
      var maxmax = max + max / 3;
      var area_total_list = []
      var area_member_list = []
      var area_agency_list = []
      console.log(this.origin_list_dict, 'getAddress客源地统计图表')
      for (let i = 0; i < this.origin_list_dict.area_total_list.length; i++) {
        area_total_list.push(this.origin_list_dict.area_total_list[i] + divisor)
      }
      for (let i = 0; i < this.origin_list_dict.area_member_list.length; i++) {
        area_member_list.push(this.origin_list_dict.area_member_list[i] + divisor)
      }
      for (let i = 0; i < this.origin_list_dict.area_agency_list.length; i++) {
        area_agency_list.push(this.origin_list_dict.area_agency_list[i] + divisor)
      }
      // var address = this.echarts.init(document.getElementById('address'));
      var address_1 = this.echarts.init(document.getElementById('address_1'));
      var address_2 = this.echarts.init(document.getElementById('address_2'));
      option = {
        color: ['#2f80ed', '#12b886', '#f59f00'],
        legend: {
          show: true,
          // y: '10px',    //延Y轴居中
          bottom: 0,
          left: 10,
          // orient: 'vertical',
          align: 'left',
          itemWidth: 10,
          itemHeight: 2,
          textStyle: {
            color: '#526173'
          }
        },
        radar: {
          splitNumber: 1,
          radius: 45,
          nameGap: 6,
          textStyle: {
            fontSize: 10,
            color: '#526173'
          },
          center: ['50%', '45%'],
          indicator: [
            { name: '东北', max: maxmax },
            { name: '华东', max: maxmax },
            { name: '华北', max: maxmax },
            { name: '华中', max: maxmax },
            { name: '西北', max: maxmax },
            { name: '西南', max: maxmax },
            { name: '华南', max: maxmax },
          ],
          splitLine: {
            show: true,
            lineStyle: {
              width: 0.5,
              color: 'rgba(34, 49, 63, 0.16)'
            }
          },
          axisLine: {
            lineStyle: {
              width: 0.5,
              color: 'rgba(34, 49, 63, 0.16)'
            }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ['rgba(47, 128, 237, 0.04)', 'rgba(18, 184, 134, 0.04)']
            }
          },

        },
        tooltip: {
          formatter: function (params) {
            var arr = []
            var _address = ['东北', '华东', '华北', '华中', '西北', '西南', '华南']
            for (let i = 0; i < params.value.length; i++) {
              arr.push(_address[i] + ':' + (params.value[i] - divisor) + ' ')
            }
            return params.name + '：[ ' + arr + ' ]'
          }
        },
        series: [

          {
            symbol: 'none',
            type: 'radar',
            data: [
              {
                value: area_total_list,
                name: '总数',
                lineStyle: { // 单项线条样式。

                  normal: {

                    opacity: 0.8, // 图形透明度

                  }
                },
                areaStyle: {
                  normal: {
                    type: 'default',
                    opacity: 0.6, // 图表中各个图区域的透明
                  }
                },
                label: {
                  normal: {
                    show: true,

                  }
                },
              }
            ]
          },

          {
            symbol: 'none',
            type: 'radar',
            data: [
              {
                value: area_member_list,
                name: '散客',
                lineStyle: { // 单项线条样式。
                  normal: {
                    opacity: 0.8, // 图形透明度
                  }
                },
                areaStyle: {
                  normal: {
                    type: 'default',
                    opacity: 0.6, // 图表中各个图区域的透明度

                  }
                },
                label: {
                  normal: {
                    show: true,
                    formatter: function (params) {
                      // return this.origin_list_dict.area_member_list[params.dataIndex] ;
                      return params.value - divisor
                    }
                  }
                },
              }
            ]
          },
          {
            symbol: 'none',
            type: 'radar',
            data: [
              {
                value: area_agency_list,
                name: '团队',
                lineStyle: { // 单项线条样式。
                  normal: {
                    opacity: 0.8, // 图形透明度

                  }
                },
                areaStyle: {
                  normal: {
                    type: 'default',
                    opacity: 0.6, // 图表中各个图区域的透明
                  }
                },
                label: {
                  normal: {
                    show: true,
                    formatter: function (params) {
                      // return this.origin_list_dict.area_agency_list[params.dataIndex] ;
                      return params.value - divisor
                    }
                  }
                },
              }
            ]
          },
        ]
      }
      option.tooltip.position = 'right'
      var option_1 = JSON.parse(JSON.stringify(option))
      option_1.radar.radius = 60
      // address.setOption(option);
      address_1.setOption(option);
      address_2.setOption(option_1);
      // var addressBar = this.echarts.init(document.getElementById('addressBar'));
      var addressBar_1 = this.echarts.init(document.getElementById('addressBar_1'));
      var addressBar_2 = this.echarts.init(document.getElementById('addressBar_2'));
      var addressBar_5 = this.echarts.init(document.getElementById('addressBar_5'));
      var newAddressArr = [];
      for (var i = this.origin_list_dict.o_total_list.length - 1; i >= 0; i--) {
        newAddressArr[newAddressArr.length] = this.origin_list_dict.o_total_list[i];
      }

      var newAddressName = [];
      for (var i = this.origin_list_dict.o_address_list.length - 1; i >= 0; i--) {
        newAddressName[newAddressName.length] = this.origin_list_dict.o_address_list[i];
      }
      var option = {
        grid: {
          top: "0",
          left: "0",
          right: "0",
          bottom: "0"
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: function (params) {
            return params.value;
          },
        },
        xAxis: {
          splitLine: {
            show: false
          },
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false }
        },
        yAxis: {
          data: newAddressName,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: '#526173',
            fontSize: 9
          }
        },

        series: [
          {
            type: 'bar',
            color: this.getLightBarGradient('#94d5ff', '#2f80ed', true),
            data: newAddressArr,
            barWidth: 10
          },
        ]
      }
      // addressBar.setOption(option)
      addressBar_1.setOption(option)
      addressBar_2.setOption(option)
      addressBar_5.setOption(option)
    },
    //获取游客客流分析
    getTouristLine() {
      // 检查数据是否存在
      if (!this.real_time_traffic_list || !this.real_time_traffic_list.time_list || !this.real_time_traffic_list.data_list) {
        return
      }
      var xAxisArr = [];
      var yAxisArr = [];
      for (var i = this.real_time_traffic_list.time_list.length - 1; i >= 0; i--) {
        xAxisArr.push(this.real_time_traffic_list.time_list[i].slice(5, 10))
      }
      for (var i = this.real_time_traffic_list.data_list.length - 1; i >= 0; i--) {
        yAxisArr.push((this.real_time_traffic_list.data_list[i] * this.coefficient_data / 100).toFixed(0))
      }
      console.log(xAxisArr, yAxisArr, '30天天')
      var dom1 = document.getElementById('touristLine')
      var dom2 = document.getElementById('touristLine_6')
      var dom3 = document.getElementById('touristLine_1')
      var touristLine = dom1 && dom1.offsetWidth > 0 ? this.echarts.init(dom1) : null
      var touristLine_6 = dom2 && dom2.offsetWidth > 0 ? this.echarts.init(dom2) : null
      var touristLine_1 = dom3 && dom3.offsetWidth > 0 ? this.echarts.init(dom3) : null
      var option = {
        grid: {
          top: "30%",
          left: "13%",
          right: "4%",
          bottom: "18%"
        },
        xAxis: {
          boundaryGap: false,
          axisLabel: {
            show: true,
            interval: 3,
            rotate: 0,
            formatter: value => value.replace('-', '/'),
            textStyle: {
              color: '#7b8794',
              fontSize: 11
            }
          },
          splitLine: {
            show: false
          },
          axisTick: { show: false },
          axisLine: { lineStyle: { color: 'rgba(34, 49, 63, 0.1)' } },
          data: xAxisArr
        },
        yAxis: {
          type: 'value',
          name: '人次',
          nameTextStyle: {
            color: '#909399',
            fontSize: 11,
            padding: [0, 26, 0, 0]
          },
          axisLabel: {
            show: true,
            formatter: value => value >= 10000 ? (value / 10000).toFixed(1) + '万' : value,
            textStyle: {
              color: '#7b8794',
              fontSize: 11
            }
          },
          splitLine: {
            show: true,
            lineStyle: this.getLightSplitLineStyle()
          },
          splitNumber: 5,
        },
        tooltip: Object.assign({}, this.getLightTooltipStyle(), {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#409eff',
              width: 1,
              type: 'dashed'
            }
          }
        }),
        series: [
          {
            name: '客流热度',
            data: yAxisArr,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            showSymbol: false,
            lineStyle: {
              width: 3,
              color: '#409eff'
            },
            areaStyle: {
              color: this.getLightBarGradient('rgba(64, 158, 255, 0.28)', 'rgba(64, 158, 255, 0.02)')
            },
            itemStyle: {
              color: '#409eff',
              borderColor: '#ffffff',
              borderWidth: 2
            },
            emphasis: {
              focus: 'series',
              itemStyle: {
                borderColor: '#409eff',
                borderWidth: 3
              }
            }
          }
        ]
      }
      if (touristLine) touristLine.setOption(option);
      if (touristLine_6) touristLine_6.setOption(option)
      var option_1 = JSON.parse(JSON.stringify(option))
      option_1.grid.left = '15%'
      option_1.grid.right = '5%'
      option_1.grid.top = '20%'
      option_1.grid.bottom = '20%'
      if (touristLine_1) touristLine_1.setOption(option_1)
      if (touristLine_6) touristLine_6.setOption(option_1)
    },
    //获取游客进出园时间
    getInOrOut() {
      var inOrOut = this.echarts.init(document.getElementById('inOrOut'));

      var f = (e, i, t) => Number(e) + Number(t[i])
      inOrOut.setOption({
        grid: {
          top: "18%",
          left: "8%",
          right: "4%",
          bottom: "18%"
        },
        color: [
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#01F1E3' // 0% 处的颜色
            }, {
              offset: 1, color: '#2f80ed' // 100% 处的颜色
            }],
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#02A4FF' // 0% 处的颜色
            }, {
              offset: 1, color: '#12b886' // 100% 处的颜色
            }],
          }
        ],
        legend: {
          show: true,
          y: 'top',
          x: 'right',
          icon: 'roundRect',
          itemWidth: 14,
          itemHeight: 8,
          textStyle: {
            fontSize: 11,
            color: '#606266'
          }
        },

        xAxis: {
          boundaryGap: true,
          axisLabel: {
            show: true,
            interval: 1,
            textStyle: {
              color: '#7b8794',
              fontSize: 11
            },
            formatter: (value, index) => {
              return index % 2 === 0 ? value + ':00' : ''
            }
          },
          splitLine: {
            show: false
          },
          axisTick: { show: false },
          axisLine: { lineStyle: { color: 'rgba(34, 49, 63, 0.1)' } },
          data: this.current_traffic_trend.categories,

        },
        yAxis: {
          type: 'value',
          name: '人次',
          nameTextStyle: {
            color: '#909399',
            fontSize: 11,
            padding: [0, 26, 0, 0]
          },
          axisLabel: {
            show: true,
            formatter: value => value >= 10000 ? (value / 10000).toFixed(1) + '万' : value,
            textStyle: {
              color: '#7b8794',
              fontSize: 11
            }
          },
          splitLine: {
            show: true,
            lineStyle: this.getLightSplitLineStyle()
          },
          splitNumber: 5,
        },
        lineStyle: {
          color: '#526173',
        },
        tooltip: Object.assign({}, this.getLightTooltipStyle(), {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: 'rgba(64, 158, 255, 0.08)'
            }
          }
        }),
        series: [
          {
            data: (this.current_traffic_trend.series[7] ?
              this.current_traffic_trend.series[0].data.map((e, i) => f(e, i, this.current_traffic_trend.series[7].data)) :
              this.current_traffic_trend.series[0].data),
            type: 'bar',
            name: '入园客流',
            barWidth: 12,
            barGap: '28%',
            itemStyle: {
              normal: {
                borderRadius: [8, 8, 0, 0],
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#8ed1ff' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#2f80ed' // 100% 处的颜色
                  }],
                }
              },
            }
          },
          {
            data: (this.current_traffic_trend.series[8] ?
              this.current_traffic_trend.series[0].data.map((e, i) => f(e, i, this.current_traffic_trend.series[8].data)) :
              this.current_traffic_trend.series[1].data),
            type: 'bar',
            name: '出园客流',
            barWidth: 12,
            itemStyle: {
              normal: {
                borderRadius: [8, 8, 0, 0],
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#a1e8c9' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#12b886' // 100% 处的颜色
                  }],
                }
              }
            },
          },
        ]
      })
    },
    convertData(data, geoCoordMap) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var dataItem = data[i];
        var fromCoord = geoCoordMap[dataItem[0].name];
        var toCoord = geoCoordMap[dataItem[1].name];
        if (fromCoord && toCoord) {
          res.push({
            fromName: dataItem[0].name,
            toName: dataItem[1].name,
            coords: [toCoord, fromCoord]
          });
        }
      }
      return res;
    },
    // 飞机图或热力图
    flight_coordinates(i) {
      var data = arcData.slice(0, 50);
      const renderMapLayer = () => {
        if (i == 1) {
          this.clearFlightLayer()
        } else if (this.typeIndex == 2 || this.typeIndex == PRICE_SUPERVISION_TYPE_INDEX) {
          this.destroyMainMap()
          this.createDashboardMap()
        } else if (this.typeIndex == 7) {
          // 客群画像热力图需要显示全国范围，不限制婺源边界
          this.destroyMainMap()
          var center = new TMap.LatLng(
            parseFloat(this.weather.lat) + this.setting.lat_offset,
            parseFloat(this.weather.lng) + this.setting.lng_offset
          );
          this.map = new TMap.Map('migrateMap', {
            zoom: 5,
            minZoom: 4,
            maxZoom: 10,
            pitch: 0,
            center: center,
            showControl: false,
            draggable: true,
            baseMap: {
              type: 'vector',
              features: ['base', 'building3d', 'point']
            }
          })
        } else {
          this.destroyMainMap()
          var center = new TMap.LatLng(
            parseFloat(this.weather.lat) + this.setting.lat_offset,
            parseFloat(this.weather.lng) + this.setting.lng_offset
          );
          this.createRestrictedWuyuanMap("migrateMap", {
            zoom: this.setting.map_show,//设置地图缩放级别
            pitch: 0,
            center: center,//设置地图中心点坐标
            showControl: false, //禁止所有控件
            draggable: true, //允许拖拽
            scrollable: true, //允许滚轮缩放
            baseMap: {
              type: "vector",
              features: ["base", "building3d", "point"], // 隐藏矢量文字
            },
          });
        }

        if (!this.map) {
          if (this.typeIndex == 2 || this.typeIndex == PRICE_SUPERVISION_TYPE_INDEX) {
            this.createDashboardMap()
          } else {
            return
          }
        }

        if (this.typeIndex == PRICE_SUPERVISION_TYPE_INDEX) {
          this.renderPriceFenceLayer()
        }

        if (this.typeIndex == 0 || this.typeIndex == 7 || this.typeIndex == 1 || this.typeIndex == 5 || this.typeIndex == 6 || this.typeIndex == PRICE_SUPERVISION_TYPE_INDEX) {
          // typeIndex==7 客群画像是全国热力图，不过滤婺源边界
          var heatPoints = this.typeIndex == 7 ? (heatData || []) : this.getWuyuanHeatData(heatData)
          if (!heatPoints.length) {
            heatPoints = WUYUAN_HEAT_POINTS.slice()
          }
          var heatMax = Math.max(100, heatPoints.reduce(function (m, p) { return Math.max(m, p.count || 0) }, 0) || 600)
          this.flightMap = new TMap.visualization.Heat({
            max: heatMax,
            min: 0,
            height: 6,
            radius: this.typeIndex == 7 ? 50 : 28
          }).addTo(this.map)
          this.flightMap.setOpacity(0.8)
          var gradient = this.flightMap.getGradientColor()
          gradient.stops[0.1] = '#fff'
          gradient.stops[0.3] = '#5589f2'
          gradient.stops[0.6] = '#E9AB1D'
          gradient.stops[0.8] = '#e53f31'
          gradient.stops[0.99] = '#b84b41'
          gradient.stops[1.0] = '#652074'
          this.flightMap.setGradientColor(gradient); // 设置渐变色
          this.flightMap.setData(this.typeIndex == 7 ? (heatData || []) : this.getWuyuanHeatData(heatData));//设置数据
          if (this.typeIndex == 5) {
            this.renderBusinessFenceLayers()
            this.renderBusinessResourceMarkers()
            if (this.isBusinessFenceDrawing) {
              this.bindBusinessFenceMapClick()
            }
          }
        }
      }

      this.ensureWuyuanBoundaryReady().then(() => {
        renderMapLayer()
      })
    },
    getWuyuanHeatData(sourceData) {
      return (sourceData || []).filter(item => this.isPointInWuyuanBoundary(item))
    },
    changeTheDate(day) {
      if (day == 0) {
        var date = '';
        this.$router.push({ path: '/', query: { id: this.scenic_id, date: date, typeIndex: this.typeIndex, token: store.state.token } })
        this.$router.go(0)
      } else {
        if (this.req_date != null) {
          var today = new Date(this.req_date)
        } else {
          var today = new Date()
        }
        var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
        today.setTime(targetday_milliseconds) //注意，这行是关键代码
        var tYear = today.getFullYear()
        var tMonth = today.getMonth()
        var tDate = today.getDate()
        this.nowYear = tYear;
        tMonth = this.doHandleMonth(tMonth + 1)
        tDate = this.doHandleMonth(tDate)
        var date = tYear + "-" + tMonth + "-" + tDate
        this.$router.push({ path: '/', query: { id: this.scenic_id, date: date, typeIndex: this.typeIndex, token: store.state.token } })
        this.$router.go(0)
      }

    },
    doHandleMonth(month) {
      var m = month
      if (month.toString().length == 1) {
        m = "0" + month
      }
      return m
    },
    // 获取客源月份
    getAnalysisMonth() {
      getAnalysisMonthApi({
        scenic_id: this.scenic_id
      }).then(res => {
        for (var month in res.data.data) {
          this.monthList = res.data.data[month]
          break
        }
        this.getCityCome()
        this.getOldCome()
      })
    },
    // 获取城市客源结构分析
    getCityCome() {
      getDataCustomerSourceMarketApi({
        scenic_id: this.scenic_id,
        city_name: this.city_name,
        month: this.monthList[0]
      }).then(res => {
        this.now_city_name = this.city_name
        this.cityComeData = res.data.data
        var categories = []
        var series = []
        var series_num = []
        var five_type = 'zongti_list'
        var five_num_type = 'zongti_list_num'
        for (let i = 0; i < this.monthList[1].length; i++) {
          categories.push(this.monthList[1][i] + '月')
        }
        series.push({ name: '60+', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][0] })
        series.push({ name: '50-60', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][1] })
        series.push({ name: '40-50', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][2] })
        series.push({ name: '30-40', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][3] })
        series.push({ name: '18-30', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][4] })
        series.push({ name: '18-', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][5] })
        // for(let i=0;i<series_num.length;i++){
        // 	series_num[i].data.unshift(series_num[i].data[11])
        // 	series_num[i].data.splice(12,1)
        // }
        var cityCome = this.echarts.init(document.getElementById('cityCome'));
        var cityCome_7 = this.echarts.init(document.getElementById('cityCome_7'));
        var option = {
          legend: {
            // Try 'horizontal'
            orient: 'horizontal',
            right: 'center',
            width: 325,
            bottom: 0,
            textStyle: {
              color: "#606266"
            }
          },
          tooltip: {
            trigger: 'axis',
            position: function (point, params, dom, rect, size) {
              return [point[0] - 100, '10%']  //返回x、y（横向、纵向）两个点的位置
            },
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#1e5671'
              }
            },
            textStyle: {
              fontSize: 10,
            }
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            top: '20%',
            left: '3%',
            right: '3%',
            bottom: '24%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: categories,
              minorTick: {
                splitNumber: 12
              },
              axisLabel: {
                fontSize: 9,
                color: '#606266'
              }
            }
          ],
          yAxis: [
            {
              max: 1,
              type: 'value',
              axisLabel: {
                formatter: function (value, index) {
                  return (value * 100).toFixed(0) + '%';
                },
                color: '#606266'
              }
            }
          ],
          series: series
        }
        cityCome.setOption(option)
        cityCome_7.setOption(option)
      })
    },
    getOldCome() {
      getDataMainSourceMarketApi({
        scenic_id: this.scenic_id,
        data_type: 1,
        month: this.monthList[0]
      }).then(res => {
        this.oldComeData = res.data.data
        this.drawOldCome(this.oldComeIndex)
      })
    },
    getTradingNum_bar() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getTradingNumApi(params).then(res => {
        var categories = []
        var series_data = []

        res.data.data.ote_type_sale_volume_list.slice(0, 10).forEach(item => {
          categories.push(item[0])
          series_data.push(item[1])
        })
        categories.reverse()
        series_data.reverse()
        var obj = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {},
          grid: {
            left: '3%',
            right: '10%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            // boundaryGap: [0, 0.01],
            axisLabel: {
              textStyle: {
                color: '#606266',
                fontSize: 8     //更改坐标轴文字大小
              }
            },
            splitNumber: 3,
          },
          yAxis: {
            type: 'category',
            data: categories,
            axisLabel: {
              textStyle: {
                color: '#606266',
                fontSize: 10      //更改坐标轴文字大小
              },
              formatter: function (value) {
                return value.slice(0, 5);
              }
            }
          },
          series: [
            {
              name: '',
              type: 'bar',
              data: series_data,
              itemStyle: {
                color: "#0437ea"
              }
            }
          ]
        }
        var OTArank = this.echarts.init(document.getElementById('OTArank'));
        OTArank.setOption(obj)
      })
    },
    //今日交易总额
    getTradingNum() {
      // var params = {}
      // if (this.typeIndex === 2 && this.isToday) {
      //   params = { scenic_id: this.scenic_id, dates: this.last_day }
      // } else {
      //   params = { scenic_id: this.scenic_id, dates: this.req_date }
      // }

      // getTradingNumApi(params).then(res => {
      //   if (this.typeIndex === 0) {
      //     this.ote_type_sale_person_list = res.data.data.ote_type_sale_person_list
      //     this.showOtaPie(this.ote_type_sale_person_list)
      //     return
      //   }
      //   this.tradingNum = res.data.data;
      // })
      this.ote_type_sale_person_list = [
        { name: '餐饮', value: 2132728 },
        { name: '住宿', value: 1852012 },
        { name: '游玩', value: 2802215 },
        { name: '交通', value: 3293002 },
        { name: '购物', value: 379484 },
        { name: '其他', value: 109226 }
      ]
      this.showOtaPie(this.ote_type_sale_person_list)
      // channelAnalysisData({
      //   date: this.req_date
      // }).then(res => {
      //   this.ote_type_sale_person_list = res.data.data.ota

      //   this.getTouristAgencyType(res.data.data.travel_agency)
      // })
    },
    // 出行方式
    getTravelMode() {
      this.travel_mode_list = [
        { name: '高铁', value: 5023078 },
        { name: '自驾', value: 4270830 },
        { name: '大巴', value: 2608603 },
        { name: '其他', value: 230528 }
      ]
      this.showTravelPie(this.travel_mode_list)
    },
    // ota饼图
    showOtaPie(data) {
      var series = [];
      var total = 0
      for (let i = 0; i < data.length; i++) {
        series.push({ value: (data[i].value * this.coefficient_data / 100).toFixed(0), name: data[i].name })
        total += data[i].value
      }
      var otaPieDom = document.getElementById('ota_pie')
      var otaPieFiveDom = document.getElementById('ota_pie_5')
      var option = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            radius: ['52%', '72%'],
            data: series,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              borderColor: '#ffffff',
              borderWidth: 3,
              borderRadius: 4
            },
            center: ['50%', '44%'],
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + ((params.data.value / total) * 100).toFixed(2) + "%<br/>" + params.data.value + '元'
          },
        },
        legend: {
          show: false,
          bottom: 0,
          textStyle: {
            color: '#606266',
            fontSize: 12
          },
        },
      }
      if (otaPieDom) {
        var ota_pie = this.echarts.init(otaPieDom)
        ota_pie.setOption(option)
      }
      if (otaPieFiveDom) {
        var ota_pie_5 = this.echarts.init(otaPieFiveDom)
        var option_1 = JSON.parse(JSON.stringify(option))
        option_1.legend = {
          orient: 'horizontal',
          bottom: 12,
          itemWidth: 8,   // 默认25，缩小为8
          itemHeight: 8,  // 默认14，缩小为8
          itemGap: 8,    // 默认10，可适当缩小
          textStyle: {
            color: '#000',
            fontSize: 10 // 缩小字体
          },
        }
        option_1.series[0].center = ['50%', '36%']
        ota_pie_5.setOption(option_1)
      }
    },
    getYearPie() {
      
      var series = [
        { name: '0-18', value: Number((38 * 14.9).toFixed(0)) },
        { name: '18-30', value: Number((592 * 14.9).toFixed(0)) },
        { name: '30-40', value: Number((534 * 14.9).toFixed(0)) },
        { name: '40-50', value: Number((418 * 14.9).toFixed(0)) },
        { name: '50-60', value: Number((556 * 14.9).toFixed(0)) },
        { name: '60+', value: Number((637 * 14.9).toFixed(0)) }
      ]
      
      var total = 0
      series.forEach(item => {
        total += item.value
      })
      var dom = document.getElementById('year_pie_6')
      if (!dom || dom.offsetWidth === 0) return
      var year_pie_6 = this.echarts.init(dom);
      var option = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            radius: ['52%', '72%'],
            data: series,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              borderColor: '#ffffff',
              borderWidth: 3,
              borderRadius: 4
            },
            center: ['50%', '36%'],
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + ((params.data.value / total) * 100).toFixed(2) + "%<br/>" + params.data.value + '人'
          },
        },
        legend: {
          orient: 'horizontal',
          bottom: 10,
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 7,
          textStyle: {
            color: '#000',
            fontSize: 9
          },
        },
      }
      
      year_pie_6.setOption(option)
    },
    getProvincePie() {
      var series = [
        { name: '江苏', value: 13.39 },
        { name: '江西', value: 11.70 },
        { name: '安徽', value: 11.09 },
        { name: '浙江', value: 10.26 },
        { name: '广东', value: 9.78 },
        { name: '北京 ', value: 8.48 },
      ]
      var total = 1042852
      var dom1 = document.getElementById('province_pie_6')
      var dom2 = document.getElementById('province_pie_6_2')
      if (!dom1 || dom1.offsetWidth === 0) return
      var province_pie_6 = this.echarts.init(dom1);
      var province_pie_6_2 = dom2 && dom2.offsetWidth > 0 ? this.echarts.init(dom2) : null;
      var option = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            radius: ['52%', '72%'],
            data: series,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              borderColor: '#ffffff',
              borderWidth: 3,
              borderRadius: 4
            },
            center: ['50%', '36%'],
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + params.data.value + "%<br/>" + (params.data.value * total / 100).toFixed(0) + '人'
          },
        },
        legend: {
          orient: 'horizontal',
          bottom: 10,
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 7,
          textStyle: {
            color: '#000',
            fontSize: 9
          },
        },
      }
      province_pie_6.setOption(option)
      // province_pie_6_2 使用实心饼图，无图例
      var option2 = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            radius: '65%',
            data: series,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              borderColor: '#ffffff',
              borderWidth: 3,
              borderRadius: 4
            },
            center: ['50%', '40%'],
          }
        ],
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + params.data.value + "%<br/>" + (params.data.value * total / 100).toFixed(0) + '人'
          },
        },
        legend: {
          show: false
        },
      }
      if (province_pie_6_2) province_pie_6_2.setOption(option2)
    },
    getSexPie6() {
      var series = [
        { name: '女', value: 1599 * 14.9 },
        { name: '男', value: 1176 * 14.9 },
      ]
      var total = 0
      series.forEach(item => {
        total += item.value
      })
      var dom = document.getElementById('sex_pie_6')
      if (!dom || dom.offsetWidth === 0) return
      var sex_pie_6 = this.echarts.init(dom);
      var option = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            radius: ['52%', '72%'],
            data: series,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              borderColor: '#ffffff',
              borderWidth: 3,
              borderRadius: 4
            },
            center: ['50%', '36%'],
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + ((params.data.value / total) * 100).toFixed(2) + "%<br/>" + params.data.value + '人'
          },
        },
        legend: {
          orient: 'horizontal',
          bottom: 10,
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 7,
          textStyle: {
            color: '#000',
            fontSize: 9
          },
        },
      }
      
      sex_pie_6.setOption(option)
    },
    getYearPie2() {
      var series = [
        { name: '0-18', value: Number((38 * 14.9).toFixed(0)) },
        { name: '18-30', value: Number((592 * 14.9).toFixed(0)) },
        { name: '30-40', value: Number((534 * 14.9).toFixed(0)) },
        { name: '40-50', value: Number((418 * 14.9).toFixed(0)) },
        { name: '50-60', value: Number((556 * 14.9).toFixed(0)) },
        { name: '60+', value: Number((637 * 14.9).toFixed(0)) }
      ]
      var total = 0
      series.forEach(item => {
        total += item.value
      })
      var dom = document.getElementById('year_pie_6_2')
      if (!dom || dom.offsetWidth === 0) return
      var year_pie_6_2 = this.echarts.init(dom);
      var option = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            radius: '65%',
            data: series,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              borderColor: '#ffffff',
              borderWidth: 3,
              borderRadius: 4
            },
            center: ['50%', '40%'],
          }
        ],
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + "岁:<br/>" + ((params.data.value / total) * 100).toFixed(2) + "%<br/>" + params.data.value + '人'
          },
        },
        legend: {
          show: false
        },
      }
      year_pie_6_2.setOption(option)
    },
    getPlayPie() {
      
      var series = [
        { name: '农家乐', value: 27.31 },
        { name: 'KTV', value: 14.67 },
        { name: '研学', value: 9.82 },
        { name: '旅拍', value: 12.33 },
        { name: '采摘园', value: 8.98 },
        { name: '其他 ', value: 26.89 },
      ]
      var total = 104285
      var dom = document.getElementById('play_pie_6')
      if (!dom || dom.offsetWidth === 0) return
      var play_pie_6 = this.echarts.init(dom);
      var option = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            radius: ['52%', '72%'],
            data: series,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              borderColor: '#ffffff',
              borderWidth: 3,
              borderRadius: 4
            },
            center: ['50%', '36%'],
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + params.data.value + "%<br/>" + (params.data.value * total / 100 ).toFixed(0) + '人次'
          },
        },
        legend: {
          orient: 'horizontal',
          bottom: 12,
          itemWidth: 8,   // 默认25，缩小为8
          itemHeight: 8,  // 默认14，缩小为8
          itemGap: 8,    // 默认10，可适当缩小
          textStyle: {
            color: '#000',
            fontSize: 11 // 缩小字体
          },
        },
      }
      
      play_pie_6.setOption(option)
    },
    showTravelPie(data) {
      // 只保留自驾出行和公共出行
      var travelData = [
        { value: 47.6, name: '自驾出行' },
        { value: 52.4, name: '公共出行' }
      ]
      var travel_pie_el = document.getElementById('travel_pie')
      if (!travel_pie_el || travel_pie_el.offsetWidth === 0) return
      var travel_pie = this.echarts.init(travel_pie_el);
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {d}%'
        },
        legend: {
          orient: 'horizontal',
          bottom: 4,
          left: 'center',
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 20,
          textStyle: {
            color: '#000',
            fontSize: 12
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['45%', '72%'],
            center: ['50%', '42%'],
            roseType: 'radius',
            itemStyle: {
              borderRadius: 8,
              borderColor: '#fff',
              borderWidth: 3
            },
            label: {
              show: true,
              position: 'outside',
              formatter: '{b}\n{d}%',
              fontSize: 11,
              color: '#333'
            },
            labelLine: {
              show: true,
              length: 8,
              length2: 12,
              lineStyle: {
                color: '#999'
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 13,
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 12,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.25)'
              }
            },
            data: travelData,
            color: ['#6366f1', '#22c55e']
          }
        ]
      }
      travel_pie.setOption(option)
    },
    // 旅行社交易排名
    getTouristAgencyType(data) {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getTouristAgencyType(params).then(res => {
        let list = []
        if (this.typeIndex === 0) {
          list = data
        } else {
          list = res.data.data.tourist_agency_type_sale_volume_list
        }
        let categories = []
        let series_data = []
        list.slice(0, 10).forEach(item => {
          categories.push(item[0].tourist_agency__name)
          series_data.push((item[1] * this.coefficient_data / 100).toFixed(0))
        })
        categories.reverse()
        series_data.reverse()
        var res = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {},
          grid: {
            left: '0',
            right: '10%',
            bottom: '6%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
              textStyle: {
                color: '#606266',
                fontSize: 8      //更改坐标轴文字大小
              }
            },
          },
          yAxis: {
            type: 'category',
            data: categories,
            axisLabel: {
              textStyle: {
                color: '#606266',
                fontSize: 10      //更改坐标轴文字大小
              },
              formatter: function (value) {
                return value.slice(0, 5);
              }
            }
          },
          series: [
            {
              name: '',
              type: 'bar',
              data: series_data,
              itemStyle: {
                color: "#0437ea"
              }
            }
          ]
        }
        var res_1 = JSON.parse(JSON.stringify(res))
        res_1.yAxis.axisLabel.formatter = function (value) {
          return value.slice(0, 5);
        }
        res_1.grid.top = '1%'
        res_1.grid.bottom = '0'
        res.xAxis.splitNumber = 3
        if (this.typeIndex === 0) {
          var travelPerson = this.echarts.init(document.getElementById('travelPerson'));
          travelPerson.setOption(res_1)
        } else {
          var travelRank = this.echarts.init(document.getElementById('travelRank'));
          travelRank.setOption(res)
        }

      })
    },
    // 销售数量占比、销售金额占比
    getSalesNum() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getSalesNumApi(params).then(res => {
        this.showTicketProductMoney(res.data.data.ticket_product_money)
      })
    },
    // 销售金额占比(产品)
    showTicketProductMoney(data) {
      var total = 0;
      var series = [];
      var productMoney = this.echarts.init(document.getElementById('productMoney'));
      for (let j = 0; j < data.value.length; j++) {
        total += data.value[j]
      }
      for (let i = 0; i < data.label.length; i++) {
        this.productMoneyList.push({
          name: data.label[i],
          data: (data.value[i] / total * 100).toFixed(2) + '%'
        })
        series.push({
          name: data.label[i],
          value: data.value[i]
        })
      }
      var option = {
        color: this.pieColor,
        series: [
          {
            type: 'pie',
            data: series,
            radius: '80%',
            label: {
              show: false
            },
          }
        ],
        tooltip: {
          trigger: 'item'
        },

      }
      productMoney.setOption(option)
    },
    // 获取酒店信息
    xcxGetHotelData() {
      var params = {}
      if (this.isToday) {
        params = { scenic_id: this.scenic_id, dates: this.last_day, store_id: '' }
      } else {
        params = { scenic_id: this.scenic_id, dates: this.req_date, store_id: '' }
      }
      xcxGetHotelDataApi(params).then(res => {
        this.hotelData = res.data.data
        this.setHotelList()
      })
    },
    setHotelList() {
      let categories = []
      let series_data = []
      this.hotelData.room_charge_list.slice(0, 10).forEach(item => {
        var value = Object.values(item)
        var key = Object.keys(item)
        categories.push(key[0].slice(0, 5))
        series_data.push(value[0])
      })
      categories.reverse()
      series_data.reverse()
      var hotelRank = this.echarts.init(document.getElementById('hotelRank'));

      var res = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          top: '0',
          left: '6%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLabel: {
            textStyle: {
              color: '#606266',
              fontSize: 10      //更改坐标轴文字大小
            }
          },
          splitNumber: 3
        },
        yAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            textStyle: {
              color: '#606266',
              fontSize: 10      //更改坐标轴文字大小
            },
            formatter: function (value) {
              return value.slice(0, 5);
            }
          }
        },
        series: [
          {
            name: '',
            type: 'bar',
            data: series_data,
            itemStyle: {
              color: "#0437ea"
            }
          }
        ]
      }
      hotelRank.setOption(res)

    },
    getBusinessNum() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getMerchantOrder(params).then(res => {
        this.businessNum = res.data.data
      })
    },
    getBusinessList() {
      var obj = { scenic_id: this.scenic_id, time_type: 3, is_all: 1, dates: this.req_date }
      getMerchantOrderList(obj).then(res => {
        let categories = []
        let series_data = []
        let categories_1 = []
        let categories_2 = []
        let series_data_1 = []
        let series_data_2 = []
        this.merchant_order_total_list = res.data.data.merchant_order_total_list
        for (let i = 0; i < this.merchant_order_total_list.length; i++) {
          var item = this.merchant_order_total_list[i]
          if (i < 10) {
            if (item.is_scenic_own) {
              series_data.push({ value: item.num, itemStyle: { color: '#05dfd6' } })
              categories.push(item.name)
            } else {
              series_data.push({ value: item.num, itemStyle: { color: '#063aef' } })
              categories.push(item.name)
            }
          }
          if (this.merchant_order_total_list.length > 40) {
            if (i % 2 === 1) {
              if (item.is_scenic_own) {
                series_data_1.push({ value: item.num, itemStyle: { color: '#05dfd6' } })
                categories_1.push(item.name)
              } else {
                series_data_1.push({ value: item.num, itemStyle: { color: '#063aef' } })
                categories_1.push(item.name)
              }
            } else {
              if (item.is_scenic_own) {
                series_data_2.push({ value: item.num, itemStyle: { color: '#05dfd6' } })
                categories_2.push(item.name)
              } else {
                series_data_2.push({ value: item.num, itemStyle: { color: '#063aef' } })
                categories_2.push(item.name)
              }
            }
          } else {
            if (item.is_scenic_own) {
              series_data_1.push({ value: item.num, itemStyle: { color: '#05dfd6' } })
              categories_1.push(item.name)
            } else {
              series_data_1.push({ value: item.num, itemStyle: { color: '#063aef' } })
              categories_1.push(item.name)
            }
          }
        }
        let integer
        if (this.merchant_order_total_list.length > 40) {
          integer = Math.ceil(series_data_2[0].value)
        } else {
          integer = Math.ceil(series_data_1[0].value)
        }
        categories_1.reverse()
        series_data_1.reverse()
        categories_2.reverse()
        series_data_2.reverse()
        let length = String(integer).length
        console.log(integer, length)
        let max_num = Math.ceil(integer / Math.pow(10, length - 1)) * Math.pow(10, length - 1)
        var businessRank = this.echarts.init(document.getElementById('businessRank'));
        var option = {
          grid: {
            top: "20%",
            left: "10%",
            right: "3%",
            bottom: "26%"
          },
          tooltip: {},
          xAxis: {
            axisLabel: {
              show: true,
              rotate: 36, // 倾斜30度<<<<<-----复制这里----------
              interval: 0,
              textStyle: {
                color: '#606266',
                fontSize: 10    //更改坐标轴文字大小
              }
            },
            splitLine: {
              show: false
            },
            data: categories
          },
          yAxis: {
            axisLabel: {
              show: true,
              textStyle: {
                color: '#606266',
                fontSize: 10,      //更改坐标轴文字大小
              },
            },
            splitNumber: 4,
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(96, 98, 102, 0.5)',
                type: 'dashed'
              }
            }
          },
          barWidth: 10,
          series: [{
            data: series_data, type: 'bar'
          }]
        }
        var option_1 = {
          legend: {},
          grid: {
            top: '0',
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
              show: true,
              interval: 0,
              textStyle: {
                color: '#606266',
                fontSize: 12    //更改坐标轴文字大小
              }
            },
            splitNumber: 3,
            max: max_num
          },
          yAxis: {
            type: 'category',
            data: categories_2,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#606266',
                fontSize: 12,      //更改坐标轴文字大小
              },
            },
            formatter: function (value) {
              return value.slice(0, 5);
            }
          },
          series: [
            {
              name: '',
              type: 'bar',
              data: series_data_2,
              itemStyle: {
                color: "#0437ea"
              }
            }
          ]
        }
        if (this.merchant_order_total_list.length > 40) {
          var option_2 = {
            legend: {},
            grid: {
              top: '0',
              left: '3%',
              right: '3%',
              bottom: '3%',
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01],
              axisLabel: {
                show: true,
                interval: 0,
                textStyle: {
                  color: '#606266',
                  fontSize: 12    //更改坐标轴文字大小
                }
              },
              splitNumber: 3,
              max: max_num
            },
            yAxis: {
              type: 'category',
              data: categories_1,
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#606266',
                  fontSize: 12,      //更改坐标轴文字大小
                },
              },
              formatter: function (value) {
                return value.slice(0, 5);
              }
            },
            series: [
              {
                name: '',
                type: 'bar',
                data: series_data_1,
                itemStyle: {
                  color: "#0437ea"
                }
              }
            ]
          }
        }

        businessRank.setOption(option)
        if (this.merchant_order_total_list.length > 40) {
          var shopRank_1 = this.echarts.init(document.getElementById('shopRank_1'));
          shopRank_1.setOption(option_1)
          var shopRank_2 = this.echarts.init(document.getElementById('shopRank_2'));
          shopRank_2.setOption(option_2)
        } else {
          var shopRank = this.echarts.init(document.getElementById('shopRank'));
          shopRank.setOption(option_1)
        }
      })

    },
    getBigDataOfflineRetail() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getBigDataOfflineRetailInfo(params).then(res => {
        this.offlineRetailInfo = res.data.data
      })
    },
    salesComparison() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      salesComparisonApi(params).then(res => {
        var categories = [];
        var series = [];
        var itemStyle = {
          normal: {
            lineStyle: {
              width: 0.5
            },
            borderColor: '#fff',
            borderWidth: 2
          },
        }
        series.push({ name: '总额', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        series.push({ name: '票务', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        series.push({ name: '酒店', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        series.push({ name: '线下商户', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        series.push({ name: '美食', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        for (let i = res.data.data.sales_comparison_list.length - 1; i >= 0; i--) {
          var item = res.data.data.sales_comparison_list[i]
          categories.push(item.create_time.slice(5, 10))
          series[0].data.push(item.today_total_amount)
          series[1].data.push(item.ticket_sales_revenue)
          series[2].data.push(item.hotel_sales_revenue)
          series[3].data.push(item.offline_order_total)
          series[4].data.push(item.delicious_food_sales_revenue)
        }
        var thirtyDays = this.echarts.init(document.getElementById('thirtyDays'));
        var option = {
          grid: {
            top: "10%",
            left: "2%",
            right: "2%",
            bottom: "6%"
          },
          color: ['#01f1e3', '#023aff', '#bb63ff', '#ffa63f', '#f13b01', '#c40449', '#f03fff', '#07a198', '#4c4c87', '#797983'],
          legend: {
            show: true,
            y: 'top',
            x: 'center',
            icon: 'rect',
            width: 360,
            itemWidth: 10,
            itemHeight: 10,
            align: "auto",
            textStyle: {
              color: '#606266',
              fontSize: 18
            }
          },

          xAxis: {
            boundaryGap: false,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#606266',
                fontSize: 11
              }
            },
            axisLine: {
              show: false, // 不显示坐标轴线
            },
            splitLine: {
              show: false // 不显示网格线
            },
            data: categories
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false, // 不显示坐标轴线
            },
            splitLine: {
              show: false // 不显示网格线
            },
            axisTick: {
              show: false // 不显示坐标轴刻度线
            },
            splitNumber: 5,
          },
          lineStyle: {
            color: '#606266',
          },
          tooltip: {},
          series: series
        }
        thirtyDays.setOption(option)
      })
    },
    totalWait(obj) {
      let total = 0
      for (let key in obj) {
        total += Number((obj[key] * this.coefficient_data / 100).toFixed(0))
      }
      return total
    },
    initSevenDayChart() {
      var self = this
      setTimeout(function () {
        var dom = document.getElementById('seven_day')
        if (!dom || dom.offsetWidth === 0) return
        // 如果已存在实例先销毁
        var existing = self.echarts.getInstanceByDom(dom)
        if (existing) existing.dispose()
        var chart = self.echarts.init(dom)
        // 生成未来7天日期
        var dates = []
        for (var i = 0; i < 7; i++) {
          var d = new Date()
          d.setDate(d.getDate() + i)
          var m = d.getMonth() + 1
          var day = d.getDate()
          dates.push(m + '/' + day)
        }
        var option = {
          grid: { top: '14%', left: '14%', right: '4%', bottom: '10%' },
          legend: {
            top: 0, right: 0,
            textStyle: { color: '#606266', fontSize: 11 },
            itemWidth: 16, itemHeight: 3
          },
          tooltip: {
            trigger: 'axis',
            textStyle: { fontSize: 12 }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: dates,
            axisLabel: { color: '#606266', fontSize: 11 },
            axisLine: { lineStyle: { color: 'rgba(96,98,102,0.3)' } },
            splitLine: { show: false }
          },
          yAxis: {
            type: 'value',
            axisLabel: { color: '#606266', fontSize: 11 },
            splitLine: { lineStyle: { color: 'rgba(96,98,102,0.15)', type: 'dashed' } }
          },
          series: [
            {
              name: '客流',
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 6,
              data: [34500, 31200, 39800, 35600, 32100, 40200, 36800],
              lineStyle: { color: '#3b82f6', width: 2 },
              itemStyle: { color: '#3b82f6', borderColor: '#fff', borderWidth: 2 },
              areaStyle: {
                color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                  colorStops: [
                    { offset: 0, color: 'rgba(59,130,246,0.18)' },
                    { offset: 1, color: 'rgba(59,130,246,0)' }
                  ]
                }
              }
            },
            {
              name: '车流',
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 6,
              data: [19800, 21500, 20100, 23800, 22600, 21200, 24100],
              lineStyle: { color: '#f59e0b', width: 2 },
              itemStyle: { color: '#f59e0b', borderColor: '#fff', borderWidth: 2 },
              areaStyle: {
                color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                  colorStops: [
                    { offset: 0, color: 'rgba(245,158,11,0.15)' },
                    { offset: 1, color: 'rgba(245,158,11,0)' }
                  ]
                }
              }
            },
            {
              name: '住宿客流',
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 6,
              data: [13200, 14600, 11800, 15900, 12400, 13800, 16200],
              lineStyle: { color: '#10b981', width: 2 },
              itemStyle: { color: '#10b981', borderColor: '#fff', borderWidth: 2 },
              areaStyle: {
                color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                  colorStops: [
                    { offset: 0, color: 'rgba(16,185,129,0.15)' },
                    { offset: 1, color: 'rgba(16,185,129,0)' }
                  ]
                }
              }
            }
          ]
        }
        chart.setOption(option)
      }, 300)
    },
    // 近三天
    getWaitingIn() {
      getWaitingInApi({ scenic_id: this.scenic_id, dates: this.req_date }).then(res => {
        console.log("近三天", res.data.data.data)
        var chartData = res.data.data.data.slice(0, 3)
        var series = []
        series.push({ name: '待入园', data: [], type: 'bar', color: '#023aff', barWidth: 10, stack: 'x' })
        series.push({ name: '已入园', data: [], type: 'bar', color: '#01f1e3', barWidth: 10, stack: 'x' })
        var categories = [];
        console.log(this.total_tourists_num, 'this.total_tourists_num')
        for (var i = 0; i < chartData.length; i++) {
          categories.push(chartData[i].create_time.slice(5, 10))
          // series[0].data.push(chartData[i].waiting_in)
          var total = this.totalWait(chartData[i].waiting_in_list)
          series[0].data.push(total)
          if (this.total_tourists_num > 0 && i === 0) {
            series[1].data.push(this.total_tourists_num)
            this.three_series.push({
              // data_1:chartData[i].waiting_in,
              data_1: total,
              data_2: this.total_tourists_num,
              list: chartData[i].waiting_in_list,
            })
          } else {
            series[1].data.push(null)
            this.three_series.push({
              // data_1:chartData[i].waiting_in,
              data_1: total,
              data_2: this.total_tourists_num,
              list: chartData[i].waiting_in_list,
            })
          }

        }

        var option = {
          grid: {
            top: "6%",
            left: "26%",
            right: "3%",
            bottom: "18%"
          },
          legend: {
            show: true,
            y: 'bottom',
            icon: "circle",
            itemWidth: 5,
            itemHeight: 5,
            itemGap: 30,
            textStyle: {  // 图例文字的样式
              color: '#606266',
            },
          },
          tooltip: {},
          xAxis: {
            data: categories,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#606266',
                fontSize: 9      //更改坐标轴文字大小
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(96, 98, 102, 0.5)',
                type: 'dashed'
              }
            }
          },
          yAxis: {
            splitNumber: 4,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#606266',
                fontSize: 10     //更改坐标轴文字大小
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(96, 98, 102, 0.5)',
                type: 'dashed'
              }
            }
          },
          series: series
        }

        // var waitInPart = this.echarts.init(document.getElementById('waitInPart'));
        // waitInPart.setOption(option)
        // this.pushThreeShow(0)
        // var _this = this
        // waitInPart.on('click', function (params) {
        //   _this.pushThreeShow(params.dataIndex)
        // });
        // 7天预测图表已移至 initSevenDayChart() 方法
      })
    },
    pushThreeShow(index) {
      this.three_show = []
      this.three_show.push({ text: '待入园：' + this.three_series[index].data_1 + '人' })
      if (this.three_series[index].data_2 > 0 && index === 0) {
        this.three_show.push({ text: '已入园：' + this.three_series[index].data_2 + '人' })
      } else if (index === 0) {
        this.three_show.push({ text: '已入园：0人' })
      }
      var pie_show = []
      for (let key in this.three_series[index].list) {
        if (key !== '景区窗口简易端') {
          pie_show.push({ value: this.three_series[index].list[key], name: key })
        }
        var three_pie = this.echarts.init(document.getElementById('three_pie'));
        var option = {
          color: ['#01f1e3', '#bb63ff', '#ffa63f', '#f03fff', '#07a198', '#1387f4', '#1b9b35', '#e33e31'],
          padding: [0, 0, 0, 0],
          series: [
            {
              type: 'pie',
              // radius: '50%',
              data: pie_show,
              label: {
                show: false
              },
            }
          ],
          tooltip: {
            position: 'left',
            formatter: function (params) {
              return params.data.name + "：" + params.data.value
            },
          },
          legend: {
            show: false,
          }
        }
        three_pie.setOption(option)
      }

    },
    pushTrafficLine(list) {
      var list_arr = []
      list_arr.push(list[0])
      for (let i = 1; i < list.length; i++) {
        list_arr.push(list[i] - list[i - 1])
      }
      return list_arr
    },
    getDeliciousFoodData() {
      var params = {}
      if (this.isToday) {
        params = { scenic_id: this.scenic_id, dates: this.last_day, store_id: '' }
      } else {
        params = { scenic_id: this.scenic_id, dates: this.last_day, store_id: '' }
      }
      xcxGetDeliciousFoodDataApi(params).then(res => {
        this.deliciousFoodData = res.data.data
        for (var i = 0; i < this.deliciousFoodData.business_indicators.length; i++) {
          var obj = this.deliciousFoodData.business_indicators[i]
          if (obj.key === '翻台率') {
            this.tableTurnoverRate = obj.label
            break
          }
        }
        this.showTypePie()
      })
    },
    // 市别
    showTypePie() {
      var series = [];
      var sum = 0;
      var legend_data = {}
      for (let i = 0; i < this.deliciousFoodData.time_period_type.length; i++) {
        var data = this.deliciousFoodData.time_period_type[i]
        if (i != this.deliciousFoodData.time_period_type.length - 1) {
          series.push({ value: data.label2, name: data.key })
          this.$set(legend_data, data.key, data.label2)
        } else {
          sum = data.label2
        }
      }
      var type_pie = this.echarts.init(document.getElementById('type_pie'));
      var option = {
        color: this.pieColor,

        series: [
          {
            center: ['50%', '36%'],
            type: 'pie',
            // radius: '50%',
            data: series,
            label: {
              show: false
            }
          }
        ],
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":" + params.data.value
          },
        },
        legend: {
          show: true,
          bottom: 0,
          textStyle: {
            color: '#606266'
          },
          formatter: function (params) {
            return params + '：' + (legend_data[params] / sum * 100).toFixed(2) + '%'
          },
        }
      }
      console.log(sum, '合计')
      type_pie.setOption(option)
    },
    // 切换总收和商细
    changeAllShop(index) {
      this.allShopIndex = index
    },
    //舆情动态
    // 滚动到底部回调
    tendenciesScroll() {
      get_dynamic_subscribe_info_list({
        page: 1,
        limit: 50
      }).then(res => {
        if (res.data.data && res.data.data.length > 0) {
          if (this.tendenciesList.length === 0 || this.listQuery.page === 1) {
            this.tendenciesList = res.data.data
          } else {
            this.tendenciesList = this.tendenciesList.concat(res.data.data)
          }
          this.listQuery.page++
        } else {
        }
      })
    },
    handleDetail(data) {
      this.isDetail = true
      this.isDetailLoading = true
      get_dynamic_subscribe_info_detail({ 'antdu_id': data.antduId }).then(res => {
        this.tendenciesItem = res.data.data
      }).finally(r => {
        this.isDetailLoading = false
      })
    },
    // 跳转到原文
    toUrl(url) {
      if (url) {
        window.open(url)
      }
    },

    //舆情列表
    handleGetList() {
      const threeDaysAgo = new Date()
      threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)
      const nextDay = new Date()
      nextDay.setDate(nextDay.getDate() + 1)
      get_subscribe_info_list({
        page: 1,
        limit: 200,
        start_date: parseTime(threeDaysAgo, '{y}-{m}-{d}'),
        end_date: parseTime(nextDay, '{y}-{m}-{d}'),
      }).then(res => {
        this.total = res.data.recordsTotal
        if (res.data.data.length > 0) {
          let list = res.data.data.map(item => {
            const [datePart, timePart] = item.createAt.split(' ')
            const [hour, minute] = timePart.split(':')
            item.date = datePart
            item.time = `${hour}:${minute}`
            return item
          })
          // 按照日期排序
          list = list.sort((a, b) => {
            // 直接比较整个时间字符串
            return new Date(b.createAt) - new Date(a.createAt)
          })
          // 相同日期放一起
          this.timelineList = list.reduce((groups, item) => {
            const date = String(item.date)
            if (!groups[date]) {
              groups[date] = []
            }
            groups[date].push(item)
            return groups
          }, {})
        } else {
          this.timelineList = null
        }
      })
    },
    strictClean(richText) {
      if (!richText) return ''
      // 只保留中文、英文、数字
      return richText.replace(/[^\u4e00-\u9fa5]/g, '')
    },
    // 文本高亮
    highlightText(text, rules) {
      if (!text || !rules || rules.length === 0) return text
      // 创建匹配规则的正则表达式
      const regex = this.createHighlightRegex(rules)
      // 使用正则表达式替换匹配的文本
      return text.replace(regex, '<span class="highlight">$&</span>')
    },
    createHighlightRegex(rules) {
      // 提取所有关键词
      const keywords = new Set()

      rules.forEach(rule => {
        if (!rule) return

        // 提取规则中的关键词（简化处理，实际项目需要更复杂的解析）
        const words = rule.match(/[^&|()\s]+/g) || []
        words.forEach(word => {
          if (word && word.length > 1) { // 过滤掉单个字符
            keywords.add(word.trim())
          }
        })
      })

      // 创建正则表达式，匹配任意关键词
      if (keywords.size === 0) return /(?!)/ // 不匹配任何内容

      const pattern = Array.from(keywords).map(word =>
        word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // 转义正则特殊字符
      ).join('|')

      return new RegExp(`(${pattern})`, 'gi')
    },
    // 修改图片访问来源
    imgText(text) {
      if (!text) return ''
      // 去重并过滤空值
      const words = [...new Set(['<img'].filter(word => word && word.trim()))]
      if (words.length === 0) {
        return text
      }
      // 创建正则表达式，忽略大小写，全局匹配
      const regex = new RegExp(`(${words.map(word =>
        word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      ).join('|')})`, 'gi')
      // 替换匹配的文本
      return text.replace(regex, '$1 referrerPolicy="no-referrer"')
    },

    //舆情分析开始
    // 初始化图表数据
    initEchart() {
      this.initEmotion()
      this.initHotWeb()
    },
    // 图表重置
    resizeEchart() {
      return debounce(() => {
        if (this.emotion) {
          this.emotion.resize()
        }
        if (this.hotWeb) {
          this.hotWeb.resize()
        }
      }, 200)
    },
    // 生成时间趋势折线图
    initTimeTrend() {
      this.timeTrend = echarts.init(this.$refs.timeTrend)
      this.timeTrend.setOption({
        title: {
          text: '时间趋势',
          left: 'center',
          textStyle: {
            color: '#606266'
          },
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            return `${params[0].name}<br/>数量: ${params[0].value}`
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.timeTrendData.x,
          axisTick: {
            show: false // 隐藏x轴刻度
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#606266',
            }
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#606266',
            }
          },
        },
        grid: {
          left: '1%',
          right: '4%',
          containLabel: true
        },
        series: [
          {
            data: this.timeTrendData.y,
            type: 'line',
            smooth: true,
            areaStyle: {},
            itemStyle: {
              normal: {
                label: { show: true, color: '#606266' }, color: '#6459cd', lineStyle: {
                  color: '#6459cd' // 改变折线颜色
                }
              }
            }
          }
        ]
      })
    },
    // 生成情绪分析饼图
    initEmotion() {
      this.emotion = echarts.init(this.$refs.emotion)
      // 计算总数
      const total = this.emotionData.reduce((sum, item) => sum + item.value, 0)
      this.emotion.setOption({
        title: {
          text: `情绪分析: ${total}`,
          left: 'center',
          textStyle: {
            color: '#606266'
          },
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          type: 'scroll',
          itemGap: 5,
          textStyle: {
            fontSize: 10,
            color: '#606266'
          },
          formatter: (name) => {
            const item = this.emotionData.find(d => d.name === name)
            if (item && total > 0) {
              const percent = ((item.value / total) * 100).toFixed(1)
              return `${name}: ${item.value} (${percent}%)`
            }
            return name
          }
        },
        grid: {
          left: '1%',
          right: '30%', // 为右侧图例留出空间
          bottom: '3%',
          containLabel: true
        },
        series: [
          {
            type: 'pie',
            avoidLabelOverlap: false,
            radius: ['20%', '40%'], // 调整为环形图
            center: ['35%', '50%'], // 饼图靠左，为图例留空间
            itemStyle: {
              normal: {
                color: (params) => {
                  return this.emotionType[params.name]
                }
              }
            },
            data: this.emotionData
          }
        ]
      })
    },
    // 生成媒体类型饼图
    initMediaType() {
      this.mediaType = echarts.init(this.$refs.mediaType)
      // 计算总数
      const total = this.mediaTypeData.reduce((sum, item) => sum + item.value, 0)
      this.mediaType.setOption({
        title: {
          text: `媒体类型: ${total}`,
          left: 'center',
          textStyle: {
            color: '#606266'
          },
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          type: 'scroll',
          itemGap: 5,
          textStyle: {
            fontSize: 10,
            color: '#606266'
          },
          formatter: (name) => {
            const item = this.mediaTypeData.find(d => d.name === name)
            if (item && total > 0) {
              const percent = ((item.value / total) * 100).toFixed(1)
              return `${name}: ${item.value} (${percent}%)`
            }
            return name
          }
        },
        grid: {
          left: '3%',
          right: '15%', // 为右侧图例留出空间
          bottom: '3%',
          containLabel: true
        },
        series: [
          {
            type: 'pie',
            radius: ['20%', '30%'], // 调整为环形图
            center: ['35%', '50%'], // 饼图靠左，为图例留空间
            data: this.mediaTypeData
          }
        ]
      })
    },
    // 生成热门网站柱状图
    initHotWeb() {
      this.hotWeb = echarts.init(this.$refs.hotWeb)
      this.hotWeb.setOption({
        title: {
          text: '渠道分析',
          left: 'center',
          textStyle: {
            color: '#606266'
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },

        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#606266',
            }
          },
        },
        yAxis: {
          type: 'category',
          data: this.hotWebData.y,
          inverse: true,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#606266',
            }
          },
        },
        grid: {
          left: '1%',
          right: '2.5%',
          containLabel: true
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            yAxisIndex: [0], // 控制 Y 轴
            width: 4, // 滚动条宽度
            right: 3, // 距离右侧的距离
            minValueSpan: 7, // 最小显示数量
            maxValueSpan: 7 // 最大显示数量
          },
          {
            type: 'inside',
            yAxisIndex: [0],
            moveOnMouseWheel: true // 鼠标滚轮触发平移
          }
        ],
        series: [
          {
            type: 'bar',
            smooth: true,
            show: false,
            areaStyle: {},
            data: this.hotWebData.x,
            itemStyle: { normal: { label: { show: true, position: 'right', color: '#606266' }, color: '#6459cd' } }
          }
        ]
      })
    },
    // 获取舆情分析数据
    getTimeTrend() {
      const sevenDaysAgo = new Date()
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)
      const nextDay = new Date()
      nextDay.setDate(nextDay.getDate() + 1)
      get_subscribe_time_trend({
        start_date: parseTime(sevenDaysAgo, '{y}-{m}-{d}'),
        end_date: parseTime(nextDay, '{y}-{m}-{d}'),
        time_type: 3,
      }).then(res => {
        const { data, emotion, mediaType, websiteName } = res.data
        if (data.length > 0) {
          this.timeTrendData.y = data.map(item => item.count)
          this.timeTrendData.x = data.map(item => parseTime(item.time_group, '{y}-{m}-{d}'))
        } else {
          this.timeTrendData = { x: [], y: [] }
        }

        if (emotion.length > 0) {
          this.emotionData = emotion.map(item => {
            if (item.emotion === '负面') {
              item.emotion = '疑似负面'
            }
            if (item.emotion === '差评') {
              item.emotion = '负面'
            }
            return {
              value: item.total,
              name: item.emotion
            }
          })
        } else {
          this.emotionData = []
        }

        if (mediaType.length > 0) {
          this.mediaTypeData = mediaType.map(item => {
            return {
              value: item.total,
              name: this.platform_type[item.mediaType]
            }
          })
        } else {
          this.mediaTypeData = []
        }
        if (websiteName.length > 0) {
          this.hotWebData.y = websiteName.map(item => item.websiteName)
          this.hotWebData.x = websiteName.map(item => item.total)
        } else {
          this.hotWebData = { x: [], y: [] }
        }
        this.initEchart()
      })
    },
    // 价格监管页面初始化
    type_price_supervision() {
      this.initPriceSupervisionSelection()
      this.getWeatherData()
      this.$nextTick(() => {
        // 等待地图初始化完成后再设置视野
        this.waitForMapAndSetPriceFenceView()
      })
    },
    // 等待地图就绪并设置价格监管区域视野
    waitForMapAndSetPriceFenceView() {
      if (!this.map) {
        setTimeout(() => {
          this.waitForMapAndSetPriceFenceView()
        }, 200)
        return
      }
      // 获取第一个电子围栏区域
      const firstRegion = PRICE_FENCE_REGIONS[0]
      if (firstRegion && firstRegion.mapCenter) {
        // 设置地图中心点
        this.map.setCenter(new TMap.LatLng(firstRegion.mapCenter.lat, firstRegion.mapCenter.lng))
        if (firstRegion.mapZoom) {
          this.map.setZoom(firstRegion.mapZoom)
        }
      }
      // 渲染价格围栏图层
      this.renderPriceFenceLayer()
      // 刷新价格波动图表
      this.refreshPriceFluctuationChart()
    },
    initPriceFluctuationChart() {
      var chartDom = document.getElementById('priceFluctuationChart')
      if (!chartDom) {
        return
      }
      if (this.priceFluctuationChart) {
        this.priceFluctuationChart.dispose()
      }
      this.priceFluctuationChart = this.echarts.init(chartDom)
      // 直接使用用户选择的天数
      var dayCount = Number(this.priceTrendDayCount) || 7
      console.log('initPriceFluctuationChart - 当前天数:', dayCount, '筛选模式:', this.priceTrendActiveFilter, '商户ID:', this.priceTrendMerchantId)
      // 获取价格趋势数据
      var hotels = this.getPriceTrendTargetHotels()
      var trend = this.buildPriceTrendSeries(hotels, dayCount)
      var titleText = ''
      if (this.priceTrendActiveFilter === 'merchant' && this.priceTrendMerchantId) {
        const hotel = this.accommodationPriceList.find(item => item.hotelId === this.priceTrendMerchantId)
        titleText = hotel ? hotel.hotelName : '商户价格'
      } else if (this.priceTrendActiveFilter === 'fence') {
        const region = getPriceFenceRegionById(this.priceFenceRegionId)
        titleText = region ? region.name : '区域价格'
      } else {
        titleText = '区域均价'
      }

      var recentLabel = '近' + dayCount + '天价格'
      var option = {
        title: {
          show: true,
          text: titleText,
          left: 'center',
          top: 0,
          textStyle: {
            color: '#333',
            fontSize: 12,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          formatter: function (params) {
            if (!params || params.length === 0) return ''
            var result = params[0].axisValue + '<br/>'
            params.forEach(function (p) {
              result += p.marker + p.seriesName + '：¥' + p.value + '<br/>'
            })
            return result
          }
        },
        legend: {
          data: [recentLabel, '上年同期价格'],
          textStyle: {
            color: '#2f80ed',
            fontSize: 11
          },
          top: 28,
          right: 10,
          left: 'auto',
          itemWidth: 25,
          itemHeight: 12
        },
        grid: {
          top: '22%',
          left: '8%',
          right: '6%',
          bottom: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: trend.dates,
          axisLabel: {
            textStyle: {
              color: '#2f80ed',
              fontSize: 10
            },
            rotate: dayCount === 14 ? 30 : 0,
            interval: dayCount === 14 ? 1 : 0
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 170, 255, 0.45)'
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: '价格(元)',
          nameTextStyle: {
            color: '#2f80ed',
            fontSize: 11
          },
          axisLabel: {
            textStyle: {
              color: '#2f80ed',
              fontSize: 10
            },
            formatter: '¥{value}'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(0, 170, 255, 0.15)',
              type: 'dashed'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            name: recentLabel,
            type: 'line',
            data: trend.recentSeries,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#023aff'
            },
            lineStyle: {
              width: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(2, 58, 255, 0.25)' },
                  { offset: 1, color: 'rgba(2, 58, 255, 0.02)' }
                ]
              }
            }
          },
          {
            name: '上年同期价格',
            type: 'line',
            data: trend.lastMonthSeries,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#ff9f43'
            },
            lineStyle: {
              width: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(255, 159, 67, 0.25)' },
                  { offset: 1, color: 'rgba(255, 159, 67, 0.02)' }
                ]
              }
            }
          }
        ]
      }
      this.priceFluctuationChart.setOption(option, true)
      // 添加窗口自适应
      var that = this
      window.addEventListener('resize', function () {
        if (that.priceFluctuationChart) {
          that.priceFluctuationChart.resize()
        }
      })
    },
    changeTextType(value) {
      this.text_type_value = value
    },
    changeComparisonType(value) {
      this.comparison_type_index = value
      if (this.comparison_1 && this.comparison_2) {
        this.comparisonChange_1()
        this.comparisonChange_2()
      }
    },
    comparisonChange_1() {
      if (this.comparison_1) {
        var total = 1042852
        if (this.comparison_type_index == 1) {
          var series = [
            { name: '江苏', value: 13.39 },
            { name: '江西', value: 11.70 },
            { name: '安徽', value: 11.09 },
            { name: '浙江', value: 10.26 },
            { name: '广东', value: 9.78 },
            { name: '北京 ', value: 8.48 },
            { name: '辽宁', value: 7.85 },
            { name: '河南', value: 7.03 },
            { name: '山东', value: 6.80 },
            { name: '其他', value: 13.64 },
          ]

        } else if (this.comparison_type_index == 2) {
          var series = [
            { name: '60+', value: 19.35 },
            { name: '50-60', value: 16.49 },
            { name: '40-50', value: 17.26 },
            { name: '30-40', value: 20.59 },
            { name: '18-30', value: 18.10 },
            { name: '0-18', value: 8.22 },
          ]
        } else if (this.comparison_type_index == 3) {
          var series = [
            { name: '男', value: 40.38 },
            { name: '女', value: 59.62 }
          ]
        }
        var comparison_pie_1 = this.echarts.init(document.getElementById('comparison_pie_1'));
        var option = {
          color: this.pieColor,
          grid: {
            top: 0, bottom: 0, left: 0, right: 0
          },
          series: [
            {
              type: 'pie',
              radius: ['30%', '100%'],
              data: series,
              label: {
                show: false
              },
              center: ['50%', '42%'],
            }
          ],
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              return params.data.name + ":<br/>" + (params.data.value).toFixed(2) + "%<br/>" + (total * params.data.value / 100).toFixed(0) + "人"
            },
          },
          legend: {
            orient: 'horizontal',
            bottom: 4,
            left: 'center',
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 4,
            textStyle: {
              color: '#333',
              fontSize: 9
            },
          },
        }
        comparison_pie_1.setOption(option)
      }
    },
    comparisonChange_2() {
      if (this.comparison_2) {
        var total = 1386717
        if (this.comparison_type_index == 1) {
          var series = [
            { name: '江西', value: 15.13 },
            { name: '江苏', value: 12.18 },
            { name: '浙江', value: 10.29 },
            { name: '安徽', value: 9.45 },
            { name: '广东', value: 9.45 },
            { name: '辽宁', value: 7.92 },
            { name: '河南', value: 6.70 },
            { name: '北京', value: 6.56 },
            { name: '湖北', value: 6.48 },
            { name: '其他', value: 15.85 },
          ]
        } else if (this.comparison_type_index == 2) {
          var series = [
            { name: '60+', value: 17.85 },
            { name: '50-60', value: 16.58 },
            { name: '40-50', value: 16.00 },
            { name: '30-40', value: 20.12 },
            { name: '18-30', value: 22.44 },
            { name: '0-18', value: 7.01 },
          ]
        } else if (this.comparison_type_index == 3) {
          var series = [
            { name: '男', value: 36.38 },
            { name: '女', value: 63.62 },
          ]
        }
        var comparison_pie_2 = this.echarts.init(document.getElementById('comparison_pie_2'));
        var option = {
          color: this.pieColor,
          grid: {
            top: 0, bottom: 0, left: 0, right: 0
          },
          series: [
            {
              type: 'pie',
              radius: ['30%', '100%'],
              data: series,
              label: {
                show: false
              },
              center: ['50%', '42%'],
            }
          ],
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              return params.data.name + ":<br/>" + (params.data.value).toFixed(2) + "%<br/>" + (total * params.data.value / 100).toFixed(0) + "人"
            },
          },
          legend: {
            orient: 'horizontal',
            bottom: 4,
            left: 'center',
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 4,
            textStyle: {
              color: '#333',
              fontSize: 9
            },
          },
        }
        comparison_pie_2.setOption(option)
      }
    },
    getLevel(data) {
      if (data) {
        this.level_value = 1
      }
      if (this.level_value == 1) {
        var series = [
          { name: '江西', value: 15.82 },
          { name: '浙江', value: 12.35 },
          { name: '安徽', value: 11.56 },
          { name: '江苏', value: 10.28 },
          { name: '上海', value: 8.45 },
          { name: '广东', value: 7.23 },
          { name: '河南', value: 6.15 },
          { name: '山东', value: 5.88 },
          { name: '湖北', value: 5.42 },
          { name: '其他', value: 16.86 },
        ]
        var total = 10682150
      } else if (this.level_value == 2) {
        var series = [
          { name: '上饶', value: 24.35 },
          { name: '南昌', value: 16.22 },
          { name: '景德镇', value: 12.56 },
          { name: '九江', value: 10.28 },
          { name: '抚州', value: 7.15 },
          { name: '赣州', value: 6.23 },
          { name: '鹰潭', value: 5.45 },
          { name: '吉安', value: 5.12 },
          { name: '宜春', value: 4.85 },
          { name: '其他', value: 7.79 },
        ]
        var total = 1689924
      } else if (this.level_value == 3) {
        var series = [
          { name: '信州区', value: 18.52 },
          { name: '广丰区', value: 12.35 },
          { name: '广信区', value: 11.28 },
          { name: '玉山县', value: 10.56 },
          { name: '鄱阳县', value: 9.85 },
          { name: '德兴市', value: 8.42 },
          { name: '余干县', value: 7.65 },
          { name: '弋阳县', value: 6.88 },
          { name: '铅山县', value: 5.92 },
          { name: '其他', value: 8.57 },
        ]
        var total = 411497
      }
      var level_pie = this.echarts.init(document.getElementById('level_pie'));
      var option = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            // radius: '50%',
            data: series,
            label: {
              show: false
            },
            center: ['40%', '50%'],
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + (params.data.value).toFixed(2) + "%<br/>" + (total * params.data.value / 100).toFixed(0) + "人"
          },
        },
        legend: {
          orient: 'vertical',
          show: true,
          right: 0,
          textStyle: {
            color: '#606266',
            fontSize: 12
          },
        },
      }
      level_pie.clear()
      level_pie.setOption(option)
      level_pie.off('click');
      var _this = this
      level_pie.on('click', function (params) {
        console.log('点击了系列:', params, _this.level_value);
        if (_this.level_value < 3) {
          _this.level_value += 1
          _this.getLevel()
          return
        }
      })
    },
    lastLevel() {
      this.level_value -= 1
      this.getLevel()
    },
    showPlan(data) {
      this.plan_modal_type = data
      this.showPlanModal = true
    },
    getCateringType() {
      var series = [
        { name: '徽菜', value: 20.18 },
        { name: '农家菜', value: 17.52 },
        { name: '米粉面馆', value: 26.51 },
        { name: '江西菜', value: 31.16 },
        { name: '川湘菜', value: 3.59 },
        { name: '烤串', value: 1.03 }
      ]
      var total = 10357337
      var catering_pie = this.echarts.init(document.getElementById('catering_pie'));
      var option = {
        color: ['#5B8FF9', '#5AD8A6', '#5D7092', '#F6BD16', '#E86452', '#6DC8EC'],
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            radius: ['45%', '70%'],
            data: series,
            label: {
              show: false
            },
            center: ['30%', '38%'],
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + (params.data.value).toFixed(2) + "%<br/>" + (total * params.data.value / 100).toFixed(2) + "元"
          },
        },
        legend: {
          show: true,
          bottom: 0,
          textStyle: {
            color: '#606266',
            fontSize: 12
          },
        },
      }
      catering_pie.setOption(option)
    },
    getCateringRatType() {
      var series = [
        { name: '一星', value: 3.59 },
        { name: '两星', value: 17.52 },
        { name: '三星', value: 20.18 },
        { name: '四星', value: 32.20 },
        { name: '五星', value: 26.51 }
      ]
      var total = 103573
      var catering_rat_pie = this.echarts.init(document.getElementById('catering_rat_pie'));
      var option = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            // radius: '50%',
            data: series,
            label: {
              show: false
            },
            center: ['30%', '38%'],
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + (params.data.value).toFixed(2) + "%<br/>" + (total * params.data.value / 100).toFixed(2) + "元"
          },
        },
        legend: {
          show: true,
          bottom: 0,
          textStyle: {
            color: '#606266',
            fontSize: 12
          },
        },
      }
      catering_rat_pie.setOption(option)
    },
        orderPlanChange(data) {
      if (this.order_plan_index == data) {
        this.order_plan_index = 0
      } else {
        this.order_plan_index = data
      }
    },
    dayPlanChange(data) {
      if (this.day_plan_index == data) {
        this.day_plan_index = 0
      } else {
        this.day_plan_index = data
      }
    },
    getSexPie() {
      var sex_7_el = document.getElementById('sex_7')
      if (!sex_7_el || sex_7_el.offsetWidth === 0) return
      var sex_7 = this.echarts.init(sex_7_el);
      var total = (this.gender.female || 0) + (this.gender.male || 0)
      var chartData = [{ value: this.gender.male, name: '男' }, { value: this.gender.female, name: '女' }]
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'horizontal',
          bottom: 0,
          left: 'center',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 12,
          textStyle: { color: '#333', fontSize: 11 }
        },
        graphic: [
          {
            type: 'text',
            left: 'center',
            top: '32%',
            style: {
              text: total > 0 ? total.toLocaleString() : '0',
              textAlign: 'center',
              fill: '#333',
              fontSize: 14,
              fontWeight: 'bold'
            }
          },
          {
            type: 'text',
            left: 'center',
            top: '44%',
            style: {
              text: '总人次',
              textAlign: 'center',
              fill: '#999',
              fontSize: 10
            }
          }
        ],
        series: [
          {
            name: '性别',
            type: 'pie',
            radius: ['50%', '75%'],
            center: ['50%', '40%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 8,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.2)'
              }
            },
            data: chartData,
            color: ['#3b82f6', '#ec4899']
          }
        ]
      }
      sex_7.setOption(option)
    }
  }
};
</script>
<style scoped>
.sentiment-box {
  height: calc(100vh - 100px);
  display: flex;
}

.sentiment-left {
  width: 400px;
  flex-shrink: 0;
  margin: 0 10px;
}

.sentiment-stream-card {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  max-width: 100%;
}

.sentiment-stream-body {
  flex: 1;
  padding: 0 10px 10px;
  box-sizing: border-box;
  min-height: 0;
  overflow: hidden;
  width: 100%;
}

.sentiment-stream-video {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  object-fit: contain;
  background-color: #000;
}

.sentiment-body {
  flex: 1;
  display: flex;

}

.body-left {
  height: 100%;
  flex: 1;
  padding: 10px;
}

.body-right {
  height: 100%;
  flex: 1;
  padding: 10px;
}

.body-title {
  text-align: center;
  font-size: 28px;
}

.sentiment-right {
  width: 400px;
  flex-shrink: 0;
  margin: 0 10px;
}


.list-box {
  height: calc(100vh - 160px);
  overflow: auto;
  padding-right: 0;
}

.list-box::-webkit-scrollbar {
  width: 4px;
}

.list-box::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 4px;
}

.list-box::-webkit-scrollbar-thumb:hover {
  background: #fff;
}

.list-item {
  padding: 20px 0;
  cursor: pointer;
}

.item-header {
  display: flex;
  align-items: center;
}

.avatar {
  margin-right: 14px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}

.avatar img {
  width: 40px;
  height: 40px;
}

.header-content {
  flex: auto;
  display: flex;
  align-items: center;
}

.header-content-left {
  flex: auto;
  display: flex;
  flex-direction: column;


}

.header-content-left .title {
  font-weight: bold;
  margin-bottom: 6px;
}

.header-content-left .content {
  font-size: 14px;
  color: #606266;
}

.header-content-right {
  flex-shrink: 0;
  margin-left: 20px;
  font-size: 14px;
  color: #6d5fe0;
}

.item-key {
  margin-top: 8px;
  font-size: 13px;
  color: #606266;
  display: flex;
}

.key-list {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;


}

.key {
  margin-left: 10px;
  margin-bottom: 3px;
  color: #606266;
}

.item-tap {
  margin-top: 12px;
  margin-bottom: 4px;
  font-size: 13px;
  color: #606266;
  display: flex;
}

.tap-list {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.tap {
  margin-left: 10px;
  margin-bottom: 3px;
  padding: 2px 5px;
  background-color: #6d5fe0;
  color: #606266;
  border-radius: 2px;
}

.item-body {
  padding: 0 15px;
}

.body-text {
  font-size: 15px;
  color: #c2c0c0;
  letter-spacing: 1px;
  line-height: 22px;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  /* 限制显示行数 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.body-images {
  margin-top: 10px;
  overflow: hidden;
  width: 342px;
  position: relative;


}

.body-images img {
  object-fit: cover;
  flex-shrink: 0;
  height: 80px;
  width: 110px;
  margin: 0 2px;
}

.images-list {
  display: flex;
  flex-wrap: nowrap;
}

.prev {
  color: #606266;
  position: absolute;
  left: 2px;
  background-color: rgba(52, 64, 82, .7);
  padding: 3px;
  font-size: 14px;
  top: 30px;
}

.prev:hover {
  background-color: rgba(52, 64, 82, .5);
}

.next {
  color: #606266;
  position: absolute;
  right: 2px;
  background-color: rgba(52, 64, 82, .7);
  padding: 3px;
  font-size: 14px;
  top: 30px;
}

.next:hover {
  background-color: rgba(52, 64, 82, .5);
}

.img-total {
  position: absolute;
  left: 5px;
  bottom: 5px;
  font-size: 12px;
  color: #606266;
  padding: 2px 3px;
  line-height: 12px;
  background-color: rgba(86, 105, 133, 1);
}

.box-right {
  height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
}

.right-header {
  flex-shrink: 0;
}

.right-body {
  flex: 1;
  overflow-y: scroll;
}

.right-body-text {
  white-space: pre-line;
  font-size: 15px;
  color: #606266;
  letter-spacing: 1px;
  line-height: 22px;
}

/deep/ .right-body-text p {
  margin: 5px 0;
}

/deep/ .right-body-text img {
  display: inline-block;
  width: 100%;
  margin: 3px;
}

.right-body-images img {
  display: inline-block;
  max-width: 100%;
  margin: 3px;
}

.right-body::-webkit-scrollbar {
  width: 4px;
  position: fixed;
  right: 0;
}

.right-body::-webkit-scrollbar-thumb {
  background: #a8a8a8;
  border-radius: 4px;
}


.timeline {
  width: 28vw;
  height: calc(100vh - 160px);
  overflow-y: scroll;
}

.timeline-date {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding: 10px 0;
  color: #606266;
  font-weight: bold;
}

.timeline-date:before {
  content: '';
  position: absolute;
  left: 8px;
  background-color: #6459cd;
  width: 1px;
  height: 100%;
}

.date-span {
  margin-right: 10px;
  /* background-color: #fff; */
  width: 17px;
  height: 17px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;


}

.date-item1 {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: #6459cd;
}

.timeline-item {
  position: relative;
}

.timeline-item:before {
  content: '';
  position: absolute;
  left: 8px;
  background-color: #6459cd;
  width: 1px;
  height: 100%;
}

.timeline-span {
  margin-right: 10px;
  /* background-color: #fff; */
  width: 17px;
  height: 17px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;


}

.span-item1 {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #6459cd;
}

.timeline-content {
  display: flex;
  align-items: center;
  padding: 14px 0;
}

.timeline-time {
  flex-shrink: 0;
  font-size: 14px;
  margin-right: 10px;
}

.timeline-text {
  cursor: pointer;
  flex: 1;
  font-size: 16px;
  color: #dad8d8;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  letter-spacing: 1px;
}

.timeline-website {
  width: 100px;
  flex-shrink: 0;
  font-size: 14px;
  margin-left: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.btn-box {
  width: 100px;
  flex-shrink: 0;
  font-size: 14px;
  margin-left: 10px;
}

.timeline::-webkit-scrollbar {
  width: 4px;
}

.timeline::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 4px;
}

.timeline::-webkit-scrollbar-thumb:hover {
  background: #fff;
}

.migrateMap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* max-height:calc(100% + 180px) ; */
  background-color: #555;
  z-index: 0;
  min-height: 100vh;
}

.centenr-echart {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 0;
}

.centenrBox {
  width: 1330px;
  height: 900px;
}

.centenrBox-chart {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 1230px;
  height: 800px;
}

.shop-charts-btn {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 1230px;
  height: 800px;
  display: flex;
  justify-content: space-around;
}

.shop-charts-01 {
  width: 1200px;
  height: 800px;
}

.shop-charts-02 {
  width: 500px;
  height: 800px;
}

.all_or_shop {
  display: flex;
  justify-content: center;
}

.all_or_shop_btn {
  width: 120px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  color: #606266;
  border: 1px solid #fff;
  border-radius: 6px;
}

.all_or_shop_on {
  background-color: #060c41;
  border: 1px solid #04dccf;
  color: #04dccf;
}

.all_or_shop_btn:hover {
  cursor: pointer;
}

/* .migrateMap1{
  position: relative;
  top:0;
  left: 0;
  width: 100%;
  height: 571px;
  background-color: rgba(0,0,0,0);
} */
/* 头部开始 */
.head {
  position: relative;
  display: flex;
  padding: 0 20px;
  width: 100%;
  height: 54px;
  line-height: 54px;
  background-color: rgba(3, 10, 69, 0.92);
  justify-content: center;
  z-index: 1;
  align-items: center;
}

.head-title {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  vertical-align: middle;
  cursor: pointer;
}

.head-title-listening {
  color: #606266;
}

.head-title-text {
  white-space: nowrap;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 2px;
}

.head-title-voice-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  height: 22px;
  padding: 0 8px;
  line-height: 22px;
  border: 1px solid rgba(112, 203, 255, 0.28);
  border-radius: 11px;
  color: #8cefff;
  font-size: 11px;
  box-sizing: border-box;
}

.head-title-voice-tag-active {
  border-color: rgba(112, 255, 159, 0.72);
  color: #70ff9f;
  box-shadow: 0 0 12px rgba(112, 255, 159, 0.12);
}

.head-logo {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  transform: translate(0, -2px);
}

.voice-status-box {
  position: absolute;
  top: 46px;
  left: 0;
  z-index: 4;
  display: inline-flex;
  align-items: center;
  max-width: 320px;
  min-height: 34px;
  padding: 0 12px;
  box-sizing: border-box;
  border: 1px solid rgba(112, 203, 255, 0.28);
  background: rgba(4, 9, 50, 0.96);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);
  white-space: nowrap;
}

.voice-status-dot {
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background: #8cefff;
  flex-shrink: 0;
}

.voice-status-text {
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba(96, 98, 102, 0.92);
  font-size: 12px;
}

.voice-status-info {
  border-color: rgba(112, 203, 255, 0.28);
}

.voice-status-info .voice-status-dot {
  background: #8cefff;
}

.voice-status-listening {
  border-color: rgba(112, 255, 159, 0.42);
}

.voice-status-listening .voice-status-dot {
  background: #70ff9f;
  box-shadow: 0 0 10px rgba(112, 255, 159, 0.45);
}

.voice-status-success {
  border-color: rgba(112, 255, 159, 0.42);
}

.voice-status-success .voice-status-dot {
  background: #70ff9f;
}

.voice-status-warning {
  border-color: rgba(255, 214, 106, 0.42);
}

.voice-status-warning .voice-status-dot {
  background: #ffd76a;
}

.voice-status-error {
  border-color: rgba(255, 138, 138, 0.42);
}

.voice-status-error .voice-status-dot {
  background: #ff8a8a;
}

.voice-status-fade-enter-active,
.voice-status-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.voice-status-fade-enter,
.voice-status-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.voice-metric-board {
  position: fixed;
  top: 94px;
  left: 50%;
  z-index: 6;
  width: 360px;
  min-height: 160px;
  padding: 18px 22px 20px;
  box-sizing: border-box;
  transform: translateX(-50%);
  color: #606266;
  background: linear-gradient(180deg, rgba(4, 13, 68, 0.98), rgba(3, 10, 48, 0.98));
  border: 1px solid rgba(124, 238, 255, 0.62);
  box-shadow: 0 0 28px rgba(26, 221, 255, 0.22), inset 0 0 24px rgba(27, 146, 255, 0.14);
}

.voice-metric-board::before,
.voice-metric-board::after {
  position: absolute;
  top: 10px;
  width: 28px;
  height: 28px;
  content: "";
  border-top: 2px solid #7ceeff;
}

.voice-metric-board::before {
  left: 10px;
  border-left: 2px solid #7ceeff;
}

.voice-metric-board::after {
  right: 10px;
  border-right: 2px solid #7ceeff;
}

.voice-metric-close {
  position: absolute;
  top: 8px;
  right: 12px;
  z-index: 1;
  width: 28px;
  height: 28px;
  border: 0;
  color: rgba(96, 98, 102, 0.72);
  background: transparent;
  font-size: 24px;
  line-height: 28px;
  cursor: pointer;
}

.voice-metric-caption {
  color: #8cefff;
  font-size: 13px;
  line-height: 18px;
}

.voice-metric-title {
  margin-top: 8px;
  color: rgba(96, 98, 102, 0.88);
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}

.voice-metric-value-row {
  display: flex;
  align-items: flex-end;
  margin-top: 8px;
}

.voice-metric-value {
  color: #70ffef;
  font-size: 46px;
  font-weight: 700;
  line-height: 54px;
  text-shadow: 0 0 16px rgba(112, 255, 239, 0.32);
}

.voice-metric-unit {
  margin-left: 8px;
  padding-bottom: 8px;
  color: rgba(96, 98, 102, 0.78);
  font-size: 16px;
}

.voice-metric-subtitle {
  margin-top: 8px;
  color: rgba(96, 98, 102, 0.58);
  font-size: 12px;
  line-height: 18px;
}

.voice-metric-fade-enter-active,
.voice-metric-fade-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}

.voice-metric-fade-enter,
.voice-metric-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -8px);
}

.date-weather {
  display: inline-block;
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
  background-color: #040932;
  font-size: 13px;
  border-radius: 17px;
  vertical-align: middle;
}

.head-type {
  max-width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 8px;
}

.type-item {
  height: 32px;
  line-height: 32px;
  position: relative;
  display: inline-block;
  padding: 0 8px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 2px;
  color: rgba(96, 98, 102, 0.86);
  font-size: 13px;
  cursor: pointer;
  /* transition: all 0.3s; */
}

.type-item:hover {
  border-color: #4cd9ff;
  /* background: rgba(76, 217, 255, 0.1); */
}

.type-on {
  display: none;
}

.type-item2 {
  height: 32px;
  font-size: 15px;
  text-align: center;
  color: #01F1E3;
  line-height: 32px;
  font-weight: 600;
  border-color: transparent;
  background-image: url(../../static/img/year-top.png),
    url(../../static/img/year-bottom.png),
    url(../../static/img/year-bgc.png);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-size: auto auto, auto auto, 110px 65px;
  background-position: right top, left bottom, center center;
}

/* 头部结束 */
/* 主体开始 */
.main {
  position: relative;
  width: 100%;
  /* padding-top: 28px; */
  /* box-sizing: border-box; */
  /* display: flex; */
  /* justify-content: space-between; */
  /* min-height: calc(100vh - 54px); */
  /* align-items:flex-end */
}

.warning-push-board {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  display: flex;
  align-items: center;
  min-width: 420px;
  max-width: 720px;
  height: 40px;
  padding: 0 16px;
  box-sizing: border-box;
  background: linear-gradient(90deg, rgba(8, 34, 70, 0.92) 0%, rgba(9, 46, 78, 0.72) 100%);
  border: 1px solid rgba(1, 241, 227, 0.28);
  box-shadow: 0 0 12px rgba(1, 241, 227, 0.12);
}

.warning-push-icon {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin-right: 10px;
  border-radius: 4px;
  background: rgba(255, 74, 74, 0.18);
  color: #ff4a4a;
  font-size: 15px;
  font-weight: 700;
  flex-shrink: 0;
}

.warning-push-text {
  flex: 1;
  min-width: 0;
  color: rgba(96, 98, 102, 0.95);
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.warning-push-text-on {
  color: #158ec3;
  font-weight: 600;
}

.warning-push-text-on:hover {
  cursor: pointer;
}

.warning-push-button {
  margin-left: 14px;
  min-width: 84px;
  height: 28px;
  padding: 0 12px;
  border: 1px solid rgba(1, 241, 227, 0.45);
  background: rgba(1, 241, 227, 0.12);
  color: #8cefff;
  font-size: 12px;
  line-height: 26px;
  cursor: pointer;
  flex-shrink: 0;
}

.scenic-warning-board {
  position: absolute;
  top: 0;
  right: 360px;
  display: flex;
  align-items: center;
  width: 560px;
  height: 54px;
  padding: 0 18px;
  box-sizing: border-box;
  background: linear-gradient(90deg, rgba(8, 34, 70, 0.92) 0%, rgba(9, 46, 78, 0.72) 100%);
  border: 1px solid rgba(1, 241, 227, 0.45);
  box-shadow: 0 0 14px rgba(1, 241, 227, 0.2), inset 0 0 16px rgba(17, 155, 155, 0.12);
  border-radius: 6px;
  z-index: 2;
  overflow: hidden;
}

.scenic-warning-board::before {
  content: '';
  position: absolute;
  inset: 4px;
  border: 1px solid rgba(117, 250, 120, 0.65);
  border-radius: 4px;
  pointer-events: none;
}

.scenic-warning-icon {
  position: relative;
  z-index: 1;
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  margin-right: 14px;
  border-radius: 4px;
  background: rgba(255, 74, 74, 0.18);
  color: #ff4a4a;
  font-size: 16px;
  font-weight: 700;
}

.scenic-warning-content {
  position: relative;
  z-index: 1;
  flex: 1;
  height: 28px;
  overflow: hidden;
}

.scenic-warning-item {
  display: flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  white-space: nowrap;
}

.scenic-warning-title {
  margin-right: 12px;
  color: #ff4a4a;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
}

.scenic-warning-text {
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba(96, 98, 102, 0.92);
  font-size: 16px;
}

.warning-slide-enter-active,
.warning-slide-leave-active {
  transition: all 0.45s ease;
}

.warning-slide-enter {
  opacity: 0;
  transform: translateY(100%);
}

.warning-slide-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}

.main_type {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  /* min-height: calc(100vh - 54px); */
  align-items: flex-end;
  padding-top: 20px;
}

.main_type.map-pass-through {
  pointer-events: none;
}

.main_type.map-pass-through>* {
  pointer-events: auto;
}

.click-box {
  position: absolute;
  right: 400px;
  top: 40px;
}

.data-box {
  background-color: #030A45;
  opacity: 0.9;
  box-shadow: -1px -1px 10px 2px rgba(78, 240, 228, 0.1);
  background-image: url(../../static/img/border-top.png),
    url(../../static/img/border-bottom.png);
  background-repeat: no-repeat, no-repeat;
  background-position: left top, right bottom;
  background-position: -0.3% -0.3%, 100.3% 100.3%;
}

/* 左边开始 */
.main-left {
  position: relative;
  margin: 0 20px 15px 20px;
  width: 320px;
  box-sizing: border-box;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: calc(100% - 15px);
}

/* 左边顶部开始 */
.left-top {
  padding: 15px;
  /* padding-top: 35px; */
  width: 100%;
  height: 300px;
  box-sizing: border-box;

  z-index: 1;
}

.left-top-main {
  width: 100%;
}

.left-top-title {
  color: #606266;
  text-align: left;
  align-items: center;
}

.year-sum-box {
  margin-top: 6px;
  width: 291px;
  height: 57px;
  background: url(../../static/img/big-num-box.png) no-repeat;
  background-size: 100% 57px;
}

.year-sum {
  margin: 0 -2px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  width: calc(100% + 4px);
  line-height: 57px;
  text-align: center;
}

.center-big-title {
  margin-block: 6px;
  /* line-height: 81px;
  height: 81px; */
  vertical-align: top;
  color: #98bfbd;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
}

.today-sum-one {
  width: 420px;
  height: 96px;
  background: url(../../static/img/num-box.png) no-repeat;
  background-size: auto 96px;
  background-position: left
}

.year-sum-big {
  position: relative;
  margin: 0 -3px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  width: calc(100% + 4px);
  line-height: 57px;
  text-align: center;
}

.sum-one-big {
  display: inline-block;
  /* margin-left:22px; */
  font-weight: 600;
  font-size: 80px;
}

.center-icon {
  position: absolute;
  bottom: 18px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 60px;
}

.sum-one {
  display: inline-block;
  /* margin-left:22px; */
  font-weight: 600;
  font-size: 33px
}

/* .sum-one:first-child{
   margin-left:0px;
} */
.today-sum {
  display: flex;
  justify-content: space-between;
}

.today-one {
  flex-basis: 50%;
  text-align: center;
}

.today-one-title {
  margin: 8px 0 9px;
  font-size: 12px;
  font-weight: 600;
  color: #606266;
}

.today-one-sum {
  display: inline-block;
  width: 137px;
  height: 37px;
  background: url(../../static/img/small-num-box.png) no-repeat;
}

.today-one-sum-box {
  margin: 0 -1px;
  line-height: 37px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  display: flex;
  justify-content: space-around;
  width: calc(100% + 2px);
}

.today-one-num {
  display: inline-block;
  /* margin-left: 13px; */

}

/* .today-one-num:first-child{
   margin-left: 0;
} */
.last-num {
  width: 100%;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
}

/* 左边顶部结束 */
/* 左边中间开始 */
.left-center {
  margin-top: 11px;
  padding: 0 10px 10px;
  width: 100%;
  height: 360px;
  box-sizing: border-box;
}

.inPercentage {
  margin-top: 15px;
  display: flex;
  justify-content: space-around;
}

.saturation {
  text-align: center;
}

.saturation-per {
  display: inline-block;
  width: 119px;
  height: 119px;
  background-image: url(../../static/img/Chart_bg.png);
  background-size: 102px 102px;
  background-position: center center;
  background-repeat: no-repeat;
}

.inPercentageRemark {
  margin-top: 13px;
  display: inline-block;
  height: 14px;
  line-height: 14px;
}

.little-bar {
  display: inline-block;
  width: 16px;
  height: 2px;
  vertical-align: middle;
}

/* 左边中间结束 */
/* 左边下部开始 */
.left-bottom {
  margin-top: 10px;
  width: 100%;
  height: 266px;
  box-sizing: border-box;
}

.left-bottom-title {
  position: relative;
  padding: 10px;
  font-size: 16px;
  color: #606266;
}

.last-level {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #01F1E3;
  font-size: 14px;
}

.gender {
  position: relative;
  padding-left: 5px;
  height: 80px;
}

.a-gender {
  margin-left: 10px;
  display: inline-block;
  text-align: center;
  vertical-align: top;
  transform: translate(0, 15px);
}

.a-gender>img {
  display: inline-block;
  width: 26px;
  height: 26px;
}

.gender-content {
  height: 14px;
  font-size: 10px;
  line-height: 14px
}

.matinee {
  display: inline-block;
  width: 110px;
  height: 105px;
  text-align: right;
}

.ota_pie {
  display: inline-block;
  width: 300px;
  height: 200px;
  text-align: right;
}

.scenic_ranking {
  display: inline-block;
  width: 150px;
  height: 260px;
  text-align: center;
}

.pie-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
}

.pie-text-item {
  display: inline-block;
  margin: 3px 6px 0 0;
  font-size: 10px;
}

.gender-column {
  margin-left: 7px;
  display: inline-block;
  width: 190px;
  height: 105px;
}

.travel-person {
  margin-left: 7px;
  display: inline-block;
  width: 190px;
  height: 200px;
}

/* 左边下部结束 */
/* 左边结束 */
/* 中间开始 */
.main-center {
  flex-grow: 1;
  min-width: 720px;
  position: relative;
  height: 300px;
}

.heat-address {
  position: absolute;
  padding-left: 10px;
  top: 0;
  right: -119px;
  width: 102px;
  height: 36px;
  background-image: url(../../static/img/year-top.png),
    url(../../static/img/year-bottom.png),
    url(../../static/img/year-bgc.png);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-size: auto auto, auto auto, 145px 65px;
  background-position: right top, left bottom, center center;
  font-size: 16px;
  color: #01F1E3;
  line-height: 36px;
  font-weight: 600;
}

.heat-address>img {
  display: inline-block;
  vertical-align: middle;
  transform: translate(0, -2px);
}

.charts {
  left: 0;
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.inOrOut {
  position: relative;
  width: 457px;
  height: 268px;
}

.inOrOut-chart {
  position: absolute;
  top: 11px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 425px;
  height: 256px;
}

.inTime {
  position: relative;
  width: 400px;
  height: 212px;
}

.inTime-chart {
  position: absolute;
  top: 11px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 360px;
  height: 200px;
}

/* 中间结束 */
/* 右边开始 */
.main-right {
  position: relative;
  margin: 0 20px 15px 20px;
  width: 320px;
  box-sizing: border-box;
  z-index: 1;
}

.changeDates {
  position: absolute;
  top: 0;
  left: -280px;
}

.changeDateOne {
  margin-right: 10px;
  display: inline-block;
  width: 66px;
  height: 32px;
  font-size: 15px;
  text-align: center;
  color: #01F1E3;
  line-height: 32px;
  font-weight: 600;
  background-image: url(../../static/img/year-top.png),
    url(../../static/img/year-bottom.png),
    url(../../static/img/year-bgc.png);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-size: auto auto, auto auto, 110px 65px;
  background-position: right top, left bottom, center center;
  cursor: pointer;
}

/* 右边顶部开始 */
.right-top {
  width: 100%;
  height: 301px;
  box-sizing: border-box;
}

.right-title {
  position: relative;
  padding: 15px 10px;
  color: #606266;
  font-size: 16px;
  text-align: left;
}

.right-title-1 {
  font-size: 15px;
  color: #ccc;
}

.right-datetiem {
  position: absolute;
  padding-left: 8px;
  top: 15px;
  right: 10px;
  width: 55px;
  height: 22px;
  background-image: url(../../static/img/year-top.png),
    url(../../static/img/year-bottom.png),
    url(../../static/img/year-bgc.png);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-position: right top, left bottom, center center;
  font-size: 10px;
  color: #01F1E3;
  line-height: 22px;
  font-weight: 600;
}

.right-datetiem>img {
  display: inline-block;
  vertical-align: middle;
  transform: translate(0, -1px);
}

.originTypeBox {
  position: relative;
  width: 100%;
}

.originTypeBox>img {
  display: inline-block;
  vertical-align: middle;
  transform: translate(0, -1px);
}

.originType {
  position: absolute;
  bottom: -75px;
  left: -8px;
  width: 66px;
  background-color: #08153b;
  border: 1px solid #01f1e3;
  z-index: 999;
}

.originTypeOne {
  padding: 0 4px;
  height: 24px;
  line-height: 24px;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #01f1e3;
}

.originTypeOne:last-child {
  border-bottom: 0px solid #01f1e3;
}

.touristType {
  margin: 0 auto;
  width: 100%;
  height: 240px;
}

/* 右边顶部结束 */
/* 右边中间开始 */
.right-center {
  margin-top: 20px;
  width: 100%;
  height: 261px;
  box-sizing: border-box;
}

.address {
  width: 160px;
  height: 150px;
}

.address_2 {
  width: 200px;
  height: 180px;
}

.addressList {
  display: inline-block;
  position: absolute;
  width: 100px;
  top: 50%;
  right: 8px;
  transform: translate(0, 22px);
}

.addressList_2 {
  display: inline-block;
  position: absolute;
  width: 130px;
  top: 50%;
  right: 8px;
  transform: translate(0, 22px);
}

.addressListOne {
  width: 60px;
  height: 15px;
  line-height: 15px;
  color: #aaabb0;
  font-size: 9px;
}

.addressListOne_2 {
  width: 60px;
  height: 18px;
  line-height: 18px;
  color: #aaabb0;
  font-size: 9px;
}

.addressBar {
  position: absolute;
  display: inline-block;
  width: 70px;
  height: 150px;
  top: 0;
  right: 0;
}

.addressBar_2 {
  position: absolute;
  display: inline-block;
  width: 100px;
  height: 180px;
  top: 0;
  right: 0;
}

/* 右边中间结束 */
/* 右边底部开始 */
.right-bottom {
  margin-top: 16px;
  width: 100%;
  height: 300px;
  box-sizing: border-box;
}

.touristLine {
  margin: 0 auto;
  width: 285px;
  height: 192px;

}

/* 右边底部结束 */
/* 右边结束 */
/* 第二部分左边开始 */
.cityCome {
  position: relative;
  width: 360px;
  height: 268px;
}

.cityCome-chart {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 350px;
  height: 180px;
}

.cityInput {
  padding: 0 6px;
  box-sizing: border-box;
  display: inline-block;
  width: 88px;
  height: 30px;
  line-height: 30px;
  z-index: 999;
}

.city-btn {
  margin-left: 6px;
  display: inline-block;
  width: 50px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  color: #606266;
  background-color: #1e5c79;
  border-radius: 6px;
}

.city-btn:hover {
  cursor: pointer;
}

.onOldCome {
  background-color: #0081c3;
}

.number-big {
  margin-top: 10px;
  color: #606266;
  font-size: 36px;
  font-weight: 600;
}

.number-small {
  margin-left: 14px;
  color: #01F1E3;
  font-size: 16px;
}

.title-small {
  display: inline-block;
  transform: translate(0, -2px);
}

.title-small-third {
  display: inline-block;
  width: 60px;
  text-align-last: justify;
  text-align: left;
}

.charts-percent {
  font-size: 12px;
  color: #606266;
  line-height: 12px;
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}

.ticket-dot {
  margin-left: 10px;
  margin-right: 6px;
  display: inline-block;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.three-day {
  margin-left: 6px;
  margin-top: 18px;
  display: inline-block;
  width: 108px;
  vertical-align: top;
  font-size: 12px;
  /* text-align-last: justify; */
}

.rank-box {
  position: relative;
  display: inline-block;
  width: 178px;
  height: 278px;
}

.rank-charts {
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translate(-50%, 0);
}

.center-top-num {
  position: fixed;
  top: 50px;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 18px;
}

.title-price {
  position: relative;
  color: #606266;
  margin: 10px 0 5px;
}

.title-price-tong {
  position: absolute;
  top: 6px;
  right: 6px;
}

.num-price {
  font-weight: 600;
  color: #01F1E3;
  margin-left: 10px;
  font-size: 20px;
}

.ota_pie_box {
  position: relative;
  width: 300px;
  display: inline-block;
  vertical-align: top;
}

.ota_pie_list {
  position: absolute;
  top: 20px;
  right: 15px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  width: 800px;
  border-radius: 8px;
  overflow: hidden;
}

.modal-header {
  padding: 15px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  border: none;
  background: none;
  font-size: 24px;
  cursor: pointer;
}

.modal-body {
  padding: 0;
  background: #000;
}

.click-box {
  padding: 5px;
  height: 30px;
  background: #133041;
  color: #606266;
  display: inline-block;
  cursor: pointer;
}

.scroll-text-box {
  flex: 1;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding: 0 16px;
  display: flex;
  align-items: center;
}

.scroll-text-content {
  display: flex;
  flex-direction: column;
  animation: scrollUp 5s linear infinite;
  white-space: nowrap;
}

.scroll-text-content span {
  height: 18px;
  line-height: 18px;
  color: #606266;
  font-size: 13px;
  font-weight: 400;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
}

@keyframes scrollUp {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-50%);
  }
}

/* 表格样式 */
.table-container {
  width: 100%;
}

.table-header {
  display: flex;
  background: linear-gradient(90deg, #1e3a8a 0%, #2563eb 100%);
  border-radius: 4px;
  margin-bottom: 8px;
  padding: 10px 0;
}

.th {
  flex: 1;
  text-align: center;
  color: #606266;
  font-size: 13px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.th:first-child {
  flex: 1.2;
}

.table-body {
  max-height: 400px;
  overflow-y: auto;
}

.table-body::-webkit-scrollbar {
  width: 4px;
}

.table-body::-webkit-scrollbar-track {
  background: #0a1f44;
}

.table-body::-webkit-scrollbar-thumb {
  background: #2563eb;
  border-radius: 2px;
}

.table-row {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid rgba(64, 158, 255, 0.1);
  transition: all 0.3s;
}

.table-row:hover {
  background: rgba(64, 158, 255, 0.15);
  transform: scale(1.01);
  box-shadow: 0 0 15px rgba(64, 158, 255, 0.2);
}

.table-row.even {
  background: rgba(64, 158, 255, 0.05);
}

.td {
  flex: 1;
  text-align: center;
  color: #a8c5e8;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.td:first-child {
  flex: 1.2;
}

.road-name {
  color: #606266;
  font-weight: 500;
}

/* 拥堵率颜色 */
.rate-text {
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 13px;
}

.rate-text.normal {
  color: #67c23a;
  background: rgba(103, 194, 58, 0.15);
  text-shadow: 0 0 8px rgba(103, 194, 58, 0.4);
}

.rate-text.warning {
  color: #e6a23c;
  background: rgba(230, 162, 60, 0.15);
  text-shadow: 0 0 8px rgba(230, 162, 60, 0.4);
}

.rate-text.danger {
  color: #f56c6c;
  background: rgba(245, 108, 108, 0.15);
  text-shadow: 0 0 8px rgba(245, 108, 108, 0.4);
}

.resource-panel {
  position: absolute;
  top: 50px;
  left: 400px;
  width: 150px;
  background-color: #0f4c81;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.resource-panel-title {
  padding: 10px 8px;
  color: #606266;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 1px;
  background: linear-gradient(180deg, rgba(68, 164, 231, 0.55) 0%, rgba(15, 76, 129, 0.96) 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.14);
}

.resource-item {
  display: flex;
  align-items: center;
  padding: 8px;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.resource-item:last-child {
  border-bottom: none;
}

.resource-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.resource-item.active {
  background-color: #2196F3;
  position: relative;
}

.resource-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #fff;
}

.resource-icon {
  width: 20px;
  text-align: center;
  margin-right: 10px;
  font-size: 14px;
  opacity: 0.9;
}

.resource-label {
  flex: 1;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.resource-count {
  font-size: 13px;
  opacity: 0.9;
  font-weight: 500;
}

/* 备选方案：使用 CSS 绘制简单图标，不依赖 Font Awesome */
.icon-fallback {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 10px;
  position: relative;
}

.business-resource-page {
  position: relative;
  min-height: calc(100vh - 82px);
  z-index: 1;
}

.business-resource-page.map-pass-through {
  pointer-events: none;
}

.business-resource-page.map-pass-through>* {
  pointer-events: auto;
}

.business-left-panel {
  position: absolute;
  top: 20px;
  left: 18px;
  z-index: 2;
  width: 324px;
  height: calc(100vh - 76px);
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
}

.business-saturation-card {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 12px 14px 10px;
  margin-bottom: 0;
  border: 1px solid rgba(88, 145, 255, 0.55);
  background-color: rgba(16, 30, 99, 0.94);
  background-image: url(../../static/img/border-top.png),
    url(../../static/img/border-bottom.png);
}

.business-saturation-panel .business-saturation-card {
  height: 100%;
}

.business-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.business-saturation-head {
  flex: 0 0 auto;
}

.business-saturation-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-top: 8px;
}

.business-saturation-tabs button {
  height: 30px;
  border: 1px solid rgba(73, 218, 222, 0.32);
  border-radius: 4px;
  background: rgba(5, 31, 70, 0.46);
  color: #8cefff;
  font-size: 13px;
  cursor: pointer;
}

.business-saturation-tabs button.active {
  background: #8fffff;
  border-color: #8fffff;
  color: #06294a;
  font-weight: 700;
}

.business-saturation-current-title {
  color: #9bdfff;
  font-size: 15px;
  font-weight: 700;
}

.business-card-title {
  color: #606266;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
}

.business-saturation-card .business-card-title {
  color: #9bdfff;
}

.business-saturation-card.is-danger {
  box-shadow: 0 0 18px rgba(255, 61, 53, 0.22), -1px -1px 10px 2px rgba(78, 240, 228, 0.1);
}

.business-period-filter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 24px;
  border: 1px solid rgba(73, 218, 222, 0.45);
  background: rgba(5, 31, 70, 0.72);
  color: #8cefff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: inset 0 0 10px rgba(73, 218, 222, 0.12), 0 0 10px rgba(73, 218, 222, 0.1);
}

.business-period-filter span {
  width: 7px;
  height: 7px;
  margin-left: 8px;
  border-right: 2px solid #8cefff;
  border-bottom: 2px solid #8cefff;
  transform: translateY(-2px) rotate(45deg);
}

.business-saturation-dashboard {
  margin-top: 8px;
  text-align: center;
}

.business-percent-chart {
  padding: 4px 0 6px;
}

.business-percent-gauge {
  position: relative;
  width: 168px;
  height: 98px;
  margin: 0 auto;
}

.business-percent-gauge-svg {
  width: 168px;
  height: 98px;
}

.business-percent-gauge-meta {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  color: #909399;
  font-size: 11px;
}

.business-gauge-wrap {
  position: relative;
  width: 168px;
  height: 98px;
  margin: 0 auto;
}

.business-gauge-svg {
  width: 168px;
  height: 98px;
}

.business-gauge-bg,
.business-gauge-value {
  fill: none;
  stroke-linecap: round;
  stroke-width: 12;
}

.business-gauge-bg {
  stroke: rgba(71, 102, 166, 0.45);
}

.business-gauge-value {
  stroke: #ff9f1c;
  stroke-dashoffset: 0;
}

.business-gauge-value.is-warning {
  stroke: #ff9f1c;
}

.business-gauge-value.is-danger {
  stroke: #ff3d35;
}

.business-gauge-needle {
  stroke: #ff9f1c;
  stroke-linecap: round;
  stroke-width: 3;
  transform-origin: 80px 80px;
}

.business-gauge-needle.is-danger {
  stroke: #ff3d35;
}

.business-gauge-value-text {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  z-index: 1;
  color: #ff9f1c;
  font-weight: 800;
}

.business-gauge-value-text strong {
  font-size: 34px;
  line-height: 1;
}

.business-gauge-value-text span {
  margin-left: 2px;
  font-size: 15px;
}

.business-gauge-value-text.is-warning {
  color: #ff9f1c;
}

.business-gauge-value-text.is-danger {
  color: #ff3d35;
}

.business-saturation-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 24px;
  margin-top: 2px;
  padding: 0 8px;
  color: #606266;
  font-size: 12px;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: 6px;
}

.business-saturation-meta strong {
  color: #ff9f1c;
}

.business-saturation-meta strong.is-warning {
  color: #ff9f1c;
}

.business-saturation-meta strong.is-danger {
  color: #ff3d35;
}

.business-threshold-alert {
  margin-top: 5px;
  padding: 4px 7px;
  color: #ff3d35;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.25;
  background: rgba(255, 61, 53, 0.12);
  border: 1px solid rgba(255, 61, 53, 0.36);
}

.business-advice-box {
  flex: 1;
  min-height: 0;
  overflow: auto;
  margin-top: 8px;
  padding: 7px 8px;
  border: 1px solid rgba(88, 145, 255, 0.32);
  background: rgba(5, 18, 70, 0.42);
  color: rgba(96, 98, 102, 0.88);
}

.business-saturation-card .business-advice-box {
  padding: 10px 12px;
}

.business-advice-title {
  margin-bottom: 3px;
  color: #8cefff;
  font-size: 12px;
  font-weight: 700;
}

.business-advice-box p {
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.55;
  white-space: pre-line;
}

.business-advice-box p:last-child {
  margin-bottom: 0;
}

.business-resource-menu {
  position: absolute;
  top: 50px;
  left: 400px;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: calc(100vw - 760px);
  padding: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: #0f4c81;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.business-resource-menu-head {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 8px;
}

.business-resource-menu-title {
  flex: 0 0 auto;
  padding: 0 8px;
  color: #606266;
  font-size: 14px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  letter-spacing: 1px;
  background: transparent;
  border-bottom: 0;
}

.business-resource-label-toggle {
  flex: 0 0 auto;
  height: 28px;
  padding: 0 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: #606266;
  font-size: 12px;
  cursor: pointer;
}

.business-resource-item {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  min-width: 0;
  padding: 4px 10px;
  color: #606266;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;
}

.business-resource-item:last-child {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.business-resource-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.business-resource-item.active {
  position: relative;
  background-color: #2196F3;
}

.business-resource-item.active::before {
  display: none;
}

.business-resource-name {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.business-resource-count {
  margin-left: 4px;
  flex-shrink: 0;
  color: #ffe13d;
  font-weight: 700;
}

.business-point-detail-card {
  position: absolute;
  top: 86px;
  right: 372px;
  z-index: 4;
  width: 260px;
  min-height: 152px;
  padding: 16px 16px 14px;
  border: 1px solid rgba(90, 168, 255, 0.72);
  background-color: rgba(16, 30, 99, 0.95);
  box-sizing: border-box;
  box-shadow: 0 0 18px rgba(1, 241, 227, 0.12);
}

.business-point-detail-close {
  position: absolute;
  top: 8px;
  right: 10px;
  width: 20px;
  height: 20px;
  border: 1px solid rgba(128, 196, 255, 0.46);
  background: rgba(5, 18, 70, 0.58);
  color: #8cefff;
  line-height: 18px;
  cursor: pointer;
}

.business-point-detail-body {
  margin-top: 12px;
}

.business-point-detail-name {
  margin-bottom: 10px;
  color: #606266;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.35;
}

.business-point-detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 28px;
  border-bottom: 1px solid rgba(128, 196, 255, 0.18);
  color: rgba(96, 98, 102, 0.72);
  font-size: 12px;
}

.business-point-detail-row strong {
  max-width: 148px;
  color: #8fffff;
  font-size: 13px;
  font-weight: 700;
  text-align: right;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.business-point-detail-row strong.business-point-detail-overflow {
  font-weight: 800;
}

.business-point-detail-loading,
.business-point-detail-error {
  margin-top: 18px;
  color: #8fffff;
  font-size: 13px;
  line-height: 1.5;
}

.business-point-detail-error {
  color: #ff6b61;
}

.business-right-panel {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
  width: 322px;
  height: calc(100vh - 76px);
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
}

.business-tool-card {
  flex: 0 0 380px;
  padding: 18px 14px 10px;
  border: 1px solid rgba(90, 168, 255, 0.72);
  box-sizing: border-box;
  height: auto!important;
  min-height: 0;
  overflow: hidden;
}

.business-tool-body {
  margin-top: 6px;
}

.business-tool-actions {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 5px;
  margin-top: 6px;
}

.business-fence-shape-select {
  grid-column: 1 / -1;
  width: 100%;
  height: 24px;
  min-width: 0;
  padding: 0 6px;
  border: 1px solid rgba(128, 196, 255, 0.7);
  border-radius: 2px;
  background: rgba(221, 231, 249, 0.92);
  color: #20233d;
  font-size: 11px;
  outline: none;
}

.business-tool-actions button {
  min-width: 0;
  height: 24px;
  border: 1px solid rgba(128, 196, 255, 0.7);
  border-radius: 2px;
  background: rgba(221, 231, 249, 0.92);
  color: #20233d;
  font-size: 11px;
  cursor: pointer;
}

.business-tool-actions button.active {
  background: #8fffff;
  color: #06294a;
}

.business-tool-actions button:disabled {
  opacity: 0.46;
  cursor: not-allowed;
}

.business-fence-form {
  display: grid;
  grid-template-columns: 1fr;
  gap: 5px;
  margin-top: 6px;
}

.business-fence-form label {
  display: grid;
  grid-template-columns: 58px 1fr;
  align-items: center;
  column-gap: 8px;
  color: #9bdfff;
  font-size: 12px;
}

.business-fence-form input,
.business-fence-form textarea,
.business-fence-search {
  width: 100%;
  border: 1px solid rgba(128, 196, 255, 0.5);
  background: rgba(5, 18, 70, 0.58);
  color: #606266;
  box-sizing: border-box;
  outline: none;
}

.business-fence-form input {
  height: 22px;
  padding: 0 8px;
}

.business-fence-form textarea {
  height: 34px;
  padding: 4px 8px;
  resize: none;
  line-height: 1.3;
}

.business-fence-search {
  height: 24px;
  margin-top: 6px;
  padding: 0 8px;
}

.business-fence-coordinate-label {
  align-items: start;
}

.business-fence-history {
  margin-top: 8px;
  min-height: 0;
}

.business-fence-history-title {
  color: #9bdfff;
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
}

.business-fence-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 96px;
  overflow-y: auto;
  padding-right: 2px;
}

.business-fence-list button {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  min-width: 0;
  height: 26px;
  padding: 0 8px;
  border: 1px solid rgba(128, 196, 255, 0.58);
  border-radius: 999px;
  background: rgba(221, 231, 249, 0.92);
  color: #20233d;
  font-size: 12px;
  cursor: pointer;
}

.business-fence-list button.active {
  border-color: #8fffff;
  background: #8fffff;
  color: #06294a;
  font-weight: 700;
}

.business-fence-list button span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.business-fence-list button em {
  flex: 0 0 auto;
  margin-left: 6px;
  color: #ff3d35;
  font-style: normal;
  font-size: 15px;
  line-height: 1;
}

.business-stat-card {
  flex: 1 1 auto;
  min-height: 0;
  padding: 22px 14px 12px;
  border: 1px solid rgba(90, 168, 255, 0.72);
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}

.business-stat-card::-webkit-scrollbar {
  width: 4px;
}

.business-stat-card::-webkit-scrollbar-track {
  background: rgba(219, 234, 254, 0.72);
  border-radius: 999px;
}

.business-stat-card::-webkit-scrollbar-thumb {
  background: rgba(64, 158, 255, 0.48);
  border-radius: 999px;
}

.business-stat-list {
  width: 252px;
  margin: 12px auto 0;
}

.business-stat-row {
  display: block;
  min-height: 0;
  padding: 8px 0;
  color: #606266;
  font-size: 12px;
}

.business-stat-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
}

.business-stat-info span,
.business-stat-info strong {
  min-width: 0;
  color: #606266;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.business-stat-info span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.business-progress-wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.business-stat-progress,
.business-rank-progress {
  flex: 1;
  height: 7px;
  border-radius: 999px;
  background: #dbeafe;
  overflow: hidden;
}

.business-stat-progress i,
.business-rank-progress i {
  display: block;
  width: 0;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #52c41a 0%, #67c23a 100%);
  box-shadow: none;
}

.business-progress-tip {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 6px);
  z-index: 5;
  min-width: 42px;
  padding: 3px 6px;
  border-radius: 4px;
  background: rgba(31, 41, 55, 0.92);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  opacity: 0;
  pointer-events: none;
  transform: translate(-50%, 2px);
  transition: opacity 0.16s ease, transform 0.16s ease;
  white-space: nowrap;
}

.business-progress-tip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  border: 4px solid transparent;
  border-top-color: rgba(31, 41, 55, 0.92);
  transform: translateX(-50%);
}

.business-progress-wrap:hover .business-progress-tip {
  opacity: 1;
  transform: translate(-50%, 0);
}

.business-passenger-box {
  width: 252px;
  margin: 14px auto 0;
  padding-top: 12px;
  border-top: 2px solid rgba(122, 200, 255, 0.55);
}

.business-passenger-title {
  margin-bottom: 10px;
  color: #606266;
  font-size: 15px;
  font-weight: 700;
}

.business-passenger-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  color: #606266;
  font-size: 12px;
}

.business-rank-row {
  position: relative;
  display: flex;
  align-items: center;
  height: 20px;
  margin-bottom: 3px;
  overflow: visible;
}

.business-rank-row .business-progress-wrap {
  align-self: stretch;
}

.business-rank-row span {
  position: relative;
  z-index: 1;
  width: 18px;
  height: 16px;
  margin-right: 6px;
  border-radius: 8px;
  background: linear-gradient(180deg, #ffffff 0%, #f3c232 100%);
  color: #28436e;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
}

.business-rank-row strong {
  position: relative;
  z-index: 1;
  width: 58px;
  color: #606266;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.business-rank-row em {
  position: relative;
  z-index: 1;
  color: #606266;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  white-space: nowrap;
}

.business-rank-row em {
  width: 42px;
  text-align: right;
}

.business-stat-progress i.business-rank-fill-warning,
.business-rank-progress i.business-rank-fill-warning {
  background: linear-gradient(90deg, #f3d19e 0%, #e6a23c 100%);
}

.business-stat-progress i.business-rank-fill-danger,
.business-rank-progress i.business-rank-fill-danger {
  background: linear-gradient(90deg, #fab6b6 0%, #f56c6c 100%);
}

.business-suggestion {
  width: 100%;
  max-height: 82px;
  margin-top: 12px;
  padding: 7px 10px;
  border: 1px solid rgba(88, 145, 255, 0.32);
  background: rgba(5, 18, 70, 0.42);
  color: rgba(96, 98, 102, 0.88);
  box-sizing: border-box;
  overflow: hidden;
}

.business-suggestion p {
  margin: 0 0 2px;
  font-size: 11px;
  line-height: 1.35;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.business-suggestion p:last-child {
  margin-bottom: 0;
}

.text-box {
  width: 100%;
  /* min-height: 100px; */
  /* border: 2px solid #ff4a4a; */
  border-radius: 6px;
  box-sizing: border-box;
  /* display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis; */
}

.text-item-6 {
  padding-left: 15px;
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
  width: 310px;
  box-sizing: border-box;
}

.text-item-6:hover {
  cursor: pointer;
}

.button-6 {
  margin: 15px auto;
  background-color: #169bd5;
  color: #606266;
  text-align: center;
  padding: 5px 0;
  width: 200px;
  border-radius: 6px;
}

.button-6:hover {
  cursor: pointer;
}

/* 价格监管页面 */
.price-supervision-left,
.price-supervision-right {
  width: 500px;
}

.price-supervision-right {
  position: absolute;
  right: 0;
  top: 30px;
}

.price-panel {
  padding: 0 12px 10px;
  box-sizing: border-box;
}

.price-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 4px;
}

.price-panel-header .right-title {
  margin-bottom: 0;
}

.price-search-box {
  flex-shrink: 0;
}

.price-search-input {
  width: 160px;
  height: 26px;
  padding: 0 8px;
  border-radius: 5px;
  background: #434f81;
  color: #333;
  font-size: 12px;
  outline: none;
}

.price-search-input::placeholder {
  color: #606266;
}

.price-table-container {
  margin-top: 8px;
}

.price-table-header {
  display: flex;
  background: #434f81;
  border: 1px solid rgba(0, 170, 255, 0.35);
  border-radius: 2px;
  padding: 7px 0;
}

.price-th {
  flex: 1;
  text-align: center;
  color: #9ed8ff;
  font-size: 14px;
  font-weight: 500;
}

/* 为每个列设置明确的flex值，确保表头和内容对齐 */
.price-th.hotel-col,
.price-td.hotel-name {
  flex: 1.5;
}

.price-th.room-type-col,
.price-td.room-type {
  flex: 1.2;
}

.price-th.real-time-price-col,
.price-td.real-time-price {
  flex: 1;
}

.price-th.history-avg-price-col,
.price-td.history-avg-price {
  flex: 1;
}

.price-th.premium-rate-col,
.price-td.premium-rate {
  flex: 1;
}

.price-th.price-trend-col,
.price-td.price-trend {
  flex: 1;
}

.price-th.supervision-col,
.price-td.supervision {
  flex: 1.2;
}

.price-table-body {
  max-height: 120px;
  overflow-y: auto;
}

.work-order-body {
  max-height: 692px;
}

.price-table-body::-webkit-scrollbar {
  width: 4px;
}

.price-table-body::-webkit-scrollbar-track {
  background: rgba(6, 12, 32, 0.6);
}

.price-table-body::-webkit-scrollbar-thumb {
  background: rgba(0, 170, 255, 0.55);
  border-radius: 2px;
}

.price-table-row {
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 170, 255, 0.12);
}

.price-table-row.even {
  background: rgba(0, 170, 255, 0.05);
}

.accommodation-hotel-row {
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
}

.accommodation-hotel-row:hover {
  background: rgba(0, 170, 255, 0.12);
}

.accommodation-hotel-row.active {
  background: rgba(0, 170, 255, 0.22);
  box-shadow: inset 0 0 0 1px rgba(0, 242, 255, 0.55);
}

.accommodation-header .hotel-col,
.price-td.hotel-name {
  flex: 1.5;
  text-align: left;
  padding-left: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.accommodation-list-body {
  max-height: 127px;
}

.price-table-empty {
  padding: 12px 0;
  text-align: center;
  color: #434f81;
  font-size: 12px;
}

.price-selected-hotel-tag {
  font-size: 12px;
  font-weight: 400;
  color: #2f80ed;
  margin-top: 10px;
}

.price-td {
  flex: 1;
  text-align: center;
  color: #2f80ed;
  font-size: 11px;
  line-height: 1.4;
}

.price-td.room-type,
.price-td.hotel-name {
  color: #000;
}

.complaint-linkage-box {
  padding: 4px 2px 0;
}

.complaint-summary {
  color: #2f80ed;
  font-size: 14px;
  margin-bottom: 8px;
}

.complaint-item {
  color: #2f80ed;
  font-size: 12px;
  line-height: 1.8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 27px;
}

.complaint-dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  margin-right: 6px;
  border-radius: 50%;
  background: #00aaff;
  vertical-align: middle;
}

.price-warning-list {
  padding: 2px 0;
  max-height: 110px;
  /* 控制展示高度，超出滚动 */
  overflow-y: auto;
}

.price-warning-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 0;
  border-bottom: 1px solid rgba(0, 170, 255, 0.1);
}

.price-warning-item:last-child {
  border-bottom: none;
}

.price-warning-text {
  flex: 1;
  color: #2f80ed;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
}

.price-warning-link {
  flex-shrink: 0;
  color: #2f80ed;
  font-size: 12px;
  cursor: pointer;
}

.price-warning-link:hover {
  color: #434f81;
  text-decoration: underline;
}

.price-warning-modal-overlay {
  z-index: 10000;
}


.price-trend-panel {
  margin-top: 14px;
  padding-bottom: 12px;
}

.price-trend-filters {
  gap: 8px;
  margin-bottom: 8px;
  width: 100%;
}

.price-filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 32%;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-sizing: border-box;
  transition: border-color 0.2s, background 0.2s;
}

.price-filter-item-active {
  border-color: #9ed8ff;
  background: #9ed8ff;
}

.price-filter-label {
  color: rgba(168, 197, 232, 0.85);
  font-size: 11px;
}

.price-filter-select {
  width: 100%;
  height: 28px;
  padding: 0 8px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  background: #ffffff;
  color: #606266;
  font-size: 12px;
  outline: none;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s, background-color 0.2s;
}

.price-filter-select:hover {
  border-color: #c0c4cc;
}

.price-filter-select:focus {
  border-color: #409eff;
  background: #ffffff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.12);
}

.price-filter-select option {
  background: #ffffff;
  color: #606266;
}

.price-trend-chart-tip {
  color: #2f80ed;
  font-size: 11px;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.price-fluctuation-chart {
  width: 100%;
  height: 200px;
}

.price-work-order-panel {
  height: 800px;
}

.price-map-alert-board {
  z-index: 2;
  max-width: 500px;
  width: 500px;
  margin-bottom: 13px;
}

.alert-scroll-container {
  height: 35px;
  overflow: hidden;
  background: #fff;
  border-radius: 4px;
  padding: 0 12px;
}

.alert-scroll-wrapper {
  animation: scrollUp 7s linear infinite;
  white-space: normal;
}

/* 滚动动画：从 0 滚到 -100% */
@keyframes scrollUp {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-50%);
    /* 因为复制了一份，所以滚 50% 刚好循环 */
  }
}

/* 警告项样式 */
.price-map-alert-item {
  display: flex;
  align-items: center;
  height: 32px;
  color: #606266;
  font-size: 14px;
}

.price-map-alert-icon {
  margin-right: 6px;
  color: red;
  font-weight: bold;
}

.price-map-alert-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-type-box {
  display: flex;
  margin: 10px auto;
}

.text-type-item {
  flex-grow: 1;
  border: 1px solid #00ccff;
  color: #606266;
  box-sizing: border-box;
  text-align: center;
  width:30%;
}

.text-type-item-on {
  background-color: #00ccff;
}

.filter-select-box {
  position: relative;
  display: inline-block;
  margin-left: 10px;
  width: 140px;
}

.filter-select {
  width: 100%;
  padding: 8px 32px 8px 12px;
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(96, 98, 102, 0.9);
  font-size: 13px;
  cursor: pointer;
  outline: none;
  appearance: none;
}

.filter-select:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.select-arrow {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(96, 98, 102, 0.5);
  font-size: 10px;
  pointer-events: none;
}

/* 景区对比选择器样式 */
.comparison-select-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  padding: 0 8px;
}

.comparison-select-box {
  display: flex;
  align-items: center;
  flex: 1;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 4px 8px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.comparison-select-box:hover {
  border-color: #3b82f6;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);
}

.comparison-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #3b82f6;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  margin-right: 8px;
  flex-shrink: 0;
}

.comparison-select {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: #333;
  font-size: 13px;
  cursor: pointer;
  appearance: none;
  padding: 4px 0;
}

.comparison-vs {
  font-size: 14px;
  font-weight: bold;
  color: #f59e0b;
  flex-shrink: 0;
}

/* 景区对比 - 类型切换标签 */
.comparison-type-tabs {
  display: flex;
  gap: 8px;
  margin: 12px 8px 0;
}

.comparison-tab-item {
  flex: 1;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  color: #666;
  border-radius: 6px;
  background: #f5f5f5;
  cursor: pointer;
  transition: all 0.25s;
  border: 1px solid transparent;
}

.comparison-tab-item:hover {
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.06);
}

.comparison-tab-active {
  color: #fff;
  background: #3b82f6;
  border-color: #3b82f6;
}

/* 景区对比 - 图表区域 */
.comparison-chart-area {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  margin-top: 10px;
  padding: 0 10px;
}

.comparison-chart-box {
  flex: 1;
  max-width: 48%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: none;
  border-radius: 0;
  background: transparent;
}

.comparison-chart-label {
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #333;
  padding: 4px 0;
  flex-shrink: 0;
  border-bottom: none;
  background: none;
}

.comparison-chart {
  width: 100%;
  flex: 1;
  min-height: 0;
}

/* 营销策略调整 - 滚动容器 */
.tour-customer-wrap {
  padding: 0 5px;
}

.tour-customer-wrap .scroll-box {
  max-height: 380px;
  overflow-y: auto;
  padding-right: 4px;
}

.tour-customer-wrap .scroll-box::-webkit-scrollbar {
  width: 4px;
}

.tour-customer-wrap .scroll-box::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 2px;
}

.tour-customer-wrap .scroll-box::-webkit-scrollbar-thumb {
  background: rgba(59, 130, 246, 0.3);
  border-radius: 2px;
}

.tour-customer-wrap .scroll-box::-webkit-scrollbar-thumb:hover {
  background: rgba(59, 130, 246, 0.5);
}

.tour-customer-wrap .block-item {
  margin-bottom: 14px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  border-left: 3px solid #3b82f6;
}

.tour-customer-wrap .block-item.full-bg {
  border-left-color: #ec4899;
  background: rgba(236, 72, 153, 0.03);
}

.tour-customer-wrap .title {
  font-size: 13px;
  font-weight: 600;
  color: #1e3a5f;
  margin: 0 0 6px 0;
}

.tour-customer-wrap .desc {
  font-size: 12px;
  color: #555;
  line-height: 1.6;
  margin: 0 0 8px 0;
}

.tour-customer-wrap .sub-title {
  font-size: 12px;
  font-weight: 600;
  color: #333;
  margin: 0 0 4px 0;
}

.tour-customer-wrap .point-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tour-customer-wrap .point-list li {
  font-size: 11px;
  color: #444;
  line-height: 1.7;
  margin-bottom: 6px;
  padding-left: 10px;
  position: relative;
}

.tour-customer-wrap .point-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 7px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #3b82f6;
}

.tour-customer-wrap .block-item.full-bg .point-list li::before {
  background: #ec4899;
}

.tour-customer-wrap .point-list .label {
  font-weight: 600;
  color: #1e3a5f;
}

.plan-modal-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  width: 500px;
  padding-bottom: 10px;
  background-color: #fff;
}

.plan-modal-title {
  position: relative;
  padding: 10px 0;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #606266;
  background-color: #158ec3;
}

.plan-modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
}

.rich-text-content {
  margin: 0 5px;
  box-sizing: border-box;
  padding: 5px 15px;
  color: #111;
  height: 450px;
  overflow: hidden;
  overflow-y: auto;
  border: 1px solid #000;
}

.deal-status-btn {
  padding: 2px 6px;
  border-radius: 2px;
  font-size: 11px;
  cursor: pointer;
  user-select: none;
}

.deal-status-btn.doing {
  color: #2f80ed;
  border: 1px solid #2f80ed;
  background: rgba(221, 241, 247, 0.1);
}

.deal-status-btn.done {
  color: #52c41a;
  border: 1px solid #52c41a;
  background: rgba(82, 196, 26, 0.1);
}

/* 工单处置弹窗 */
.deal-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.deal-modal-content {
  width: 360px;
  background: #fff;
  border: 1px solid rgba(0, 170, 255, 0.6);
  border-radius: 6px;
  box-shadow: 0 0 20px rgba(0, 170, 255, 0.2);
  overflow: hidden;
}

.deal-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(90deg, rgba(54, 150, 247, 0.4), #434f81);
  border-bottom: 1px solid rgba(0, 170, 255, 0.3);
}

.deal-modal-title {
  color: #606266;
  font-size: 16px;
  font-weight: 600;
}

.deal-modal-close {
  background: none;
  border: none;
  color: #a8c5e8;
  font-size: 18px;
  cursor: pointer;
}

.deal-modal-body {
  padding: 24px 16px;
  text-align: center;
}

.deal-modal-tip {
  font-size: 14px;
}

.deal-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 16px;
  border-top: 1px solid rgba(0, 170, 255, 0.2);
  background: linear-gradient(90deg, rgba(54, 150, 247, 0.4), #434f81);
}

.deal-btn {
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 13px;
  cursor: pointer;
  border: none;
}

.deal-btn.cancel {
  background: #fff;
  color: #2f80ed;
}

.deal-btn.confirm {
  background: #00aaff;
  color: #606266;
}

.deal-btn.confirm:hover {
  background: #0088cc;
}

.day-plan-container {
  padding: 0 12px 12px;
  display: flex;
  flex-direction: column;
}

.day-plan-group {
  border: 1px solid var(--ui-border-soft, #ebeef5);
  margin-top: -1px;
}

.day-plan-group:first-child {
  margin-top: 0;
  border-radius: 8px 8px 0 0;
}

.day-plan-group:last-child {
  border-radius: 0 0 8px 8px;
}

.day_plan_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  font-size: 13px;
  font-weight: 500;
  color: var(--ui-text, #1f2937);
  cursor: pointer;
  background: var(--ui-surface-soft, #f9fafc);
  transition: background 0.2s;
}

.day_plan_item:hover {
  background: #eff6ff;
}

.day_plan_item.day_plan_active {
  background: #dbeafe;
  color: #1d4ed8;
}

.day_plan_arrow {
  font-size: 10px;
  color: #9ca3af;
  transition: transform 0.25s ease;
}

.day_plan_arrow_on {
  transform: rotate(180deg);
}

.day_plan_text {
  padding: 12px 14px;
  font-size: 12px;
  line-height: 1.8;
  color: var(--ui-text-regular, #606266);
  background: #fff;
  border-top: 1px solid var(--ui-border-soft, #ebeef5);
}

/* B 公司白色系展示主题 */
.head {
  position: relative;
  z-index: 20;
  padding: 0 24px;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(34, 49, 63, 0.08);
  box-shadow: 0 10px 28px rgba(34, 49, 63, 0.08);
  color: #22313f;
}

.head-title {
  color: #22313f;
  font-weight: 700;
}

.head-title-listening {
  color: #0f766e;
}

.head-title-voice-tag {
  border-color: rgba(47, 128, 237, 0.28);
  background: rgba(47, 128, 237, 0.08);
  color: #2f80ed;
}

.head-title-voice-tag-active {
  border-color: rgba(18, 184, 134, 0.36);
  background: rgba(18, 184, 134, 0.1);
  color: #0f766e;
  box-shadow: none;
}

.voice-status-box,
.voice-metric-board {
  background: rgba(255, 255, 255, 0.98);
  border-color: rgba(47, 128, 237, 0.18);
  color: #22313f;
  box-shadow: 0 14px 30px rgba(34, 49, 63, 0.16);
}

.voice-status-text,
.voice-metric-title {
  color: #22313f;
}

.voice-metric-caption,
.voice-metric-value {
  color: #2f80ed;
  text-shadow: none;
}

.voice-metric-unit,
.voice-metric-subtitle,
.voice-metric-close {
  color: #526173;
}

.voice-metric-board::before,
.voice-metric-board::after {
  border-color: #2f80ed;
}

.date-weather {
  background: #f3f7fb;
  border: 1px solid rgba(34, 49, 63, 0.08);
  color: #526173;
}

.right-nav-drawer {
  position: fixed;
  top: 72px;
  right: 1px;
  z-index: 30;
  width: 170px;
  padding: 12px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(34, 49, 63, 0.1);
  border-radius: 8px 0 0 8px;
  box-shadow: 0 16px 36px rgba(34, 49, 63, 0.16);
  transition: transform 0.24s ease, box-shadow 0.24s ease;
}

.right-nav-drawer-collapsed {
  transform: translateX(170px);
  box-shadow: 0 10px 24px rgba(34, 49, 63, 0.12);
}

.drawer-side-panel {
  position: absolute;
  top: 12px;
  left: -48px;
  width: 48px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
}

.right-nav-toggle {
  width: 100%;
  height: 88px;
  border: none;
  background: transparent;
  color: #606266;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}

.voice-toggle {
  position: relative;
  margin-top: 12px;
  width: 100%;
  height: 44px;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.voice-toggle-icon {
  font-size: 14px;
}

.voice-toggle-dot {
  position: absolute;
  top: 6px;
  right: 10px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  transition: background 0.2s;
}

.voice-toggle-dot-on {
  background: #4ade80;
  box-shadow: 0 0 6px rgba(74, 222, 128, 0.6);
}

.head-type {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}

.type-item {
  display: block;
  width: 100%;
  height: 36px;
  padding: 0 12px;
  box-sizing: border-box;
  line-height: 36px;
  background: #f6f9fc;
  border: 1px solid rgba(34, 49, 63, 0.08);
  border-radius: 6px;
  color: #526173;
  font-size: 13px;
  text-align: left;
  transition: all 0.2s ease;
}

.type-item:hover {
  border-color: rgba(47, 128, 237, 0.35);
  background: rgba(47, 128, 237, 0.08);
  color: #2f80ed;
}

.type-item2 {
  height: 36px;
  line-height: 36px;
  background: #2f80ed;
  background-image: none;
  border-color: #2f80ed;
  color: #606266;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 8px 18px rgba(47, 128, 237, 0.22);
}

.main {
  min-height: calc(100vh - 54px);
  color: #22313f;
  background: linear-gradient(180deg, #f7fafc 0%, #eef4f8 100%);
}

.migrateMap {
  background-color: #eef4f8;
}

.data-box,
.business-saturation-card,
.body-left,
.body-right {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.92);
  background-image: none;
  border: 1px solid rgba(34, 49, 63, 0.08);
  border-radius: 8px;
  box-shadow: 0 12px 30px rgba(34, 49, 63, 0.1);
  color: #22313f;
}

.left-top-title,
.left-bottom-title,
.right-title,
.right-title-1,
.today-one-title,
.title-price,
.number-big,
.charts-percent,
.road-name,
.scroll-text-content span,
.business-card-title,
.business-saturation-card .business-card-title {
  color: #22313f;
}

.right-title,
.left-bottom-title {
  font-weight: 700;
}

.right-title-1,
.title-small,
.addressListOne,
.addressListOne_2,
.td {
  color: #526173;
}

.center-big-title,
.number-small,
.num-price,
.last-level,
.right-datetiem,
.heat-address {
  color: #2f80ed;
}

.year-sum-box,
.today-sum-one,
.today-one-sum {
  background: #f4f8fb;
  border: 1px solid rgba(47, 128, 237, 0.16);
  border-radius: 8px;
}

.sum-one,
.sum-one-big,
.center-icon {
  color: #1b4f9c;
}

.changeDateOne,
.right-datetiem,
.heat-address,
.business-period-filter {
  background: #f6f9fc;
  background-image: none;
  border: 1px solid rgba(47, 128, 237, 0.18);
  border-radius: 6px;
  color: #2f80ed;
}

.warning-push-board,
.scenic-warning-board,
.click-box {
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(232, 89, 12, 0.18);
  border-radius: 8px;
  box-shadow: 0 12px 26px rgba(34, 49, 63, 0.1);
  color: #22313f;
}

.warning-push-text,
.scenic-warning-text {
  color: #22313f;
}

.warning-push-button {
  border-color: rgba(47, 128, 237, 0.24);
  background: rgba(47, 128, 237, 0.08);
  color: #2f80ed;
  border-radius: 6px;
}

.table-header {
  background: #eaf2fb;
  border: 1px solid rgba(47, 128, 237, 0.12);
}

.th {
  color: #22313f;
  text-shadow: none;
}

.table-row {
  border-bottom-color: rgba(34, 49, 63, 0.08);
}

.table-row.even,
.table-row:hover {
  background: rgba(47, 128, 237, 0.06);
  box-shadow: none;
  transform: none;
}

.table-body::-webkit-scrollbar-track,
.price-table-body::-webkit-scrollbar-track {
  background: #eef4f8;
}

.table-body::-webkit-scrollbar-thumb,
.price-table-body::-webkit-scrollbar-thumb {
  background: rgba(47, 128, 237, 0.42);
}

.resource-panel,
.business-resource-menu {
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(34, 49, 63, 0.08);
  border-radius: 8px;
  box-shadow: 0 14px 30px rgba(34, 49, 63, 0.12);
}

.resource-panel-title,
.business-resource-menu-title {
  background: #eaf2fb;
  color: #22313f;
  border-bottom-color: rgba(34, 49, 63, 0.08);
}

.resource-item,
.business-resource-item {
  color: #526173;
  border-bottom-color: rgba(34, 49, 63, 0.06);
}

.resource-item:hover,
.business-resource-item:hover {
  background: rgba(47, 128, 237, 0.08);
}

.resource-item.active,
.business-resource-item.active {
  background: #2f80ed;
  color: #606266;
}

.resource-item.active::before {
  background-color: #12b886;
}

.city-btn,
.onOldCome {
  background-color: #2f80ed;
  color: #606266;
  border-radius: 6px;
}

.cityInput {
  border: 1px solid rgba(34, 49, 63, 0.14);
  border-radius: 6px;
  color: #22313f;
  background: #fff;
}

.rate-text.normal {
  color: #0f766e;
  background: rgba(18, 184, 134, 0.12);
  text-shadow: none;
}

.rate-text.warning {
  color: #b26a00;
  background: rgba(245, 159, 0, 0.14);
  text-shadow: none;
}

.rate-text.danger {
  color: #c92a2a;
  background: rgba(250, 82, 82, 0.12);
  text-shadow: none;
}

.modal-body,
.sentiment-stream-video {
  background: #f7fafc;
}

.business-tool-body,
.business-point-detail-body,
.price-warning-modal-body,
.deal-modal-body {
  background: #fff;
  color: #22313f;
}

.data-box .body-text,
.data-box .right-body-text,
.data-box .header-content-left .content,
.data-box .item-key,
.data-box .key,
.data-box .item-tap,
.data-box .right-body-text,
.business-stat-row,
.business-passenger-title,
.business-passenger-meta,
.business-rank-row strong,
.business-rank-row em,
.business-suggestion,
.business-fence-form label,
.business-fence-form input,
.business-fence-form textarea,
.business-fence-search,
.business-point-detail-name,
.business-point-detail-row,
.text-item-6,
.ota_pie_list,
.title-price-tong,
.price-td {
  color: #22313f;
}

.data-box .body-text,
.data-box .right-body-text,
.data-box .header-content-left .content,
.business-point-detail-row,
.business-passenger-meta,
.text-item-6 {
  color: #526173;
}

.business-suggestion,
.business-advice-box {
  background: #f6f9fc;
  border-color: rgba(47, 128, 237, 0.14);
}

.business-advice-title,
.business-point-detail-row strong,
.business-point-detail-loading {
  color: #2f80ed;
}

.business-fence-form input,
.business-fence-form textarea,
.business-fence-search {
  background: #fff;
  border-color: rgba(34, 49, 63, 0.14);
}

.business-rank-progress {
  background: rgba(47, 128, 237, 0.12);
}

.tap,
.deal-status-btn.doing,
.deal-status-btn.done {
  color: #606266;
}

.warning-push-icon,
.scenic-warning-icon {
  color: #e8590c;
}

/* 现代后台 UI 视觉修正：参考 Element Plus / Ant Design 的低饱和白色系 */
.main {
  --ui-bg: #f5f7fa;
  --ui-surface: #ffffff;
  --ui-surface-soft: #f9fafc;
  --ui-border: #dcdfe6;
  --ui-border-soft: #ebeef5;
  --ui-text: #1f2937;
  --ui-text-regular: #606266;
  --ui-text-secondary: #909399;
  --ui-primary: #409eff;
  --ui-primary-soft: #ecf5ff;
  --ui-success: #67c23a;
  --ui-warning: #e6a23c;
  --ui-danger: #f56c6c;
  --ui-radius: 8px;
  --ui-radius-sm: 6px;
  --ui-shadow: 0 8px 24px rgba(31, 45, 61, 0.08);
  --ui-shadow-light: 0 4px 14px rgba(31, 45, 61, 0.06);
  background: var(--ui-bg);
  color: var(--ui-text);
}

.head,
.right-nav-drawer,
.voice-status-box,
.voice-metric-board,
.data-box,
.business-saturation-card,
.body-left,
.body-right,
.resource-panel,
.business-resource-menu,
.business-point-detail-card,
.business-tool-card,
.business-stat-card,
.price-panel,
.warning-push-board,
.scenic-warning-board {
  background: rgba(255, 255, 255, 0.96);
  background-image: none;
  border: 1px solid var(--ui-border-soft, #ebeef5);
  border-radius: var(--ui-radius, 8px);
  box-shadow: var(--ui-shadow, 0 8px 24px rgba(31, 45, 61, 0.08));
  color: var(--ui-text, #1f2937);
}

.head {
  border-radius: 0;
  box-shadow: 0 2px 10px rgba(31, 45, 61, 0.06);
}

.right-nav-drawer,
.right-nav-toggle {
  border-radius: 8px 0 0 8px;
}

.head-title,
.left-top-title,
.left-bottom-title,
.right-title,
.right-title-1,
.today-one-title,
.title-price,
.business-card-title,
.business-saturation-card .business-card-title,
.business-passenger-title,
.business-point-detail-name {
  color: var(--ui-text, #1f2937);
  font-weight: 600;
}

.right-title-1,
.title-small,
.addressListOne,
.addressListOne_2,
.td,
.business-passenger-meta,
.business-point-detail-row,
.text-item-6,
.price-td,
.data-box .body-text,
.data-box .right-body-text,
.data-box .header-content-left .content {
  color: var(--ui-text-regular, #606266);
}

.head-title-voice-tag,
.date-weather,
.changeDateOne,
.right-datetiem,
.heat-address,
.business-period-filter,
.business-resource-label-toggle,
.type-item,
.business-fence-shape-select,
.business-tool-actions button,
.warning-push-button,
.screen-btn,
.deal-status-btn {
  background: var(--ui-surface-soft, #f9fafc);
  background-image: none;
  border: 1px solid var(--ui-border, #dcdfe6);
  border-radius: var(--ui-radius-sm, 6px);
  color: var(--ui-text-regular, #606266);
  box-shadow: none;
}

.head-title-voice-tag,
.center-big-title,
.number-small,
.num-price,
.last-level,
.business-advice-title,
.business-point-detail-row strong,
.business-point-detail-loading,
.keyword-count,
.premium-rate.flat {
  color: var(--ui-primary, #409eff);
}

.right-nav-toggle,
.type-item2,
.type-item:hover,
.resource-item.active,
.business-resource-item.active,
.business-resource-label-toggle:hover,
.business-tool-actions button.active,
.city-btn,
.button-6,
.onOldCome,
.warning-map-button,
.deal-btn.confirm,
.deal-status-btn.doing,
.deal-status-btn.done {
  background: var(--ui-primary, #409eff);
  border-color: var(--ui-primary, #409eff);
  color: #606266;
  box-shadow: 0 6px 16px rgba(64, 158, 255, 0.2);
}

.type-item:hover {
  background: var(--ui-primary-soft, #ecf5ff);
  color: var(--ui-primary, #409eff);
  box-shadow: none;
}

.table-header,
.price-table-header,
.resource-panel-title,
.business-resource-menu-title {
  background: #f5f7fa;
  border: 1px solid var(--ui-border-soft, #ebeef5);
  color: var(--ui-text, #1f2937);
  border-radius: var(--ui-radius-sm, 6px);
}

.table-row,
.price-table-row,
.resource-item,
.business-resource-item {
  border-color: var(--ui-border-soft, #ebeef5);
  color: var(--ui-text-regular, #606266);
}

.table-row.even,
.table-row:hover,
.price-table-row:hover,
.resource-item:hover,
.business-resource-item:hover,
.business-suggestion,
.business-advice-box,
.business-fence-form input,
.business-fence-form textarea,
.business-fence-search,
.price-search-input,
.cityInput,
.year-sum-box,
.today-sum-one,
.today-one-sum {
  background: var(--ui-surface-soft, #f9fafc);
  border-color: var(--ui-border-soft, #ebeef5);
  box-shadow: none;
}

.business-rank-progress,
.traffic-bar-track,
.parking-rank-track {
  background: #dbeafe;
}

.business-rank-progress i,
.traffic-bar-fill,
.parking-rank-fill-cyan,
.parking-rank-fill-medium {
  box-shadow: none;
}

.rate-text.normal,
.load-high,
.parking-rank-value-green {
  color: var(--ui-success, #67c23a);
}

.rate-text.warning,
.load-low,
.parking-rank-value-gold,
.premium-rate.up {
  color: var(--ui-warning, #e6a23c);
}

.rate-text.danger,
.premium-rate.down,
.business-point-detail-error {
  color: var(--ui-danger, #f56c6c);
}

.rate-text.normal,
.status-active {
  background: #f0f9eb;
}

.rate-text.warning {
  background: #fdf6ec;
}

.rate-text.danger {
  background: #fef0f0;
}

.warning-push-icon,
.scenic-warning-icon {
  color: var(--ui-warning, #e6a23c);
}

/* 内容排版与文字可读性修正 */
.main_type {
  align-items: flex-start;
  gap: 16px;
  padding: 32px 24px 24px;
  position: relative;
}

.main-left,
.main-right {
  margin: 0;
}

.main-left {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
}

.main-right {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
}

.culture-market-page {
  align-items: stretch;
}

.culture-market-page .main-center {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  height: auto;
}

.culture-market-page .charts {
  margin-top: auto;
}

.data-box,
.business-saturation-card {
  padding: 16px;
  box-sizing: border-box;
}

.data-box *,
.business-saturation-card *,
.business-tool-card *,
.business-stat-card *,
.business-point-detail-card *,
.resource-panel *,
.business-resource-menu *,
.warning-push-board *,
.scenic-warning-board * {
  text-shadow: none;
}

.data-box,
.data-box p,
.data-box span,
.data-box div,
.data-box li,
.data-box label,
.business-saturation-card,
.business-saturation-card p,
.business-saturation-card span,
.business-saturation-card div,
.business-tool-card,
.business-tool-card p,
.business-tool-card span,
.business-tool-card div,
.business-stat-card,
.business-stat-card p,
.business-stat-card span,
.business-stat-card div,
.business-point-detail-card,
.business-point-detail-card p,
.business-point-detail-card span,
.business-point-detail-card div,
.resource-panel,
.resource-panel span,
.business-resource-menu,
.business-resource-menu span,
.warning-push-text,
.scenic-warning-text {
  color: var(--ui-text-regular, #606266);
}

.left-top-title,
.left-bottom-title,
.right-title,
.right-title-1,
.today-one-title,
.title-price,
.business-card-title,
.business-resource-menu-title,
.resource-panel-title,
.business-passenger-title,
.business-point-detail-name,
.scenic-warning-title,
.table-header,
.price-table-header,
.th {
  color: var(--ui-text, #1f2937);
}

.right-nav-toggle,
.type-item2,
.resource-item.active,
.business-resource-item.active,
.business-resource-item.active *,
.business-tool-actions button.active,
.city-btn,
.button-6,
.onOldCome,
.deal-btn.confirm,
.deal-status-btn.doing,
.deal-status-btn.done {
  color: #606266;
}

.right-title,
.left-bottom-title,
.business-card-title {
  padding: 0 0 12px;
  margin: 0;
  line-height: 1.35;
}

.business-right-panel {
  top: 20px;
  right: 20px;
  gap: 12px;
}

.business-tool-card,
.business-stat-card {
  padding: 16px;
}

.business-stat-list,
.business-passenger-box {
  width: 100%;
}

.business-passenger-box {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid var(--ui-border-soft, #ebeef5);
}

.business-rank-row {
  height: 28px;
  margin-bottom: 6px;
  gap: 6px;
}

.business-rank-row strong {
  width: 72px;
}

.business-rank-row em {
  width: 48px;
}

.business-stat-progress,
.business-rank-progress {
  max-width: none;
}

.business-stat-card .business-progress-tip {
  color: #fff;
}

.business-suggestion,
.business-advice-box {
  max-height: none;
  padding: 10px 12px;
  line-height: 1.5;
}

.business-fence-shape-select,
.business-tool-actions button {
  height: 30px;
}

.table-container,
.price-table-container {
  border: 1px solid var(--ui-border-soft, #ebeef5);
  border-radius: 8px;
  overflow: hidden;
}

.table-header,
.price-table-header {
  border: 0;
  border-radius: 0;
}

.table-row,
.price-table-row {
  min-height: 32px;
  border-bottom: 1px solid var(--ui-border-soft, #ebeef5);
}

.table-row:last-child,
.price-table-row:last-child {
  border-bottom: 0;
}

.sentiment-body,
.sentiment-box {
  gap: 16px;
}

.list-item {
  padding: 14px 0;
  border-bottom: 1px solid var(--ui-border-soft, #ebeef5);
}

.text-item-6 {
  width: 100%;
  margin-top: 8px;
  padding: 10px 12px;
  background: var(--ui-surface-soft, #f9fafc);
  border: 1px solid var(--ui-border-soft, #ebeef5);
  border-radius: 6px;
}

.day_plan_item {
  margin: 0;
  padding: 12px 14px;
}

.center-top-num {
  position: absolute;
  top: 18px;
  left: 50%;
  z-index: 4;
  width: 520px;
  max-width: calc(100vw - 520px);
  min-width: 360px;
  padding: 14px 18px 16px;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--ui-border-soft, #ebeef5);
  border-radius: 8px;
  box-shadow: var(--ui-shadow, 0 8px 24px rgba(31, 45, 61, 0.08));
  box-sizing: border-box;
}

.center-top-num .center-big-title {
  margin: 0 0 10px;
  line-height: 1.3;
}

.center-top-num .today-sum-one {
  width: 100%;
  height: 72px;
  background: var(--ui-surface-soft, #f9fafc);
  border: 1px solid var(--ui-border-soft, #ebeef5);
  border-radius: 8px;
}

.center-top-num .year-sum-big {
  height: 72px;
  line-height: 72px !important;
}

.center-top-num .sum-one-big {
  font-size: 48px;
}

.traffic-kpi-card {
  width: 560px;
  min-width: 420px;
  max-width: calc(100vw - 520px);
  padding: 18px 22px;
}

.traffic-kpi-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
}

.traffic-kpi-title {
  color: var(--ui-text, #1f2937);
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
}

.traffic-kpi-subtitle {
  margin-top: 4px;
  color: var(--ui-text-secondary, #909399);
  font-size: 12px;
  line-height: 18px;
}

.traffic-kpi-status {
  padding: 3px 9px;
  color: var(--ui-primary, #409eff);
  font-size: 12px;
  line-height: 18px;
  background: var(--ui-primary-soft, #ecf5ff);
  border: 1px solid rgba(64, 158, 255, 0.18);
  border-radius: 999px;
}

.traffic-kpi-value {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 12px;
  padding: 10px 12px;
  background: linear-gradient(180deg, #f9fafc 0%, #f3f7fc 100%);
  border: 1px solid var(--ui-border-soft, #ebeef5);
  border-radius: 8px;
}

.traffic-kpi-number {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.traffic-kpi-digit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 48px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(64, 158, 255, 0.14);
  border-radius: 6px;
  box-shadow: inset 0 -10px 18px rgba(64, 158, 255, 0.06);
}

.traffic-kpi-digit /deep/ .count-flop {
  height: 48px;
  line-height: 48px;
  font-size: 30px;
}

.traffic-kpi-digit /deep/ .count-flop-box {
  width: 30px;
  line-height: 48px;
}

.traffic-kpi-unit {
  color: var(--ui-text-secondary, #909399);
  font-size: 14px;
  line-height: 20px;
}

.traffic-kpi-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 12px;
}

.traffic-kpi-meta-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  color: var(--ui-text-regular, #606266);
  background: var(--ui-surface-soft, #f9fafc);
  border: 1px solid var(--ui-border-soft, #ebeef5);
  border-radius: 6px;
  font-size: 12px;
}

.traffic-kpi-meta-item strong {
  color: var(--ui-success, #67c23a);
  font-size: 15px;
  font-weight: 600;
}

.center-top-num .center-icon {
  bottom: 4px;
  font-size: 42px;
}

.right-nav-toggle,
.type-item2,
.resource-item.active,
.business-resource-item.active,
.business-resource-item.active *,
.business-tool-actions button.active,
.city-btn,
.button-6,
.onOldCome,
.deal-btn.confirm,
.deal-status-btn.doing,
.deal-status-btn.done {
  background: #ecf5ff;
  border-color: #b3d8ff;
  color: #1d4f91;
  box-shadow: none;
}

.business-percent-gauge-meta {
  color: #909399;
}

.date-weather {
  background: transparent;
  border: 0;
  box-shadow: none;
}

.date-weather {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0;
  height: auto;
  line-height: normal;
}

.date-switch {
  display: flex;
  width: 100%;
  gap: 2px;
  padding: 3px;
  background: #eef3f8;
  border: 1px solid #dce4ec;
  border-radius: 999px;
  margin-top: 8px;
}

.date-switch .changeDateOne {
  flex: 1;
  width: auto;
  min-width: 0;
  height: 28px;
  margin: 0;
  padding: 0 8px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #667085;
  font-size: 12px;
  line-height: 28px;
  font-weight: 500;
  box-shadow: none;
}

.date-switch .changeDateOne.active,
.date-switch .changeDateOne:hover {
  background: #ffffff;
  color: #1d4f91;
  box-shadow: 0 4px 10px rgba(31, 45, 61, 0.08);
}

.date-current {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 12px;
  background: #ffffff;
  border: 1px solid var(--ui-border-soft, #ebeef5);
  border-radius: 999px;
  color: #667085;
  box-shadow: 0 4px 14px rgba(31, 45, 61, 0.06);
}

.date-current-day {
  color: var(--ui-text, #1f2937);
  font-weight: 600;
}

.date-refresh-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid var(--ui-border-soft, #ebeef5);
  border-radius: 50%;
  background: #ffffff;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(31, 45, 61, 0.06);
}

.date-refresh-btn img {
  width: 14px;
  height: 14px;
}

.warning-push-card {
  top: 16px;
  left: 24px;
  transform: none;
  min-width: 0;
  width: 360px;
  height: auto;
  min-height: 72px;
  padding: 14px 16px;
  align-items: flex-start;
  gap: 12px;
  border-color: rgba(230, 162, 60, 0.24);
  border-left: 4px solid #e6a23c;
  border-radius: 10px;
  box-shadow: 0 10px 26px rgba(31, 45, 61, 0.1);
}

.warning-push-card .warning-push-content {
  flex: 1;
  min-width: 0;
}

.warning-push-card .warning-push-label {
  margin-bottom: 4px;
  color: #b26a00;
  font-size: 13px;
  font-weight: 600;
}

.warning-push-card .warning-push-text {
  white-space: normal;
  line-height: 1.45;
}

.warning-push-card .warning-push-button {
  align-self: center;
  margin-left: 0;
  background: #fff7e8;
  border-color: #f3d19e;
  color: #a45c00;
}

.scenic-warning-board {
  top: 16px;
  right: 210px;
  width: 420px;
  height: 46px;
  padding: 0 14px;
  border-color: rgba(245, 108, 108, 0.18);
  border-left: 4px solid #f56c6c;
  border-radius: 10px;
}

.scenic-warning-board::before {
  display: none;
}

.scenic-warning-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  border-radius: 50%;
  background: #fef0f0;
  color: #f56c6c;
  line-height: 20px;
}

.scenic-warning-content,
.scenic-warning-item {
  height: 24px;
  line-height: 24px;
}

.scenic-warning-title {
  margin-right: 8px;
  color: #1f2937;
  font-size: 13px;
}

.scenic-warning-tag {
  flex-shrink: 0;
  margin-right: 8px;
  padding: 0 7px;
  color: #f56c6c;
  background: #fef0f0;
  border-radius: 999px;
  font-size: 12px;
}

.culture-market-page {
  grid-template-columns: 360px minmax(520px, 1fr) 340px;
  display: grid;
  align-items: stretch;
  gap: 18px;
}

.culture-market-page .main-left,
.culture-market-page .main-center,
.culture-market-page .main-right {
  width: auto;
  min-width: 0;
}

.market-left,
.market-right,
.market-chart-stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.market-source-filter {
  top: -44px;
  right: auto;
  left: 0;
  width: auto;
  height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  line-height: 32px;
}

.market-overview-card,
.market-spend-card,
.market-consume-card,
.market-trend-card,
.market-flow-card {
  padding: 18px;
}

.market-overview-card {
  min-height: 286px;
}

.market-card-head,
.chart-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.market-card-head.compact {
  margin-bottom: 10px;
}

.market-eyebrow {
  margin-bottom: 3px;
  color: #909399;
  font-size: 12px;
  line-height: 16px;
}

.market-card-title,
.chart-card-title {
  color: #1f2937;
  font-size: 17px;
  line-height: 24px;
  font-weight: 700;
}

.market-ghost-btn {
  height: 28px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 999px;
  background: #ffffff;
  color: #606266;
  cursor: pointer;
}

.market-total-strip {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.market-total-main {
  padding: 12px;
  background: linear-gradient(135deg, #f8fbff 0%, #eef6ff 100%);
  border: 1px solid #dcecff;
  border-radius: 8px;
}

.market-total-main>span {
  display: block;
  margin-bottom: 6px;
  color: #606266;
  font-size: 12px;
}

.market-total-main strong {
  display: flex;
  gap: 3px;
  color: #1d4f91;
  font-size: 28px;
  line-height: 34px;
  font-weight: 700;
  font-family: DIN Alternate, Arial, sans-serif;
}

.market-metric-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 12px;
}

.market-metric-cell {
  padding: 10px;
  background: #f9fafc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.market-metric-cell span,
.market-spend-row span,
.market-spend-value span {
  display: block;
  color: #909399;
  font-size: 12px;
  line-height: 16px;
}

.market-metric-cell strong {
  display: block;
  margin-top: 6px;
  color: #67c23a;
  font-size: 18px;
  line-height: 22px;
}

.market-spend-card {
  min-height: 162px;
}

.market-spend-value {
  padding: 12px;
  background: #f6f9fc;
  border-radius: 8px;
}

.market-spend-value strong {
  display: block;
  margin-top: 6px;
  color: #409eff;
  font-size: 26px;
  line-height: 30px;
}

.market-spend-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 10px;
}

.market-spend-row>div {
  padding: 9px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.market-spend-row strong {
  display: block;
  margin-top: 5px;
  color: #1f2937;
  font-size: 14px;
}

.market-consume-card {
  min-height: 210px;
}

.market-consume-layout {
  display: grid;
  grid-template-columns: 150px 1fr;
  align-items: center;
  gap: 10px;
}

.market-ota-pie {
  width: 150px;
  height: 140px;
}

.market-consume-list {
  position: static;
  display: grid;
  gap: 7px;
  align-content: center;
  min-width: 0;
  font-size: 12px;
  line-height: 18px;
}

.market-center {
  display: flex;
  flex-direction: column;
}

.market-chart-stack {
  width: 100%;
  margin-top: auto;
}

.market-trend-card {
  width: 100%;
  height: 180px;
}

.market-flow-card {
  width: 100%;
  height: 298px;
}

.chart-card-tools {
  height: 26px;
  padding: 0 10px;
  color: #409eff;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: 999px;
  font-size: 12px;
  line-height: 26px;
}

.chart-card-tools.muted {
  color: #606266;
  background: #f5f7fa;
  border-color: #ebeef5;
}

.market-trend-chart {
  width: 100%;
  height: 90px;
}

.market-flow-chart {
  position: static;
  width: 100%;
  height: 220px;
  transform: none;
}

.market-right .right-top,
.market-right .left-center {
  margin-top: 0 !important;
}
.pie-flex-box {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.warning-list-box {
  width: 350px;
  overflow: hidden;
  overflow-y: auto;
  padding: 0 8px;
}

.warning-list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  margin-bottom: 6px;
  background: var(--ui-surface-soft, rgba(47, 128, 237, 0.04));
  border: 1px solid var(--ui-border-soft, #ebeef5);
  border-radius: 6px;
}

.warning-list-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--ui-text, #1f2937);
  white-space: nowrap;
  flex-shrink: 0;
}

.warning-list-level {
  font-size: 11px;
  padding: 1px 6px;
  border-radius: 10px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.warning-list-level.level-高 {
  background: #fff1f0;
  color: #cf1322;
}

.warning-list-level.level-中 {
  background: #fff7e6;
  color: #d46b08;
}

.warning-list-level.level-低 {
  background: #f6ffed;
  color: #389e0d;
}

.warning-list-time {
  font-size: 12px;
  color: var(--ui-text-secondary, #909399);
  white-space: nowrap;
  flex-shrink: 0;
}

.warning-list-advice {
  font-size: 12px;
  color: var(--ui-text-regular, #606266);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

/* 餐饮排行榜 */
.ranking-list-box {
  height: calc(100vh - 140px);
  overflow-y: auto;
  padding: 0 8px;
}

.ranking-list-item {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border-bottom: 1px solid rgba(96, 98, 102, 0.08);
}

.ranking-list-item:last-child {
  border-bottom: none;
}

.ranking-number {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  background: #f3f4f6;
  margin-right: 10px;
  flex-shrink: 0;
}

.ranking-number.rank-top-1 {
  background: linear-gradient(135deg, #fbbf24, #f59e0b);
  color: #fff;
}

.ranking-number.rank-top-2 {
  background: linear-gradient(135deg, #9ca3af, #6b7280);
  color: #fff;
}

.ranking-number.rank-top-3 {
  background: linear-gradient(135deg, #d97706, #b45309);
  color: #fff;
}

.ranking-name {
  flex: 1;
  font-size: 13px;
  color: var(--ui-text, #1f2937);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ranking-score {
  font-size: 13px;
  font-weight: 600;
  color: #f59e0b;
  margin-left: 8px;
  flex-shrink: 0;
}

/* 右侧价格趋势悬浮面板 */
.price-right-trend-panel {
  width: 600px;
  background: #fff;
  border: 1px solid rgba(0, 170, 255, 0.55);
  z-index: 99;
  border-radius: 6px;
  overflow: hidden;
  left: 533px;
  top: 67px;
  position: absolute;
}
.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: #fff;
  color: #606266;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid rgba(0, 170, 255, 0.25);
}
.panel-close {
  font-size: 24px;
  color: #a8c5e8;
  cursor: pointer;
  line-height: 24px;
}
.panel-sub {
  padding: 12px 18px 0;
  font-size: 13px;
  line-height: 1.6;
  color: #333;
}
.panel-tip {
  padding: 6px 18px;
  font-size: 12px;
  color: #333;
}
.right-trend-chart {
  width: 100%;
  height: 340px;
  padding: 0 10px 16px;
  box-sizing: border-box;
}
.price-td.premium-rate {
  font-weight: 600;
}
/* 根据溢价率设置背景色，文字统一为黑色 */
.premium-normal {
  background-color: rgba(0, 168, 84, 0.08);
}
.premium-normal .price-td,
.premium-normal .deal-status-btn {
  color: #000 !important;
}

.premium-warning {
  background-color: rgba(255, 125, 0, 0.12);
}
.premium-warning .price-td,
.premium-warning .deal-status-btn {
  color: #000;
}

.premium-danger {
  background-color: rgba(245, 63, 63, 0.15);
}
.premium-danger .price-td,
.premium-danger .deal-status-btn {
  color: #000;
}
.complaint-summary {
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}
.complaint-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.complaint-table th,
.complaint-table td {
  border: 1px solid #e4e7ed;
  padding: 8px 10px;
  text-align: center;
  vertical-align: middle;
}
.complaint-table th {
  background-color: #f5f7fa;
  color: #606266;
}
.complaint-table tbody tr:hover {
  background: #fafafa;
}
.price-table-empty {
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 13px;
}

.business-saturation-panel .business-saturation-tabs button {
  background: #f6f9fc;
  border: 1px solid #dcdfe6;
  color: #606266;
}

.business-saturation-panel .business-saturation-tabs button.active {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}

.business-saturation-panel .business-saturation-current-title,
.business-saturation-panel .business-advice-title {
  color: #409eff;
}

.business-saturation-panel .business-advice-box p {
  color: #303133;
  white-space: pre-line;
}

.business-tool-card .business-fence-history-title {
  color: #409eff;
}

.business-tool-card .business-fence-list button {
  background: #f6f9fc;
  border: 1px solid #dcdfe6;
  color: #606266;
}

.business-tool-card .business-fence-list button.active {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}

.business-tool-card .business-fence-list button.active span {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/ScenicData.vue